<template>
    <div
        class="search-filter-box nf-filter-modal"
        id="searchFilterBox"
        v-show="isOpen"
        :style="{ display: isOpen ? 'block' : 'none' }"
        :aria-hidden="isOpen ? 'false' : 'true'"
    >
        <div class="search-filter-box-out nf-filter-overlay" @click.self="close">
            <div class="search-filter-box-in nf-filter-panel" role="dialog" aria-modal="true" aria-label="Detaylı Filtrele">
                <button type="button" class="search-filter-close nf-filter-close" @click="close">
                    <i class="ph-light ph-x"></i>
                </button>

                <!-- Wizard Header -->
                <div class="nf-filter-head">
                    <div>
                        <div class="nf-filter-title">Detaylı Filtrele</div>
                        <p class="nf-filter-subtitle">{{ wizardStepLabel }} <span class="nf-step-badge">{{ currentStep }}/4</span></p>
                    </div>
                    <div class="nf-filter-count" v-if="activeFilterCount > 0">
                        <strong>{{ activeFilterCount }}</strong>
                        <span>filtre</span>
                    </div>
                </div>

                <!-- Progress Bar -->
                <div class="nf-wizard-progress">
                    <div class="nf-wizard-progress-bar" :style="{ width: wizardProgress + '%' }"></div>
                </div>

                <!-- Step Indicator Breadcrumb -->
                <div class="nf-wizard-steps">
                    <button type="button" class="nf-wizard-step-btn" :class="{ active: currentStep === 1, completed: currentStep > 1 }" @click="goToStep(1)">
                        <span class="nf-step-num">1</span>
                        <span class="nf-step-text">İlan Türü</span>
                    </button>
                    <i class="ph-bold ph-caret-right nf-step-arrow"></i>
                    <button type="button" class="nf-wizard-step-btn" :class="{ active: currentStep === 2, completed: currentStep > 2, disabled: !canProceedToStep2 }" @click="canProceedToStep2 && goToStep(2)">
                        <span class="nf-step-num">2</span>
                        <span class="nf-step-text">Kategori</span>
                    </button>
                    <i class="ph-bold ph-caret-right nf-step-arrow"></i>
                    <button type="button" class="nf-wizard-step-btn" :class="{ active: currentStep === 3, completed: currentStep > 3, disabled: !canProceedToStep3 }" @click="canProceedToStep3 && goToStep(3)">
                        <span class="nf-step-num">3</span>
                        <span class="nf-step-text">Tür</span>
                    </button>
                    <i class="ph-bold ph-caret-right nf-step-arrow"></i>
                    <button type="button" class="nf-wizard-step-btn" :class="{ active: currentStep === 4, disabled: !canProceedToStep4 }" @click="canProceedToStep4 && goToStep(4)">
                        <span class="nf-step-num">4</span>
                        <span class="nf-step-text">Filtreler</span>
                    </button>
                </div>

                <!-- Selection Summary Chips -->
                <div class="nf-wizard-summary" v-if="selectionSummaryChips.length > 0">
                    <span class="nf-wizard-chip" v-for="(chip, idx) in selectionSummaryChips" :key="'wchip-' + idx">
                        <i class="ph-fill ph-check-circle"></i>
                        {{ chip }}
                    </span>
                </div>

                <!-- Active Filter Chips (only on step 4) -->
                <div class="nf-active-filter-bar" v-if="currentStep === 4 && activeChips.length">
                    <button
                        v-for="chip in activeChips"
                        :key="chip.key"
                        type="button"
                        class="nf-active-chip"
                        @click="removeChip(chip)"
                    >
                        <span>{{ chip.label }}</span>
                        <i class="ph-bold ph-x"></i>
                    </button>
                </div>

                <!-- Wizard Content -->
                <div class="filter-box filter-toggle-out nf-filter-scroll">

                    <!-- ═══ STEP 1: İlan Türü ═══ -->
                    <div v-if="currentStep === 1" class="nf-wizard-step-content">
                        <div class="nf-step-title-bar">
                            <i class="ph-light ph-tag"></i>
                            <strong>İlan Türünü Seçin</strong>
                        </div>
                        <div class="nf-choice-grid">
                            <label v-if="context === 'agency'" class="nf-choice-card" :class="{ selected: form.transaction_type === '' }">
                                <input type="radio" name="wz_transaction" value="" :checked="form.transaction_type === ''" @click="selectTransactionType('')">
                                <div class="nf-choice-inner">
                                    <i class="ph-light ph-list-bullets"></i>
                                    <span>{{ transactionTypeLabel('') }}</span>
                                    <i class="ph-bold ph-check-circle nf-choice-check"></i>
                                </div>
                            </label>
                            <label class="nf-choice-card" :class="{ selected: form.transaction_type === '1' }">
                                <input type="radio" name="wz_transaction" value="1" :checked="form.transaction_type === '1'" @click="selectTransactionType('1')">
                                <div class="nf-choice-inner">
                                    <i class="ph-light ph-house"></i>
                                    <span>{{ transactionTypeLabel('1') }}</span>
                                    <i class="ph-bold ph-check-circle nf-choice-check"></i>
                                </div>
                            </label>
                            <label class="nf-choice-card" :class="{ selected: form.transaction_type === '2' }">
                                <input type="radio" name="wz_transaction" value="2" :checked="form.transaction_type === '2'" @click="selectTransactionType('2')">
                                <div class="nf-choice-inner">
                                    <i class="ph-light ph-key"></i>
                                    <span>{{ transactionTypeLabel('2') }}</span>
                                    <i class="ph-bold ph-check-circle nf-choice-check"></i>
                                </div>
                            </label>
                        </div>
                        <div class="nf-step-note">
                            <i class="ph-fill ph-info"></i> Önce ilan türünü seçin. Kategoriler bu seçime göre filtrelenecektir.
                        </div>
                    </div>

                    <!-- ═══ STEP 2: Gayrimenkul Kategorisi ═══ -->
                    <div v-if="currentStep === 2" class="nf-wizard-step-content">
                        <div class="nf-step-title-bar">
                            <i class="ph-light ph-buildings"></i>
                            <strong>Gayrimenkul Kategorisi Seçin</strong>
                        </div>
                        <div class="nf-choice-grid" v-if="filteredRootCategories.length > 0">
                            <label class="nf-choice-card" v-for="cat in filteredRootCategories" :key="'wz-root-' + cat.id" :class="{ selected: String(form.main_category_id) === String(cat.id) }">
                                <input type="radio" name="wz_main_category" :value="String(cat.id)" :checked="String(form.main_category_id) === String(cat.id)" @click="selectMainCategory(cat.id)">
                                <div class="nf-choice-inner">
                                    <i :class="categoryIcon(cat)"></i>
                                    <span>{{ cat.name }}</span>
                                    <i class="ph-bold ph-check-circle nf-choice-check"></i>
                                </div>
                            </label>
                        </div>
                        <div class="nf-choice-empty" v-else>
                            <i class="ph-light ph-warning-circle"></i>
                            Bu ilan türü için kullanılabilir kategori bulunamadı.
                        </div>
                    </div>

                    <!-- ═══ STEP 3: Gayrimenkul Türü ═══ -->
                    <div v-if="currentStep === 3" class="nf-wizard-step-content">
                        <div class="nf-step-title-bar">
                            <i class="ph-light ph-house-line"></i>
                            <strong>Gayrimenkul Türünü Seçin</strong>
                        </div>
                        <div class="nf-choice-grid nf-choice-grid-sm" v-if="filteredLeafCategories.length > 0">
                            <label class="nf-choice-card" v-for="cat in filteredLeafCategories" :key="'wz-leaf-' + cat.id" :class="{ selected: String(form.subcategory_id) === String(cat.id) }">
                                <input type="radio" name="wz_sub_category" :value="String(cat.id)" :checked="String(form.subcategory_id) === String(cat.id)" @click="selectSubCategory(cat.id)">
                                <div class="nf-choice-inner">
                                    <span>{{ cat.name }}</span>
                                    <i class="ph-bold ph-check-circle nf-choice-check"></i>
                                </div>
                            </label>
                        </div>
                        <div class="nf-choice-empty" v-else>
                            <i class="ph-light ph-warning-circle"></i>
                            Bu kategori için alt tür bulunamadı.
                        </div>
                        <div class="nf-step-skip" v-if="filteredLeafCategories.length > 0">
                            <button type="button" class="nf-skip-btn" @click="skipSubCategory">
                                <small>Tümünü Seç (Alt tür belirtmeden devam et)</small>
                                <i class="ph-light ph-arrow-right"></i>
                            </button>
                        </div>
                    </div>

                    <!-- ═══ STEP 4: Detaylı Filtreler ═══ -->
                    <div v-if="currentStep === 4" class="nf-wizard-step-content">

                        <template v-if="isLandFilterMode">
                            <div class="nf-land-filter-layout">
                                <!--                <div class="nf-land-context-card" v-if="landTypeLabel">-->
                                <!--                  <i class="ph-light ph-map-trifold"></i>-->
                                <!--                  <div>-->
                                <!--                    <strong>{{ landTypeLabel }}</strong>-->
                                <!--                  </div>-->
                                <!--                </div>-->

                                <!-- Arsa: Fiyat bölümü her zaman üstte -->
                                <div class="filter-box-item nf-accordion-item nf-land-price-card" :class="{ 'nf-collapsed': collapsedSections.price }">
                                    <button type="button" class="nf-accordion-header" @click="toggleSection('price')">
                                        <div class="fbr-title"><i class="ph-light ph-chart-pie"></i>Fiyat</div>
                                        <i class="ph-bold nf-accordion-chevron" :class="collapsedSections.price ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                    </button>
                                    <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections.price">
                                        <div class="nf-land-subtitle">Fiyat Aralığı</div>
                                        <div class="filter-toggle-range modern-range nf-range">
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'min_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.min_price)" @input="onPriceInput('min_price', $event)" @focus="openCombo('min_price')" placeholder="En az" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('min_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'min_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in priceOptions" :key="'land-cb-pmin-' + option.value" :class="{ selected: String(form.min_price) === String(option.value) }" @mousedown.prevent="selectCombo('min_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'max_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.max_price)" @input="onPriceInput('max_price', $event)" @focus="openCombo('max_price')" placeholder="En çok" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('max_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'max_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in filteredMaxPriceOptions" :key="'land-cb-pmax-' + option.value" :class="{ selected: String(form.max_price) === String(option.value) }" @mousedown.prevent="selectCombo('max_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="nf-land-price-block" v-if="landPriceStatusItems.length">
                                            <div class="nf-land-subtitle mt-2">Kullanım Durumu</div>
                                            <div class="filter-checkbox-grid">
                                                <button
                                                    v-for="item in landPriceStatusItems"
                                                    :key="'land-price-status-' + item.key"
                                                    type="button"
                                                    class="checkbox-btn nf-land-toggle-btn"
                                                    :class="{ active: isLandToggleSelected(item) }"
                                                    @click="toggleLandToggleItem(item)"
                                                >
                                                    <i class="ph-bold" :class="isLandToggleSelected(item) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ uiText(item.label) }}</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="nf-land-price-block" v-if="landPriceOpportunityItems.length">
                                            <div class="nf-land-subtitle">Fırsatlar</div>
                                            <div class="filter-checkbox-grid">
                                                <button
                                                    v-for="item in landPriceOpportunityItems"
                                                    :key="'land-price-opportunity-' + item.key"
                                                    type="button"
                                                    class="checkbox-btn nf-land-toggle-btn"
                                                    :class="{ active: isLandToggleSelected(item) }"
                                                    @click="toggleLandToggleItem(item)"
                                                >
                                                    <i class="ph-bold" :class="isLandToggleSelected(item) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ uiText(item.label) }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Kimden filtresi korunur, ancak arsa düzeninde fiyatın altında yer alır -->
                                <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections.owner }">
                                    <button type="button" class="nf-accordion-header" @click="toggleSection('owner')">
                                        <div class="fbr-title"><i class="ph-light ph-user-list"></i>Kimden</div>
                                        <i class="ph-bold nf-accordion-chevron" :class="collapsedSections.owner ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                    </button>
                                    <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections.owner">
                                        <div class="filter-checkbox-grid">
                                            <label class="checkbox-btn" v-for="option in ownerTypeOptions" :key="'land-owner-' + option.value" :class="{ active: form.owner_types.includes(option.value) }">
                                                <input type="checkbox" :value="option.value" v-model="form.owner_types">
                                                <i class="ph-bold" :class="form.owner_types.includes(option.value) ? 'ph-check-square' : 'ph-square'"></i>
                                                <span>{{ option.label }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="loading" class="filter-loading">
                                    <i class="ph-bold ph-spinner ph-spin"></i> Özellikler yükleniyor...
                                </div>

                                <template v-if="landOrderedItems.length > 0">
                                    <div class="nf-group-title">{{ landDetailsGroupTitle }}</div>
                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['land-' + item.key], 'nf-land-compact-counter': isLandCompactCounter(item) }" v-for="item in landOrderedItems" :key="'land-item-' + item.key">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('land-' + item.key)">
                                            <div class="fbr-title">{{ item.label }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['land-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['land-' + item.key]">
                                            <template v-if="item.type === 'parking_group'">
                                                <div class="nf-parking-grid">
                                                    <div
                                                        class="nf-parking-option"
                                                        v-for="parking in item.options"
                                                        :key="item.key + '-' + parking.key"
                                                        :class="{ active: isParkingOptionSelected(parking) }"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="checkbox-btn nf-parking-toggle-btn"
                                                            :class="{ active: isParkingOptionSelected(parking) }"
                                                            @click="toggleParkingOption(parking)"
                                                        >
                                                            <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ parking.label }}</span>
                                                        </button>

                                                        <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                            <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                    <input
                                                                        type="text"
                                                                        inputmode="numeric"
                                                                        :value="getNumericRangeVal(parking.countField, 'min')"
                                                                        @input="onParkingCountInput(parking, $event)"
                                                                        placeholder="En az"
                                                                        class="input"
                                                                        autocomplete="off"
                                                                    >
                                                                    <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                            <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'field'">
                                                <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                    <div class="filter-checkbox-grid">
                                                        <button
                                                            v-for="opt in item.field.options"
                                                            :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                            type="button"
                                                            class="checkbox-btn"
                                                            :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                            @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                        >
                                                            <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </button>
                                                    </div>

                                                    <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                        <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                    <div class="nf-year-range-grid">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'min')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    :placeholder="uiText('En Az')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'max')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    :placeholder="uiText('En Çok')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                        <div class="nf-combobox-label">En geç teslim yılı</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                </div>

                                                <div v-else-if="item.renderAsCheckboxes || isMultiField(item.field)" class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="opt in item.field.options" :key="'land-field-multi-' + item.field.id + '-' + opt.id" :class="{ active: isFieldArrayValueSelected(item.field, opt.id) }">
                                                        <input type="checkbox" :checked="isFieldArrayValueSelected(item.field, opt.id)" @change="toggleFieldArrayValue(item.field, opt.id)">
                                                        <i class="ph-bold" :class="isFieldArrayValueSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ opt.name }}</span>
                                                    </label>
                                                </div>

                                                <div v-else-if="isLandMinOnlyNumericField(item.field)" class="filter-box-input">
                                                    <div class="nf-stepper-field">
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepLandMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                        <div class="nf-stepper-input-wrap" :class="{ 'has-badge': item.field.unit }">
                                                            <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                            <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                        </div>
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepLandMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                    </div>
                                                </div>

                                                <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                    <div class="filter-toggle-range modern-range nf-range">
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'land-nummin-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('land-nummin-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('land-nummin-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'land-nummin-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'land-nmin-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'land-nummax-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('land-nummax-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('land-nummax-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'land-nummax-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'land-nmax-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'land-dynfield-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('land-dynfield-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('land-dynfield-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'land-dynfield-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'land-cb-dyn-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else class="filter-box-input relative-input">
                                                    <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'feature_group'">
                                                <div class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'land-ft-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                        <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                        <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ featureItem.name }}</span>
                                                    </label>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="landRemainingItems.length > 0">
                                    <div class="nf-group-title">Diğer Filtreler</div>
                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['land-extra-' + item.key] }" v-for="item in landRemainingItems" :key="'land-extra-' + item.key">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('land-extra-' + item.key)">
                                            <div class="fbr-title">{{ item.label }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['land-extra-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['land-extra-' + item.key]">
                                            <template v-if="item.type === 'parking_group'">
                                                <div class="nf-parking-grid">
                                                    <div
                                                        class="nf-parking-option"
                                                        v-for="parking in item.options"
                                                        :key="item.key + '-' + parking.key"
                                                        :class="{ active: isParkingOptionSelected(parking) }"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="checkbox-btn nf-parking-toggle-btn"
                                                            :class="{ active: isParkingOptionSelected(parking) }"
                                                            @click="toggleParkingOption(parking)"
                                                        >
                                                            <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ parking.label }}</span>
                                                        </button>

                                                        <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                            <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                    <input
                                                                        type="text"
                                                                        inputmode="numeric"
                                                                        :value="getNumericRangeVal(parking.countField, 'min')"
                                                                        @input="onParkingCountInput(parking, $event)"
                                                                        placeholder="En az"
                                                                        class="input"
                                                                        autocomplete="off"
                                                                    >
                                                                    <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                            <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'field'">
                                                <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                    <div class="filter-checkbox-grid">
                                                        <button
                                                            v-for="opt in item.field.options"
                                                            :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                            type="button"
                                                            class="checkbox-btn"
                                                            :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                            @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                        >
                                                            <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </button>
                                                    </div>

                                                    <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                        <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                    <div class="nf-year-range-grid">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'min')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    :placeholder="uiText('En Az')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'max')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    :placeholder="uiText('En Çok')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                        <div class="nf-combobox-label">En geç teslim yılı</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                </div>
                                                <div v-else-if="item.renderAsCheckboxes || isMultiField(item.field)" class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="opt in item.field.options" :key="'land-extra-field-multi-' + item.field.id + '-' + opt.id" :class="{ active: isFieldArrayValueSelected(item.field, opt.id) }">
                                                        <input type="checkbox" :checked="isFieldArrayValueSelected(item.field, opt.id)" @change="toggleFieldArrayValue(item.field, opt.id)">
                                                        <i class="ph-bold" :class="isFieldArrayValueSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ opt.name }}</span>
                                                    </label>
                                                </div>
                                                <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                    <div class="filter-toggle-range modern-range nf-range">
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'land-extra-nummin-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('land-extra-nummin-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('land-extra-nummin-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'land-extra-nummin-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'land-extra-nmin-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'land-extra-nummax-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('land-extra-nummax-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('land-extra-nummax-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'land-extra-nummax-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'land-extra-nmax-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'land-extra-dynfield-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('land-extra-dynfield-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('land-extra-dynfield-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'land-extra-dynfield-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'land-extra-cb-dyn-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="filter-box-input relative-input">
                                                    <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                </div>
                                            </template>
                                            <template v-else-if="item.type === 'feature_group'">
                                                <div class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'land-extra-ft-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                        <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                        <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ featureItem.name }}</span>
                                                    </label>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>


                        <template v-else-if="isCommercialFilterMode">
                            <div class="nf-commercial-filter-layout">
                                <!--                <div class="nf-commercial-context-card">-->
                                <!--                  <i class="ph-light" :class="currentCommercialTypeKey === 'hotel' ? 'ph-bed' : currentCommercialTypeKey === 'cafe' ? 'ph-fork-knife' : currentCommercialTypeKey === 'office' ? 'ph-briefcase' : 'ph-storefront'"></i>-->
                                <!--                  <div>-->
                                <!--                    <strong>{{ commercialTypeLabel }}</strong>-->

                                <!--                  </div>-->
                                <!--                </div>-->

                                <div class="filter-box-item nf-accordion-item nf-commercial-price-card" :class="{ 'nf-collapsed': collapsedSections.price }">
                                    <button type="button" class="nf-accordion-header" @click="toggleSection('price')">
                                        <div class="fbr-title"><i class="ph-light ph-chart-pie"></i>Fiyat</div>
                                        <i class="ph-bold nf-accordion-chevron" :class="collapsedSections.price ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                    </button>
                                    <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections.price">
                                        <div class="nf-commercial-subtitle">Fiyat Aralığı</div>
                                        <div class="filter-toggle-range modern-range nf-range">
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'min_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.min_price)" @input="onPriceInput('min_price', $event)" @focus="openCombo('min_price')" placeholder="En az" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('min_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'min_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in priceOptions" :key="'commercial-cb-pmin-' + option.value" :class="{ selected: String(form.min_price) === String(option.value) }" @mousedown.prevent="selectCombo('min_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'max_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.max_price)" @input="onPriceInput('max_price', $event)" @focus="openCombo('max_price')" placeholder="En çok" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('max_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'max_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in filteredMaxPriceOptions" :key="'commercial-cb-pmax-' + option.value" :class="{ selected: String(form.max_price) === String(option.value) }" @mousedown.prevent="selectCombo('max_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="nf-commercial-price-block" v-if="commercialPriceStatusItems.length">
                                            <div class="nf-commercial-subtitle">Kullanım Durumu</div>
                                            <div class="filter-checkbox-grid">
                                                <button v-for="item in commercialPriceStatusItems" :key="'commercial-price-status-' + item.key" type="button" class="checkbox-btn nf-commercial-toggle-btn" :class="{ active: isCommercialToggleSelected(item) }" @click="toggleCommercialToggleItem(item)">
                                                    <i class="ph-bold" :class="isCommercialToggleSelected(item) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ uiText(item.label) }}</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="nf-commercial-price-block" v-if="commercialPriceOpportunityItems.length">
                                            <div class="nf-commercial-subtitle">Fırsatlar</div>
                                            <div class="filter-checkbox-grid">
                                                <button v-for="item in commercialPriceOpportunityItems" :key="'commercial-price-opportunity-' + item.key" type="button" class="checkbox-btn nf-commercial-toggle-btn" :class="{ active: isCommercialToggleSelected(item) }" @click="toggleCommercialToggleItem(item)">
                                                    <i class="ph-bold" :class="isCommercialToggleSelected(item) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ uiText(item.label) }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="loading" class="filter-loading">
                                    <i class="ph-bold ph-spinner ph-spin"></i> Özellikler yükleniyor...
                                </div>

                                <template v-if="commercialRoomBuilderVisible">
                                    <div class="nf-group-title">Odalar ve Diğer Alanlar</div>

                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['commercial-areas'] }">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('commercial-areas')">
                                            <div class="fbr-title">{{ uiText('Odalar ve Diğer Alanlar') }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['commercial-areas'] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['commercial-areas']">
                                            <div class="nf-commercial-nested-fields">
                                                <div class="nf-commercial-nested-field" v-if="commercialPlanField && commercialPlanOptions.length" :style="{ order: commercialRoomBlockOrder('plan') }">
                                                    <div class="nf-commercial-subtitle">İç Mekan Özellikleri</div>
                                                    <div class="filter-checkbox-grid">
                                                        <label class="checkbox-btn" v-for="opt in commercialPlanOptions" :key="'commercial-plan-' + opt.id" :class="{ active: isCommercialFieldOptionSelected(commercialPlanField, opt.id) }">
                                                            <input type="checkbox" :checked="isCommercialFieldOptionSelected(commercialPlanField, opt.id)" @change="toggleCommercialFieldOption(commercialPlanField, opt.id)">
                                                            <i class="ph-bold" :class="isCommercialFieldOptionSelected(commercialPlanField, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div class="nf-commercial-min-grid" v-if="commercialPartitionSelected && commercialPartitionCountField" :style="{ order: commercialRoomBlockOrder('partition') }">
                                                    <div class="nf-commercial-min-card">
                                                        <span>Bölüm Sayısı</span>
                                                        <div class="nf-stepper-field">
                                                            <button type="button" class="nf-stepper-btn" @click="stepCommercialMinOnlyNumeric(commercialPartitionCountField, -1)"><i class="ph-bold ph-minus"></i></button>
                                                            <input type="text" inputmode="numeric" :value="getNumericRangeVal(commercialPartitionCountField, 'min')" @input="onNumericRangeInput(commercialPartitionCountField, 'min', $event)" class="input" placeholder="En az">
                                                            <button type="button" class="nf-stepper-btn" @click="stepCommercialMinOnlyNumeric(commercialPartitionCountField, 1)"><i class="ph-bold ph-plus"></i></button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="nf-commercial-min-grid" v-if="commercialPartitionSelected && commercialRoomCountField" :style="{ order: commercialRoomBlockOrder('room_count') }">
                                                    <div class="nf-commercial-min-card">
                                                        <span>Oda Sayısı</span>

                                                        <div v-if="isSelectField(commercialRoomCountField)" class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-room-count-' + commercialRoomCountField.id }">
                                                            <div class="nf-combobox-field">
                                                                <input
                                                                    type="text"
                                                                    :value="dynamicFieldLabel(commercialRoomCountField)"
                                                                    readonly
                                                                    @click="toggleCombo('commercial-room-count-' + commercialRoomCountField.id)"
                                                                    placeholder="Seçiniz"
                                                                    class="input nf-combobox-readonly"
                                                                    autocomplete="off"
                                                                >
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-room-count-' + commercialRoomCountField.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-room-count-' + commercialRoomCountField.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(commercialRoomCountField.id)] }" @mousedown.prevent="selectDynField(commercialRoomCountField, '')">Tümü</button>
                                                                <button
                                                                    type="button"
                                                                    class="nf-combobox-item"
                                                                    v-for="opt in commercialRoomCountField.options"
                                                                    :key="'commercial-room-count-' + commercialRoomCountField.id + '-' + opt.id"
                                                                    :class="{ selected: String(form.fields[String(commercialRoomCountField.id)]) === String(opt.id) }"
                                                                    @mousedown.prevent="selectDynField(commercialRoomCountField, String(opt.id))"
                                                                >{{ opt.name }}</button>
                                                            </div>
                                                        </div>

                                                        <div v-else class="nf-stepper-field">
                                                            <button type="button" class="nf-stepper-btn" @click="stepCommercialMinOnlyNumeric(commercialRoomCountField, -1)"><i class="ph-bold ph-minus"></i></button>
                                                            <input type="text" inputmode="numeric" :value="getNumericRangeVal(commercialRoomCountField, 'min')" @input="onNumericRangeInput(commercialRoomCountField, 'min', $event)" class="input" placeholder="En az">
                                                            <button type="button" class="nf-stepper-btn" @click="stepCommercialMinOnlyNumeric(commercialRoomCountField, 1)"><i class="ph-bold ph-plus"></i></button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="nf-commercial-nested-field" v-if="commercialKitchenField" :style="{ order: commercialRoomBlockOrder('kitchen') }">
                                                    <div class="nf-commercial-subtitle">Mutfak Türü</div>
                                                    <div class="filter-checkbox-grid">
                                                        <label class="checkbox-btn" v-for="opt in commercialKitchenField.options" :key="'commercial-kitchen-' + opt.id" :class="{ active: isCommercialFieldOptionSelected(commercialKitchenField, opt.id) }">
                                                            <input type="checkbox" :checked="isCommercialFieldOptionSelected(commercialKitchenField, opt.id)" @change="toggleCommercialFieldOption(commercialKitchenField, opt.id)">
                                                            <i class="ph-bold" :class="isCommercialFieldOptionSelected(commercialKitchenField, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div class="nf-commercial-nested-field" v-if="commercialTeaKitchenField" :style="{ order: commercialRoomBlockOrder('tea_kitchen') }">
                                                    <div class="nf-commercial-subtitle">Çay Ocağı / Mutfak</div>
                                                    <div v-if="isBooleanField(commercialTeaKitchenField)" class="nf-boolean-toggle">
                                                        <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(commercialTeaKitchenField.id)] && form.fields[String(commercialTeaKitchenField.id)] !== booleanFieldValues(commercialTeaKitchenField).noVal }" @click="form.fields[String(commercialTeaKitchenField.id)] = ''">Tümü</button>
                                                        <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(commercialTeaKitchenField.id)] === booleanFieldValues(commercialTeaKitchenField).yesVal }" @click="form.fields[String(commercialTeaKitchenField.id)] = booleanFieldValues(commercialTeaKitchenField).yesVal">Var</button>
                                                        <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(commercialTeaKitchenField.id)] === booleanFieldValues(commercialTeaKitchenField).noVal }" @click="form.fields[String(commercialTeaKitchenField.id)] = booleanFieldValues(commercialTeaKitchenField).noVal">Yok</button>
                                                    </div>
                                                    <div v-else class="filter-checkbox-grid">
                                                        <label class="checkbox-btn" v-for="opt in commercialTeaKitchenField.options" :key="'commercial-tea-kitchen-' + opt.id" :class="{ active: isCommercialFieldOptionSelected(commercialTeaKitchenField, opt.id) }">
                                                            <input type="checkbox" :checked="isCommercialFieldOptionSelected(commercialTeaKitchenField, opt.id)" @change="toggleCommercialFieldOption(commercialTeaKitchenField, opt.id)">
                                                            <i class="ph-bold" :class="isCommercialFieldOptionSelected(commercialTeaKitchenField, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div class="nf-commercial-min-grid" v-if="commercialRoomMinOnlyItems.length" :style="{ order: commercialRoomBlockOrder('min_fields') }">
                                                    <div class="nf-commercial-min-card" v-for="item in commercialRoomMinOnlyItems" :key="'commercial-room-minonly-' + item.key">
                                                        <span>{{ uiText(item.label) }}</span>
                                                        <div class="nf-stepper-field">
                                                            <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepCommercialMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                            <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" class="input" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'">
                                                            <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepCommercialMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </template>

                                <template v-if="commercialBasicItems.length > 0">
                                    <div class="nf-group-title">{{ currentCommercialTypeKey === 'hotel' ? 'Temel Bilgiler' : 'Temel Özellikler' }}</div>

                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['commercial-basic-' + item.key] }" v-for="item in commercialBasicItems" :key="'commercial-basic-' + item.key">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('commercial-basic-' + item.key)">
                                            <div class="fbr-title">{{ item.label }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['commercial-basic-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['commercial-basic-' + item.key]">

                                            <template v-if="item.type === 'parking_group'">
                                                <div class="nf-parking-grid">
                                                    <div
                                                        class="nf-parking-option"
                                                        v-for="parking in item.options"
                                                        :key="item.key + '-' + parking.key"
                                                        :class="{ active: isParkingOptionSelected(parking) }"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="checkbox-btn nf-parking-toggle-btn"
                                                            :class="{ active: isParkingOptionSelected(parking) }"
                                                            @click="toggleParkingOption(parking)"
                                                        >
                                                            <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ parking.label }}</span>
                                                        </button>

                                                        <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                            <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                    <input
                                                                        type="text"
                                                                        inputmode="numeric"
                                                                        :value="getNumericRangeVal(parking.countField, 'min')"
                                                                        @input="onParkingCountInput(parking, $event)"
                                                                        placeholder="En az"
                                                                        class="input"
                                                                        autocomplete="off"
                                                                    >
                                                                    <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                            <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'field'">
                                                <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                    <div class="filter-checkbox-grid">
                                                        <button
                                                            v-for="opt in item.field.options"
                                                            :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                            type="button"
                                                            class="checkbox-btn"
                                                            :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                            @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                        >
                                                            <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </button>
                                                    </div>

                                                    <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                        <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                    <div class="nf-year-range-grid">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'min')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    :placeholder="uiText('En Az')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'max')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    :placeholder="uiText('En Çok')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                        <div class="nf-combobox-label">En geç teslim yılı</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                </div>
                                                <div v-else-if="item.renderAsCheckboxes || isMultiField(item.field)" class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="opt in item.field.options" :key="'commercial-basic-multi-' + item.field.id + '-' + opt.id" :class="{ active: isCommercialFieldOptionSelected(item.field, opt.id) }">
                                                        <input type="checkbox" :checked="isCommercialFieldOptionSelected(item.field, opt.id)" @change="toggleCommercialFieldOption(item.field, opt.id)">
                                                        <i class="ph-bold" :class="isCommercialFieldOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ opt.name }}</span>
                                                    </label>
                                                </div>
                                                <div v-else-if="isCommercialMinOnlyNumericField(item.field) || item.minOnly" class="filter-box-input">
                                                    <div class="nf-stepper-field">
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepCommercialMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                        <div class="nf-stepper-input-wrap" :class="{ 'has-badge': item.field.unit }">
                                                            <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                            <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                        </div>
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepCommercialMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                    </div>
                                                </div>
                                                <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                    <div class="filter-toggle-range modern-range nf-range">
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-basic-nummin-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('commercial-basic-nummin-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-basic-nummin-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-basic-nummin-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'commercial-basic-nmin-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-basic-nummax-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('commercial-basic-nummax-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-basic-nummax-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-basic-nummax-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'commercial-basic-nmax-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-basic-dynfield-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('commercial-basic-dynfield-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-basic-dynfield-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-basic-dynfield-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'commercial-basic-cb-dyn-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="filter-box-input relative-input">
                                                    <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                </div>
                                            </template>
                                            <template v-else-if="item.type === 'feature_group'">
                                                <div class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'commercial-basic-ft-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                        <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                        <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ featureItem.name }}</span>
                                                    </label>
                                                </div>
                                            </template>

                                        </div>
                                    </div>
                                </template>

                                <template v-if="commercialPropertyItems.length > 0 || (currentCommercialTypeKey !== 'hotel' && ownerTypeOptions.length > 0)">
                                    <div class="nf-group-title">Mülk Bilgileri</div>
                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['commercial-prop-' + item.key] }" v-for="item in commercialPropertyItems" :key="'commercial-prop-' + item.key">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('commercial-prop-' + item.key)">
                                            <div class="fbr-title">{{ item.label }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['commercial-prop-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['commercial-prop-' + item.key]">

                                            <template v-if="item.type === 'parking_group'">
                                                <div class="nf-parking-grid">
                                                    <div
                                                        class="nf-parking-option"
                                                        v-for="parking in item.options"
                                                        :key="item.key + '-' + parking.key"
                                                        :class="{ active: isParkingOptionSelected(parking) }"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="checkbox-btn nf-parking-toggle-btn"
                                                            :class="{ active: isParkingOptionSelected(parking) }"
                                                            @click="toggleParkingOption(parking)"
                                                        >
                                                            <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ parking.label }}</span>
                                                        </button>

                                                        <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                            <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                    <input
                                                                        type="text"
                                                                        inputmode="numeric"
                                                                        :value="getNumericRangeVal(parking.countField, 'min')"
                                                                        @input="onParkingCountInput(parking, $event)"
                                                                        placeholder="En az"
                                                                        class="input"
                                                                        autocomplete="off"
                                                                    >
                                                                    <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                            <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'field'">
                                                <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                    <div class="filter-checkbox-grid">
                                                        <button
                                                            v-for="opt in item.field.options"
                                                            :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                            type="button"
                                                            class="checkbox-btn"
                                                            :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                            @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                        >
                                                            <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </button>
                                                    </div>

                                                    <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                        <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                    <div class="nf-year-range-grid">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'min')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    :placeholder="uiText('En Az')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'max')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    :placeholder="uiText('En Çok')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                        <div class="nf-combobox-label">En geç teslim yılı</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                </div>
                                                <div v-else-if="item.renderAsCheckboxes || isMultiField(item.field)" class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="opt in item.field.options" :key="'commercial-prop-multi-' + item.field.id + '-' + opt.id" :class="{ active: isCommercialFieldOptionSelected(item.field, opt.id) }">
                                                        <input type="checkbox" :checked="isCommercialFieldOptionSelected(item.field, opt.id)" @change="toggleCommercialFieldOption(item.field, opt.id)">
                                                        <i class="ph-bold" :class="isCommercialFieldOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ opt.name }}</span>
                                                    </label>
                                                </div>
                                                <div v-else-if="isCommercialMinOnlyNumericField(item.field) || item.minOnly" class="filter-box-input">
                                                    <div class="nf-stepper-field">
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepCommercialMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                        <div class="nf-stepper-input-wrap" :class="{ 'has-badge': item.field.unit }">
                                                            <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                            <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                        </div>
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepCommercialMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                    </div>
                                                </div>
                                                <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                    <div class="filter-toggle-range modern-range nf-range">
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-prop-nummin-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('commercial-prop-nummin-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-prop-nummin-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-prop-nummin-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'commercial-prop-nmin-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-prop-nummax-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('commercial-prop-nummax-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-prop-nummax-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-prop-nummax-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'commercial-prop-nmax-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-prop-dynfield-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('commercial-prop-dynfield-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-prop-dynfield-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-prop-dynfield-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'commercial-prop-cb-dyn-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="filter-box-input relative-input">
                                                    <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                </div>
                                            </template>
                                            <template v-else-if="item.type === 'feature_group'">
                                                <div class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'commercial-prop-ft-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                        <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                        <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ featureItem.name }}</span>
                                                    </label>
                                                </div>
                                            </template>

                                        </div>
                                    </div>

                                    <div v-if="currentCommercialTypeKey !== 'hotel'" class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['commercial-owner'] }">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('commercial-owner')">
                                            <div class="fbr-title"><i class="ph-light ph-user-list"></i>Kimden</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['commercial-owner'] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['commercial-owner']">
                                            <div class="filter-checkbox-grid">
                                                <label class="checkbox-btn" v-for="option in ownerTypeOptions" :key="'commercial-owner-' + option.value" :class="{ active: form.owner_types.includes(option.value) }">
                                                    <input type="checkbox" :value="option.value" v-model="form.owner_types">
                                                    <i class="ph-bold" :class="form.owner_types.includes(option.value) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ option.label }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="commercialSocialFeatureGroups.length > 0">
                                    <div class="nf-group-title">Sosyal & Teknik Özellikler</div>
                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['commercial-social-' + group.id] }" v-for="group in commercialSocialFeatureGroups" :key="'commercial-social-' + group.id">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('commercial-social-' + group.id)">
                                            <div class="fbr-title">{{ group.name }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['commercial-social-' + group.id] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['commercial-social-' + group.id]">
                                            <div class="filter-checkbox-grid">
                                                <label class="checkbox-btn" v-for="item in group.items" :key="'commercial-social-ft-' + group.id + '-' + item.id" :class="{ active: form.feature_value_ids.includes(Number(item.id)) }">
                                                    <input type="checkbox" :value="Number(item.id)" v-model="form.feature_value_ids">
                                                    <i class="ph-bold" :class="form.feature_value_ids.includes(Number(item.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ item.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="commercialRemainingItems.length > 0">
                                    <div class="nf-group-title">Diğer Filtreler</div>
                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['commercial-extra-' + item.key] }" v-for="item in commercialRemainingItems" :key="'commercial-extra-' + item.key">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('commercial-extra-' + item.key)">
                                            <div class="fbr-title">{{ item.label }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['commercial-extra-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['commercial-extra-' + item.key]">

                                            <template v-if="item.type === 'parking_group'">
                                                <div class="nf-parking-grid">
                                                    <div
                                                        class="nf-parking-option"
                                                        v-for="parking in item.options"
                                                        :key="item.key + '-' + parking.key"
                                                        :class="{ active: isParkingOptionSelected(parking) }"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="checkbox-btn nf-parking-toggle-btn"
                                                            :class="{ active: isParkingOptionSelected(parking) }"
                                                            @click="toggleParkingOption(parking)"
                                                        >
                                                            <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ parking.label }}</span>
                                                        </button>

                                                        <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                            <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                    <input
                                                                        type="text"
                                                                        inputmode="numeric"
                                                                        :value="getNumericRangeVal(parking.countField, 'min')"
                                                                        @input="onParkingCountInput(parking, $event)"
                                                                        placeholder="En az"
                                                                        class="input"
                                                                        autocomplete="off"
                                                                    >
                                                                    <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                            <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'field'">
                                                <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                    <div class="filter-checkbox-grid">
                                                        <button
                                                            v-for="opt in item.field.options"
                                                            :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                            type="button"
                                                            class="checkbox-btn"
                                                            :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                            @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                        >
                                                            <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </button>
                                                    </div>

                                                    <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                        <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                    <div class="nf-year-range-grid">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'min')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    :placeholder="uiText('En Az')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'max')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    :placeholder="uiText('En Çok')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                        <div class="nf-combobox-label">En geç teslim yılı</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                </div>
                                                <div v-else-if="item.renderAsCheckboxes || isMultiField(item.field)" class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="opt in item.field.options" :key="'commercial-extra-multi-' + item.field.id + '-' + opt.id" :class="{ active: isCommercialFieldOptionSelected(item.field, opt.id) }">
                                                        <input type="checkbox" :checked="isCommercialFieldOptionSelected(item.field, opt.id)" @change="toggleCommercialFieldOption(item.field, opt.id)">
                                                        <i class="ph-bold" :class="isCommercialFieldOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ opt.name }}</span>
                                                    </label>
                                                </div>
                                                <div v-else-if="isCommercialMinOnlyNumericField(item.field) || item.minOnly" class="filter-box-input">
                                                    <div class="nf-stepper-field">
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepCommercialMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                        <div class="nf-stepper-input-wrap" :class="{ 'has-badge': item.field.unit }">
                                                            <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                            <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                        </div>
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepCommercialMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                    </div>
                                                </div>
                                                <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                    <div class="filter-toggle-range modern-range nf-range">
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-extra-nummin-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('commercial-extra-nummin-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-extra-nummin-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-extra-nummin-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'commercial-extra-nmin-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-extra-nummax-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('commercial-extra-nummax-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-extra-nummax-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-extra-nummax-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'commercial-extra-nmax-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'commercial-extra-dynfield-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('commercial-extra-dynfield-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('commercial-extra-dynfield-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'commercial-extra-dynfield-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'commercial-extra-cb-dyn-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="filter-box-input relative-input">
                                                    <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                </div>
                                            </template>
                                            <template v-else-if="item.type === 'feature_group'">
                                                <div class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'commercial-extra-ft-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                        <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                        <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ featureItem.name }}</span>
                                                    </label>
                                                </div>
                                            </template>

                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>

                        <template v-else-if="isProjectFilterMode">
                            <div class="nf-project-filter-layout">
                                <!--                <div class="nf-project-context-card">-->
                                <!--                  <i class="ph-light" :class="currentProjectTypeKey === 'villa' ? 'ph-house-line' : 'ph-buildings'"></i>-->
                                <!--                  <div>-->
                                <!--                    <strong>{{ projectTypeLabel }}</strong>-->
                                <!--                  </div>-->
                                <!--                </div>-->

                                <!-- Proje: Fiyat bölümü her zaman üstte -->
                                <div class="filter-box-item nf-accordion-item nf-project-price-card" :class="{ 'nf-collapsed': collapsedSections.price }">
                                    <button type="button" class="nf-accordion-header" @click="toggleSection('price')">
                                        <div class="fbr-title"><i class="ph-light ph-chart-pie"></i>Fiyat</div>
                                        <i class="ph-bold nf-accordion-chevron" :class="collapsedSections.price ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                    </button>
                                    <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections.price">
                                        <div class="nf-project-subtitle">Fiyat Aralığı (Tüm Üniteler)</div>
                                        <div class="filter-toggle-range modern-range nf-range">
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'min_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.min_price)" @input="onPriceInput('min_price', $event)" @focus="openCombo('min_price')" placeholder="En az" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('min_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'min_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in priceOptions" :key="'project-cb-pmin-' + option.value" :class="{ selected: String(form.min_price) === String(option.value) }" @mousedown.prevent="selectCombo('min_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'max_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.max_price)" @input="onPriceInput('max_price', $event)" @focus="openCombo('max_price')" placeholder="En çok" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('max_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'max_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in filteredMaxPriceOptions" :key="'project-cb-pmax-' + option.value" :class="{ selected: String(form.max_price) === String(option.value) }" @mousedown.prevent="selectCombo('max_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="nf-project-price-block" v-if="projectPriceStatusItems.length">
                                            <div class="nf-project-subtitle">Kullanım Durumu</div>
                                            <div class="filter-checkbox-grid">
                                                <button
                                                    v-for="item in projectPriceStatusItems"
                                                    :key="'project-price-status-' + item.key"
                                                    type="button"
                                                    class="checkbox-btn nf-project-toggle-btn"
                                                    :class="{ active: isProjectToggleSelected(item) }"
                                                    @click="toggleProjectToggleItem(item)"
                                                >
                                                    <i class="ph-bold" :class="isProjectToggleSelected(item) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ uiText(item.label) }}</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="nf-project-price-block" v-if="projectPriceOpportunityItems.length">
                                            <div class="nf-project-subtitle">Fırsatlar</div>
                                            <div class="filter-checkbox-grid">
                                                <button
                                                    v-for="item in projectPriceOpportunityItems"
                                                    :key="'project-price-opportunity-' + item.key"
                                                    type="button"
                                                    class="checkbox-btn nf-project-toggle-btn"
                                                    :class="{ active: isProjectToggleSelected(item) }"
                                                    @click="toggleProjectToggleItem(item)"
                                                >
                                                    <i class="ph-bold" :class="isProjectToggleSelected(item) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ uiText(item.label) }}</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="nf-project-price-block" v-if="projectInstallmentSelected && projectInstallmentTermItems.length">
                                            <div class="nf-project-subtitle">Taksit Bilgileri</div>
                                            <div class="nf-filter-installment-stack nf-installment-input-stack">
                                                <div
                                                    class="nf-installment-term-input"
                                                    v-for="item in projectInstallmentTermItems"
                                                    :key="'project-installment-term-' + item.key"
                                                >
                                                    <div class="nf-installment-term-head">
                                                        <strong>{{ item.label }}</strong>
                                                        <small>En az vade süresi giriniz</small>
                                                    </div>

                                                    <div class="nf-stepper-field nf-installment-min-field">
                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                        <div class="nf-stepper-input-wrap" :class="{ 'has-badge': installmentFieldUnit(item.field, item.label) }">
                                                            <input
                                                                type="text"
                                                                inputmode="numeric"
                                                                :value="getNumericRangeVal(item.field, 'min')"
                                                                @input="onNumericRangeInput(item.field, 'min', $event)"
                                                                class="input"
                                                                placeholder="En az"
                                                                autocomplete="off"
                                                            >
                                                            <span v-if="installmentFieldUnit(item.field, item.label)" class="unit-badge">{{ installmentFieldUnit(item.field, item.label) }}</span>
                                                        </div>
                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                    </div>

                                                    <button
                                                        type="button"
                                                        class="nf-installment-term-clear nf-installment-input-clear"
                                                        v-if="getNumericRangeVal(item.field, 'min')"
                                                        @click="clearProjectInstallmentTermField(item.field)"
                                                    >
                                                        Temizle
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="loading" class="filter-loading">
                                    <i class="ph-bold ph-spinner ph-spin"></i> Özellikler yükleniyor...
                                </div>

                                <!-- Odalar: fiyat bölümünün hemen altında gösterilir. -->
                                <template v-if="projectRoomBuilderVisible">
                                    <div class="nf-group-title">Odalar ve Diğer Alanlar</div>

                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['project-rooms'] }">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('project-rooms')">
                                            <div class="fbr-title">{{ ['office', 'shop'].includes(currentProjectTypeKey) ? 'Odalar ve Diğer Alanlar' : 'Odalar' }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['project-rooms'] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['project-rooms']">
                                            <div class="nf-room-builder">
                                                <div class="nf-room-counter-frame" v-if="projectRoomCounterVisible">
                                                    <div class="nf-room-counter-head">
                                                        <strong>{{ uiText('Oda Aralığı') }}</strong>
                                                        <small>{{ uiText('En çok değerler, aynı alanın en az değeriyle eşit veya daha yüksek olmalı.') }}</small>
                                                    </div>

                                                    <div class="nf-room-range-grid">
                                                        <div class="nf-room-range-card" v-if="projectBedroomCounterVisible || projectSalonCounterVisible">
                                                            <div class="nf-room-range-title">{{ uiText('En Az') }}</div>
                                                            <div class="nf-room-range-fields">
                                                                <div class="nf-room-counter" v-if="projectBedroomCounterVisible">
                                                                    <span>{{ uiText('Yatak Odası') }}</span>
                                                                    <div class="nf-stepper-field">
                                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectRoomCounter('bedrooms', 'min', -1)"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="projectRoomCounterValue('bedrooms', 'min')" @input="onProjectRoomCounterInput('bedrooms', 'min', $event)" class="input" placeholder="0">
                                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectRoomCounter('bedrooms', 'min', 1)"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>

                                                                <div class="nf-room-counter" v-if="projectSalonCounterVisible">
                                                                    <span>{{ uiText('Salon') }}</span>
                                                                    <div class="nf-stepper-field">
                                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectRoomCounter('living_rooms', 'min', -1)"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="projectRoomCounterValue('living_rooms', 'min')" @input="onProjectRoomCounterInput('living_rooms', 'min', $event)" class="input" placeholder="0">
                                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectRoomCounter('living_rooms', 'min', 1)"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-room-range-card" v-if="projectBedroomCounterVisible || projectSalonCounterVisible">
                                                            <div class="nf-room-range-title">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-room-range-fields">
                                                                <div class="nf-room-counter" v-if="projectBedroomCounterVisible" :class="{ 'has-warning': projectRoomCounterConstraintMessage('bedrooms') }">
                                                                    <span>{{ uiText('Yatak Odası') }}</span>
                                                                    <div class="nf-stepper-field">
                                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectRoomCounter('bedrooms', 'max', -1)"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="projectRoomCounterValue('bedrooms', 'max')" @input="onProjectRoomCounterInput('bedrooms', 'max', $event)" class="input" placeholder="0">
                                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectRoomCounter('bedrooms', 'max', 1)"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                    <small class="nf-room-warning" v-if="projectRoomCounterConstraintMessage('bedrooms')">{{ projectRoomCounterConstraintMessage('bedrooms') }}</small>
                                                                </div>

                                                                <div class="nf-room-counter" v-if="projectSalonCounterVisible" :class="{ 'has-warning': projectRoomCounterConstraintMessage('living_rooms') }">
                                                                    <span>{{ uiText('Salon') }}</span>
                                                                    <div class="nf-stepper-field">
                                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectRoomCounter('living_rooms', 'max', -1)"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="projectRoomCounterValue('living_rooms', 'max')" @input="onProjectRoomCounterInput('living_rooms', 'max', $event)" class="input" placeholder="0">
                                                                        <button type="button" class="nf-stepper-btn" @click="stepProjectRoomCounter('living_rooms', 'max', 1)"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                    <small class="nf-room-warning" v-if="projectRoomCounterConstraintMessage('living_rooms')">{{ projectRoomCounterConstraintMessage('living_rooms') }}</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="nf-room-dropdowns" v-if="projectRoomPresetVisible">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-room-min' }">
                                                        <div class="nf-combobox-label">{{ uiText('En az oda') }}</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectRoomPresetLabel('min')" readonly @click="toggleCombo('project-room-min')" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-room-min')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'project-room-min'">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectRoomPresetValue('min') }" @mousedown.prevent="setProjectRoomPreset('min', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="option in projectRoomOptions" :key="'project-room-min-' + option.id" :class="{ selected: String(projectRoomPresetValue('min')) === String(option.id) }" @mousedown.prevent="setProjectRoomPreset('min', option.id, option.name)">{{ option.name }}</button>
                                                        </div>
                                                    </div>
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-room-max' }">
                                                        <div class="nf-combobox-label">{{ uiText('En çok oda') }}</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectRoomPresetLabel('max')" readonly @click="toggleCombo('project-room-max')" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-room-max')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'project-room-max'">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectRoomPresetValue('max') }" @mousedown.prevent="setProjectRoomPreset('max', '')">Tümü</button>
                                                            <button
                                                                type="button"
                                                                class="nf-combobox-item"
                                                                v-for="option in projectRoomOptions"
                                                                :key="'project-room-max-' + option.id"
                                                                :disabled="isRoomMaxOptionDisabled(projectRoomOptions, option, projectRoomPresetValue('min'))"
                                                                :class="{
                                                                    selected: String(projectRoomPresetValue('max')) === String(option.id),
                                                                    disabled: isRoomMaxOptionDisabled(projectRoomOptions, option, projectRoomPresetValue('min'))
                                                                }"
                                                                @mousedown.prevent="setProjectRoomPreset('max', option.id, option.name)"
                                                            >{{ option.name }}</button>
                                                        </div>
                                                    </div>
                                                    <div class="nf-room-range-warning" v-if="roomPresetConstraintMessage(projectRoomOptions, projectRoomPresetValue('min'), projectRoomPresetValue('max'))">
                                                        <i class="ph-fill ph-info"></i>
                                                        <span>{{ roomPresetConstraintMessage(projectRoomOptions, projectRoomPresetValue('min'), projectRoomPresetValue('max')) }}</span>
                                                    </div>
                                                </div>

                                                <div class="nf-project-nested-fields" v-if="(projectCommercialPlanField && projectCommercialPlanOptions.length) || projectKitchenField || projectRoomMinOnlyItems.length || (projectCommercialPartitionSelected && projectPartitionCountField)">
                                                    <div class="nf-project-nested-field" v-if="projectCommercialPlanField && projectCommercialPlanOptions.length">
                                                        <div class="nf-project-subtitle">İç Mekan Özellikleri</div>
                                                        <div class="filter-checkbox-grid">
                                                            <label class="checkbox-btn" v-for="opt in projectCommercialPlanOptions" :key="'project-plan-' + opt.id" :class="{ active: isProjectFieldOptionSelected(projectCommercialPlanField, opt.id) }">
                                                                <input type="checkbox" :checked="isProjectFieldOptionSelected(projectCommercialPlanField, opt.id)" @change="setProjectSingleFieldOption(projectCommercialPlanField, opt.id, $event.target.checked)">
                                                                <i class="ph-bold" :class="isProjectFieldOptionSelected(projectCommercialPlanField, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                                <span>{{ opt.name }}</span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div class="nf-project-min-grid" v-if="projectCommercialPartitionSelected && projectPartitionCountField">
                                                        <div class="nf-project-min-card">
                                                            <span>Bölüm Sayısı</span>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepProjectMinOnlyNumeric(projectPartitionCountField, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(projectPartitionCountField, 'min')" @input="onNumericRangeInput(projectPartitionCountField, 'min', $event)" class="input" placeholder="En az">
                                                                <button type="button" class="nf-stepper-btn" @click="stepProjectMinOnlyNumeric(projectPartitionCountField, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="nf-project-nested-field" v-if="projectKitchenField">
                                                        <div class="nf-project-subtitle">Mutfak Türü</div>
                                                        <div class="filter-checkbox-grid">
                                                            <label class="checkbox-btn" v-for="opt in projectKitchenField.options" :key="'project-kitchen-' + opt.id" :class="{ active: isFieldArrayValueSelected(projectKitchenField, opt.id) }">
                                                                <input type="checkbox" :checked="isFieldArrayValueSelected(projectKitchenField, opt.id)" @change="toggleFieldArrayValue(projectKitchenField, opt.id)">
                                                                <i class="ph-bold" :class="isFieldArrayValueSelected(projectKitchenField, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                                <span>{{ opt.name }}</span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div class="nf-project-min-grid">
                                                        <div class="nf-project-min-card" v-for="item in projectRoomMinOnlyItems" :key="'project-room-minonly-' + item.key">
                                                            <span>{{ uiText(item.label) }}</span>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepProjectMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" class="input" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'">
                                                                <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepProjectMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </template>

                                <!-- Metrekare ve temel özellikler oda seçiminden sonra gelir. -->
                                <template v-if="projectBasicItems.length > 0">
                                    <div class="nf-group-title">Temel Özellikler</div>

                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['project-basic-' + item.key] }" v-for="item in projectBasicItems" :key="'project-basic-' + item.key">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('project-basic-' + item.key)">
                                            <div class="fbr-title">{{ item.label }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['project-basic-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['project-basic-' + item.key]">
                                            <template v-if="item.type === 'project_unit_area'">
                                                <div class="filter-toggle-range modern-range nf-range">
                                                    <div class="nf-combobox">
                                                        <div class="nf-combobox-field has-badge">
                                                            <input type="text" inputmode="numeric" :value="projectUnitAreaValue('min')" @input="onProjectUnitAreaInput('min', $event)" placeholder="En az" class="input" autocomplete="off">
                                                            <span class="unit-badge">m²</span>
                                                        </div>
                                                    </div>
                                                    <div class="nf-combobox">
                                                        <div class="nf-combobox-field has-badge">
                                                            <input type="text" inputmode="numeric" :value="projectUnitAreaValue('max')" @input="onProjectUnitAreaInput('max', $event)" placeholder="En çok" class="input" autocomplete="off">
                                                            <span class="unit-badge">m²</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'parking_group'">
                                                <div class="nf-parking-grid">
                                                    <div
                                                        class="nf-parking-option"
                                                        v-for="parking in item.options"
                                                        :key="item.key + '-' + parking.key"
                                                        :class="{ active: isParkingOptionSelected(parking) }"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="checkbox-btn nf-parking-toggle-btn"
                                                            :class="{ active: isParkingOptionSelected(parking) }"
                                                            @click="toggleParkingOption(parking)"
                                                        >
                                                            <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ parking.label }}</span>
                                                        </button>

                                                        <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                            <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                    <input
                                                                        type="text"
                                                                        inputmode="numeric"
                                                                        :value="getNumericRangeVal(parking.countField, 'min')"
                                                                        @input="onParkingCountInput(parking, $event)"
                                                                        placeholder="En az"
                                                                        class="input"
                                                                        autocomplete="off"
                                                                    >
                                                                    <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                            <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'field'">
                                                <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                    <div class="filter-checkbox-grid">
                                                        <button
                                                            v-for="opt in item.field.options"
                                                            :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                            type="button"
                                                            class="checkbox-btn"
                                                            :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                            @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                        >
                                                            <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </button>
                                                    </div>

                                                    <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                        <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                    <div class="nf-year-range-grid">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'min')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    :placeholder="uiText('En Az')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'max')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    :placeholder="uiText('En Çok')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                        <div class="nf-combobox-label">En geç teslim yılı</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                </div>
                                                <div v-else-if="item.renderAsCheckboxes || isProjectPdfMultipleChoiceField(item.field) || isMultiField(item.field)" class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="opt in item.field.options" :key="'project-basic-multi-' + item.field.id + '-' + opt.id" :class="{ active: isFieldArrayValueSelected(item.field, opt.id) }">
                                                        <input type="checkbox" :checked="isFieldArrayValueSelected(item.field, opt.id)" @change="toggleFieldArrayValue(item.field, opt.id)">
                                                        <i class="ph-bold" :class="isFieldArrayValueSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ opt.name }}</span>
                                                    </label>
                                                </div>
                                                <div v-else-if="isProjectMinOnlyNumericField(item.field)" class="filter-box-input">
                                                    <div class="nf-stepper-field">
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepProjectMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                        <div class="nf-stepper-input-wrap" :class="{ 'has-badge': item.field.unit }">
                                                            <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                            <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                        </div>
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepProjectMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                    </div>
                                                </div>
                                                <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                    <div class="filter-toggle-range modern-range nf-range">
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-nummin-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('project-nummin-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-nummin-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'project-nummin-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'project-nmin-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-nummax-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('project-nummax-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-nummax-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'project-nummax-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'project-nmax-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-dynfield-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('project-dynfield-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-dynfield-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'project-dynfield-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'project-cb-dyn-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="filter-box-input relative-input">
                                                    <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                </div>
                                            </template>
                                            <template v-else-if="item.type === 'feature_group'">
                                                <div class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'project-basic-ft-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                        <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                        <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ featureItem.name }}</span>
                                                    </label>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>

                                <!-- Mülk Bilgileri -->
                                <template v-if="projectPropertyItems.length > 0 || ownerTypeOptions.length > 0">
                                    <div class="nf-group-title">Mülk Bilgileri</div>
                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['project-prop-' + item.key] }" v-for="item in projectPropertyItems" :key="'project-prop-' + item.key">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('project-prop-' + item.key)">
                                            <div class="fbr-title">{{ item.label }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['project-prop-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['project-prop-' + item.key]">
                                            <template v-if="item.type === 'parking_group'">
                                                <div class="nf-parking-grid">
                                                    <div
                                                        class="nf-parking-option"
                                                        v-for="parking in item.options"
                                                        :key="item.key + '-' + parking.key"
                                                        :class="{ active: isParkingOptionSelected(parking) }"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="checkbox-btn nf-parking-toggle-btn"
                                                            :class="{ active: isParkingOptionSelected(parking) }"
                                                            @click="toggleParkingOption(parking)"
                                                        >
                                                            <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ parking.label }}</span>
                                                        </button>

                                                        <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                            <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                    <input
                                                                        type="text"
                                                                        inputmode="numeric"
                                                                        :value="getNumericRangeVal(parking.countField, 'min')"
                                                                        @input="onParkingCountInput(parking, $event)"
                                                                        placeholder="En az"
                                                                        class="input"
                                                                        autocomplete="off"
                                                                    >
                                                                    <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                            <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'field'">
                                                <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                    <div class="filter-checkbox-grid">
                                                        <button
                                                            v-for="opt in item.field.options"
                                                            :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                            type="button"
                                                            class="checkbox-btn"
                                                            :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                            @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                        >
                                                            <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </button>
                                                    </div>

                                                    <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                        <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                    <div class="nf-year-range-grid">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'min')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    :placeholder="uiText('En Az')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'max')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    :placeholder="uiText('En Çok')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                        <div class="nf-combobox-label">En geç teslim yılı</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                </div>
                                                <div v-else-if="item.renderAsCheckboxes || isProjectPdfMultipleChoiceField(item.field) || isMultiField(item.field)" class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="opt in item.field.options" :key="'project-prop-multi-' + item.field.id + '-' + opt.id" :class="{ active: isFieldArrayValueSelected(item.field, opt.id) }">
                                                        <input type="checkbox" :checked="isFieldArrayValueSelected(item.field, opt.id)" @change="toggleFieldArrayValue(item.field, opt.id)">
                                                        <i class="ph-bold" :class="isFieldArrayValueSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ opt.name }}</span>
                                                    </label>
                                                </div>
                                                <div v-else-if="isProjectMinOnlyNumericField(item.field)" class="filter-box-input">
                                                    <div class="nf-stepper-field">
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepProjectMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                        <div class="nf-stepper-input-wrap" :class="{ 'has-badge': item.field.unit }">
                                                            <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                            <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                        </div>
                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepProjectMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                    </div>
                                                </div>
                                                <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                    <div class="filter-toggle-range modern-range nf-range">
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-prop-nummin-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('project-prop-nummin-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-prop-nummin-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'project-prop-nummin-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'project-prop-nmin-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-prop-nummax-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('project-prop-nummax-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-prop-nummax-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'project-prop-nummax-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'project-prop-nmax-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-prop-dynfield-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('project-prop-dynfield-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-prop-dynfield-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'project-prop-dynfield-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'project-prop-cb-dyn-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="filter-box-input relative-input">
                                                    <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                </div>
                                            </template>
                                            <template v-else-if="item.type === 'feature_group'">
                                                <div class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'project-prop-ft-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                        <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                        <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ featureItem.name }}</span>
                                                    </label>
                                                </div>
                                            </template>
                                        </div>
                                    </div>

                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['project-owner'] }">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('project-owner')">
                                            <div class="fbr-title"><i class="ph-light ph-user-list"></i>Kimden</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['project-owner'] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['project-owner']">
                                            <div class="filter-checkbox-grid">
                                                <label class="checkbox-btn" v-for="option in ownerTypeOptions" :key="'project-owner-' + option.value" :class="{ active: form.owner_types.includes(option.value) }">
                                                    <input type="checkbox" :value="option.value" v-model="form.owner_types">
                                                    <i class="ph-bold" :class="form.owner_types.includes(option.value) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ option.label }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <!-- Sosyal & Teknik Özellikler -->
                                <template v-if="projectSocialFeatureGroups.length > 0">
                                    <div class="nf-group-title">Sosyal & Teknik Özellikler</div>
                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['project-social-' + group.id] }" v-for="group in projectSocialFeatureGroups" :key="'project-social-' + group.id">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('project-social-' + group.id)">
                                            <div class="fbr-title">{{ group.name }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['project-social-' + group.id] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['project-social-' + group.id]">
                                            <div class="filter-checkbox-grid">
                                                <label class="checkbox-btn" v-for="item in group.items" :key="'project-social-ft-' + group.id + '-' + item.id" :class="{ active: form.feature_value_ids.includes(Number(item.id)) }">
                                                    <input type="checkbox" :value="Number(item.id)" v-model="form.feature_value_ids">
                                                    <i class="ph-bold" :class="form.feature_value_ids.includes(Number(item.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ item.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="projectRemainingItems.length > 0">
                                    <div class="nf-group-title">Diğer Filtreler</div>
                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['project-extra-' + item.key] }" v-for="item in projectRemainingItems" :key="'project-extra-' + item.key">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('project-extra-' + item.key)">
                                            <div class="fbr-title">{{ item.label }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['project-extra-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['project-extra-' + item.key]">
                                            <template v-if="item.type === 'parking_group'">
                                                <div class="nf-parking-grid">
                                                    <div
                                                        class="nf-parking-option"
                                                        v-for="parking in item.options"
                                                        :key="item.key + '-' + parking.key"
                                                        :class="{ active: isParkingOptionSelected(parking) }"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="checkbox-btn nf-parking-toggle-btn"
                                                            :class="{ active: isParkingOptionSelected(parking) }"
                                                            @click="toggleParkingOption(parking)"
                                                        >
                                                            <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ parking.label }}</span>
                                                        </button>

                                                        <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                            <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                    <input
                                                                        type="text"
                                                                        inputmode="numeric"
                                                                        :value="getNumericRangeVal(parking.countField, 'min')"
                                                                        @input="onParkingCountInput(parking, $event)"
                                                                        placeholder="En az"
                                                                        class="input"
                                                                        autocomplete="off"
                                                                    >
                                                                    <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                            <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'field'">
                                                <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                    <div class="filter-checkbox-grid">
                                                        <button
                                                            v-for="opt in item.field.options"
                                                            :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                            type="button"
                                                            class="checkbox-btn"
                                                            :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                            @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                        >
                                                            <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </button>
                                                    </div>

                                                    <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                        <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                    <div class="nf-year-range-grid">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'min')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    :placeholder="uiText('En Az')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'max')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    :placeholder="uiText('En Çok')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                        <div class="nf-combobox-label">En geç teslim yılı</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                </div>
                                                <div v-else-if="item.renderAsCheckboxes || isProjectPdfMultipleChoiceField(item.field) || isMultiField(item.field)" class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="opt in item.field.options" :key="'project-extra-multi-' + item.field.id + '-' + opt.id" :class="{ active: isFieldArrayValueSelected(item.field, opt.id) }">
                                                        <input type="checkbox" :checked="isFieldArrayValueSelected(item.field, opt.id)" @change="toggleFieldArrayValue(item.field, opt.id)">
                                                        <i class="ph-bold" :class="isFieldArrayValueSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ opt.name }}</span>
                                                    </label>
                                                </div>
                                                <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                    <div class="filter-toggle-range modern-range nf-range">
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-extra-nummin-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('project-extra-nummin-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-extra-nummin-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'project-extra-nummin-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'project-extra-nmin-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-extra-nummax-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('project-extra-nummax-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-extra-nummax-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'project-extra-nummax-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'project-extra-nmax-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-extra-dynfield-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('project-extra-dynfield-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('project-extra-dynfield-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'project-extra-dynfield-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'project-extra-cb-dyn-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="filter-box-input relative-input">
                                                    <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                </div>
                                            </template>
                                            <template v-else-if="item.type === 'feature_group'">
                                                <div class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'project-extra-ft-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                        <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                        <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ featureItem.name }}</span>
                                                    </label>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>



                        <template v-else-if="isResidentialFilterMode">
                            <div class="nf-res-filter-layout">
                                <!--                <div class="nf-res-context-card">-->
                                <!--                  <i class="ph-light" :class="currentResidentialTypeKey === 'villa' ? 'ph-house-line' : 'ph-buildings'"></i>-->
                                <!--                  <div>-->
                                <!--                    <strong>{{ residentialTypeLabel }}</strong>-->
                                <!--                  </div>-->
                                <!--                </div>-->

                                <!-- Proje: Fiyat bölümü her zaman üstte -->
                                <div class="filter-box-item nf-accordion-item nf-res-price-card" :class="{ 'nf-collapsed': collapsedSections.price }">
                                    <button type="button" class="nf-accordion-header" @click="toggleSection('price')">
                                        <div class="fbr-title"><i class="ph-light ph-chart-pie"></i>Fiyat</div>
                                        <i class="ph-bold nf-accordion-chevron" :class="collapsedSections.price ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                    </button>
                                    <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections.price">
                                        <div class="nf-res-subtitle">Fiyat Aralığı</div>
                                        <div class="filter-toggle-range modern-range nf-range">
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'min_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.min_price)" @input="onPriceInput('min_price', $event)" @focus="openCombo('min_price')" placeholder="En az" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('min_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'min_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in priceOptions" :key="'res-cb-pmin-' + option.value" :class="{ selected: String(form.min_price) === String(option.value) }" @mousedown.prevent="selectCombo('min_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'max_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.max_price)" @input="onPriceInput('max_price', $event)" @focus="openCombo('max_price')" placeholder="En çok" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('max_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'max_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in filteredMaxPriceOptions" :key="'res-cb-pmax-' + option.value" :class="{ selected: String(form.max_price) === String(option.value) }" @mousedown.prevent="selectCombo('max_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="nf-res-price-block" v-if="residentialPriceStatusItems.length">
                                            <div class="nf-res-subtitle">Kullanım Durumu</div>
                                            <div class="filter-checkbox-grid">
                                                <button
                                                    v-for="item in residentialPriceStatusItems"
                                                    :key="'res-price-status-' + item.key"
                                                    type="button"
                                                    class="checkbox-btn nf-res-toggle-btn"
                                                    :class="{ active: isResidentialToggleSelected(item) }"
                                                    @click="toggleResidentialToggleItem(item)"
                                                >
                                                    <i class="ph-bold" :class="isResidentialToggleSelected(item) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ uiText(item.label) }}</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div class="nf-res-price-block" v-if="residentialPriceOpportunityItems.length">
                                            <div class="nf-res-subtitle">Fırsatlar</div>
                                            <div class="filter-checkbox-grid">
                                                <button
                                                    v-for="item in residentialPriceOpportunityItems"
                                                    :key="'res-price-opportunity-' + item.key"
                                                    type="button"
                                                    class="checkbox-btn nf-res-toggle-btn"
                                                    :class="{ active: isResidentialToggleSelected(item) }"
                                                    @click="toggleResidentialToggleItem(item)"
                                                >
                                                    <i class="ph-bold" :class="isResidentialToggleSelected(item) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ uiText(item.label) }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="loading" class="filter-loading">
                                    <i class="ph-bold ph-spinner ph-spin"></i> Özellikler yükleniyor...
                                </div>

                                <!-- Konut: Step 3 ilan verme adımıyla uyumlu gruplama -->
                                <template v-if="residentialStep3Sections.length > 0">
                                    <template v-for="section in residentialStep3Sections" :key="'res-step-section-' + section.key">
                                        <div class="nf-group-title">{{ uiText(section.title) }}</div>

                                        <template v-if="section.type === 'rooms'">
                                            <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['res-rooms'] }">
                                                <button type="button" class="nf-accordion-header" @click="toggleSection('res-rooms')">
                                                    <div class="fbr-title">{{ uiText('Odalar ve Diğer Alanlar') }}</div>
                                                    <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['res-rooms'] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                                </button>
                                                <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['res-rooms']">
                                                    <div class="nf-room-builder">
                                                        <div class="nf-room-counter-frame" v-if="residentialRoomRangeVisible">
                                                            <div class="nf-room-counter-head">
                                                                <strong>{{ uiText('Oda Aralığı') }}</strong>
                                                                <small>{{ uiText('En çok değerler, aynı alanın en az değeriyle eşit veya daha yüksek olmalı.') }}</small>
                                                            </div>

                                                            <div class="nf-room-range-grid">
                                                                <div class="nf-room-range-card" v-if="residentialBedroomField || residentialSalonField">
                                                                    <div class="nf-room-range-title">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-room-range-fields">
                                                                        <div class="nf-room-counter" v-if="residentialBedroomField">
                                                                            <span>{{ uiText('Yatak Odası') }}</span>
                                                                            <div class="nf-stepper-field">
                                                                                <button type="button" class="nf-stepper-btn" @click="stepResidentialRangeNumeric(residentialBedroomField, 'min', -1)"><i class="ph-bold ph-minus"></i></button>
                                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(residentialBedroomField, 'min')" @input="onNumericRangeInput(residentialBedroomField, 'min', $event)" class="input" placeholder="0">
                                                                                <button type="button" class="nf-stepper-btn" @click="stepResidentialRangeNumeric(residentialBedroomField, 'min', 1)"><i class="ph-bold ph-plus"></i></button>
                                                                            </div>
                                                                        </div>

                                                                        <div class="nf-room-counter" v-if="residentialSalonField">
                                                                            <span>{{ uiText('Salon') }}</span>
                                                                            <div class="nf-stepper-field">
                                                                                <button type="button" class="nf-stepper-btn" @click="stepResidentialRangeNumeric(residentialSalonField, 'min', -1)"><i class="ph-bold ph-minus"></i></button>
                                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(residentialSalonField, 'min')" @input="onNumericRangeInput(residentialSalonField, 'min', $event)" class="input" placeholder="0">
                                                                                <button type="button" class="nf-stepper-btn" @click="stepResidentialRangeNumeric(residentialSalonField, 'min', 1)"><i class="ph-bold ph-plus"></i></button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="nf-room-range-card" v-if="residentialBedroomField || residentialSalonField">
                                                                    <div class="nf-room-range-title">{{ uiText('En Çok') }}</div>
                                                                    <div class="nf-room-range-fields">
                                                                        <div class="nf-room-counter" v-if="residentialBedroomField" :class="{ 'has-warning': residentialRoomCounterConstraintMessage(residentialBedroomField, 'yatak odası') }">
                                                                            <span>{{ uiText('Yatak Odası') }}</span>
                                                                            <div class="nf-stepper-field">
                                                                                <button type="button" class="nf-stepper-btn" @click="stepResidentialRangeNumeric(residentialBedroomField, 'max', -1)"><i class="ph-bold ph-minus"></i></button>
                                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(residentialBedroomField, 'max')" @input="onNumericRangeInput(residentialBedroomField, 'max', $event)" class="input" placeholder="0">
                                                                                <button type="button" class="nf-stepper-btn" @click="stepResidentialRangeNumeric(residentialBedroomField, 'max', 1)"><i class="ph-bold ph-plus"></i></button>
                                                                            </div>
                                                                            <small class="nf-room-warning" v-if="residentialRoomCounterConstraintMessage(residentialBedroomField, 'yatak odası')">{{ residentialRoomCounterConstraintMessage(residentialBedroomField, 'yatak odası') }}</small>
                                                                        </div>

                                                                        <div class="nf-room-counter" v-if="residentialSalonField" :class="{ 'has-warning': residentialRoomCounterConstraintMessage(residentialSalonField, 'salon') }">
                                                                            <span>{{ uiText('Salon') }}</span>
                                                                            <div class="nf-stepper-field">
                                                                                <button type="button" class="nf-stepper-btn" @click="stepResidentialRangeNumeric(residentialSalonField, 'max', -1)"><i class="ph-bold ph-minus"></i></button>
                                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(residentialSalonField, 'max')" @input="onNumericRangeInput(residentialSalonField, 'max', $event)" class="input" placeholder="0">
                                                                                <button type="button" class="nf-stepper-btn" @click="stepResidentialRangeNumeric(residentialSalonField, 'max', 1)"><i class="ph-bold ph-plus"></i></button>
                                                                            </div>
                                                                            <small class="nf-room-warning" v-if="residentialRoomCounterConstraintMessage(residentialSalonField, 'salon')">{{ residentialRoomCounterConstraintMessage(residentialSalonField, 'salon') }}</small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-room-dropdowns" v-if="residentialRoomPresetVisible">
                                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'res-room-min' }">
                                                                <div class="nf-combobox-label">{{ uiText('En az oda') }}</div>
                                                                <div class="nf-combobox-field">
                                                                    <input type="text" :value="residentialRoomPresetLabel('min')" readonly @click="toggleCombo('res-room-min')" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('res-room-min')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                                </div>
                                                                <div class="nf-combobox-menu" v-if="openDropdown === 'res-room-min'">
                                                                    <button type="button" class="nf-combobox-item" :class="{ selected: !residentialRoomPresetValue('min') }" @mousedown.prevent="setResidentialRoomPreset('min', '')">Tümü</button>
                                                                    <button type="button" class="nf-combobox-item" v-for="option in residentialRoomOptions" :key="'res-room-min-' + option.id" :class="{ selected: String(residentialRoomPresetValue('min')) === String(option.id) }" @mousedown.prevent="setResidentialRoomPreset('min', option.id, option.name)">{{ option.name }}</button>
                                                                </div>
                                                            </div>
                                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'res-room-max' }">
                                                                <div class="nf-combobox-label">{{ uiText('En çok oda') }}</div>
                                                                <div class="nf-combobox-field">
                                                                    <input type="text" :value="residentialRoomPresetLabel('max')" readonly @click="toggleCombo('res-room-max')" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('res-room-max')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                                </div>
                                                                <div class="nf-combobox-menu" v-if="openDropdown === 'res-room-max'">
                                                                    <button type="button" class="nf-combobox-item" :class="{ selected: !residentialRoomPresetValue('max') }" @mousedown.prevent="setResidentialRoomPreset('max', '')">Tümü</button>
                                                                    <button
                                                                        type="button"
                                                                        class="nf-combobox-item"
                                                                        v-for="option in residentialRoomOptions"
                                                                        :key="'res-room-max-' + option.id"
                                                                        :disabled="isRoomMaxOptionDisabled(residentialRoomOptions, option, residentialRoomPresetValue('min'))"
                                                                        :class="{
                                                                            selected: String(residentialRoomPresetValue('max')) === String(option.id),
                                                                            disabled: isRoomMaxOptionDisabled(residentialRoomOptions, option, residentialRoomPresetValue('min'))
                                                                        }"
                                                                        @mousedown.prevent="setResidentialRoomPreset('max', option.id, option.name)"
                                                                    >{{ option.name }}</button>
                                                                </div>
                                                            </div>
                                                            <div class="nf-room-range-warning" v-if="roomPresetConstraintMessage(residentialRoomOptions, residentialRoomPresetValue('min'), residentialRoomPresetValue('max'))">
                                                                <i class="ph-fill ph-info"></i>
                                                                <span>{{ roomPresetConstraintMessage(residentialRoomOptions, residentialRoomPresetValue('min'), residentialRoomPresetValue('max')) }}</span>
                                                            </div>
                                                        </div>

                                                        <div class="nf-res-nested-fields" v-if="residentialKitchenField || residentialRoomMinOnlyItems.length">
                                                            <div class="nf-res-nested-field" v-if="residentialKitchenField">
                                                                <div class="nf-res-subtitle">{{ uiText('Mutfak Türü') }}</div>
                                                                <div class="filter-checkbox-grid">
                                                                    <label class="checkbox-btn" v-for="opt in residentialKitchenField.options" :key="'res-kitchen-' + opt.id" :class="{ active: isFieldArrayValueSelected(residentialKitchenField, opt.id) }">
                                                                        <input type="checkbox" :checked="isFieldArrayValueSelected(residentialKitchenField, opt.id)" @change="toggleFieldArrayValue(residentialKitchenField, opt.id)">
                                                                        <i class="ph-bold" :class="isFieldArrayValueSelected(residentialKitchenField, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                                        <span>{{ opt.name }}</span>
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            <div class="nf-res-min-grid">
                                                                <div class="nf-res-min-card" v-for="item in residentialRoomMinOnlyItems" :key="'res-room-minonly-' + item.key">
                                                                    <span>{{ uiText(item.label) }}</span>
                                                                    <div class="nf-stepper-field">
                                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepResidentialMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" class="input" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'">
                                                                        <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepResidentialMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>

                                        <template v-else-if="section.type === 'social'">
                                            <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['res-social-' + group.key] }" v-for="group in section.groups" :key="'res-social-' + group.key">
                                                <button type="button" class="nf-accordion-header" @click="toggleSection('res-social-' + group.key)">
                                                    <div class="fbr-title">{{ group.name }}</div>
                                                    <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['res-social-' + group.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                                </button>
                                                <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['res-social-' + group.key]">
                                                    <div class="filter-checkbox-grid">
                                                        <label class="checkbox-btn" v-for="item in group.items" :key="'res-social-ft-' + group.key + '-' + item.id" :class="{ active: form.feature_value_ids.includes(Number(item.id)) }">
                                                            <input type="checkbox" :value="Number(item.id)" v-model="form.feature_value_ids">
                                                            <i class="ph-bold" :class="form.feature_value_ids.includes(Number(item.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ item.name }}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>

                                        <template v-else>
                                            <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['res-step-' + section.key + '-' + item.key] }" v-for="item in section.items" :key="'res-step-' + section.key + '-' + item.key">
                                                <button type="button" class="nf-accordion-header" @click="toggleSection('res-step-' + section.key + '-' + item.key)">
                                                    <div class="fbr-title">{{ item.label }}</div>
                                                    <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['res-step-' + section.key + '-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                                </button>
                                                <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['res-step-' + section.key + '-' + item.key]">
                                                    <template v-if="item.type === 'parking_group'">
                                                        <div class="nf-parking-grid">
                                                            <div
                                                                class="nf-parking-option"
                                                                v-for="parking in item.options"
                                                                :key="item.key + '-' + parking.key"
                                                                :class="{ active: isParkingOptionSelected(parking) }"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    class="checkbox-btn nf-parking-toggle-btn"
                                                                    :class="{ active: isParkingOptionSelected(parking) }"
                                                                    @click="toggleParkingOption(parking)"
                                                                >
                                                                    <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                                    <span>{{ parking.label }}</span>
                                                                </button>

                                                                <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                                    <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                                    <div class="nf-stepper-field">
                                                                        <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                        <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                            <input
                                                                                type="text"
                                                                                inputmode="numeric"
                                                                                :value="getNumericRangeVal(parking.countField, 'min')"
                                                                                @input="onParkingCountInput(parking, $event)"
                                                                                placeholder="En az"
                                                                                class="input"
                                                                                autocomplete="off"
                                                                            >
                                                                            <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                        </div>
                                                                        <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                    <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <template v-else-if="item.type === 'owner'">
                                                        <div class="filter-checkbox-grid">
                                                            <label class="checkbox-btn" v-for="option in ownerTypeOptions" :key="'res-owner-' + option.value" :class="{ active: form.owner_types.includes(option.value) }">
                                                                <input type="checkbox" :value="option.value" v-model="form.owner_types">
                                                                <i class="ph-bold" :class="form.owner_types.includes(option.value) ? 'ph-check-square' : 'ph-square'"></i>
                                                                <span>{{ option.label }}</span>
                                                            </label>
                                                        </div>
                                                    </template>

                                                    <template v-else-if="item.type === 'field'">
                                                        <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                            <div class="filter-checkbox-grid">
                                                                <button
                                                                    v-for="opt in item.field.options"
                                                                    :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                                    type="button"
                                                                    class="checkbox-btn"
                                                                    :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                                    @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                                >
                                                                    <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                                    <span>{{ opt.name }}</span>
                                                                </button>
                                                            </div>

                                                            <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                                <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                                    <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                                    <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                        <div class="nf-year-range-item">
                                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                            <div class="nf-year-stepper-field">
                                                                                <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                                <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                                <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                                    <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                                    <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                        <div class="nf-year-range-item">
                                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                            <div class="nf-year-stepper-field">
                                                                                <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                                <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                                <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                            <div class="nf-year-range-grid">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button
                                                                            type="button"
                                                                            class="nf-year-stepper-btn"
                                                                            :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                            @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                            :aria-label="uiText('En Az')"
                                                                        >
                                                                            <i class="ph-bold ph-minus"></i>
                                                                        </button>
                                                                        <input
                                                                            type="text"
                                                                            inputmode="numeric"
                                                                            :value="dynamicYearRangeValue(item.field, 'min')"
                                                                            @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                            @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                            :placeholder="uiText('En Az')"
                                                                            class="input nf-year-stepper-input"
                                                                            autocomplete="off"
                                                                        >
                                                                        <button
                                                                            type="button"
                                                                            class="nf-year-stepper-btn"
                                                                            :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                            @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                            :aria-label="uiText('En Az')"
                                                                        >
                                                                            <i class="ph-bold ph-plus"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button
                                                                            type="button"
                                                                            class="nf-year-stepper-btn"
                                                                            :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                            @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                            :aria-label="uiText('En Çok')"
                                                                        >
                                                                            <i class="ph-bold ph-minus"></i>
                                                                        </button>
                                                                        <input
                                                                            type="text"
                                                                            inputmode="numeric"
                                                                            :value="dynamicYearRangeValue(item.field, 'max')"
                                                                            @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                            @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                            :placeholder="uiText('En Çok')"
                                                                            class="input nf-year-stepper-input"
                                                                            autocomplete="off"
                                                                        >
                                                                        <button
                                                                            type="button"
                                                                            class="nf-year-stepper-btn"
                                                                            :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                            @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                            :aria-label="uiText('En Çok')"
                                                                        >
                                                                            <i class="ph-bold ph-plus"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                                <div class="nf-combobox-field">
                                                                    <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                                </div>
                                                                <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                                    <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                                    <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                                <div class="nf-combobox-label">En geç teslim yılı</div>
                                                                <div class="nf-combobox-field">
                                                                    <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                                    <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                                </div>
                                                                <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                                    <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                                    <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                            <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                            <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                            <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                        </div>
                                                        <div v-else-if="isResidentialYesNoOptionField(item.field)" class="nf-boolean-toggle">
                                                            <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] }" @click="selectDynField(item.field, '')">Tümü</button>
                                                            <button
                                                                v-for="opt in item.field.options"
                                                                :key="'res-step-yesno-' + section.key + '-' + item.field.id + '-' + opt.id"
                                                                type="button"
                                                                class="nf-toggle-btn"
                                                                :class="{ active: String(form.fields[String(item.field.id)] || '') === String(opt.id) }"
                                                                @click="selectDynField(item.field, String(opt.id))"
                                                            >{{ opt.name }}</button>
                                                        </div>
                                                        <div v-else-if="item.renderAsCheckboxes || isResidentialCheckboxOptionField(item.field) || isMultiField(item.field)" class="filter-checkbox-grid">
                                                            <label class="checkbox-btn" v-for="opt in item.field.options" :key="'res-step-multi-' + section.key + '-' + item.field.id + '-' + opt.id" :class="{ active: isFieldArrayValueSelected(item.field, opt.id) }">
                                                                <input type="checkbox" :checked="isFieldArrayValueSelected(item.field, opt.id)" @change="toggleFieldArrayValue(item.field, opt.id)">
                                                                <i class="ph-bold" :class="isFieldArrayValueSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                                <span>{{ opt.name }}</span>
                                                            </label>
                                                        </div>
                                                        <div v-else-if="isResidentialMinOnlyNumericField(item.field) || item.minOnly" class="filter-box-input">
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, -1) : stepResidentialMinOnlyNumeric(item.field, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': item.field.unit }">
                                                                    <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="isCurrentFloorField(item.field) ? stepCurrentFloor(item.field, 1) : stepResidentialMinOnlyNumeric(item.field, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                        </div>
                                                        <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                            <div class="filter-toggle-range modern-range nf-range">
                                                                <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'res-step-nummin-' + section.key + '-' + item.field.id }">
                                                                    <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                        <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('res-step-nummin-' + section.key + '-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                        <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                        <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('res-step-nummin-' + section.key + '-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                                    </div>
                                                                    <div class="nf-combobox-menu" v-if="openDropdown === 'res-step-nummin-' + section.key + '-' + item.field.id">
                                                                        <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                        <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'res-step-nmin-' + section.key + '-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                                    </div>
                                                                </div>
                                                                <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'res-step-nummax-' + section.key + '-' + item.field.id }">
                                                                    <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                        <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('res-step-nummax-' + section.key + '-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                        <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                        <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('res-step-nummax-' + section.key + '-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                                    </div>
                                                                    <div class="nf-combobox-menu" v-if="openDropdown === 'res-step-nummax-' + section.key + '-' + item.field.id">
                                                                        <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                        <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'res-step-nmax-' + section.key + '-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'res-step-dynfield-' + section.key + '-' + item.field.id }">
                                                                <div class="nf-combobox-field">
                                                                    <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('res-step-dynfield-' + section.key + '-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('res-step-dynfield-' + section.key + '-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                                </div>
                                                                <div class="nf-combobox-menu" v-if="openDropdown === 'res-step-dynfield-' + section.key + '-' + item.field.id">
                                                                    <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                                    <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'res-step-cb-dyn-' + section.key + '-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else class="filter-box-input relative-input">
                                                            <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                            <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                        </div>
                                                    </template>

                                                    <template v-else-if="item.type === 'feature_group'">
                                                        <div class="filter-checkbox-grid">
                                                            <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'res-step-ft-' + section.key + '-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                                <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                                <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                                <span>{{ featureItem.name }}</span>
                                                            </label>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </template>

                                <template v-if="residentialRemainingItems.length > 0">
                                    <div class="nf-group-title">Diğer Bilgiler</div>
                                    <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['res-extra-' + item.key] }" v-for="item in residentialRemainingItems" :key="'res-extra-' + item.key">
                                        <button type="button" class="nf-accordion-header" @click="toggleSection('res-extra-' + item.key)">
                                            <div class="fbr-title">{{ item.label }}</div>
                                            <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['res-extra-' + item.key] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                        </button>
                                        <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['res-extra-' + item.key]">
                                            <template v-if="item.type === 'parking_group'">
                                                <div class="nf-parking-grid">
                                                    <div
                                                        class="nf-parking-option"
                                                        v-for="parking in item.options"
                                                        :key="item.key + '-' + parking.key"
                                                        :class="{ active: isParkingOptionSelected(parking) }"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="checkbox-btn nf-parking-toggle-btn"
                                                            :class="{ active: isParkingOptionSelected(parking) }"
                                                            @click="toggleParkingOption(parking)"
                                                        >
                                                            <i class="ph-bold" :class="isParkingOptionSelected(parking) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ parking.label }}</span>
                                                        </button>

                                                        <div class="nf-parking-count" v-if="parking.countField && isParkingOptionSelected(parking)">
                                                            <div class="nf-parking-count-title">{{ parkingCountTitle(parking) }}</div>
                                                            <div class="nf-stepper-field">
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, -1)"><i class="ph-bold ph-minus"></i></button>
                                                                <div class="nf-stepper-input-wrap" :class="{ 'has-badge': parking.countField.unit }">
                                                                    <input
                                                                        type="text"
                                                                        inputmode="numeric"
                                                                        :value="getNumericRangeVal(parking.countField, 'min')"
                                                                        @input="onParkingCountInput(parking, $event)"
                                                                        placeholder="En az"
                                                                        class="input"
                                                                        autocomplete="off"
                                                                    >
                                                                    <span v-if="parking.countField.unit" class="unit-badge">{{ parking.countField.unit }}</span>
                                                                </div>
                                                                <button type="button" class="nf-stepper-btn" @click="stepParkingCount(parking, 1)"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                            <div class="nf-parking-count-help">{{ parkingCountHelp(parking) }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-else-if="item.type === 'field'">
                                                <div v-if="isDynamicPropertyStatusField(item.field)" class="nf-property-status-block">
                                                    <div class="filter-checkbox-grid">
                                                        <button
                                                            v-for="opt in item.field.options"
                                                            :key="'dyn-status-' + item.field.id + '-' + opt.id"
                                                            type="button"
                                                            class="checkbox-btn"
                                                            :class="{ active: isDynamicPropertyStatusOptionSelected(item.field, opt.id) }"
                                                            @click="selectDynamicPropertyStatusOption(item.field, opt.id)"
                                                        >
                                                            <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                            <span>{{ opt.name }}</span>
                                                        </button>
                                                    </div>

                                                    <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(item.field)">
                                                        <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                            <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                            <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                                <div class="nf-year-range-item">
                                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                                    <div class="nf-year-stepper-field">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                        <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                        <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicConstructionYearField(item.field)" class="filter-box-input nf-year-filter-control">
                                                    <div class="nf-year-range-grid">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'min') || Number(dynamicYearRangeValue(item.field, 'min')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', -1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'min')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'min', $event)"
                                                                    :placeholder="uiText('En Az')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'min', 1)"
                                                                    :aria-label="uiText('En Az')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="!dynamicYearRangeValue(item.field, 'max') || Number(dynamicYearRangeValue(item.field, 'max')) <= 1900"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', -1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-minus"></i>
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    inputmode="numeric"
                                                                    :value="dynamicYearRangeValue(item.field, 'max')"
                                                                    @input="onDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    @blur="commitDynamicYearRangeInput(item.field, 'max', $event)"
                                                                    :placeholder="uiText('En Çok')"
                                                                    class="input nf-year-stepper-input"
                                                                    autocomplete="off"
                                                                >
                                                                <button
                                                                    type="button"
                                                                    class="nf-year-stepper-btn"
                                                                    :disabled="Number(dynamicYearRangeValue(item.field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                                    @click="stepDynamicYearRangeField(item.field, 'max', 1)"
                                                                    :aria-label="uiText('En Çok')"
                                                                >
                                                                    <i class="ph-bold ph-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isDynamicRenovationYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dyn-renovation-year-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicYearValue(item.field)" readonly @click="toggleCombo('dyn-renovation-year-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dyn-renovation-year-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'dyn-renovation-year-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(item.field) }" @mousedown.prevent="setDynamicYearField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'dyn-renovation-year-' + item.field.id + '-' + year" :class="{ selected: String(dynamicYearValue(item.field)) === String(year) }" @mousedown.prevent="setDynamicYearField(item.field, year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-else-if="isProjectDeliveryYearField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'project-delivery-max-' + item.field.id }">
                                                        <div class="nf-combobox-label">En geç teslim yılı</div>
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="projectDeliveryYearValue(item.field, 'max')" :disabled="isProjectCompletedSelected()" readonly @click="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" :disabled="isProjectCompletedSelected()" @click.stop="!isProjectCompletedSelected() && toggleCombo('project-delivery-max-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="!isProjectCompletedSelected() && openDropdown === 'project-delivery-max-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !projectDeliveryYearValue(item.field, 'max') }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="year in projectDeliveryYearOptions" :key="'project-delivery-max-' + item.field.id + '-' + year" :class="{ selected: String(projectDeliveryYearValue(item.field, 'max')) === String(year) }" @mousedown.prevent="setProjectDeliveryYear(item.field, 'max', year)">{{ year }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isBooleanField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] && form.fields[String(item.field.id)] !== booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = ''">Tümü</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).yesVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).yesVal">Evet</button>
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(item.field.id)] === booleanFieldValues(item.field).noVal }" @click="form.fields[String(item.field.id)] = booleanFieldValues(item.field).noVal">Hayır</button>
                                                </div>
                                                <div v-else-if="isResidentialYesNoOptionField(item.field)" class="nf-boolean-toggle">
                                                    <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(item.field.id)] }" @click="selectDynField(item.field, '')">Tümü</button>
                                                    <button
                                                        v-for="opt in item.field.options"
                                                        :key="'res-extra-yesno-' + item.field.id + '-' + opt.id"
                                                        type="button"
                                                        class="nf-toggle-btn"
                                                        :class="{ active: String(form.fields[String(item.field.id)] || '') === String(opt.id) }"
                                                        @click="selectDynField(item.field, String(opt.id))"
                                                    >{{ opt.name }}</button>
                                                </div>
                                                <div v-else-if="item.renderAsCheckboxes || isResidentialCheckboxOptionField(item.field) || isMultiField(item.field)" class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="opt in item.field.options" :key="'res-extra-multi-' + item.field.id + '-' + opt.id" :class="{ active: isFieldArrayValueSelected(item.field, opt.id) }">
                                                        <input type="checkbox" :checked="isFieldArrayValueSelected(item.field, opt.id)" @change="toggleFieldArrayValue(item.field, opt.id)">
                                                        <i class="ph-bold" :class="isFieldArrayValueSelected(item.field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ opt.name }}</span>
                                                    </label>
                                                </div>
                                                <div v-else-if="isNumericField(item.field)" class="filter-box-input">
                                                    <div class="filter-toggle-range modern-range nf-range">
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'res-extra-nummin-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="isCurrentFloorField(item.field) ? currentFloorDisplay(item.field) : getNumericRangeVal(item.field, 'min')" @input="isCurrentFloorField(item.field) ? onCurrentFloorInput(item.field, $event) : onNumericRangeInput(item.field, 'min', $event)" @focus="openCombo('res-extra-nummin-' + item.field.id)" :placeholder="isCurrentFloorField(item.field) ? '0 (Zemin Kat)' : 'En az'" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('res-extra-nummin-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'res-extra-nummin-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'min') }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(item.field)" :key="'res-extra-nmin-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                        <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'res-extra-nummax-' + item.field.id }">
                                                            <div class="nf-combobox-field" :class="{ 'has-badge': item.field.unit }">
                                                                <input type="text" inputmode="numeric" :value="getNumericRangeVal(item.field, 'max')" @input="onNumericRangeInput(item.field, 'max', $event)" @focus="openCombo('res-extra-nummax-' + item.field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                                <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                                <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('res-extra-nummax-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                            </div>
                                                            <div class="nf-combobox-menu" v-if="openDropdown === 'res-extra-nummax-' + item.field.id">
                                                                <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(item.field, 'max') }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', ''); openDropdown = null;">Tümü</button>
                                                                <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(item.field)" :key="'res-extra-nmax-' + item.field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(item.field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(item.field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(item.field, preset) }}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="isSelectField(item.field)" class="filter-box-input">
                                                    <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'res-extra-dynfield-' + item.field.id }">
                                                        <div class="nf-combobox-field">
                                                            <input type="text" :value="dynamicFieldLabel(item.field)" readonly @click="toggleCombo('res-extra-dynfield-' + item.field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                            <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('res-extra-dynfield-' + item.field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                        </div>
                                                        <div class="nf-combobox-menu" v-if="openDropdown === 'res-extra-dynfield-' + item.field.id">
                                                            <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(item.field.id)] }" @mousedown.prevent="selectDynField(item.field, '')">Tümü</button>
                                                            <button type="button" class="nf-combobox-item" v-for="opt in item.field.options" :key="'res-extra-cb-dyn-' + item.field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(item.field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(item.field, String(opt.id))">{{ opt.name }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else class="filter-box-input relative-input">
                                                    <input type="text" v-model="form.fields[String(item.field.id)]" :placeholder="item.field.placeholder || item.field.name" class="input">
                                                    <span v-if="item.field.unit" class="unit-badge">{{ item.field.unit }}</span>
                                                </div>
                                            </template>
                                            <template v-else-if="item.type === 'feature_group'">
                                                <div class="filter-checkbox-grid">
                                                    <label class="checkbox-btn" v-for="featureItem in item.group.items" :key="'res-extra-ft-' + item.group.id + '-' + featureItem.id" :class="{ active: form.feature_value_ids.includes(Number(featureItem.id)) }">
                                                        <input type="checkbox" :value="Number(featureItem.id)" v-model="form.feature_value_ids">
                                                        <i class="ph-bold" :class="form.feature_value_ids.includes(Number(featureItem.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                        <span>{{ featureItem.name }}</span>
                                                    </label>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>

                        <template v-else>
                            <!-- Fiyat + Kimden yan yana -->
                            <div class="nf-filter-duo-grid">
                                <!-- Fiyat Aralığı -->
                                <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections.price }">
                                    <button type="button" class="nf-accordion-header" @click="toggleSection('price')">
                                        <div class="fbr-title"><i class="ph-light ph-chart-pie"></i>Fiyat Aralığı</div>
                                        <i class="ph-bold nf-accordion-chevron" :class="collapsedSections.price ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                    </button>
                                    <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections.price">
                                        <div class="filter-toggle-range modern-range nf-range">
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'min_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.min_price)" @input="onPriceInput('min_price', $event)" @focus="openCombo('min_price')" placeholder="En az" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('min_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'min_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in priceOptions" :key="'cb-pmin-' + option.value" :class="{ selected: String(form.min_price) === String(option.value) }" @mousedown.prevent="selectCombo('min_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'max_price' }">
                                                <div class="nf-combobox-field has-badge">
                                                    <input type="text" inputmode="numeric" :value="formatPrice(form.max_price)" @input="onPriceInput('max_price', $event)" @focus="openCombo('max_price')" placeholder="En çok" class="input" autocomplete="off">
                                                    <span class="unit-badge">TL</span>
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('max_price')" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'max_price'">
                                                    <button type="button" class="nf-combobox-item" v-for="option in filteredMaxPriceOptions" :key="'cb-pmax-' + option.value" :class="{ selected: String(form.max_price) === String(option.value) }" @mousedown.prevent="selectCombo('max_price', option.value)">{{ option.label }}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Kimden -->
                                <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections.owner }">
                                    <button type="button" class="nf-accordion-header" @click="toggleSection('owner')">
                                        <div class="fbr-title"><i class="ph-light ph-user-list"></i>Kimden</div>
                                        <i class="ph-bold nf-accordion-chevron" :class="collapsedSections.owner ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                    </button>
                                    <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections.owner">
                                        <div class="filter-checkbox-grid">
                                            <label class="checkbox-btn" v-for="option in ownerTypeOptions" :key="'owner-' + option.value" :class="{ active: form.owner_types.includes(option.value) }">
                                                <input type="checkbox" :value="option.value" v-model="form.owner_types">
                                                <i class="ph-bold" :class="form.owner_types.includes(option.value) ? 'ph-check-square' : 'ph-square'"></i>
                                                <span>{{ option.label }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Detaylı Seçimler -->
                            <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections.details }" v-if="availableQuickFieldConfigs.length > 0">
                                <button type="button" class="nf-accordion-header" @click="toggleSection('details')">
                                    <div class="fbr-title"><i class="ph-light ph-sliders-horizontal"></i>Detaylı Seçimler</div>
                                    <i class="ph-bold nf-accordion-chevron" :class="collapsedSections.details ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                </button>
                                <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections.details">
                                    <div class="nf-quick-field-list">
                                        <div class="nf-quick-field" v-for="config in availableQuickFieldConfigs" :key="'qf-' + config.key">
                                            <div class="nf-quick-field-title">{{ config.label }}</div>
                                            <div class="filter-checkbox-grid">
                                                <label class="checkbox-btn" v-for="option in quickFieldOptions(config)" :key="'qf-opt-' + config.key + '-' + option.id" :class="{ active: isQuickFieldSelected(config, option.id) }">
                                                    <input type="checkbox" :checked="isQuickFieldSelected(config, option.id)" @change="toggleQuickField(config, option.id)">
                                                    <i class="ph-bold" :class="isQuickFieldSelected(config, option.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ option.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Sosyal & Teknik Özellikler -->
                            <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections.features }" v-if="compactFeatureGroups.length > 0">
                                <button type="button" class="nf-accordion-header" @click="toggleSection('features')">
                                    <div class="fbr-title"><i class="ph-light ph-squares-four"></i>Sosyal & Teknik Özellikler</div>
                                    <i class="ph-bold nf-accordion-chevron" :class="collapsedSections.features ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                </button>
                                <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections.features">
                                    <div class="filter-checkbox-grid">
                                        <button v-for="group in compactFeatureGroups" :key="'compact-feature-' + group.id" type="button" class="checkbox-btn nf-feature-select-btn" :class="{ active: selectedFeatureCount(group) > 0 }" @click="openFeaturePicker(group)">
                                            <i class="ph-light ph-list-checks"></i>
                                            <span>{{ group.name }}<small v-if="selectedFeatureCount(group) > 0"> ({{ selectedFeatureCount(group) }})</small></span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="loading" class="filter-loading">
                                <i class="ph-bold ph-spinner ph-spin"></i> Özellikler yükleniyor...
                            </div>

                            <!-- Ek Alanlar -->
                            <template v-if="visibleDynamicFields.length > 0">
                                <div class="nf-group-title">Ek Alanlar</div>
                                <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['field-' + field.id] }" v-for="field in visibleDynamicFields" :key="'field-' + field.id">
                                    <button type="button" class="nf-accordion-header" @click="toggleSection('field-' + field.id)">
                                        <div class="fbr-title">{{ field.name }}</div>
                                        <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['field-' + field.id] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                    </button>
                                    <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['field-' + field.id]">

                                        <!-- Taşınmaz Durumu + koşullu yıl alanları tüm kategori modlarında ortak çalışır. -->
                                        <div v-if="isDynamicPropertyStatusField(field)" class="nf-property-status-block">
                                            <div class="filter-checkbox-grid">
                                                <button
                                                    v-for="opt in field.options"
                                                    :key="'field-status-' + field.id + '-' + opt.id"
                                                    type="button"
                                                    class="checkbox-btn"
                                                    :class="{ active: isDynamicPropertyStatusOptionSelected(field, opt.id) }"
                                                    @click="selectDynamicPropertyStatusOption(field, opt.id)"
                                                >
                                                    <i class="ph-bold" :class="isDynamicPropertyStatusOptionSelected(field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                    <span>{{ opt.name }}</span>
                                                </button>
                                            </div>

                                            <div class="nf-property-year-stack" v-if="shouldShowPropertyStatusInlineYears(field)">
                                                <div class="nf-property-year-card nf-construction-year-card" v-if="dynamicConstructionYearField() && shouldShowDynamicConstructionYearField()">
                                                    <div class="nf-property-year-label">{{ uiText('Yapım Yılı') }}</div>
                                                    <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicConstructionYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicConstructionYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicConstructionYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicConstructionYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="nf-property-year-card" v-if="dynamicRenovationYearField() && shouldShowDynamicRenovationYearField()">
                                                    <div class="nf-property-year-label">{{ uiText('Yenileme Yılı') }}</div>
                                                    <div class="nf-year-range-grid nf-year-range-grid-min-only">
                                                        <div class="nf-year-range-item">
                                                            <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                            <div class="nf-year-stepper-field">
                                                                <button type="button" class="nf-year-stepper-btn" :disabled="!dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min')) <= 1900" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', -1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-minus"></i></button>
                                                                <input type="text" inputmode="numeric" :value="dynamicYearRangeValue(dynamicRenovationYearField(), 'min')" @input="onDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" @blur="commitDynamicYearRangeInput(dynamicRenovationYearField(), 'min', $event)" :placeholder="String(dynamicYearCurrentYear())" class="input nf-year-stepper-input" autocomplete="off">
                                                                <button type="button" class="nf-year-stepper-btn" :disabled="Number(dynamicYearRangeValue(dynamicRenovationYearField(), 'min') || 0) >= dynamicYearCurrentYear()" @click="stepDynamicYearRangeField(dynamicRenovationYearField(), 'min', 1)" :aria-label="uiText('En Az')"><i class="ph-bold ph-plus"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else-if="isDynamicConstructionYearField(field)" class="filter-box-input nf-year-filter-control">
                                            <div class="nf-year-range-grid">
                                                <div class="nf-year-range-item">
                                                    <div class="nf-year-range-label">{{ uiText('En Az') }}</div>
                                                    <div class="nf-year-stepper-field">
                                                        <button
                                                            type="button"
                                                            class="nf-year-stepper-btn"
                                                            :disabled="!dynamicYearRangeValue(field, 'min') || Number(dynamicYearRangeValue(field, 'min')) <= 1900"
                                                            @click="stepDynamicYearRangeField(field, 'min', -1)"
                                                            :aria-label="uiText('En Az')"
                                                        >
                                                            <i class="ph-bold ph-minus"></i>
                                                        </button>
                                                        <input
                                                            type="text"
                                                            inputmode="numeric"
                                                            :value="dynamicYearRangeValue(field, 'min')"
                                                            @input="onDynamicYearRangeInput(field, 'min', $event)"
                                                            @blur="commitDynamicYearRangeInput(field, 'min', $event)"
                                                            :placeholder="uiText('En Az')"
                                                            class="input nf-year-stepper-input"
                                                            autocomplete="off"
                                                        >
                                                        <button
                                                            type="button"
                                                            class="nf-year-stepper-btn"
                                                            :disabled="Number(dynamicYearRangeValue(field, 'min') || 0) >= dynamicYearCurrentYear()"
                                                            @click="stepDynamicYearRangeField(field, 'min', 1)"
                                                            :aria-label="uiText('En Az')"
                                                        >
                                                            <i class="ph-bold ph-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="nf-year-range-item">
                                                    <div class="nf-year-range-label">{{ uiText('En Çok') }}</div>
                                                    <div class="nf-year-stepper-field">
                                                        <button
                                                            type="button"
                                                            class="nf-year-stepper-btn"
                                                            :disabled="!dynamicYearRangeValue(field, 'max') || Number(dynamicYearRangeValue(field, 'max')) <= 1900"
                                                            @click="stepDynamicYearRangeField(field, 'max', -1)"
                                                            :aria-label="uiText('En Çok')"
                                                        >
                                                            <i class="ph-bold ph-minus"></i>
                                                        </button>
                                                        <input
                                                            type="text"
                                                            inputmode="numeric"
                                                            :value="dynamicYearRangeValue(field, 'max')"
                                                            @input="onDynamicYearRangeInput(field, 'max', $event)"
                                                            @blur="commitDynamicYearRangeInput(field, 'max', $event)"
                                                            :placeholder="uiText('En Çok')"
                                                            class="input nf-year-stepper-input"
                                                            autocomplete="off"
                                                        >
                                                        <button
                                                            type="button"
                                                            class="nf-year-stepper-btn"
                                                            :disabled="Number(dynamicYearRangeValue(field, 'max') || 0) >= dynamicYearCurrentYear()"
                                                            @click="stepDynamicYearRangeField(field, 'max', 1)"
                                                            :aria-label="uiText('En Çok')"
                                                        >
                                                            <i class="ph-bold ph-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else-if="isDynamicRenovationYearField(field)" class="filter-box-input">
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'field-renovation-year-' + field.id }">
                                                <div class="nf-combobox-field">
                                                    <input type="text" :value="dynamicYearValue(field)" readonly @click="toggleCombo('field-renovation-year-' + field.id)" placeholder="Yıl seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('field-renovation-year-' + field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'field-renovation-year-' + field.id">
                                                    <button type="button" class="nf-combobox-item" :class="{ selected: !dynamicYearValue(field) }" @mousedown.prevent="setDynamicYearField(field, '')">Tümü</button>
                                                    <button type="button" class="nf-combobox-item" v-for="year in dynamicRenovationYearOptions()" :key="'field-renovation-year-' + field.id + '-' + year" :class="{ selected: String(dynamicYearValue(field)) === String(year) }" @mousedown.prevent="setDynamicYearField(field, year)">{{ year }}</button>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Boolean / Switch toggle (Tümü / Evet / Hayır) -->
                                        <div v-else-if="isBooleanField(field)" class="nf-boolean-toggle">
                                            <button type="button" class="nf-toggle-btn" :class="{ active: !form.fields[String(field.id)] && form.fields[String(field.id)] !== booleanFieldValues(field).noVal }" @click="form.fields[String(field.id)] = ''">Tümü</button>
                                            <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(field.id)] === booleanFieldValues(field).yesVal }" @click="form.fields[String(field.id)] = booleanFieldValues(field).yesVal">Evet</button>
                                            <button type="button" class="nf-toggle-btn" :class="{ active: form.fields[String(field.id)] === booleanFieldValues(field).noVal }" @click="form.fields[String(field.id)] = booleanFieldValues(field).noVal">Hayır</button>
                                        </div>

                                        <!-- Multi-select checkboxes -->
                                        <div v-else-if="isMultiField(field)" class="filter-checkbox-grid">
                                            <label class="checkbox-btn" v-for="opt in field.options" :key="'field-multi-' + field.id + '-' + opt.id" :class="{ active: isFieldArrayValueSelected(field, opt.id) }">
                                                <input type="checkbox" :checked="isFieldArrayValueSelected(field, opt.id)" @change="toggleFieldArrayValue(field, opt.id)">
                                                <i class="ph-bold" :class="isFieldArrayValueSelected(field, opt.id) ? 'ph-check-square' : 'ph-square'"></i>
                                                <span>{{ opt.name }}</span>
                                            </label>
                                        </div>

                                        <!-- Numeric field with min-max range (m², kat sayısı, yapım yılı vb.) -->
                                        <div v-else-if="isNumericField(field)" class="filter-box-input">
                                            <div class="filter-toggle-range modern-range nf-range">
                                                <!-- Min -->
                                                <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'nummin-' + field.id }">
                                                    <div class="nf-combobox-field" :class="{ 'has-badge': field.unit }">
                                                        <input type="text" inputmode="numeric" :value="getNumericRangeVal(field, 'min')" @input="onNumericRangeInput(field, 'min', $event)" @focus="openCombo('nummin-' + field.id)" placeholder="En az" class="input" autocomplete="off">
                                                        <span v-if="field.unit" class="unit-badge">{{ field.unit }}</span>
                                                        <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('nummin-' + field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                    </div>
                                                    <div class="nf-combobox-menu" v-if="openDropdown === 'nummin-' + field.id">
                                                        <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(field, 'min') }" @mousedown.prevent="setNumericRangeVal(field, 'min', ''); openDropdown = null;">Tümü</button>
                                                        <button type="button" class="nf-combobox-item" v-for="preset in numericPresets(field)" :key="'nmin-' + field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(field, 'min')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(field, 'min', String(preset)); openDropdown = null;">{{ numericPresetLabel(field, preset) }}</button>
                                                    </div>
                                                </div>
                                                <!-- Max -->
                                                <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'nummax-' + field.id }">
                                                    <div class="nf-combobox-field" :class="{ 'has-badge': field.unit }">
                                                        <input type="text" inputmode="numeric" :value="getNumericRangeVal(field, 'max')" @input="onNumericRangeInput(field, 'max', $event)" @focus="openCombo('nummax-' + field.id)" placeholder="En çok" class="input" autocomplete="off">
                                                        <span v-if="field.unit" class="unit-badge">{{ field.unit }}</span>
                                                        <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('nummax-' + field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                    </div>
                                                    <div class="nf-combobox-menu" v-if="openDropdown === 'nummax-' + field.id">
                                                        <button type="button" class="nf-combobox-item" :class="{ selected: !getNumericRangeVal(field, 'max') }" @mousedown.prevent="setNumericRangeVal(field, 'max', ''); openDropdown = null;">Tümü</button>
                                                        <button type="button" class="nf-combobox-item" v-for="preset in filteredNumericMaxPresets(field)" :key="'nmax-' + field.id + '-' + preset" :class="{ selected: String(getNumericRangeVal(field, 'max')) === String(preset) }" @mousedown.prevent="setNumericRangeVal(field, 'max', String(preset)); openDropdown = null;">{{ numericPresetLabel(field, preset) }}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Select dropdown -->
                                        <div v-else-if="isSelectField(field)" class="filter-box-input">
                                            <div class="nf-combobox" :class="{ 'is-open': openDropdown === 'dynfield-' + field.id }">
                                                <div class="nf-combobox-field">
                                                    <input type="text" :value="dynamicFieldLabel(field)" readonly @click="toggleCombo('dynfield-' + field.id)" placeholder="Seçiniz" class="input nf-combobox-readonly" autocomplete="off">
                                                    <button type="button" class="nf-combobox-caret" @click.stop="toggleCombo('dynfield-' + field.id)" tabindex="-1"><i class="ph-bold ph-caret-down"></i></button>
                                                </div>
                                                <div class="nf-combobox-menu" v-if="openDropdown === 'dynfield-' + field.id">
                                                    <button type="button" class="nf-combobox-item" :class="{ selected: !form.fields[String(field.id)] }" @mousedown.prevent="selectDynField(field, '')">Tümü</button>
                                                    <button type="button" class="nf-combobox-item" v-for="opt in field.options" :key="'cb-dyn-' + field.id + '-' + opt.id" :class="{ selected: String(form.fields[String(field.id)]) === String(opt.id) }" @mousedown.prevent="selectDynField(field, String(opt.id))">{{ opt.name }}</button>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Text fallback -->
                                        <div v-else class="filter-box-input relative-input">
                                            <input type="text" v-model="form.fields[String(field.id)]" :placeholder="field.placeholder || field.name" class="input">
                                            <span v-if="field.unit" class="unit-badge">{{ field.unit }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <!-- Özellikler -->
                            <template v-if="visibleDynamicFeatures.length > 0">
                                <div class="nf-group-title">Özellikler</div>
                                <div class="filter-box-item nf-accordion-item" :class="{ 'nf-collapsed': collapsedSections['feat-' + featureGroup.id] }" v-for="featureGroup in visibleDynamicFeatures" :key="'grp-' + featureGroup.id">
                                    <button type="button" class="nf-accordion-header" @click="toggleSection('feat-' + featureGroup.id)">
                                        <div class="fbr-title">{{ featureGroup.name }}</div>
                                        <i class="ph-bold nf-accordion-chevron" :class="collapsedSections['feat-' + featureGroup.id] ? 'ph-caret-down' : 'ph-caret-up'"></i>
                                    </button>
                                    <div class="filter-box-content nf-accordion-body" v-show="!collapsedSections['feat-' + featureGroup.id]">
                                        <div class="filter-checkbox-grid">
                                            <label class="checkbox-btn" v-for="item in featureGroup.items" :key="'ft-' + item.id" :class="{ active: form.feature_value_ids.includes(Number(item.id)) }">
                                                <input type="checkbox" :value="Number(item.id)" v-model="form.feature_value_ids">
                                                <i class="ph-bold" :class="form.feature_value_ids.includes(Number(item.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                                <span>{{ item.name }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>

                        <!-- Sanal Tur -->
                        <div class="filter-box-item">
                            <div class="filter-box-row nf-switch-row">
                                <div class="fbr-title"><i class="ph-light ph-sphere"></i>Sadece Sanal Turu Olanlar</div>
                                <div class="fbr-cta">
                                    <div class="switch-btn-wrap fl">
                                        <label class="switch-btn">
                                            <input type="checkbox" v-model="form.has_virtual_tour" :true-value="1" :false-value="0">
                                            <span class="switch-btn-slider"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Footer CTA -->
                <div class="filter-cta nf-filter-cta nf-cta-trio">
                    <button type="button" class="button btn-light nf-cta-btn" @click="currentStep > 1 ? goBack() : close()">
                        <i class="ph-light" :class="currentStep > 1 ? 'ph-arrow-left' : 'ph-x'"></i>
                        <small>{{ currentStep > 1 ? 'Geri' : 'Kapat' }}</small>
                    </button>

                    <button v-if="currentStep === 4" type="button" class="button nf-cta-btn nf-cta-primary" id="sfSubmitBtn" @click="submitFilter">
                        <i class="ph-light ph-magnifying-glass"></i>
                        <small>{{ submitButtonText }}</small>
                    </button>
                    <button v-else type="button" class="button nf-cta-btn nf-cta-primary" disabled>
                        <i class="ph-light ph-magnifying-glass"></i>
                        <small>Adımları Tamamlayın</small>
                    </button>

                    <button type="button" class="button btn-light nf-cta-btn" id="sfClearLink" @click="resetWizard">
                        <i class="ph-light ph-arrow-counter-clockwise"></i>
                        <small>Temizle</small>
                    </button>
                </div>

                <!-- Feature Picker Overlay -->
                <div class="nf-picker-backdrop" v-if="featurePicker" @click.self="closeFeaturePicker">
                    <div class="nf-picker-panel">
                        <div class="nf-picker-head">
                            <strong>{{ featurePicker.name }}</strong>
                            <button type="button" @click="closeFeaturePicker"><i class="ph-light ph-x"></i></button>
                        </div>
                        <div class="filter-checkbox-grid nf-picker-list">
                            <label class="checkbox-btn" v-for="item in featurePicker.items" :key="'picker-' + item.id" :class="{ active: form.feature_value_ids.includes(Number(item.id)) }">
                                <input type="checkbox" :value="Number(item.id)" v-model="form.feature_value_ids">
                                <i class="ph-bold" :class="form.feature_value_ids.includes(Number(item.id)) ? 'ph-check-square' : 'ph-square'"></i>
                                <span>{{ item.name }}</span>
                            </label>
                        </div>
                        <button type="button" class="button w100" @click="closeFeaturePicker">
                            <small>Seçimleri Kaydet</small>
                            <i class="ph-light ph-check"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const DEFAULT_TRANSACTION_TYPE = '1';

export default {
    props: {
        categoryTree: { type: Array, default: () => [] },
        initialRoomOptions: { type: Array, default: () => [] },
        searchUrl: { type: String, required: true },
        requestParams: { type: Object, default: () => ({}) },
        metadataBaseUrl: { type: String, default: '' },
        selectedMainCategoryId: { type: [String, Number], default: '' },
        selectedSubCategoryId: { type: [String, Number], default: '' },
        context: { type: String, default: 'default' },
        showTransaction: { type: [Boolean, String, Number], default: false },
        countUrl: { type: String, default: '' },
        locationSearchUrl: { type: String, default: '' },
        countriesUrl: { type: String, default: '' },
        citiesUrl: { type: String, default: '' },
        districtsUrl: { type: String, default: '' },
        neighborhoodsUrl: { type: String, default: '' },
    },

    data() {
        return {
            isOpen: false,
            isOpeningFilter: false,
            loading: false,
            liveCount: null,
            countTimer: null,
            countRequestId: 0,
            countAbortController: null,
            locationSearch: '',
            locationTimer: null,
            locationLoading: false,
            locationResultsOpen: false,
            locationResults: [],
            countries: [],
            cities: [],
            districts: [],
            neighborhoods: [],
            dynamicFields: [],
            dynamicFeatures: [],
            metadataCategory: null,
            fieldFilterModes: {},
            featurePicker: null,
            quickFieldConfigs: this.defaultQuickFieldConfigs(),
            form: this.emptyForm(),
            isDomSyncing: false,
            isDynamicYearSyncing: false,
            currentStep: 1,
            maxReachedStep: 1,
            collapsedSections: {},
            openDropdown: null,
            filterBodyScrollY: 0,
            filterBodyLocked: false,
            _nfViewportHandler: null,
            uiTranslations: (window.HOME_SEARCH_I18N && typeof window.HOME_SEARCH_I18N === 'object')
                ? window.HOME_SEARCH_I18N
                : {},
            activeLocale: String(window.HOME_SEARCH_LOCALE || document.documentElement?.lang || 'tr')
                .replace('_', '-')
                .split('-')[0]
                .toLowerCase(),
            _uiLocalizationRaf: null,
            // Gruplama kimliği her dilde aynı kalsın diye TR metadata yalnızca
            // kanonik referans olarak cache'lenir. Görünen metinler aktif locale'den gelir.
            canonicalMetadataCache: {},
        };
    },

    computed: {
        shouldShowTransaction() {
            return this.showTransaction === true || this.showTransaction === '1' || this.showTransaction === 1;
        },

        isMyAdsContext() {
            return this.context === 'my_ads';
        },

        priceOptions() {
            const saleValues = [500000, 750000, 1000000, 1250000, 1500000, 1750000, 2000000, 2500000, 3000000, 4000000, 5000000, 6000000, 7000000, 8000000, 9000000, 10000000, 20000000, 30000000, 40000000, 50000000, 60000000, 70000000, 80000000, 90000000];
            // Ana sayfa ve ilan listesi detaylı filtresinde kiralık hazır seçenekleri 1.000.000 TL'de biter.
            const rentValues = [5000, 7500, 10000, 12500, 15000, 17500, 20000, 25000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 150000, 200000, 250000, 300000, 400000, 500000, 750000, 1000000];
            const values = String(this.form.transaction_type) === '2' ? rentValues : saleValues;

            return values.map(value => ({ value: String(value), label: this.formatPrice(value) + ' TL' }));
        },

        filteredMaxPriceOptions() {
            if (!this.form.min_price) return this.priceOptions;
            const minVal = parseFloat(String(this.form.min_price).replace(/\./g, '').replace(',', '.'));
            if (isNaN(minVal) || minVal <= 0) return this.priceOptions;
            return this.priceOptions.filter(opt => {
                const optVal = parseFloat(String(opt.value).replace(/\./g, '').replace(',', '.'));
                return !isNaN(optVal) && optVal >= minVal;
            });
        },

        ownerTypeOptions() {
            // İlanlarım ekranı zaten yalnızca oturum sahibinin portföyünü listeler.
            // Bu bağlamda "Kimden" filtresi anlamsız olduğu için gizlenir.
            if (this.isMyAdsContext) {
                return [];
            }

            return [
                { value: 'user', label: this.uiText('Bireysel Satıcı') },
                { value: 'agency', label: this.uiText('Emlak Acentesi') },
                { value: 'consultant', label: this.uiText('Bireysel Danışman') },
                { value: 'construction', label: this.uiText('İnşaat Şirketi') },
            ];
        },

        availableQuickFieldConfigs() {
            return this.quickFieldConfigs
                .map(config => ({ ...config, field: this.findFieldByKeys(config.keys) }))
                .filter(config => config.field && !this.isGloballyHiddenDynamicField(config.field) && Array.isArray(config.field.options) && config.field.options.length > 0)
                // Taşınmaz Durumu özel koşullu yıl mantığına bağlıdır; hızlı çoklu seçim bloğunda değil, genel özel renderer'da gösterilir.
                .filter(config => !this.isDynamicPropertyStatusField(config.field));
        },

        visibleDynamicFields() {
            const quickIds = this.availableQuickFieldConfigs.map(config => Number(config.field.id));
            const hiddenKeys = [];

            return this.dynamicFields.filter(field => {
                if (quickIds.includes(Number(field.id))) return false;
                if (!this.shouldRenderDynamicField(field)) return false;
                return !hiddenKeys.includes(this.fieldSchemaKey(field));
            });
        },

        compactFeatureGroups() {
            const compactNames = ['sosyal', 'teknik', 'diğer özellikler', 'güvenlik', 'havuz', 'spor', 'aktivite', 'wellness', 'spa', 'altyapı', 'ortak alan'];
            return this.dynamicFeatures.filter(group => {
                const name = this.normalizeText([group.canonical_name, group.name].filter(Boolean).join(' '));
                return compactNames.some(needle => name.includes(this.normalizeText(needle)));
            });
        },

        visibleDynamicFeatures() {
            const compactIds = this.compactFeatureGroups.map(group => Number(group.id));
            return this.dynamicFeatures.filter(group => !compactIds.includes(Number(group.id)));
        },

        wizardStepLabel() {
            const labels = ['İlan Türü', 'Gayrimenkul Kategorisi', 'Gayrimenkul Türü', 'Detaylı Filtreler'];
            return this.uiText(labels[this.currentStep - 1] || '');
        },

        wizardProgress() {
            return Math.round((this.currentStep / 4) * 100);
        },

        canProceedToStep2() {
            return this.context === 'agency' || !!this.form.transaction_type;
        },

        canProceedToStep3() {
            return this.canProceedToStep2 && !!this.form.main_category_id;
        },

        canProceedToStep4() {
            if (!this.canProceedToStep3) return false;
            if (this.filteredLeafCategories.length === 0) return true;
            return !!this.form.subcategory_id;
        },

        filteredRootCategories() {
            const tx = parseInt(this.form.transaction_type || '0', 10);
            if (!tx) return this.mainCategories;

            return this.mainCategories.filter(root => this.isCategoryAllowedForTransaction(root, tx));
        },

        filteredLeafCategories() {
            if (!this.selectedMainNode || !Array.isArray(this.selectedMainNode.children)) {
                return [];
            }

            const tx = parseInt(this.form.transaction_type || '0', 10);

            return this.selectedMainNode.children.filter(child => {
                if (this.isRemovedLandCategory(child)) {
                    return false;
                }

                return this.isCategoryAllowedForTransaction(child, tx);
            });
        },

        selectionSummaryChips() {
            const chips = [];
            if (this.form.transaction_type) {
                chips.push(this.transactionTypeLabel(this.form.transaction_type));
            }
            if (this.form.main_category_id) {
                const main = this.mainCategories.find(c => String(c.id) === String(this.form.main_category_id));
                if (main) chips.push(main.name);
            }
            if (this.form.subcategory_id) {
                const sub = this.filteredLeafCategories.find(c => String(c.id) === String(this.form.subcategory_id));
                if (sub) chips.push(sub.name);
            }
            return chips;
        },

        mainCategories() {
            return Array.isArray(this.categoryTree) ? this.categoryTree : [];
        },

        selectedMainNode() {
            return this.mainCategories.find(cat => String(cat.id) === String(this.form.main_category_id)) || null;
        },

        subCategoryOptions() {
            if (!this.selectedMainNode || !Array.isArray(this.selectedMainNode.children)) {
                return [];
            }

            return this.flattenChildren(this.selectedMainNode.children);
        },

        effectiveCategoryId() {
            return this.normalizeId(this.form.subcategory_id) || this.normalizeId(this.form.main_category_id) || '';
        },

        selectedCategoryNode() {
            const id = this.effectiveCategoryId;
            if (!id) return null;
            return this.allCategoryOptions().find(cat => String(cat.id) === String(id)) || null;
        },

        selectedCategoryHaystack() {
            return [
                this.selectedMainNode?.name || '',
                this.selectedMainNode?.canonical_name || '',
                this.selectedMainNode?.slug || '',
                this.selectedMainNode?.schema_key || '',
                this.selectedMainNode?.meta?.schema_key || '',
                this.selectedCategoryNode?.name || '',
                this.selectedCategoryNode?.canonical_name || '',
                this.selectedCategoryNode?.slug || '',
                this.selectedCategoryNode?.schema_key || '',
                this.selectedCategoryNode?.meta?.schema_key || '',
                this.selectedCategoryNode?.path_label || '',
                this.metadataCategory?.name || '',
                this.metadataCategory?.canonical_name || '',
                this.metadataCategory?.schema_key || '',
                this.categoryLabel(this.effectiveCategoryId),
            ].filter(Boolean).join(' ');
        },

        selectedCategorySchemaHaystack() {
            return [
                this.selectedMainNode?.schema_key || '',
                this.selectedMainNode?.meta?.schema_key || '',
                this.selectedCategoryNode?.schema_key || '',
                this.selectedCategoryNode?.meta?.schema_key || '',
                this.metadataCategory?.schema_key || '',
            ]
                .filter(Boolean)
                .map(value => this.normalizeText(value))
                .join(' ');
        },

        isLandFilterMode() {
            const schema = this.selectedCategorySchemaHaystack;
            if (schema.includes('arsa') || schema.includes('arazi') || schema.includes('land')) {
                return true;
            }

            const text = this.normalizeText(this.selectedCategoryHaystack);
            return text.includes('arsa')
                || text.includes('arazi')
                || text.includes('land')
                || text.includes('plot')
                || text.includes('agricultural_land');
        },



        isCommercialFilterMode() {
            if (this.isLandFilterMode || this.isProjectFilterMode) return false;

            const schema = this.selectedCategorySchemaHaystack;
            const text = this.normalizeText(this.selectedCategoryHaystack);
            const mainIdentity = this.normalizeText([
                this.selectedMainNode?.schema_key,
                this.selectedMainNode?.meta?.schema_key,
                this.selectedMainNode?.canonical_name,
                this.selectedMainNode?.name,
                this.selectedMainNode?.canonical_slug,
                this.selectedMainNode?.slug,
            ].filter(Boolean).join(' '));

            /*
             * Kritik locale güvenliği:
             * İngilizce "Apartment" kelimesi eski `includes('apart')` kontrolünde
             * Ticari > Otel/Pansiyon/Apart sanılıyordu. Bunun sonucu Residential
             * layout hiç açılmıyor ve Oda Aralığı kayboluyordu.
             *
             * Önce root/family kimliğini sabit schema/canonical veriden çözüyoruz.
             * Konut/Residential ailesi ticari fallback'e hiçbir zaman giremez.
             */
            const residentialFamily = [
                'konut', 'residential',
            ].some(key => this.identityHasToken(schema, key) || this.identityHasToken(mainIdentity, key));

            if (residentialFamily) {
                return false;
            }

            const commercialFamily = [
                'ticari', 'commercial', 'business',
            ].some(key => this.identityHasToken(schema, key) || this.identityHasToken(mainIdentity, key));

            if (commercialFamily) {
                return this.currentCommercialTypeKey !== '';
            }

            // Eski/veri eksik kategoriler için leaf fallback. "apart" burada yalnızca
            // tam token olarak eşleşir; "apartment" artık eşleşmez.
            const isCommercialLeaf = [
                'magaza', 'dukkan', 'shop', 'store',
                'ofis', 'buro', 'office',
                'kafe', 'cafe', 'restoran', 'restaurant',
                'otel', 'hotel', 'pansiyon', 'apart', 'hostel', 'motel', 'aparthotel', 'apart_hotel',
            ].some(key => this.identityHasToken(text, key));

            return isCommercialLeaf && this.currentCommercialTypeKey !== '';
        },

        currentCommercialTypeKey() {
            if (this.isLandFilterMode || this.isProjectFilterMode) return '';

            const schema = this.selectedCategorySchemaHaystack;
            const text = this.normalizeText(this.selectedCategoryHaystack);
            const mainIdentity = this.normalizeText([
                this.selectedMainNode?.schema_key,
                this.selectedMainNode?.meta?.schema_key,
                this.selectedMainNode?.canonical_name,
                this.selectedMainNode?.name,
                this.selectedMainNode?.canonical_slug,
                this.selectedMainNode?.slug,
            ].filter(Boolean).join(' '));
            const source = `${schema}_${text}`;

            // Residential root seçildiyse "Apartment" içindeki "apart" ticari otel
            // sinyali olamaz.
            if ([
                'konut', 'residential',
            ].some(key => this.identityHasToken(schema, key) || this.identityHasToken(mainIdentity, key))) {
                return '';
            }

            if (['otel', 'hotel', 'pansiyon', 'apart', 'hostel', 'motel', 'aparthotel', 'apart_hotel']
                .some(key => this.identityHasToken(source, key))) return 'hotel';
            if (['kafe', 'cafe', 'restoran', 'restaurant'].some(key => this.identityHasToken(source, key))) return 'cafe';
            if (['ofis', 'buro', 'office'].some(key => this.identityHasToken(source, key))) return 'office';
            if (['magaza', 'dukkan', 'shop', 'store'].some(key => this.identityHasToken(source, key))) return 'shop';

            return '';
        },

        commercialTypeLabel() {
            const labels = {
                shop: 'Ticari - Mağaza / Dükkan',
                office: 'Ticari - Ofis / Büro',
                cafe: 'Ticari - Kafe / Restoran',
                hotel: 'Ticari - Otel / Pansiyon / Apart',
            };
            return labels[this.currentCommercialTypeKey] || 'Ticari';
        },

        commercialPriceStatusItems() {
            if (String(this.form.transaction_type) === '2') {
                return [];
            }

            return this.findCommercialToggleItems(this.commercialPriceToggleDefinitions('status'));
        },

        commercialPriceOpportunityItems() {
            const type = String(this.form.transaction_type) === '2' ? 'rental_opportunity' : 'sale_opportunity';
            return this.findCommercialToggleItems(this.commercialPriceToggleDefinitions(type));
        },

        commercialPlanField() {
            if (this.currentCommercialTypeKey === 'hotel') return null;
            return this.commercialFindField(['ic_mekan_ozellikleri', 'iç mekan özellikleri', 'ic mekan', 'iç mekan', 'acik_plan', 'açık plan', 'acik plan', 'duvarlarla_bolunmus', 'duvarlarla bölünmüş', 'duvarlarla bolunmus', 'bolunmus', 'bölünmüş']);
        },

        commercialPlanOptions() {
            const field = this.commercialPlanField;
            if (!field || !Array.isArray(field.options)) return [];
            return field.options.filter(option => String(option.name || option.value || '').trim() !== '');
        },

        commercialPartitionCountField() {
            if (this.currentCommercialTypeKey === 'hotel') return null;
            return this.commercialFindField(['bolum_sayisi', 'bölüm sayısı', 'bolum sayisi', 'bolunmus_bolum_sayisi', 'bölünmüş bölüm']);
        },

        commercialRoomCountField() {
            if (this.currentCommercialTypeKey === 'hotel') return null;
            return this.commercialFindField([
                'oda_sayisi', 'oda sayisi', 'oda sayısı',
                'toplam_oda_sayisi', 'toplam oda sayisi', 'toplam oda sayısı',
                'oda_adedi', 'oda adedi', 'room_count', 'room count'
            ]);
        },

        commercialPartitionSelected() {
            const field = this.commercialPlanField;
            if (!field || !Array.isArray(field.options)) return false;
            return field.options.some(option => {
                const label = this.normalizeText([option.canonical_name, option.name, option.value].filter(Boolean).join(' '));
                return (label.includes('bolunmus') || label.includes('duvar')) && this.isCommercialFieldOptionSelected(field, option.id);
            });
        },

        commercialKitchenField() {
            return this.currentCommercialTypeKey === 'office'
                ? this.commercialFindField(['mutfak_tipi', 'mutfak turu', 'mutfak türü', 'mutfak'])
                : null;
        },

        commercialTeaKitchenField() {
            if (!['shop', 'cafe'].includes(this.currentCommercialTypeKey)) return null;
            return this.commercialFindField(['cay_ocagi_mutfak', 'çay ocağı mutfak', 'cay ocagi mutfak', 'cay_ocagi', 'çay ocağı', 'cay ocagi', 'mutfak_var', 'mutfak var']);
        },

        commercialRoomMinOnlyItems() {
            const type = this.currentCommercialTypeKey;
            if (type === 'hotel') return [];

            const revisionScope = this.isPdfCommercialRevisionScope(['shop', 'office', 'cafe']);
            const countDefinitions = revisionScope
                ? [
                    { label: 'Depo', keys: ['depo_adet', 'depo_sayisi', 'depo adet', 'depo sayisi', 'depo sayısı'] },
                    { label: 'Teras', keys: ['teras_adet', 'teras_sayisi', 'teras adet', 'teras sayisi', 'teras sayısı'] },
                    { label: 'Balkon', keys: ['balkon_adet', 'balkon_sayisi', 'balkon adet', 'balkon sayisi', 'balkon sayısı'] },
                    { label: 'Banyo', keys: ['banyo_sayisi', 'banyo sayisi', 'banyo sayısı'] },
                    { label: 'WC', keys: ['wc_sayisi', 'wc sayisi', 'wc sayısı', 'tuvalet_sayisi', 'tuvalet sayısı'] },
                    { label: 'Soğuk Hava Deposu', keys: ['soguk_hava_deposu_adet', 'soguk_hava_deposu', 'soğuk hava deposu', 'soguk hava deposu'] },
                ]
                : [
                    { label: 'Banyo', keys: ['banyo_sayisi', 'banyo sayisi', 'banyo sayısı'] },
                    { label: 'WC', keys: ['wc_sayisi', 'wc sayisi', 'wc sayısı', 'tuvalet_sayisi', 'tuvalet sayısı'] },
                    { label: 'Depo', keys: ['depo_sayisi', 'depo sayisi', 'depo sayısı'] },
                    { label: 'Soğuk Hava Deposu', keys: ['soguk_hava_deposu', 'soğuk hava deposu', 'soguk hava deposu'] },
                    { label: 'Balkon', keys: ['balkon_sayisi', 'balkon sayisi', 'balkon sayısı'] },
                    { label: 'Teras', keys: ['teras_sayisi', 'teras sayisi', 'teras sayısı'] },
                ];

            return this.commercialResolveDefinitions(countDefinitions, { fieldsOnly: true });
        },
        commercialRoomBuilderVisible() {
            return !!(
                (this.commercialPlanField && this.commercialPlanOptions.length) ||
                this.commercialKitchenField ||
                this.commercialTeaKitchenField ||
                this.commercialRoomMinOnlyItems.length ||
                (this.commercialPartitionSelected && this.commercialPartitionCountField) ||
                (this.commercialPartitionSelected && this.commercialRoomCountField)
            );
        },

        commercialRoomBlockOrder() {
            const type = this.currentCommercialTypeKey;
            const revisionScope = this.isPdfCommercialRevisionScope(['shop', 'office', 'cafe']);

            const orderMap = {
                shop: { min_fields: 1, tea_kitchen: 2, plan: 3, partition: 4, room_count: 5, kitchen: 9 },
                cafe: { min_fields: 1, tea_kitchen: 2, plan: 3, partition: 4, room_count: 5, kitchen: 9 },
                office: revisionScope
                    ? { min_fields: 1, kitchen: 2, plan: 3, partition: 4, room_count: 5, tea_kitchen: 9 }
                    : { kitchen: 1, min_fields: 2, plan: 3, partition: 4, room_count: 5, tea_kitchen: 9 },
            };

            return (block) => orderMap[type]?.[block] || 20;
        },
        commercialBasicItems() {
            const items = this.uniqueFilterItems(this.buildCommercialSectionItems('basic'));

            // PDF Ticari kuralı Satılık/Kiralık ortak: Manzara -> Güneş Alma -> Cephe.
            if (this.isPdfCommercialRevisionScope(['shop', 'office', 'cafe', 'hotel'])) {
                return this.orderViewSunlightFacade(items);
            }

            return this.orderViewImmediatelyBeforeFacade(items);
        },

        commercialPropertyItems() {
            return this.orderViewImmediatelyBeforeFacade(
                this.uniqueFilterItems(this.buildCommercialSectionItems('property'))
            );
        },

        commercialSocialFeatureGroups() {
            const groups = this.commercialSocialDefinitions()
                .map(definition => this.dynamicFeatures.find(group => (
                    !this.isViewOrFacadeFeatureGroup(group)
                    && this.commercialFeatureGroupMatches(group, definition.keys)
                )))
                .filter(Boolean);

            const used = new Set();
            return groups.filter(group => {
                const id = Number(group.id);
                if (used.has(id)) return false;
                used.add(id);
                return true;
            });
        },

        commercialHasBasicContent() {
            return this.commercialRoomBuilderVisible || this.commercialBasicItems.length > 0;
        },

        commercialRemainingItems() {
            return this.uniqueFilterItems(this.buildCommercialRemainingItems());
        },

        parkingFeatureGroupIds() {
            return this.parkingFeatureGroups()
                .map(group => Number(group?.id || 0))
                .filter(id => Number.isFinite(id) && id > 0);
        },

        isProjectFilterMode() {
            if (this.isLandFilterMode) return false;

            const schema = this.selectedCategorySchemaHaystack;
            const text = this.normalizeText(this.selectedCategoryHaystack);
            const isProject = schema.includes('proje')
                || schema.includes('project')
                || text.includes('proje')
                || text.includes('project');

            return isProject && this.currentProjectTypeKey !== '';
        },

        currentProjectTypeKey() {
            if (this.isLandFilterMode) return '';

            const schema = this.selectedCategorySchemaHaystack;
            const text = this.normalizeText(this.selectedCategoryHaystack);
            const source = `${schema} ${text}`;

            if (['ofis', 'buro', 'office'].some(key => source.includes(key))) return 'office';
            if (['magaza', 'dukkan', 'shop', 'store'].some(key => source.includes(key))) return 'shop';
            if (['villa', 'tiny', 'detached_house', 'farmhouse'].some(key => source.includes(key))) return 'villa';
            if (['daire', 'residence', 'rezidans', 'konut', 'apartment', 'residential'].some(key => source.includes(key))) return 'apartment';

            return '';
        },

        projectTypeLabel() {
            const labels = {
                apartment: 'Proje - Daire / Residence',
                villa: 'Proje - Villa / Tiny House',
                office: 'Proje - Ofis / Büro',
                shop: 'Proje - Mağaza / Dükkan',
            };
            return labels[this.currentProjectTypeKey] || 'Proje';
        },

        projectUnitAreaFallbackLabel() {
            const labels = {
                apartment: 'Daire m²',
                villa: 'Villa m²',
                office: 'Ofis/Büro m²',
                shop: 'Mağaza/Dükkan m²',
            };
            return labels[this.currentProjectTypeKey] || 'Ünite m²';
        },

        projectPriceStatusItems() {
            return [];
        },

        projectPriceOpportunityItems() {
            const type = String(this.form.transaction_type) === '2' ? 'rental_opportunity' : 'sale_opportunity';
            return this.findProjectToggleItems(this.projectPriceToggleDefinitions(type));
        },

        projectInstallmentTermItems() {
            return this.projectResolveDefinitions([
                { label: 'Vade Süresi', keys: ['vade_suresi', 'vade süresi', 'vade suresi', 'taksit_vadesi', 'taksit vadesi', 'ay'] },
            ], { fieldsOnly: true });
        },

        projectInstallmentSelected() {
            return this.projectPriceOpportunityItems.some(item => item.definitionKey === 'installment_sale' && this.isProjectToggleSelected(item));
        },

        projectBedroomField() {
            return this.projectFindField(['yatak_odasi_sayisi', 'yatak odasi', 'yatak odası', 'bedroom']);
        },

        projectSalonField() {
            return this.projectFindField(['salon_sayisi', 'salon sayisi', 'salon sayısı', 'living room']);
        },

        projectRoomCountField() {
            return this.projectFindField(['oda_sayisi', 'oda sayisi', 'oda sayısı', 'oda_salon', 'room_count', 'room count']);
        },

        projectResidentialUnitRoomMode() {
            return ['apartment', 'villa'].includes(this.currentProjectTypeKey);
        },

        projectBedroomCounterVisible() {
            return this.projectResidentialUnitRoomMode || !!this.projectBedroomField;
        },

        projectSalonCounterVisible() {
            return this.projectResidentialUnitRoomMode || !!this.projectSalonField;
        },

        projectRoomCounterVisible() {
            return this.projectBedroomCounterVisible || this.projectSalonCounterVisible;
        },

        projectDeliveryYearOptions() {
            const currentYear = new Date().getFullYear();
            const start = currentYear;
            const end = currentYear + 10;
            const years = [];

            for (let year = start; year <= end; year += 1) {
                years.push(year);
            }

            return years;
        },

        projectKitchenField() {
            return ['apartment', 'villa'].includes(this.currentProjectTypeKey)
                ? this.projectFindField(['mutfak_tipi', 'mutfak turu', 'mutfak türü', 'mutfak'])
                : null;
        },

        projectCommercialPlanField() {
            if (!['office', 'shop'].includes(this.currentProjectTypeKey)) return null;
            return this.projectFindField(['oda_tipi', 'oda tipi', 'plan_tipi', 'plan tipi', 'ofis_tipi', 'ofis tipi', 'magaza_tipi', 'mağaza tipi', 'dukkan_tipi', 'dükkan tipi', 'acik_bolunmus', 'açık bölünmüş', 'acik bolunmus', 'bolunmus', 'bölünmüş', 'acik', 'açık']);
        },

        projectCommercialPlanOptions() {
            const field = this.projectCommercialPlanField;
            if (!field || !Array.isArray(field.options)) return [];
            return field.options.filter(option => String(option.name || option.value || '').trim() !== '');
        },

        projectPartitionCountField() {
            if (!['office', 'shop'].includes(this.currentProjectTypeKey)) return null;
            return this.projectFindField(['bolum_sayisi', 'bölüm sayısı', 'bolum sayisi', 'bolunmus_bolum_sayisi', 'bölünmüş bölüm']);
        },

        projectCommercialPartitionSelected() {
            const field = this.projectCommercialPlanField;
            if (!field || !Array.isArray(field.options)) return false;
            return field.options.some(option => {
                const label = this.normalizeText([option.canonical_name, option.name, option.value].filter(Boolean).join(' '));
                return label.includes('bolunmus') && this.isProjectFieldOptionSelected(field, option.id);
            });
        },

        projectRoomOptions() {
            const field = this.projectRoomCountField;
            const baseOptions = field && Array.isArray(field.options) && field.options.length > 0
                ? field.options.map(option => ({ id: String(option.id), name: option.name || String(option.id), synthetic: false }))
                : (this.initialRoomOptions || []).map(option => ({ id: String(option.id), name: option.name || String(option.id), synthetic: false }));

            return this.mergeTurkishRoomPresetOptions(baseOptions);
        },

        filteredProjectRoomMaxOptions() {
            return this.filteredRoomMaxOptions(this.projectRoomOptions, this.projectRoomPresetValue('min'));
        },

        projectRoomPresetVisible() {
            return !!(this.projectRoomCounterVisible && this.projectRoomOptions.length > 0);
        },

        projectRoomMinOnlyItems() {
            const type = this.currentProjectTypeKey;

            if (type === 'apartment') {
                return this.projectResolveDefinitions([
                    { label: 'Banyo', keys: ['banyo_sayisi', 'ortak_banyo_sayisi', 'ortak banyo', 'banyo sayisi', 'banyo sayısı'] },
                    { label: 'Balkon', keys: ['balkon_adet', 'balkon_sayisi', 'balkon sayisi', 'balkon sayısı'] },
                ], { fieldsOnly: true });
            }

            if (type === 'villa') {
                return this.projectResolveDefinitions([
                    { label: 'Banyo', keys: ['banyo_sayisi', 'ortak_banyo_sayisi', 'ortak banyo', 'banyo sayisi', 'banyo sayısı'] },
                    { label: 'Balkon', keys: ['balkon_adet', 'balkon_sayisi', 'balkon sayisi', 'balkon sayısı'] },
                    { label: 'Depo', keys: ['depo_adet', 'depo_sayisi', 'depo sayisi', 'depo sayısı'] },
                    { label: 'Teras', keys: ['teras_adet', 'teras_sayisi', 'teras sayisi', 'teras sayısı'] },
                    { label: 'Asansör', keys: ['asansor_sayisi', 'asansör sayısı', 'asansor'] },
                ], { fieldsOnly: true });
            }

            if (['office', 'shop'].includes(type)) {
                return this.projectResolveDefinitions([
                    { label: 'Balkon', keys: ['balkon_sayisi', 'balkon sayisi', 'balkon sayısı'] },
                    { label: 'Teras', keys: ['teras_sayisi', 'teras sayisi', 'teras sayısı'] },
                ], { fieldsOnly: true });
            }

            return [];
        },

        projectRoomBuilderVisible() {
            return !!(
                this.projectRoomCounterVisible ||
                this.projectRoomPresetVisible ||
                this.projectRoomCountField ||
                this.projectKitchenField ||
                (this.projectCommercialPlanField && this.projectCommercialPlanOptions.length) ||
                (this.projectCommercialPartitionSelected && this.projectPartitionCountField) ||
                this.projectRoomMinOnlyItems.length
            );
        },

        projectBasicItems() {
            const items = this.uniqueFilterItems(this.buildProjectSectionItems('basic'));

            if (this.isProjectFilterMode) {
                const alreadyHasUnitArea = items.some(item => item.type === 'field' && this.projectFieldMatches(item.field, [
                    'unit_m2', 'ünite m2', 'unite m2', 'daire_m2_brut', 'daire m2', 'villa_m2_brut', 'villa m2', 'ofis_buro_m2_brut', 'magaza_dukkan_m2_brut', 'brut_m2', 'net_m2'
                ]));

                if (!alreadyHasUnitArea) {
                    items.unshift({
                        type: 'project_unit_area',
                        key: 'project-unit-area',
                        label: this.projectUnitAreaFallbackLabel,
                    });
                }
            }

            // Projelerde Güneş Alma kaldırıldı; Manzara ve Cephe korunur.
            return this.orderViewSunlightFacade(this.uniqueFilterItems(items));
        },

        projectPropertyItems() {
            return this.orderViewImmediatelyBeforeFacade(
                this.uniqueFilterItems(this.buildProjectSectionItems('property'))
            );
        },

        projectSocialFeatureGroups() {
            // Proje türünde sosyal/teknik alanları ilan ekleme ekranındaki gerçek
            // feature değerleriyle eşleştiriyoruz. Sadece grup adına bakmak, aynı
            // section altındaki itemların büyük bölümünü kaçırıyordu.
            const definitions = this.projectSocialDefinitions();
            // Proje sosyal grupları yalnızca ilan eklemedeki "Sosyal & Teknik Özellikler"
            // kaynağından beslenir. Güneş Alma, Manzara, Cephe, Park Yeri ve Isıtma/Soğutma
            // gibi Mülk Detayları gruplarının sosyal eşleme tarafından tüketilmesini engeller.
            const allItems = this.residentialSocialFeatureSourceItems()
                .filter(entry => this.residentialSocialGroupLooksTechnical(entry.group));
            const usedItemIds = new Set();
            const groups = [];

            definitions.forEach((definition, definitionIndex) => {
                const matchedEntries = [];

                allItems.forEach(entry => {
                    const itemId = Number(entry?.id || 0);
                    if (!itemId || usedItemIds.has(itemId)) return;

                    const groupMatches = this.residentialSocialGroupMatchesDefinition(entry.group, definition);
                    const itemMatches = this.residentialSocialItemMatchesDefinition(entry, definition);

                    if (groupMatches || itemMatches) {
                        matchedEntries.push(entry);
                    }
                });

                // Ofis/Büro ve Mağaza/Dükkan için PDF'deki "Diğer Özellikler"
                // grubu, Sosyal & Teknik Özellikler section'ında kalan değerleri de
                // toplar. Daire/Residence ve Villa/Tiny House'ta ise dokümanda
                // belirtilen 6 grup dışına çıkmıyoruz.
                if (definition.collectUnmatchedSocial) {
                    allItems.forEach(entry => {
                        const itemId = Number(entry?.id || 0);
                        if (!itemId || usedItemIds.has(itemId)) return;

                        if (this.residentialSocialGroupLooksTechnical(entry.group)) {
                            matchedEntries.push(entry);
                        }
                    });
                }

                const sourceGroupIds = new Set();
                const sourceItemIds = new Set();
                const items = [];

                matchedEntries.forEach(entry => {
                    const itemId = Number(entry?.id || 0);
                    if (!itemId || usedItemIds.has(itemId)) return;

                    usedItemIds.add(itemId);
                    sourceItemIds.add(itemId);
                    if (Number(entry?.sourceGroupId || 0) > 0) {
                        sourceGroupIds.add(Number(entry.sourceGroupId));
                    }

                    items.push({
                        ...entry.item,
                        id: itemId,
                        name: entry.name,
                        source_group_id: Number(entry?.sourceGroupId || 0),
                        source_group_name: entry.groupName,
                    });
                });

                if (items.length > 0) {
                    groups.push({
                        id: `${definition.key || 'project-social'}-${definitionIndex}`,
                        key: definition.key,
                        name: definition.label,
                        items,
                        sourceGroupIds: Array.from(sourceGroupIds),
                        sourceItemIds: Array.from(sourceItemIds),
                    });
                }
            });

            return groups;
        },

        projectHasBasicContent() {
            return this.projectRoomBuilderVisible || this.projectBasicItems.length > 0;
        },

        projectRemainingItems() {
            return this.uniqueFilterItems(this.buildProjectRemainingItems());
        },

        isResidentialFilterMode() {
            if (this.isLandFilterMode || this.isProjectFilterMode || this.isCommercialFilterMode) return false;

            const schema = this.selectedCategorySchemaHaystack;
            if (schema.includes('konut') || schema.includes('residential')) {
                return this.currentResidentialTypeKey !== '';
            }

            const text = this.normalizeText(this.selectedCategoryHaystack);
            const isResidential = [
                'konut', 'residential', 'daire', 'apartment', 'residence', 'rezidans',
                'villa', 'mustakil', 'detached_house', 'detached', 'tiny', 'ciftlik_evi', 'farmhouse',
            ].some(key => text.includes(key));

            return isResidential && this.currentResidentialTypeKey !== '';
        },

        currentResidentialTypeKey() {
            if (this.isLandFilterMode) return '';

            const schema = this.selectedCategorySchemaHaystack;
            const text = this.normalizeText(this.selectedCategoryHaystack);
            const source = `${schema} ${text}`;

            if (['villa', 'mustakil', 'detached_house', 'detached', 'tiny', 'ciftlik_evi', 'farmhouse'].some(key => source.includes(key))) {
                return 'villa';
            }

            if (['daire', 'apartment', 'residence', 'rezidans', 'konut', 'residential'].some(key => source.includes(key))) {
                return 'apartment';
            }

            return '';
        },

        residentialTypeLabel() {
            return this.currentResidentialTypeKey === 'villa'
                ? 'Villa / Müstakil Ev / Tiny House / Çiftlik Evi'
                : 'Daire / Residence';
        },

        residentialPriceStatusItems() {
            if (String(this.form.transaction_type) === '2') {
                return [];
            }

            return this.findResidentialToggleItems(this.residentialPriceToggleDefinitions('status'));
        },

        residentialPriceOpportunityItems() {
            const type = String(this.form.transaction_type) === '2' ? 'rental_opportunity' : 'sale_opportunity';
            return this.findResidentialToggleItems(this.residentialPriceToggleDefinitions(type));
        },

        residentialBedroomField() {
            return this.residentialFindField(['yatak_odasi_sayisi', 'yatak odasi', 'yatak odası', 'bedroom']);
        },

        residentialSalonField() {
            return this.residentialFindField(['salon_sayisi', 'salon sayisi', 'salon sayısı', 'living room']);
        },

        residentialRoomCountField() {
            return this.residentialFindField(['oda_sayisi', 'oda sayisi', 'oda sayısı', 'oda_salon', 'room_count', 'room count']);
        },

        residentialKitchenField() {
            return this.residentialFindField(['mutfak_tipi', 'mutfak turu', 'mutfak türü', 'mutfak']);
        },

        residentialRoomOptions() {
            const field = this.residentialRoomCountField;
            const baseOptions = field && Array.isArray(field.options) && field.options.length > 0
                ? field.options.map(option => ({ id: String(option.id), name: option.name || String(option.id), synthetic: false }))
                : (this.initialRoomOptions || []).map(option => ({ id: String(option.id), name: option.name || String(option.id), synthetic: false }));

            return this.mergeTurkishRoomPresetOptions(baseOptions);
        },

        filteredResidentialRoomMaxOptions() {
            return this.filteredRoomMaxOptions(this.residentialRoomOptions, this.residentialRoomPresetValue('min'));
        },

        residentialRoomPresetVisible() {
            const hasPresetTarget = !!(
                this.residentialRoomCountField
                || (this.residentialBedroomField && this.residentialSalonField)
            );

            return hasPresetTarget && this.residentialRoomOptions.length > 0;
        },

        residentialRoomRangeVisible() {
            return !!(
                this.residentialBedroomField
                || this.residentialSalonField
                || this.residentialRoomPresetVisible
                || this.residentialRoomCountField
            );
        },

        residentialRoomMinOnlyItems() {
            return this.residentialResolveDefinitions([
                { label: 'Giyinme Odası', keys: ['giyinme_odasi_sayisi', 'giyinme odasi', 'giyinme odası'] },
                { label: 'Ebeveyn Banyosu', keys: ['ebeveyn_banyosu_sayisi', 'ebeveyn banyosu'] },
                { label: 'Ortak Banyo', keys: ['banyo_sayisi', 'ortak_banyo_sayisi', 'ortak banyo', 'ortak banyo sayisi', 'ortak banyo sayısı'] },
                { label: 'WC', keys: ['wc_sayisi', 'wc sayisi', 'wc sayısı'] },
                { label: 'Balkon', keys: ['balkon_adet', 'balkon_sayisi', 'balkon sayisi', 'balkon sayısı'] },
                { label: 'Teras', keys: ['teras_adet', 'teras_sayisi', 'teras sayisi', 'teras sayısı'] },
                { label: 'Depo', keys: ['depo_adet', 'depo_sayisi', 'depo sayisi', 'depo sayısı'] },
            ], { fieldsOnly: true });
        },

        residentialRoomBuilderVisible() {
            const hasCanonicalRoomSection = this.dynamicFields.some(field =>
                this.fieldBelongsToCanonicalSection(field, [
                    'Odalar ve Diğer Alanlar',
                    'Rooms and Other Areas',
                    'Rooms & Other Areas',
                ])
            );

            return !!(
                this.residentialBedroomField ||
                this.residentialSalonField ||
                this.residentialRoomPresetVisible ||
                this.residentialRoomCountField ||
                this.residentialKitchenField ||
                this.residentialRoomMinOnlyItems.length ||
                hasCanonicalRoomSection
            );
        },

        residentialBasicItems() {
            return this.uniqueFilterItems(this.buildResidentialSectionItems('basic'));
        },

        residentialStatusItems() {
            const items = this.uniqueFilterItems(this.buildResidentialSectionItems('status'));
            const sunlightRevisionScope = this.isPdfRevisionTransaction() && (
                this.currentResidentialTypeKey === 'villa'
                || (this.currentResidentialTypeKey === 'apartment' && this.isPdfRevisionTurkishLocale())
            );

            return sunlightRevisionScope
                ? this.orderViewSunlightFacade(items)
                : this.orderViewImmediatelyBeforeFacade(items);
        },

        residentialDetailItems() {
            return this.orderViewImmediatelyBeforeFacade(
                this.uniqueFilterItems(this.buildResidentialSectionItems('detail'))
            );
        },

        residentialParkingItems() {
            return this.uniqueFilterItems(this.buildResidentialSectionItems('parking'));
        },

        residentialPropertyItems() {
            return this.residentialDetailItems;
        },

        residentialLegalItems() {
            return this.uniqueFilterItems(this.buildResidentialSectionItems('legal'));
        },

        residentialStep3Sections() {
            const sections = [];

            const addItems = (key, title, items) => {
                if (Array.isArray(items) && items.length > 0) {
                    sections.push({ key, title, type: 'items', items });
                }
            };

            const itemLabel = (item) => this.normalizeText([item?.label, item?.field?.canonical_name, item?.field?.name, item?.group?.canonical_name, item?.group?.name].filter(Boolean).join(' '));
            const isEarthquakeItem = (item) => {
                const label = itemLabel(item);
                return label.includes('deprem') || label.includes('earthquake');
            };

            // PDF sırası: Fiyat -> Odalar -> Temel Özellikler -> Mülk Bilgileri -> Sosyal & Teknik Özellikler.
            if (this.residentialRoomBuilderVisible) {
                sections.push({ key: 'rooms', title: 'Odalar ve Diğer Alanlar', type: 'rooms', items: [] });
            }

            addItems('basic', 'Temel Özellikler', [
                ...this.residentialBasicItems,
                ...this.residentialStatusItems,
            ]);

            const legalItems = this.residentialLegalItems;
            const nonEarthquakeLegalItems = legalItems.filter(item => !isEarthquakeItem(item));
            const earthquakeLegalItems = legalItems.filter(item => isEarthquakeItem(item));

            const propertyItems = [
                ...this.residentialDetailItems,
                ...this.residentialParkingItems,
                ...nonEarthquakeLegalItems,
            ];

            // PDF'te Kimden, Tapu/İskan'dan sonra ve Deprem Yönetmeliği'nden önce isteniyor.
            if (this.ownerTypeOptions.length > 0) {
                propertyItems.push({ type: 'owner', key: 'owner', label: 'Kimden' });
            }

            propertyItems.push(...earthquakeLegalItems);

            addItems('property', 'Mülk Bilgileri', propertyItems);

            if (this.residentialSocialFeatureGroups.length > 0) {
                sections.push({
                    key: 'social',
                    title: 'Sosyal & Teknik Özellikler',
                    type: 'social',
                    groups: this.residentialSocialFeatureGroups,
                });
            }

            return sections;
        },

        residentialSocialFeatureGroups() {
            const definitions = this.residentialSocialDefinitions();
            const allItems = this.residentialSocialFeatureSourceItems();
            const usedItemIds = new Set();
            const result = [];

            definitions.forEach(definition => {
                let matched = [];

                allItems.forEach(entry => {
                    const itemId = Number(entry.id);
                    if (!itemId || usedItemIds.has(itemId)) return;

                    const groupMatched = this.residentialSocialGroupMatchesDefinition(entry.group, definition);
                    const itemMatched = this.residentialSocialItemMatchesDefinition(entry, definition);

                    if (groupMatched || itemMatched) {
                        matched.push(entry);
                    }
                });

                if (definition.collectUnmatchedSocial) {
                    allItems.forEach(entry => {
                        const itemId = Number(entry.id);
                        if (!itemId || usedItemIds.has(itemId)) return;

                        if (this.residentialSocialGroupLooksTechnical(entry.group)) {
                            matched.push(entry);
                        }
                    });
                }

                const uniqueItems = [];
                const sourceGroupIds = new Set();

                matched.forEach(entry => {
                    const itemId = Number(entry.id);
                    if (!itemId || usedItemIds.has(itemId)) return;

                    usedItemIds.add(itemId);
                    if (entry.sourceGroupId > 0) {
                        sourceGroupIds.add(entry.sourceGroupId);
                    }

                    uniqueItems.push({
                        ...entry.item,
                        id: entry.id,
                        name: entry.name,
                        source_group_id: entry.sourceGroupId,
                        source_group_name: entry.groupName,
                    });
                });

                if (uniqueItems.length > 0) {
                    result.push({
                        id: `res-social-${definition.key}`,
                        key: definition.key,
                        name: definition.label,
                        sourceGroupIds: Array.from(sourceGroupIds),
                        items: uniqueItems,
                    });
                }
            });

            return result;
        },

        residentialHasBasicContent() {
            return this.residentialStep3Sections.length > 0;
        },

        residentialRemainingItems() {
            return this.uniqueFilterItems(this.buildResidentialRemainingItems());
        },

        currentLandTypeKey() {
            if (!this.isLandFilterMode) return '';

            const text = this.normalizeText(this.selectedCategoryHaystack);

            if (text.includes('tarim') || text.includes('bag') || text.includes('bahce') || text.includes('hobi')) {
                return 'agricultural';
            }

            if (text.includes('kirsal') || text.includes('koy')) {
                return 'rural_village';
            }

            if (text.includes('konut') && text.includes('imar')) {
                return 'residential_zoned';
            }

            if (text.includes('villa') && text.includes('imar')) {
                return 'villa_zoned';
            }

            if (text.includes('enerji') || text.includes('depolama')) {
                return 'energy_storage';
            }

            if (text.includes('sanayi')) {
                return 'industrial';
            }

            return 'generic_land';
        },

        landTypeLabel() {
            return this.landLayoutConfig().label || 'Arsa / Arazi';
        },

        landDetailsGroupTitle() {
            return this.landLayoutConfig().detailsTitle || 'Arsa Detayları';
        },

        landNeedsExtraPriceOptions() {
            return ['residential_zoned', 'villa_zoned'].includes(this.currentLandTypeKey);
        },

        landPriceStatusItems() {
            return this.findLandToggleItems(this.landPriceToggleDefinitions('status'));
        },

        landPriceOpportunityItems() {
            const definitions = this.landPriceToggleDefinitions('opportunity');

            if (this.landNeedsExtraPriceOptions) {
                // Satılık Konut İmarlı Arsa ve Villa İmarlı Arsa aynı hazırlık alanlarını kullanır.
                definitions.push(...this.landPriceToggleDefinitions('land_sale_opportunity'));
                definitions.push(...this.landPriceToggleDefinitions('zoned_ready_opportunity'));
            }

            return this.findLandToggleItems(definitions);
        },

        landOrderedItems() {
            return this.orderViewImmediatelyBeforeFacade(
                this.uniqueFilterItems(this.buildLandOrderedItems())
            );
        },

        landRemainingItems() {
            return this.uniqueFilterItems(this.buildLandRemainingItems());
        },

        activeChips() {
            const chips = [];
            const parkingChipItem = this.buildParkingFilterItem('active-chip');
            const parkingChipOptions = Array.isArray(parkingChipItem?.options) ? parkingChipItem.options : [];
            const parkingOptionForCountField = (fieldId) => parkingChipOptions.find(option => (
                option?.countField && String(option.countField.id) === String(fieldId)
            )) || null;

            if (this.effectiveCategoryId) {
                chips.push({ key: 'category_id', label: this.categoryLabel(this.effectiveCategoryId), type: 'category' });
            }

            const locationLabel = this.locationLabel();
            if (locationLabel) {
                chips.push({ key: 'location', label: locationLabel, type: 'location' });
            }

            if (this.form.min_price || this.form.max_price) {
                chips.push({ key: 'price', label: this.rangeText(this.form.min_price, this.form.max_price, 'TL', true), type: 'price' });
            }



            if (this.form.owner_types.length) {
                chips.push({
                    key: 'owner_types',
                    label: this.uiText('Kimden: :count seçim', { count: this.form.owner_types.length }),
                    type: 'owner_types'
                });
            }

            const projectUnitRoomChip = this.projectUnitRoomChipLabel();
            if (projectUnitRoomChip) {
                chips.push({
                    key: 'project_unit_rooms',
                    label: this.uiText('Odalar: :value', { value: projectUnitRoomChip }),
                    type: 'project_unit_rooms'
                });
            }

            const projectUnitAreaChip = this.projectUnitAreaChipLabel();
            if (projectUnitAreaChip) {
                chips.push({
                    key: 'project_unit_area',
                    label: this.uiText('Ünite m²: :value', { value: projectUnitAreaChip }),
                    type: 'project_unit_area'
                });
            }

            Object.keys(this.form.fields || {}).forEach(fieldId => {
                const value = this.form.fields[fieldId];

                // Range object (numeric min-max)
                if (value && typeof value === 'object' && !Array.isArray(value)) {
                    const min = String(value.min || '').trim();
                    const max = String(value.max || '').trim();
                    if (!min && !max) return;

                    const field = this.dynamicFields.find(item => String(item.id) === String(fieldId));
                    if (field && this.isGloballyHiddenDynamicField(field)) return;

                    const parkingOption = parkingOptionForCountField(fieldId);
                    if (
                        parkingOption?.featureItem
                        && this.form.feature_value_ids.includes(Number(parkingOption.featureItem.id))
                    ) {
                        return;
                    }

                    const unit = field?.unit || '';

                    const isMoney = field && this.isMoneyField(field);
                    const isCurrentFloor = field && this.isCurrentFloorField(field);
                    const displayUnit = isMoney || isCurrentFloor ? (isMoney ? 'TL' : '') : unit;
                    const minLabel = isMoney ? this.formatPrice(min) : (isCurrentFloor ? this.currentFloorLabel(min) : min);
                    const maxLabel = isMoney ? this.formatPrice(max) : (isCurrentFloor ? this.currentFloorLabel(max) : max);

                    let rangeLabel = '';
                    if (isCurrentFloor) {
                        if (min && max && String(min) === String(max)) {
                            rangeLabel = minLabel;
                        } else if (min && max) {
                            rangeLabel = `${minLabel} - ${maxLabel}`;
                        } else if (min) {
                            rangeLabel = minLabel;
                        } else {
                            rangeLabel = maxLabel;
                        }
                    } else if (min && max) {
                        rangeLabel = `${minLabel} - ${maxLabel}${displayUnit ? ' ' + displayUnit : ''}`;
                    } else if (min) {
                        rangeLabel = `${minLabel}${displayUnit ? ' ' + displayUnit : ''}+`;
                    } else {
                        const valueWithUnit = `${maxLabel}${displayUnit ? ' ' + displayUnit : ''}`;
                        rangeLabel = this.uiText(':value ve altı', { value: valueWithUnit });
                    }

                    const label = field
                        ? `${this.uiText(field.name)}: ${rangeLabel}`
                        : this.uiText('Alan: :value', { value: rangeLabel });
                    chips.push({ key: `field-${fieldId}`, label, type: 'field', fieldId });
                    return;
                }

                const values = Array.isArray(value)
                    ? value.map(item => String(item).trim()).filter(Boolean)
                    : (value !== null && value !== undefined && String(value).trim() !== '' ? [String(value).trim()] : []);

                if (!values.length) {
                    return;
                }

                const field = this.dynamicFields.find(item => String(item.id) === String(fieldId));
                if (field && this.isGloballyHiddenDynamicField(field)) return;

                const parkingOption = parkingOptionForCountField(fieldId);
                if (
                    parkingOption?.featureItem
                    && this.form.feature_value_ids.includes(Number(parkingOption.featureItem.id))
                ) {
                    return;
                }

                const readableValue = field
                    ? values.map(item => this.fieldValueLabel(field, item)).filter(Boolean).join(', ')
                    : values.join(', ');
                const label = field
                    ? `${this.uiText(field.name)}: ${readableValue}`
                    : this.uiText('Alan: :value', { value: readableValue });
                chips.push({ key: `field-${fieldId}`, label, type: 'field', fieldId });
            });

            this.form.feature_value_ids.forEach(id => {
                chips.push({ key: `feature-${id}`, label: this.featureValueLabel(id), type: 'feature', valueId: Number(id) });
            });

            if (Number(this.form.has_virtual_tour) === 1) {
                chips.push({ key: 'has_virtual_tour', label: this.uiText('Sanal tur'), type: 'has_virtual_tour' });
            }

            return chips;
        },

        activeFilterCount() {
            return this.activeChips.length;
        },

        submitButtonText() {
            if (this.liveCount === null || this.liveCount === undefined) {
                return this.uiText('İlanları göster');
            }

            return this.uiText(':count ilanı göster', { count: this.formatNumber(this.liveCount) });
        },
    },

    watch: {
        form: {
            deep: true,
            handler() {
                if (this.isDomSyncing) {
                    return;
                }

                this.syncDynamicConditionalYearFields();
                this.enforceAllRoomPresetRanges();
                this.syncDomState();
                this.scheduleLiveCount();
            },
        },
        'form.min_price'(newMin) {
            if (!newMin || !this.form.max_price) return;
            const min = parseFloat(String(newMin).replace(/\./g, '').replace(',', '.'));
            const max = parseFloat(String(this.form.max_price).replace(/\./g, '').replace(',', '.'));
            if (!isNaN(min) && !isNaN(max) && max < min) {
                this.form.max_price = '';
            }
        },
        commercialPartitionSelected(isSelected) {
            if (isSelected) return;

            [this.commercialPartitionCountField, this.commercialRoomCountField].forEach(field => {
                if (field && this.form.fields && Object.prototype.hasOwnProperty.call(this.form.fields, String(field.id))) {
                    this.form.fields[String(field.id)] = '';
                }
            });
        },
        projectInstallmentSelected(isSelected) {
            if (isSelected) return;

            this.projectInstallmentTermItems.forEach(item => {
                if (item && item.field) {
                    this.clearProjectInstallmentTermField(item.field);
                }
            });
        },
    },

    mounted() {
        this.updateFilterViewportHeight();
        this._nfViewportHandler = () => this.updateFilterViewportHeight();
        window.addEventListener('resize', this._nfViewportHandler, { passive: true });
        window.addEventListener('orientationchange', this._nfViewportHandler, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this._nfViewportHandler, { passive: true });
        }

        this.fillFormFromRequest();
        this.sanitizeCategoryForCurrentTransaction(false);
        this.syncDynamicConditionalYearFields();
        this.enforceAllRoomPresetRanges();
        this.syncDomState();
        this.bindOpenTriggers();
        this.bootstrapLocationOptions();
        this.refreshMetadataForCurrentSelection(false);
        // Page-load sırasında otomatik lokasyon resolve kapalı. Sadece kullanıcı seçince veya submit sırasında çalışır.
        this.scheduleLiveCount();

        this.exposeFilterBridge();

        window.addEventListener('home-search-state-changed', this.onExternalSearchStateChanged);
        document.addEventListener('click', this._onDocClickCombo);

        this.$nextTick(() => this.scheduleUiLocalization());
    },

    updated() {
        this.scheduleUiLocalization();
    },

    beforeUnmount() {
        window.removeEventListener('open-filter-popup', this.open);
        window.removeEventListener('home-search-state-changed', this.onExternalSearchStateChanged);
        document.removeEventListener('click', this._onDocClickCombo);

        if (this._nfViewportHandler) {
            window.removeEventListener('resize', this._nfViewportHandler);
            window.removeEventListener('orientationchange', this._nfViewportHandler);
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', this._nfViewportHandler);
            }
            this._nfViewportHandler = null;
        }

        if (window.NetteSearchFilter && window.NetteSearchFilter.context === this.context) {
            delete window.NetteSearchFilter;
        }

        if (this._uiLocalizationRaf) {
            window.cancelAnimationFrame(this._uiLocalizationRaf);
            this._uiLocalizationRaf = null;
        }

        clearTimeout(this.countTimer);
        if (this.countAbortController) {
            this.countAbortController.abort();
            this.countAbortController = null;
        }

        this.unlockFilterBody();
    },

    methods: {
        uiText(source, replacements = {}) {
            const table = (this.uiTranslations && typeof this.uiTranslations === 'object')
                ? this.uiTranslations
                : {};
            const fragments = (table.__fragments && typeof table.__fragments === 'object')
                ? table.__fragments
                : {};

            const original = String(source ?? '');
            let text = Object.prototype.hasOwnProperty.call(table, original)
                ? String(table[original])
                : original;

            if (text === original && text) {
                Object.keys(fragments)
                    .sort((a, b) => b.length - a.length)
                    .forEach(fragment => {
                        if (!fragment || !text.includes(fragment)) return;
                        text = text.split(fragment).join(String(fragments[fragment]));
                    });
            }

            Object.entries(replacements || {}).forEach(([key, value]) => {
                text = text.split(':' + key).join(String(value ?? ''));
            });

            return text;
        },

        transactionTypeLabel(transactionType) {
            const type = String(transactionType ?? '');
            if (this.context === 'agency' && !type) {
                return this.uiText('Tümü');
            }
            const listForm = (document.getElementById('listFilterForm') || document.getElementById('agencyFilterForm'));

            if (listForm) {
                const radio = listForm.querySelector(`input[name="transaction_type"][value="${type}"]`);
                const small = radio?.closest('label')?.querySelector('small');
                const domText = String(small?.textContent || '').trim();

                if (domText) {
                    return this.uiText(domText);
                }
            }

            const transaction = (window.AD_LIST_I18N && typeof window.AD_LIST_I18N.transaction === 'object')
                ? window.AD_LIST_I18N.transaction
                : {};

            if (type === '2') {
                return String(transaction.rent || this.uiText('Kiralık'));
            }

            return String(transaction.sale || this.uiText('Satılık'));
        },

        scheduleUiLocalization() {
            if (this._uiLocalizationRaf) {
                window.cancelAnimationFrame(this._uiLocalizationRaf);
            }

            this._uiLocalizationRaf = window.requestAnimationFrame(() => {
                this._uiLocalizationRaf = null;
                this.localizeRenderedUi();
            });
        },

        localizeRenderedUi() {
            const root = this.$el;
            if (!root || !this.uiTranslations || typeof this.uiTranslations !== 'object') {
                return;
            }

            const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
            let node;

            while ((node = walker.nextNode())) {
                const raw = String(node.nodeValue || '');
                const core = raw.trim();
                if (!core) continue;

                const translated = this.uiText(core);
                if (translated === core) continue;

                const leading = raw.match(/^\s*/)?.[0] || '';
                const trailing = raw.match(/\s*$/)?.[0] || '';
                node.nodeValue = leading + translated + trailing;
            }

            const elements = [root, ...root.querySelectorAll('*')];
            elements.forEach(element => {
                ['placeholder', 'title', 'aria-label'].forEach(attribute => {
                    if (!element.hasAttribute || !element.hasAttribute(attribute)) return;

                    const value = element.getAttribute(attribute);
                    if (!value) return;

                    const translated = this.uiText(value);
                    if (translated !== value) {
                        element.setAttribute(attribute, translated);
                    }
                });
            });
        },
        updateFilterViewportHeight() {
            const height = window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight || 0;
            const vh = height * 0.01;

            if (vh > 0) {
                document.documentElement.style.setProperty('--nf-filter-vh', `${vh}px`);
            }
        },

        lockFilterBody() {
            if (this.filterBodyLocked) return;
            this.filterBodyLocked = true;
            this.filterBodyScrollY = window.HMScrollLock?.scrollY || window.scrollY || document.documentElement.scrollTop || 0;
            window.HMScrollLock?.lock('search-filter');
            document.documentElement.style.setProperty('--nf-filter-body-top', `-${this.filterBodyScrollY}px`);
            document.documentElement.classList.add('nf-filter-open');
            document.body.classList.add('lockscreen', 'nf-filter-open');
        },

        unlockFilterBody() {
            const restoreY = this.filterBodyScrollY || Math.abs(parseInt(
                getComputedStyle(document.documentElement).getPropertyValue('--nf-filter-body-top') || '0', 10
            )) || 0;
            this.filterBodyLocked = false;
            document.body.classList.remove('lockscreen', 'nf-filter-open');
            document.documentElement.classList.remove('nf-filter-open');
            document.documentElement.style.removeProperty('--nf-filter-body-top');
            if (window.HMScrollLock) window.HMScrollLock.unlock('search-filter');
            else if (!document.body.classList.contains('hm-mobile-search-open')) window.scrollTo(0, restoreY);
        },

        categoryAllowedTransactions(category) {
            const raw = category?.allowed_transaction_types ?? category?.meta?.allowed_transaction_types ?? [1, 2];
            const values = Array.isArray(raw) ? raw : String(raw || '').split(',');
            const parsed = values
                .map(value => parseInt(value, 10))
                .filter(value => value === 1 || value === 2);

            return parsed.length ? parsed : [1, 2];
        },

        isProjectCategoryNode(category) {
            const haystack = this.normalizeText([
                category?.schema_key,
                category?.meta?.schema_key,
                category?.canonical_name,
                category?.name,
                category?.title,
                category?.slug,
                category?.key,
                category?.type,
                category?.meta?.name,
                category?.meta?.slug,
                category?.meta?.key,
                category?.meta?.type,
            ].filter(Boolean).join(' '));

            return haystack.includes('proje') || haystack.includes('project');
        },

        isCategoryAllowedForTransaction(category, transactionType) {
            const tx = parseInt(transactionType || '0', 10);
            if (!tx) return true;

            // İlan girişinde kiralıkta proje açılmadığı için filtre tarafında da proje gösterilmez.
            if (tx === 2 && this.isProjectCategoryNode(category)) {
                return false;
            }

            return this.categoryAllowedTransactions(category).includes(tx);
        },

        findCategoryNodeById(categoryId, nodes = null) {
            const needle = this.normalizeId(categoryId);
            if (!needle) return null;

            const list = Array.isArray(nodes) ? nodes : this.mainCategories;

            for (const item of list) {
                if (String(item?.id) === needle) {
                    return item;
                }

                if (Array.isArray(item?.children) && item.children.length > 0) {
                    const found = this.findCategoryNodeById(needle, item.children);
                    if (found) return found;
                }
            }

            return null;
        },

        sanitizeCategoryForCurrentTransaction(resetDynamic = false) {
            const tx = parseInt(this.form.transaction_type || '0', 10);
            if (!tx) return false;

            let changed = false;

            if (this.form.main_category_id) {
                const root = this.findCategoryNodeById(this.form.main_category_id, this.mainCategories);

                if (!root || !this.isCategoryAllowedForTransaction(root, tx)) {
                    this.form.main_category_id = '';
                    this.form.subcategory_id = '';
                    changed = true;
                }
            }

            if (!changed && this.form.subcategory_id) {
                const child = this.findCategoryNodeById(this.form.subcategory_id, this.mainCategories);

                if (!child || !this.isCategoryAllowedForTransaction(child, tx)) {
                    this.form.subcategory_id = '';
                    changed = true;
                }
            }

            if (changed && resetDynamic) {
                this.resetDynamicState();
            }

            return changed;
        },

        residentialSocialFeatureSourceItems() {
            const rows = [];

            this.dynamicFeatures.forEach(group => {
                if (this.isViewOrFacadeFeatureGroup(group)) {
                    return;
                }

                const groupItems = Array.isArray(group?.items) ? group.items : [];
                groupItems.forEach(item => {
                    rows.push({
                        id: Number(item?.id || 0),
                        name: item?.name || item?.label || item?.value || '',
                        canonicalName: item?.canonical_name || item?.schema_value || '',
                        item,
                        group,
                        groupName: group?.name || group?.label || group?.key || '',
                        canonicalGroupName: group?.canonical_name || group?.schema_key || group?.key || '',
                        sourceGroupId: Number(group?.id || 0),
                    });
                });
            });

            return rows;
        },

        residentialSocialGroupMatchesDefinition(group, definition) {
            const primaryGroupName = this.filterStructuralPrimaryIdentity(group);
            const groupIdentity = this.filterStructuralIdentity(group);
            const aliases = [definition.label].concat(definition.groupNames || []);

            return aliases.some(alias => {
                const normalizedAlias = this.normalizeText(alias);
                if (!normalizedAlias) return false;

                return primaryGroupName === normalizedAlias
                    || groupIdentity === normalizedAlias
                    || groupIdentity.includes(normalizedAlias);
            });
        },

        residentialSocialItemMatchesDefinition(entry, definition) {
            const itemName = this.filterStructuralPrimaryIdentity(entry?.item);
            const labels = (definition.labels || []).map(label => this.normalizeText(label)).filter(Boolean);

            if (labels.includes(itemName)) {
                return true;
            }

            const exactNeedles = (definition.keys || []).map(key => this.normalizeText(key)).filter(Boolean);
            const haystack = this.normalizeText([
                this.filterStructuralDescriptor(entry?.group, false),
                this.filterStructuralDescriptor(entry?.item, false),
            ].filter(Boolean).join(' '));

            return exactNeedles.some(needle => {
                if (!needle) return false;
                return haystack === needle || haystack.includes(needle);
            });
        },

        residentialSocialGroupLooksTechnical(group) {
            const groupName = this.filterStructuralIdentity(group);
            const metaSection = this.normalizeText([
                group?.canonical_section,
                group?.meta?.canonical_section,
                group?.meta?.section,
                group?.meta?.group,
            ].filter(Boolean).join(' '));

            if (metaSection.includes('sosyal') && metaSection.includes('teknik')) {
                return true;
            }

            return ['diger ozellik', 'diğer özellik'].some(needle => {
                const normalizedNeedle = this.normalizeText(needle);
                return normalizedNeedle && groupName.includes(normalizedNeedle);
            });
        },

        residentialSocialFeatureItemIds() {
            const ids = new Set();

            this.residentialSocialFeatureGroups.forEach(group => {
                (group.items || []).forEach(item => {
                    const id = Number(item.id || 0);
                    if (id > 0) ids.add(id);
                });
            });

            return Array.from(ids);
        },

        residentialSocialFeatureSourceGroupIds() {
            const ids = new Set();

            this.residentialSocialFeatureGroups.forEach(group => {
                (group.sourceGroupIds || []).forEach(id => {
                    const numericId = Number(id || 0);
                    if (numericId > 0) ids.add(numericId);
                });
            });

            return Array.from(ids);
        },

        residentialSocialUsesFeatureGroup(group) {
            const id = Number(group?.id || 0);
            return id > 0 && this.residentialSocialFeatureSourceGroupIds().includes(id);
        },

        emptyForm() {
            return {
                transaction_type: this.context === 'agency' ? '' : DEFAULT_TRANSACTION_TYPE,
                main_category_id: '',
                subcategory_id: '',
                min_price: '',
                max_price: '',

                owner_types: [],
                country_id: '',
                city_id: '',
                district_id: '',
                quarter_id: '',
                location_label: '',
                q: '',
                has_virtual_tour: 0,
                project_unit_rooms: {
                    bedrooms: { min: '', max: '' },
                    living_rooms: { min: '', max: '' },
                },
                project_unit_area: { min: '', max: '' },
                fields: {},
                feature_value_ids: [],
            };
        },

        defaultQuickFieldConfigs() {
            return [
                { key: 'property-status', label: 'Taşınmaz Durumu', keys: ['tasinmaz_durumu', 'taşınmaz durumu'] },
                { key: 'garden', label: 'Bahçe Durumu', keys: ['bahce_tipi', 'bahçe'] },
                { key: 'parking', label: 'Park Yeri', keys: ['acik_otopark_arac', 'kapali_otopark_arac', 'park yeri'] },
                { key: 'title-deed', label: 'Tapu Durumu', keys: ['tapu_durumu_bina', 'tapu_durumu_arsa', 'tapu durumu'] },
                { key: 'occupancy', label: 'İskan Durumu', keys: ['iskan_durumu', 'iskan durumu'] },
                { key: 'earthquake', label: 'Deprem Yönetmeliği', keys: ['deprem_yonetmeligine_uygun', 'deprem yönetmeliğine uygun'] },
                { key: 'kitchen', label: 'Mutfak Türü', keys: ['mutfak_tipi', 'mutfak_tipi_proje', 'mutfak türü'] },
                { key: 'dressing', label: 'Giyinme Odası', keys: ['giyinme_odasi_sayisi', 'giyinme odası sayısı'] },
                { key: 'flat-type', label: 'Mülk Şekli / Villa Tipi', keys: ['mulk_sekli_daire', 'mulk_sekli_villa', 'mulk_sekli_magaza', 'mulk_sekli_ofis', 'mulk_sekli_kafe', 'mülk şekli', 'villa tipi'] },
                { key: 'furnished', label: 'Eşya Durumu', keys: ['esya_durumu', 'esya_durumu_proje', 'eşya durumu'] },
                { key: 'construction-status', label: 'Yapım Durumu', keys: ['yapim_durumu', 'yapim_asamasinda', 'yapım durumu'] },
                { key: 'building-type', label: 'Yapı Tipi', keys: ['yapi_tipi', 'yapı tipi'] },
                { key: 'usage-purpose', label: 'Kullanım Amacı', keys: ['kullanim_amaci_magaza', 'kullanim_amaci_ofis', 'kullanim_amaci_kafe', 'kullanım amacı'] },
            ];
        },

        normalizeText(value) {
            return String(value || '')
                .toLocaleLowerCase('tr-TR')
                .replace(/ı/g, 'i')
                .replace(/ğ/g, 'g')
                .replace(/ü/g, 'u')
                .replace(/ş/g, 's')
                .replace(/ö/g, 'o')
                .replace(/ç/g, 'c')
                .replace(/[^a-z0-9]+/g, '_')
                .replace(/^_+|_+$/g, '');
        },

        identityHasToken(value, token) {
            const haystack = this.normalizeText(value);
            const needle = this.normalizeText(token);

            if (!haystack || !needle) return false;

            return (`_${haystack}_`).includes(`_${needle}_`);
        },

        isProjectFieldOptionSelected(field, optionId) {
            if (!field) return false;
            const value = this.form.fields[String(field.id)];
            if (Array.isArray(value)) return value.map(String).includes(String(optionId));
            return String(value || '') === String(optionId);
        },

        setProjectSingleFieldOption(field, optionId, checked = true) {
            if (!field) return;
            this.form.fields[String(field.id)] = checked ? String(optionId) : '';
        },



        isCommercialFieldOptionSelected(field, optionId) {
            if (!field) return false;
            const value = this.form.fields[String(field.id)];
            if (Array.isArray(value)) return value.map(String).includes(String(optionId));
            return String(value || '') === String(optionId);
        },

        setCommercialSingleFieldOption(field, optionId, checked = true) {
            if (!field) return;
            this.form.fields[String(field.id)] = checked ? String(optionId) : '';
        },

        toggleCommercialFieldOption(field, optionId) {
            if (!field) return;
            if (this.isMultiField(field)) {
                this.toggleFieldArrayValue(field, optionId);
                return;
            }
            const selected = this.isCommercialFieldOptionSelected(field, optionId);
            this.setCommercialSingleFieldOption(field, optionId, !selected);
        },

        isPdfRevisionTransaction() {
            // PDF filtre revizyonları aynı kategori seçildiğinde Satılık ve Kiralıkta
            // aynı görsel/işlevsel düzeni kullanır. Proje vb. diğer işlem tiplerine
            // bu özel düzeni taşımıyoruz.
            return ['1', '2'].includes(String(this.form?.transaction_type ?? '').trim());
        },

        isPdfCommercialRevisionScope(types = []) {
            const allowed = Array.isArray(types) && types.length
                ? types
                : ['shop', 'office', 'cafe', 'hotel'];

            return !!(
                this.isPdfRevisionTransaction()
                && this.isCommercialFilterMode
                && allowed.includes(this.currentCommercialTypeKey)
            );
        },

        isPdfRevisionTurkishLocale() {
            return String(this.activeLocale || 'tr').toLowerCase() === 'tr';
        },

        isPdfRevisionOtherLocale() {
            return !['tr', 'en'].includes(String(this.activeLocale || 'tr').toLowerCase());
        },

        isPdfRevisionPaymentField(field) {
            if (!field || !this.isPdfRevisionTransaction() || !this.isPdfRevisionOtherLocale()) return false;

            const text = this.normalizeText([
                this.dynamicFieldHaystack(field),
                field?.canonical_name,
                field?.canonical_placeholder,
            ].filter(Boolean).join(' '));
            if (this.isResidentialFilterMode && ['apartment', 'villa'].includes(this.currentResidentialTypeKey)) {
                return text.includes('pesinat') || text.includes('depozito') || text.includes('down payment') || text.includes('security deposit');
            }

            if (this.isCommercialFilterMode && ['shop', 'office', 'cafe', 'hotel'].includes(this.currentCommercialTypeKey)) {
                return text.includes('depozito') || text.includes('kapora') || text.includes('kaparo') || text.includes('security deposit');
            }

            return false;
        },

        isPdfRevisionPaymentFeatureGroup(group) {
            if (!group || !this.isPdfRevisionTransaction() || !this.isPdfRevisionOtherLocale()) return false;

            const text = this.normalizeText(this.filterStructuralDescriptor(group, true));
            if (this.isResidentialFilterMode && ['apartment', 'villa'].includes(this.currentResidentialTypeKey)) {
                return text.includes('pesinat') || text.includes('depozito') || text.includes('down payment') || text.includes('security deposit');
            }

            if (this.isCommercialFilterMode && ['shop', 'office', 'cafe', 'hotel'].includes(this.currentCommercialTypeKey)) {
                return text.includes('depozito') || text.includes('kapora') || text.includes('kaparo') || text.includes('security deposit');
            }

            return false;
        },

        hasDirectionalFacadeOptions(value) {
            const options = Array.isArray(value?.options)
                ? value.options
                : (Array.isArray(value?.items) ? value.items : []);
            if (!options.length) return false;

            const text = this.normalizeText(options.map(option => [
                option?.canonical_name,
                option?.name,
                option?.label,
                option?.value,
                option?.schema_value,
            ].filter(Boolean).join(' ')).join(' '));

            const directions = ['kuzey', 'guney', 'dogu', 'bati', 'north', 'south', 'east', 'west'];
            return directions.filter(direction => text.includes(this.normalizeText(direction))).length >= 2;
        },

        isPdfRevisionWrongCommercialFacadeField(field) {
            if (!field || !this.isPdfCommercialRevisionScope(['shop', 'cafe'])) return false;

            const exactSchema = this.fieldMatchesExactSchema(field, ['cephe', 'cephe_durumu']);
            const ownLabel = this.normalizeText([field?.canonical_name, field?.name, field?.label].filter(Boolean).join(' '));
            const exactLabel = ['cephe', 'cephe durumu'].includes(ownLabel);

            return (exactSchema || exactLabel) && !this.hasDirectionalFacadeOptions(field);
        },

        isPdfCommercialCurrentFloorMinOnly(field) {
            return !!(
                field
                && this.isPdfCommercialRevisionScope(['shop', 'office', 'cafe'])
                && this.isCurrentFloorField(field)
            );
        },

        commercialLayoutConfigs() {
            const commercialRevisionTypes = ['shop', 'office', 'cafe', 'hotel'];
            const type = this.currentCommercialTypeKey;
            const applyCommercialRevision = this.isPdfCommercialRevisionScope(commercialRevisionTypes);

            const commonAreaKeys = [
                'banyo_sayisi', 'banyo sayisi', 'banyo sayısı',
                'wc_sayisi', 'wc sayisi', 'wc sayısı', 'tuvalet_sayisi',
                'depo_sayisi', 'depo sayisi', 'depo sayısı',
                ...(applyCommercialRevision ? ['depo_adet', 'depo adet'] : []),
                'soguk_hava_deposu', 'soğuk hava deposu', 'soguk hava deposu',
                ...(applyCommercialRevision ? ['soguk_hava_deposu_adet', 'soğuk hava deposu adet'] : []),
                'balkon_sayisi', 'balkon sayisi', 'balkon sayısı',
                ...(applyCommercialRevision ? ['balkon_adet', 'balkon adet'] : []),
                'teras_sayisi', 'teras sayisi', 'teras sayısı',
                ...(applyCommercialRevision ? ['teras_adet', 'teras adet'] : []),
                'ic_mekan_ozellikleri', 'iç mekan özellikleri', 'acik_plan', 'açık plan', 'duvarlarla_bolunmus', 'duvarlarla bölünmüş',
                'bolum_sayisi', 'bölüm sayısı', 'bolum sayisi',
                'oda_sayisi', 'oda sayisi', 'oda sayısı', 'toplam_oda_sayisi', 'toplam oda sayısı', 'room_count',
                'mutfak_tipi', 'mutfak türü', 'cay_ocagi', 'çay ocağı',
                'esya_durumu', 'eşya durumu', 'esya durumu',
            ];

            const priceKeys = this.commercialPriceToggleDefinitions('status')
                .concat(this.commercialPriceToggleDefinitions('sale_opportunity'))
                .concat(this.commercialPriceToggleDefinitions('rental_opportunity'))
                .flatMap(item => item.keys || []);

            const standardBasicBase = [
                { label: 'Brüt m²', keys: ['m2_brut', 'brut_m2', 'brüt m2', 'brut metrekare', 'brüt metrekare'] },
                { label: 'Net m²', keys: ['m2_net', 'net_m2', 'net m2', 'net metrekare'] },
                { label: 'Bulunduğu Kat', keys: ['bulundugu_kat', 'bulunduğu kat', 'bulundugu kat'], minOnly: applyCommercialRevision },
                { label: 'Kat Sayısı', keys: ['kat_sayisi', 'kat sayisi', 'kat sayısı'] },
                { label: 'Taşınmaz Durumu', keys: ['tasinmaz_durumu', 'taşınmaz durumu', 'tasınmaz durumu'] },
                { label: 'Yapım Yılı', keys: ['yapim_yili', 'yapım yılı'] },
                { label: 'Yenileme Yılı', keys: ['yenileme_yili', 'yenilenme_yili', 'yenileme yılı'] },
                { label: 'Site / AVM İçerisinde', keys: ['site_avm_icerisinde', 'site/avm içerisinde', 'avm_icerisinde', 'avm içerisinde', 'site_icerisinde', 'site içerisinde'] },
            ];

            const viewFacadeBlock = applyCommercialRevision
                ? [
                    { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true, strictVisual: true },
                    { label: 'Güneş Alma', keys: ['gunes_alma', 'güneş alma', 'cephe_gunes'], preferFeature: true, featureOnly: true },
                    {
                        label: 'Cephe',
                        keys: ['cephe', 'cephe_durumu'],
                        // Satılık Mağaza/Dükkan ve Kafe/Restoran'da üstteki hatalı
                        // dropdown kesinlikle kullanılmaz. Gerçek `cephe` feature grubu
                        // (Kuzey/Güney/Doğu/Batı...) checkbox olarak taşınır.
                        featureOnly: ['shop', 'cafe'].includes(type),
                        preferFeature: ['shop', 'cafe'].includes(type),
                        directionalOnly: ['shop', 'cafe'].includes(type),
                        asCheckbox: ['shop', 'cafe'].includes(type),
                    },
                ]
                : [
                    { label: 'Manzara', keys: ['manzara', 'manzara_tipi'] },
                            { label: 'Cephe', keys: ['cephe', 'cephe_durumu'] },
                ];

            const standardBasic = [
                ...standardBasicBase,
                ...((applyCommercialRevision && ['shop', 'cafe'].includes(type))
                    ? [{ label: 'Yaya Trafiği Yoğunluğu', keys: ['yaya_trafigi_yogunlugu', 'yaya_trafigi', 'yaya trafiği yoğunluğu', 'yaya trafigi yogunlugu'], asCheckbox: true }]
                    : []),
                { label: 'Bahçe Durumu', keys: ['bahce_tipi', 'bahce_durumu', 'bahçe durumu', 'bahçe'] },
                ...viewFacadeBlock,
            ];

            const standardProperty = [
                { label: 'Asansör', keys: ['asansor_sayisi', 'asansör sayısı', 'asansor'], minOnly: true },
                { label: 'Park Yeri', keys: ['park_yeri', 'otopark', 'acik_otopark_arac', 'kapali_otopark_arac', 'park yeri'] },
                ...(!applyCommercialRevision ? [{ label: 'Güneş Alma', keys: ['gunes_alma', 'güneş alma', 'cephe_gunes'] }] : []),
                { label: 'Isıtma / Soğutma', keys: ['isitma_sogutma', 'isitma', 'soğutma', 'sogutma', 'klima'] },
                { label: 'Mülk Şekli', keys: ['mulk_sekli_ticari', 'mulk_sekli_magaza', 'mulk_sekli_ofis', 'mulk_sekli_kafe', 'mülk şekli', 'mulk sekli'] },
                { label: 'Kullanım Amacı', keys: ['kullanim_amaci_ticari', 'kullanim_amaci_magaza', 'kullanim_amaci_ofis', 'kullanim_amaci_kafe', 'kullanım amacı', 'kullanim amaci'] },
                { label: 'Tapu Durumu', keys: ['tapu_durumu_bina', 'tapu_durumu', 'tapu durumu'] },
                { label: 'İskan Durumu', keys: ['iskan_durumu', 'iskan durumu'] },
                { label: 'Deprem Yönetmeliği', keys: ['deprem_yonetmeligine_uygun', 'deprem yönetmeliğine uygun', 'deprem yonetmeligi'] },
            ];

            const shopCafeHidden = applyCommercialRevision && ['shop', 'cafe'].includes(type)
                ? ['tavan_yuksekligi', 'tavan yüksekliği', 'tavan yuksekligi_metre', 'ceiling_height']
                : [];

            const hotelRemovedBottomFields = applyCommercialRevision && type === 'hotel'
                ? [
                    'acik_alan_m2', 'açık alan m²', 'acik alan m2', 'open_area_m2',
                    'taban_oturumu_m2', 'taban oturumu m²', 'taban oturumu', 'footprint_m2',
                    'konaklama_birimi_sayisi', 'konaklama birimi sayısı',
                    'konaklama_unite_sayisi', 'konaklama_unitesi_sayisi', 'konaklama birimi/ünite sayısı',
                    'accommodation_unit_count',
                ]
                : [];

            return {
                shop: {
                    label: 'Ticari - Mağaza / Dükkan',
                    hidden: commonAreaKeys.concat(priceKeys, shopCafeHidden),
                    basic: standardBasic,
                    property: standardProperty,
                },
                office: {
                    label: 'Ticari - Ofis / Büro',
                    hidden: commonAreaKeys.concat(priceKeys),
                    basic: standardBasic,
                    property: standardProperty,
                },
                cafe: {
                    label: 'Ticari - Kafe / Restoran',
                    hidden: commonAreaKeys.concat(priceKeys, shopCafeHidden),
                    basic: standardBasic,
                    property: standardProperty,
                },
                hotel: {
                    label: 'Ticari - Otel / Pansiyon / Apart',
                    hidden: priceKeys.concat(hotelRemovedBottomFields),
                    basic: [
                        { label: 'Toplam Oda Sayısı', keys: ['toplam_oda_sayisi', 'toplam oda sayısı', 'oda_sayisi', 'oda sayısı'] },
                        { label: 'Yıldız Sayısı', keys: ['yildiz_sayisi', 'yıldız sayısı', 'yildiz', 'yıldız'] },
                        { label: 'Toplam Yatak Kapasitesi', keys: ['toplam_yatak_kapasitesi', 'toplam yatak kapasitesi', 'yatak_kapasitesi'] },
                        { label: 'Kat Sayısı', keys: ['kat_sayisi', 'kat sayisi', 'kat sayısı'] },
                        { label: 'Asansör Sayısı', keys: ['asansor_sayisi', 'asansör sayısı', 'asansor'] },
                        { label: 'Tesis Türü', keys: ['tesis_turu', 'tesis türü', 'otel_tipi', 'konaklama_tipi'], asCheckbox: applyCommercialRevision },
                        { label: 'İşletme Bilgileri', keys: ['isletme_bilgileri', 'işletme bilgileri', 'isletme durumu', 'faaliyette', 'sezonluk'] },
                        { label: 'Park Yeri', keys: ['park_yeri', 'otopark', 'acik_otopark_arac', 'kapali_otopark_arac', 'park yeri'] },
                        { label: 'Taşınmaz Durumu', keys: ['tasinmaz_durumu', 'taşınmaz durumu', 'tasınmaz durumu'] },
                        { label: 'Yapım Yılı', keys: ['yapim_yili', 'yapım yılı'] },
                        { label: 'Yenileme Yılı', keys: ['yenileme_yili', 'yenilenme_yili', 'yenileme yılı'] },
                        { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], ...(applyCommercialRevision ? { preferFeature: true, featureOnly: true } : {}) },
                        ...(applyCommercialRevision ? [{ label: 'Güneş Alma', keys: ['gunes_alma', 'güneş alma', 'cephe_gunes'], preferFeature: true, featureOnly: true }] : []),
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'], ...(applyCommercialRevision ? { preferFeature: true, featureOnly: true } : {}) },
                        ...(!applyCommercialRevision ? [{ label: 'Güneş Alma', keys: ['gunes_alma', 'güneş alma', 'cephe_gunes'] }] : []),
                        { label: 'Isıtma', keys: ['isitma', 'ısıtma', 'isitma_sogutma'] },
                    ],
                    property: [],
                },
            };
        },
        commercialLayoutConfig() {
            const configs = this.commercialLayoutConfigs();
            return configs[this.currentCommercialTypeKey] || configs.shop;
        },

        commercialSocialDefinitions() {
            const type = this.currentCommercialTypeKey;
            if (type === 'hotel') {
                return [
                    { label: 'Havuz & Plajlar', keys: ['havuz', 'plaj'] },
                    { label: 'Spor & Aktivite', keys: ['spor', 'aktivite', 'dalis', 'dalış', 'su sporlari', 'su sporları', 'surf', 'sörf', 'yelken', 'golf'] },
                    { label: 'Sosyal Alanlar', keys: ['sosyal alan', 'pastane', 'gece klubu', 'gece kulübü', 'sarap mahzeni', 'şarap mahzeni', 'lobi', 'resepsiyon', 'fuar'] },
                    { label: 'Wellness & SPA', keys: ['wellness', 'welness', 'spa'] },
                    { label: 'Ortak Alanlar ve Tesis Özellikleri', keys: ['ortak alan', 'tesis ozellikleri', 'tesis özellikleri'] },
                ];
            }

            if (type === 'office') {
                return [
                    { label: 'Güvenlik', keys: ['guvenlik', 'güvenlik'] },
                    { label: 'Sosyal Alanlar', keys: ['sosyal alan'] },
                    { label: 'Teknik Altyapı', keys: ['teknik altyapi', 'teknik altyapı', 'altyapi', 'altyapı'] },
                    { label: 'Diğer Özellikler', keys: ['diger ozellik', 'diğer özellik'] },
                ];
            }

            if (type === 'cafe') {
                return [
                    ...(!this.isPdfCommercialRevisionScope(['cafe']) ? [{ label: 'Yaya Trafiği Yoğunluğu', keys: ['yaya_trafigi_yogunlugu', 'yaya_trafigi', 'yaya trafiği yoğunluğu', 'yaya trafigi yogunlugu'] }] : []),
                    { label: 'Baca Durumu', keys: ['baca_durumu', 'baca durumu', 'baca'] },
                    { label: 'Havalandırma Sistemi', keys: ['havalandirma_sistemi', 'havalandırma sistemi', 'havalandirma'] },
                    { label: 'Güvenlik', keys: ['guvenlik', 'güvenlik'] },
                    { label: 'Teknik Altyapı', keys: ['teknik altyapi', 'teknik altyapı', 'altyapi', 'altyapı'] },
                    { label: 'Diğer Özellikler', keys: ['diger ozellik', 'diğer özellik'] },
                ];
            }

            return [
                ...(!this.isPdfCommercialRevisionScope(['shop']) ? [{ label: 'Yaya Trafiği Yoğunluğu', keys: ['yaya_trafigi_yogunlugu', 'yaya_trafigi', 'yaya trafiği yoğunluğu', 'yaya trafigi yogunlugu'] }] : []),
                { label: 'Güvenlik', keys: ['guvenlik', 'güvenlik'] },
                { label: 'Teknik Altyapı', keys: ['teknik altyapi', 'teknik altyapı', 'altyapi', 'altyapı'] },
                { label: 'Diğer Özellikler', keys: ['diger ozellik', 'diğer özellik'] },
            ];
        },

        commercialPriceToggleDefinitions(type) {
            const offer = { key: 'offer_available', label: 'Fiyat Teklifi Yapılabilir', keys: ['fiyat_teklifi_yapilabilir', 'fiyat_teklifi_var', 'fiyat teklifi', 'teklif yapilabilir', 'teklif yapılabilir', 'teklif'] };
            const transfer = { key: 'transfer_sale_rent', label: 'Devren Satılık / Kiralık', keys: ['devren_satilik_kiralik', 'devren satılık kiralık', 'devren satilik kiralik', 'devren', 'devren satılık', 'devren kiralık'] };

            const groups = {
                status: [
                    { key: 'income_tenant', label: 'Gelir Getiren Kiracılı', keys: ['gelir_getiren_kiracili', 'gelir getiren kiracili', 'gelir getiren kiracılı', 'kiracili', 'kiracılı'] },
                    { key: 'empty_property', label: 'Boş Gayrimenkul', keys: ['bos_gayrimenkul', 'boş gayrimenkul', 'bos gayrimenkul', 'bos', 'boş'] },
                    { key: 'owner_uses', label: 'Mülk Sahibi Kullanıyor', keys: ['mulk_sahibi_kullaniyor', 'mulk sahibi kullaniyor', 'mülk sahibi kullanıyor', 'sahibi kullaniyor'] },
                ],
                sale_opportunity: [
                    { key: 'credit_suitable', label: 'Krediye Uygun', keys: ['krediye_uygun', 'krediye uygun', 'kredi'] },
                    { key: 'barter_suitable', label: 'Takasa Uygun', keys: ['takasa_uygun', 'takas_var_mi', 'takasa uygun', 'takas'] },
                    { key: 'residence_permit', label: 'İkamet İzni', keys: ['ikamet_izni', 'ikamet izni', 'ikamete uygun', 'ikamet'] },
                    { key: 'citizenship', label: 'Türk Vatandaşlığı', keys: ['turk_vatandasligi', 'türk vatandaşlığı', 'turk vatandasligi', 'vatandaslik', 'vatandaşlık'] },
                    offer,
                    transfer,
                ],
                rental_opportunity: [offer, transfer],
            };

            return (groups[type] || []).map(item => ({ ...item }));
        },

        commercialDescriptor(value) {
            return this.filterStructuralDescriptor(value, true);
        },

        commercialMatches(value, keys = []) {
            const haystack = this.normalizeText(this.commercialDescriptor(value));
            return keys.some(key => {
                const needle = this.normalizeText(key);
                return needle && haystack.includes(needle);
            });
        },

        commercialFieldMatches(field, keys = []) {
            // Alan eşleştirmesinde option metinlerini dikkate almıyoruz.
            // Aksi halde örn. seçeneklerinde "Isıtmalı Havuz" geçen Havuz alanı, "Isıtma / Soğutma" alanı gibi yakalanabiliyor.
            return this.commercialFieldOwnMatches(field, keys);
        },

        commercialFieldOwnMatches(field, keys = []) {
            return this.commercialMatches({
                schema_key: field?.schema_key,
                key: field?.key,
                name: field?.name,
                canonical_name: field?.canonical_name,
                placeholder: field?.placeholder,
                canonical_placeholder: field?.canonical_placeholder,
                unit: field?.unit,
                meta: field?.meta,
            }, keys);
        },

        commercialFeatureGroupMatches(group, keys = []) {
            // Grup eşleştirmesi sadece grubun kendi adı/schema bilgisiyle yapılır;
            // iç item adları ayrıca commercialFeatureItemMatches ile kontrol edilir.
            return this.commercialMatches({
                schema_key: group?.schema_key,
                key: group?.key,
                name: group?.name,
                canonical_name: group?.canonical_name,
                label: group?.label,
                meta: group?.meta,
            }, keys);
        },

        commercialFeatureItemMatches(group, item, keys = []) {
            return this.filterStructuralMatches([group, item], keys);
        },

        commercialFindField(keys = []) {
            const exact = this.dynamicFields.find(field => this.fieldMatchesExactSchema(field, keys));
            if (exact) return exact;

            return this.dynamicFields.find(field => this.commercialFieldMatches(field, keys)) || null;
        },

        commercialResolveDefinitions(definitions = [], options = {}) {
            const items = [];
            const usedFieldIds = new Set();
            const usedFeatureIds = new Set();

            definitions.forEach((definition, index) => {
                let field = this.dynamicFields.find(candidate => {
                    const id = Number(candidate.id);
                    return !usedFieldIds.has(id)
                        && !this.isGloballyHiddenDynamicField(candidate)
                        && this.fieldMatchesExactSchema(candidate, definition.keys || []);
                });

                if (!field) {
                    field = this.dynamicFields.find(candidate => {
                        const id = Number(candidate.id);
                        return !usedFieldIds.has(id)
                            && !this.isGloballyHiddenDynamicField(candidate)
                            && this.commercialFieldMatches(candidate, definition.keys || []);
                    });
                }

                if (field) {
                    usedFieldIds.add(Number(field.id));
                    items.push({
                        type: 'field',
                        key: `${definition.label}-${field.id}`,
                        label: definition.label || field.name,
                        field,
                        definitionIndex: index,
                    });
                    return;
                }

                if (options.fieldsOnly) {
                    return;
                }

                const group = this.dynamicFeatures.find(candidate => {
                    const id = Number(candidate.id);
                    return !usedFeatureIds.has(id) && this.commercialFeatureGroupMatches(candidate, definition.keys || []);
                });

                if (group) {
                    usedFeatureIds.add(Number(group.id));
                    items.push({
                        type: 'feature_group',
                        key: `${definition.label}-${group.id}`,
                        label: definition.label || group.name,
                        group,
                        definitionIndex: index,
                    });
                }
            });

            return items;
        },

        buildCommercialSectionItems(section) {
            if (!this.isCommercialFilterMode) return [];

            const config = this.commercialLayoutConfig();
            const definitions = Array.isArray(config[section]) ? config[section] : [];
            const excludedIds = new Set(this.commercialAlwaysHiddenFieldIds());
            const used = new Set();

            return definitions.map((definition, index) => {
                if (this.isParkingDefinition(definition)) {
                    return this.buildParkingFilterItem(`${section}-${index}`);
                }

                const preferFeature = definition.preferFeature === true;
                const featureOnly = definition.featureOnly === true;
                const findFeatureGroup = () => {
                    const exact = this.dynamicFeatures.find(candidate => (
                        this.featureGroupMatchesExactSchema(candidate, definition.keys || [])
                        && (!definition.directionalOnly || this.hasDirectionalFacadeOptions(candidate))
                    ));
                    if (exact) return exact;

                    return this.dynamicFeatures.find(candidate => {
                        if (!this.commercialFeatureGroupMatches(candidate, definition.keys || [])) return false;
                        return !definition.directionalOnly || this.hasDirectionalFacadeOptions(candidate);
                    });
                };

                if (preferFeature || featureOnly) {
                    const group = findFeatureGroup();
                    const isPinnedVisualGroup = this.isViewOrFacadeDefinition(definition);
                    if (
                        group &&
                        (isPinnedVisualGroup || !this.commercialSocialFeatureGroups.some(social => Number(social.id) === Number(group.id)))
                    ) {
                        return {
                            type: 'feature_group',
                            key: `${section}-feature-${group.id}`,
                            label: definition.label || group.name,
                            group,
                            definitionIndex: index,
                        };
                    }
                }

                let field = null;

                if (!featureOnly) {
                    field = this.dynamicFields.find(candidate => {
                        const id = Number(candidate.id);
                        return !excludedIds.has(id)
                            && !used.has(id)
                            && this.fieldMatchesExactSchema(candidate, definition.keys || [])
                            && (!definition.directionalOnly || this.hasDirectionalFacadeOptions(candidate));
                    });

                    if (!field) {
                        field = this.dynamicFields.find(candidate => {
                            const id = Number(candidate.id);
                            return !excludedIds.has(id)
                                && !used.has(id)
                                && this.commercialFieldMatches(candidate, definition.keys || [])
                                && (!definition.directionalOnly || this.hasDirectionalFacadeOptions(candidate));
                        });
                    }
                }

                if (field) {
                    used.add(Number(field.id));
                    return {
                        type: 'field',
                        key: `${section}-${field.id}`,
                        label: definition.label || field.name,
                        field,
                        definitionIndex: index,
                        renderAsCheckboxes: definition.asCheckbox === true,
                        minOnly: definition.minOnly === true,
                    };
                }

                const group = findFeatureGroup();
                const isPinnedVisualGroup = this.isViewOrFacadeDefinition(definition);
                if (
                    group &&
                    (isPinnedVisualGroup || !this.commercialSocialFeatureGroups.some(social => Number(social.id) === Number(group.id)))
                ) {
                    return {
                        type: 'feature_group',
                        key: `${section}-feature-${group.id}`,
                        label: definition.label || group.name,
                        group,
                        definitionIndex: index,
                    };
                }

                return null;
            }).filter(Boolean);
        },
        commercialAlwaysHiddenFieldIds() {
            const ids = new Set();
            [this.commercialPlanField, this.commercialPartitionCountField, this.commercialRoomCountField, this.commercialKitchenField, this.commercialTeaKitchenField].forEach(field => {
                if (field) ids.add(Number(field.id));
            });
            this.commercialRoomMinOnlyItems.forEach(item => { if (item.field) ids.add(Number(item.field.id)); });
            this.commercialPriceStatusItems.concat(this.commercialPriceOpportunityItems).forEach(item => { if (item.field) ids.add(Number(item.field.id)); });
            this.parkingRelatedFields().forEach(field => { if (field) ids.add(Number(field.id)); });
            const hiddenKeys = this.commercialLayoutConfig().hidden || [];
            this.dynamicFields.forEach(field => {
                if (
                    this.commercialFieldMatches(field, hiddenKeys)
                    || this.isGloballyHiddenDynamicField(field)
                    || this.isPdfRevisionWrongCommercialFacadeField(field)
                ) ids.add(Number(field.id));
            });
            return Array.from(ids);
        },

        commercialPriceToggleFeatureGroupIds() {
            const ids = new Set();

            this.commercialPriceStatusItems
                .concat(this.commercialPriceOpportunityItems)
                .forEach(item => {
                    if (item && item.group) {
                        ids.add(Number(item.group.id));
                    }
                });

            return Array.from(ids).filter(id => id > 0);
        },

        commercialSectionFieldIds() {
            return this.commercialBasicItems
                .concat(this.commercialPropertyItems)
                .filter(item => item.type === 'field' && item.field)
                .map(item => Number(item.field.id));
        },

        buildCommercialRemainingItems() {
            if (!this.isCommercialFilterMode) return [];

            const excludedFieldIds = new Set(this.commercialAlwaysHiddenFieldIds().concat(this.commercialSectionFieldIds()));
            const excludedFeatureGroupIds = new Set(
                this.commercialSocialFeatureGroups
                    .concat(this.commercialBasicItems.filter(item => item.type === 'feature_group').map(item => item.group))
                    .concat(this.commercialPropertyItems.filter(item => item.type === 'feature_group').map(item => item.group))
                    .filter(Boolean)
                    .map(group => Number(group.id))
                    .concat(this.commercialPriceToggleFeatureGroupIds())
                    .concat(this.parkingFeatureGroupIds)
            );

            const excludedFeatureItemIds = new Set();

            const fields = this.dynamicFields
                .filter(field => !excludedFieldIds.has(Number(field.id)))
                .filter(field => !this.isPdfRevisionPaymentField(field))
                .filter(field => !this.isProjectOtherFilterRemovedField(field))
                .map(field => ({
                    type: 'field',
                    key: `field-${field.id}`,
                    label: field.name,
                    field,
                }));

            const groups = this.dynamicFeatures
                .filter(group => !excludedFeatureGroupIds.has(Number(group.id)))
                .filter(group => !this.isPdfRevisionPaymentFeatureGroup(group))
                .map(group => {
                    const visibleItems = Array.isArray(group.items)
                        ? group.items.filter(item => !excludedFeatureItemIds.has(Number(item.id)))
                        : [];

                    return {
                        type: 'feature_group',
                        key: `feature-${group.id}`,
                        label: group.name,
                        group: { ...group, items: visibleItems },
                    };
                })
                .filter(item => Array.isArray(item.group.items) && item.group.items.length > 0);

            return fields.concat(groups);
        },

        findCommercialToggleItems(definitions = []) {
            const items = [];
            const used = new Set();

            definitions.forEach(definition => {
                let found = null;

                const directField = this.dynamicFields.find(field => this.commercialFieldOwnMatches(field, definition.keys));

                if (directField) {
                    found = {
                        type: 'field_toggle',
                        key: `${definition.key}-field-${directField.id}`,
                        definitionKey: definition.key,
                        label: definition.label,
                        field: directField,
                    };
                }

                if (!found) {
                    for (const field of this.dynamicFields) {
                        if (!Array.isArray(field.options)) continue;

                        const option = field.options.find(opt => this.commercialMatches(opt, definition.keys));
                        if (option) {
                            found = {
                                type: 'field_option',
                                key: `${definition.key}-field-${field.id}-option-${option.id}`,
                                definitionKey: definition.key,
                                label: definition.label,
                                field,
                                option,
                            };
                            break;
                        }
                    }
                }

                if (!found) {
                    for (const group of this.dynamicFeatures) {
                        const option = (group.items || []).find(item => this.commercialFeatureItemMatches(group, item, definition.keys));
                        if (option) {
                            found = {
                                type: 'feature',
                                key: `${definition.key}-feature-${option.id}`,
                                definitionKey: definition.key,
                                label: definition.label,
                                group,
                                item: option,
                            };
                            break;
                        }
                    }
                }

                if (found && !used.has(found.key)) {
                    used.add(found.key);
                    items.push(found);
                }
            });

            return items;
        },

        commercialToggleFieldValue(field) {
            if (this.isBooleanField(field)) {
                return this.booleanFieldValues(field).yesVal;
            }

            const options = Array.isArray(field?.options) ? field.options : [];
            if (options.length > 0) {
                const positives = ['evet', 'var', 'uygun', 'dahil', 'yes', 'true', 'mevcut', 'yapilabilir', 'yapılabilir', 'kiracili', 'kiracılı', 'devren'];
                const positive = options.find(option => {
                    const name = this.normalizeText([option.canonical_name, option.schema_value, option.name, option.value].filter(Boolean).join(' '));
                    return positives.some(word => name.includes(this.normalizeText(word)));
                });

                return String((positive || options[0]).id);
            }

            return '1';
        },

        isCommercialToggleSelected(item) {
            if (!item) return false;

            if (item.type === 'feature') {
                return this.form.feature_value_ids.includes(Number(item.item.id));
            }

            if (item.type === 'field_option') {
                const value = this.form.fields[String(item.field.id)];
                if (Array.isArray(value)) {
                    return value.map(String).includes(String(item.option.id));
                }
                return String(value || '') === String(item.option.id);
            }

            if (item.type === 'field_toggle') {
                const value = this.form.fields[String(item.field.id)];
                return String(value || '') === String(this.commercialToggleFieldValue(item.field));
            }

            return false;
        },

        toggleCommercialToggleItem(item) {
            if (!item) return;

            if (item.type === 'feature') {
                const id = Number(item.item.id);
                this.form.feature_value_ids = this.form.feature_value_ids.includes(id)
                    ? this.form.feature_value_ids.filter(value => Number(value) !== id)
                    : this.form.feature_value_ids.concat(id);
                return;
            }

            if (item.type === 'field_option') {
                if (this.isMultiField(item.field)) {
                    this.toggleFieldArrayValue(item.field, item.option.id);
                    return;
                }

                const fieldId = String(item.field.id);
                this.form.fields[fieldId] = this.isCommercialToggleSelected(item) ? '' : String(item.option.id);
                return;
            }

            if (item.type === 'field_toggle') {
                const fieldId = String(item.field.id);
                this.form.fields[fieldId] = this.isCommercialToggleSelected(item) ? '' : this.commercialToggleFieldValue(item.field);
            }
        },

        isCommercialMinOnlyNumericField(field) {
            if (!this.isCommercialFilterMode) return false;
            const key = this.fieldSchemaKey(field);
            const name = this.normalizeText([field?.canonical_name, field?.name].filter(Boolean).join(' '));

            // PDF Ticari Mağaza/Ofis/Kafe kuralı Satılık ve Kiralıkta aynıdır.
            // Gerçek *_adet schema anahtarlarını +/- 'En az' renderer'ına dahil ediyoruz.
            const minOnlyKeys = [
                'banyo_sayisi', 'wc_sayisi', 'tuvalet_sayisi',
                'depo_sayisi', 'soguk_hava_deposu', 'balkon_sayisi', 'teras_sayisi',
                'asansor_sayisi', 'asansör sayısı', 'asansor',
                'park_yeri', 'otopark', 'arac_sayisi', 'araç sayısı',
                'kat_sayisi', 'bölüm sayısı', 'bolum_sayisi',
                'toplam_oda_sayisi', 'toplam_yatak_kapasitesi', 'yildiz_sayisi', 'yıldız sayısı',
            ];

            if (this.isPdfCommercialRevisionScope(['shop', 'office', 'cafe'])) {
                minOnlyKeys.push('depo_adet', 'soguk_hava_deposu_adet', 'balkon_adet', 'teras_adet');
            }

            return minOnlyKeys.some(item => key.includes(this.normalizeText(item)) || name.includes(this.normalizeText(item)));
        },

        stepCommercialMinOnlyNumeric(field, direction = 1) {
            this.stepCommercialRangeNumeric(field, 'min', direction);
        },

        stepCommercialRangeNumeric(field, side = 'min', direction = 1) {
            if (!field) return;
            const currentRaw = this.getNumericRangeVal(field, side);
            const current = parseInt(String(currentRaw || '0').replace(/\D/g, ''), 10);
            const next = Math.max(0, (Number.isFinite(current) ? current : 0) + (direction > 0 ? 1 : -1));
            this.setNumericRangeVal(field, side, next > 0 ? String(next) : '');
        },
        projectLayoutConfigs() {
            const commonRoomKeys = [
                'yatak_odasi_sayisi', 'yatak odasi', 'yatak odası', 'salon_sayisi', 'salon sayisi', 'salon sayısı',
                'oda_sayisi', 'oda sayisi', 'oda sayısı', 'room_count', 'mutfak_tipi', 'mutfak turu', 'mutfak türü',
                'banyo_sayisi', 'banyo sayisi', 'banyo sayısı', 'balkon_sayisi', 'balkon sayisi', 'balkon sayısı',
                'teras_sayisi', 'teras sayisi', 'teras sayısı', 'depo_sayisi', 'depo sayisi', 'depo sayısı',
                'asansor_sayisi', 'asansör sayısı', 'asansor', 'oda_tipi', 'oda tipi', 'plan_tipi', 'plan tipi',
                'ofis_tipi', 'ofis tipi', 'magaza_tipi', 'mağaza tipi', 'dukkan_tipi', 'dükkan tipi',
                'bolum_sayisi', 'bölüm sayısı', 'bolum sayisi', 'bölünmüş bölüm',
            ];
            const priceKeys = this.projectPriceToggleDefinitions('status').concat(this.projectPriceToggleDefinitions('sale_opportunity')).concat(this.projectPriceToggleDefinitions('rental_opportunity')).flatMap(item => item.keys || []);
            const commonBasic = [
                { label: 'Kat Sayısı', keys: ['kat_sayisi', 'kat sayisi', 'kat sayısı'] },
                { label: 'Teslim Tarihi', keys: ['teslim_tarihi', 'teslim tarihi', 'teslim_yili', 'teslim yılı'] },
                { label: 'Yapım Durumu', keys: ['yapim_durumu', 'yapım durumu', 'yapim_asamasinda'], asCheckbox: true },
                { label: 'Site İçerisinde', keys: ['site_icerisinde', 'site içerisinde', 'site icinde'] },
                { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true, strictVisual: true },
                { label: 'Cephe', keys: ['cephe', 'cephe_durumu'], preferFeature: true, strictVisual: true },
            ];
            const commonProperty = [
                { label: 'Park Yeri', keys: ['park_yeri', 'otopark', 'acik_otopark_arac', 'kapali_otopark_arac', 'park yeri'] },
                { label: 'Isıtma / Soğutma', keys: ['isitma_sogutma', 'isitma', 'soğutma', 'sogutma', 'klima'] },
                { label: 'Tapu Durumu', keys: ['tapu_durumu_bina', 'tapu_durumu', 'tapu durumu'] },
                { label: 'Deprem Yönetmeliği', keys: ['deprem_yonetmeligine_uygun', 'deprem yönetmeliğine uygun', 'deprem yonetmeligi'] },
            ];
            return {
                apartment: {
                    label: 'Proje - Daire / Residence',
                    hidden: commonRoomKeys.concat(priceKeys),
                    basic: [
                        { label: 'Arsa m²', keys: ['arsa_m2', 'arsa metrekare', 'arsa m2', 'arazi_m2'] },
                        { label: 'Daire Brüt m²', keys: ['daire_m2_brut', 'daire_brut_m2', 'm2_brut', 'brut_m2', 'brüt m2'] },
                        { label: 'Daire Net m²', keys: ['daire_m2_net', 'daire_net_m2', 'm2_net', 'net_m2', 'net m2'] },
                        { label: 'Kat Sayısı', keys: ['kat_sayisi', 'kat sayisi', 'kat sayısı'] },
                        { label: 'Eşya Durumu', keys: ['esya_durumu', 'eşya durumu'] },
                        { label: 'Teslim Tarihi', keys: ['teslim_tarihi', 'teslim tarihi', 'teslim_yili', 'teslim yılı'] },
                        { label: 'Yapım Durumu', keys: ['yapim_durumu', 'yapım durumu', 'yapim_asamasinda'], asCheckbox: true },
                        { label: 'Site İçerisinde', keys: ['site_icerisinde', 'site içerisinde', 'site icinde'] },
                        { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true, strictVisual: true },
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'], preferFeature: true, strictVisual: true },
                    ],
                    property: [{ label: 'Asansör', keys: ['asansor_sayisi', 'asansör sayısı', 'asansor'], minOnly: true }, ...commonProperty],
                },
                villa: {
                    label: 'Proje - Villa / Tiny House',
                    hidden: commonRoomKeys.concat(priceKeys),
                    basic: [
                        { label: 'Arsa m²', keys: ['arsa_m2', 'arsa metrekare', 'arsa m2', 'arazi_m2'] },
                        { label: 'Villa Brüt m²', keys: ['villa_m2_brut', 'villa_brut_m2', 'm2_brut', 'brut_m2', 'brüt m2'] },
                        { label: 'Villa Net m²', keys: ['villa_m2_net', 'villa_net_m2', 'm2_net', 'net_m2', 'net m2'] },
                        { label: 'Kat Sayısı', keys: ['kat_sayisi', 'kat sayisi', 'kat sayısı'] },
                        { label: 'Eşya Durumu', keys: ['esya_durumu', 'eşya durumu'] },
                        { label: 'Bahçe', keys: ['bahce_tipi', 'bahce_durumu', 'bahçe durumu', 'bahçe'] },
                        { label: 'Havuz Durumu', keys: ['havuz_durumu', 'havuz_secimi', 'havuz'], asCheckbox: true },
                        { label: 'Teslim Tarihi', keys: ['teslim_tarihi', 'teslim tarihi', 'teslim_yili', 'teslim yılı'] },
                        { label: 'Yapım Durumu', keys: ['yapim_durumu', 'yapım durumu', 'yapim_asamasinda'], asCheckbox: true },
                        { label: 'Site İçerisinde', keys: ['site_icerisinde', 'site içerisinde', 'site icinde'] },
                        { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true, strictVisual: true },
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'], preferFeature: true, strictVisual: true },
                    ],
                    property: [
                        { label: 'Park Yeri', keys: ['park_yeri', 'otopark', 'acik_otopark_arac', 'kapali_otopark_arac', 'park yeri'] },
                        { label: 'Isıtma / Soğutma', keys: ['isitma_sogutma', 'isitma', 'soğutma', 'sogutma', 'klima'] },
                        { label: 'Yapı Tipi', keys: ['yapi_tipi', 'yapı tipi'], asCheckbox: true },
                        { label: 'Tapu Durumu', keys: ['tapu_durumu_bina', 'tapu_durumu', 'tapu durumu'] },
                        { label: 'Deprem Yönetmeliği', keys: ['deprem_yonetmeligine_uygun', 'deprem yönetmeliğine uygun', 'deprem yonetmeligi'] },
                    ],
                },
                office: {
                    label: 'Proje - Ofis / Büro',
                    hidden: commonRoomKeys.concat(priceKeys),
                    basic: [
                        { label: 'Arsa m²', keys: ['arsa_m2', 'arsa metrekare', 'arsa m2', 'arazi_m2'] },
                        { label: 'Ofis/Büro Brüt m²', keys: ['ofis_buro_m2_brut', 'ofis_brut_m2', 'buro_brut_m2', 'm2_brut', 'brut_m2', 'brüt m2'] },
                        { label: 'Ofis/Büro Net m²', keys: ['ofis_buro_m2_net', 'ofis_net_m2', 'buro_net_m2', 'm2_net', 'net_m2', 'net m2'] },
                        ...commonBasic,
                    ],
                    property: [{ label: 'Asansör', keys: ['asansor_sayisi', 'asansör sayısı', 'asansor'], minOnly: true }, ...commonProperty],
                },
                shop: {
                    label: 'Proje - Mağaza / Dükkan',
                    hidden: commonRoomKeys.concat(priceKeys),
                    basic: [
                        { label: 'Arsa m²', keys: ['arsa_m2', 'arsa metrekare', 'arsa m2', 'arazi_m2'] },
                        { label: 'Mağaza/Dükkan Brüt m²', keys: ['magaza_dukkan_m2_brut', 'magaza_brut_m2', 'dukkan_brut_m2', 'm2_brut', 'brut_m2', 'brüt m2', 'ofis_buro_m2_brut'] },
                        { label: 'Mağaza/Dükkan Net m²', keys: ['magaza_dukkan_m2_net', 'magaza_net_m2', 'dukkan_net_m2', 'm2_net', 'net_m2', 'net m2', 'ofis_buro_m2_net'] },
                        ...commonBasic,
                    ],
                    property: [{ label: 'Asansör', keys: ['asansor_sayisi', 'asansör sayısı', 'asansor'], minOnly: true }, ...commonProperty],
                },
            };
        },
        projectLayoutConfig() {
            const configs = this.projectLayoutConfigs();
            return configs[this.currentProjectTypeKey] || configs.apartment;
        },

        projectSocialDefinitions() {
            // Kullanıcının gönderdiği "Proje Türü Detaylı Filtre" dokümanından
            // yalnız Sosyal & Teknik Özellikler bölümü uygulanır. Aynı katalog
            // ilan ekleme ekranında da kullanıldığı için seçenekleri oradaki tam
            // label listeleriyle eşleştiriyoruz. Transaction (Satılık/Kiralık)
            // ayrımı yapılmaz; Proje alt kategorilerinde iki tarafta da aynıdır.
            const catalog = this.residentialSocialDefinitions();
            const byKey = (key) => {
                const definition = catalog.find(item => item.key === key);
                return definition ? { ...definition } : null;
            };

            if (['office', 'shop'].includes(this.currentProjectTypeKey)) {
                const otherFeatures = byKey('other_features');
                if (otherFeatures) {
                    // Ofis/Mağaza için dokümandaki "Diğer Özellikler", ilan ekleme ekranındaki
                    // Sosyal & Teknik Özellikler kaynağında Güvenlik/Sosyal/Teknik gruplarına
                    // girmeyen kalan seçeneklerin tamamını taşır.
                    otherFeatures.collectUnmatchedSocial = true;
                }

                return [
                    byKey('security'),
                    byKey('social_areas'),
                    byKey('technical_infra'),
                    otherFeatures,
                ].filter(Boolean);
            }

            return [
                byKey('security'),
                byKey('pool_beach'),
                byKey('sport_activity'),
                byKey('social_areas'),
                byKey('wellness_spa'),
                byKey('technical_infra'),
            ].filter(Boolean);
        },
        projectPriceToggleDefinitions(type) {
            const offer = { key: 'offer_available', label: 'Fiyat Teklifi Yapılabilir', keys: ['fiyat_teklifi_yapilabilir', 'fiyat_teklifi_var', 'fiyat teklifi', 'teklif yapilabilir', 'teklif yapılabilir', 'teklif'] };
            const groups = {
                status: [],
                sale_opportunity: [
                    { key: 'credit_suitable', label: 'Krediye Uygun', keys: ['krediye_uygun', 'krediye uygun', 'kredi'] },
                    { key: 'barter_suitable', label: 'Takasa Uygun', keys: ['takasa_uygun', 'takas_var_mi', 'takasa uygun', 'takas'] },
                    { key: 'residence_permit', label: 'İkamet İzni', keys: ['ikamet_izni', 'ikamet izni', 'ikamete uygun', 'ikamet'] },
                    { key: 'citizenship', label: 'Türk Vatandaşlığı', keys: ['turk_vatandasligi', 'türk vatandaşlığı', 'turk vatandasligi', 'vatandaslik', 'vatandaşlık'] },
                    offer,
                    { key: 'rental_guarantee', label: 'Kira Garantili Satış', keys: ['kira_garantili_satis', 'kira garantili satış', 'kira garantili satis', 'kira garantili'] },
                    { key: 'installment_sale', label: 'Taksitli Satışa Uygun', keys: ['taksitli_satisa_uygun', 'taksitli satışa uygun', 'taksitli satisa uygun', 'taksitli satış', 'taksitli'] },
                ],
                rental_opportunity: [offer],
            };
            return (groups[type] || []).map(item => ({ ...item }));
        },
        projectDescriptor(value) {
            return this.filterStructuralDescriptor(value, true);
        },

        projectMatches(value, keys = []) {
            const haystack = this.normalizeText(this.projectDescriptor(value));
            return keys.some(key => {
                const needle = this.normalizeText(key);
                return needle && haystack.includes(needle);
            });
        },

        projectFieldMatches(field, keys = []) {
            // Alan eşleştirmesinde option metinlerini dikkate almıyoruz.
            // Özellikle Proje tarafında "Isıtmalı Havuz" gibi seçenekler,
            // "Isıtma / Soğutma" alanına yanlış alan/grup bağlamasın.
            return this.projectFieldOwnMatches(field, keys);
        },

        projectFieldOwnMatches(field, keys = []) {
            return this.projectMatches({
                schema_key: field?.schema_key,
                key: field?.key,
                name: field?.name,
                canonical_name: field?.canonical_name,
                placeholder: field?.placeholder,
                canonical_placeholder: field?.canonical_placeholder,
                unit: field?.unit,
                meta: field?.meta,
            }, keys);
        },

        projectFeatureGroupMatches(group, keys = []) {
            // Grup adı/schema bilgisi üzerinden eşleşir; item metinleri
            // projectFeatureItemMatches ile ayrı değerlendirilir. Böylece
            // "Havuz & Plajlar" grubu, içindeki "Isıtmalı Havuz" yüzünden
            // "Isıtma / Soğutma" altında komple görünmez.
            return this.projectMatches({
                schema_key: group?.schema_key,
                key: group?.key,
                name: group?.name,
                canonical_name: group?.canonical_name,
                label: group?.label,
                meta: group?.meta,
            }, keys);
        },

        projectFeatureItemMatches(group, item, keys = []) {
            return this.filterStructuralMatches([group, item], keys);
        },

        projectFindField(keys = []) {
            const exact = this.dynamicFields.find(field => this.fieldMatchesExactSchema(field, keys));
            if (exact) return exact;

            return this.dynamicFields.find(field => this.projectFieldMatches(field, keys)) || null;
        },

        projectFindFeatureGroup(keys = []) {
            return this.dynamicFeatures.find(group => this.projectFeatureGroupMatches(group, keys)) || null;
        },

        projectResolveDefinitions(definitions = [], options = {}) {
            const items = [];
            const usedFieldIds = new Set();
            const usedFeatureIds = new Set();

            definitions.forEach((definition, index) => {
                let field = this.dynamicFields.find(candidate => {
                    const id = Number(candidate.id);
                    return !usedFieldIds.has(id)
                        && !this.isGloballyHiddenDynamicField(candidate)
                        && this.fieldMatchesExactSchema(candidate, definition.keys || []);
                });

                if (!field) {
                    field = this.dynamicFields.find(candidate => {
                        const id = Number(candidate.id);
                        return !usedFieldIds.has(id)
                            && !this.isGloballyHiddenDynamicField(candidate)
                            && this.projectFieldMatches(candidate, definition.keys || []);
                    });
                }

                if (field) {
                    usedFieldIds.add(Number(field.id));
                    items.push({
                        type: 'field',
                        key: `${definition.label}-${field.id}`,
                        label: definition.label || field.name,
                        field,
                        definitionIndex: index,
                    });
                    return;
                }

                if (options.fieldsOnly) {
                    return;
                }

                const group = this.dynamicFeatures.find(candidate => {
                    const id = Number(candidate.id);
                    return !usedFeatureIds.has(id) && this.projectFeatureGroupMatches(candidate, definition.keys || []);
                });

                if (group) {
                    usedFeatureIds.add(Number(group.id));
                    items.push({
                        type: 'feature_group',
                        key: `${definition.label}-${group.id}`,
                        label: definition.label || group.name,
                        group,
                        definitionIndex: index,
                    });
                }
            });

            return items;
        },

        buildProjectSectionItems(section) {
            if (!this.isProjectFilterMode) return [];

            const config = this.projectLayoutConfig();
            const definitions = Array.isArray(config[section]) ? config[section] : [];
            const excludedIds = new Set(this.projectAlwaysHiddenFieldIds());
            const used = new Set();

            return definitions.map((definition, index) => {
                if (this.isParkingDefinition(definition)) {
                    return this.buildParkingFilterItem(`${section}-${index}`);
                }

                const resolveFeatureGroup = () => {
                    const exact = this.dynamicFeatures.find(candidate => (
                        this.featureGroupMatchesExactSchema(candidate, definition.keys || [])
                        && Array.isArray(candidate?.items)
                        && candidate.items.length > 0
                    ));
                    if (exact) return exact;

                    return this.dynamicFeatures.find(candidate => (
                        this.projectFeatureGroupMatches(candidate, definition.keys || [])
                        && Array.isArray(candidate?.items)
                        && candidate.items.length > 0
                    ));
                };

                // Proje Manzara / Cephe verileri zaten metadata'da mevcut.
                // Önce dolu feature grubunu kullan; yoksa mevcut exact field'a geri dön.
                // Böylece cephe_genisligi_metre gibi isim benzerliği olan alanlara düşülmez.
                if (definition.preferFeature === true) {
                    const preferredGroup = resolveFeatureGroup();
                    if (preferredGroup) {
                        return {
                            type: 'feature_group',
                            key: `${section}-feature-${preferredGroup.id}`,
                            label: definition.label || preferredGroup.name,
                            group: preferredGroup,
                            definitionIndex: index,
                        };
                    }
                }

                let field = this.dynamicFields.find(candidate => {
                    const id = Number(candidate.id);
                    return !excludedIds.has(id)
                        && !used.has(id)
                        && this.fieldMatchesExactSchema(candidate, definition.keys || []);
                });

                if (!field && definition.strictVisual === true) {
                    const exactLabels = [definition.label].concat(definition.keys || [])
                        .map(value => this.normalizeText(value))
                        .filter(Boolean);

                    field = this.dynamicFields.find(candidate => {
                        const id = Number(candidate.id);
                        if (excludedIds.has(id) || used.has(id)) return false;

                        const ownNames = [candidate?.canonical_name, candidate?.name, candidate?.label]
                            .map(value => this.normalizeText(value))
                            .filter(Boolean);

                        return ownNames.some(value => exactLabels.includes(value))
                            && Array.isArray(candidate?.options)
                            && candidate.options.length > 0;
                    });
                }

                if (!field && definition.strictVisual !== true) {
                    field = this.dynamicFields.find(candidate => {
                        const id = Number(candidate.id);
                        return !excludedIds.has(id)
                            && !used.has(id)
                            && this.projectFieldMatches(candidate, definition.keys || []);
                    });
                }

                if (field) {
                    used.add(Number(field.id));
                    return {
                        type: 'field',
                        key: `${section}-${field.id}`,
                        label: definition.label || field.name,
                        field,
                        renderAsCheckboxes: definition.asCheckbox === true,
                        definitionIndex: index,
                    };
                }

                const group = resolveFeatureGroup();
                const isPinnedVisualGroup = this.isViewOrFacadeDefinition(definition) || definition.strictVisual === true;
                if (
                    group &&
                    (isPinnedVisualGroup || !this.projectSocialFeatureGroups.some(social => Number(social.id) === Number(group.id)))
                ) {
                    return {
                        type: 'feature_group',
                        key: `${section}-feature-${group.id}`,
                        label: definition.label || group.name,
                        group,
                        definitionIndex: index,
                    };
                }

                return null;
            }).filter(Boolean);
        },

        // PDF Proje s.2,4,6-9: yalnız arama arayüzünden çıkarılır;
        // veri şemasına, ilan eklemeye ve diğer kategorilere dokunulmaz.
        isProjectPdfHiddenField(field) {
            if (!this.isProjectFilterMode || !field) return false;
            const key = this.fieldSchemaKey(field);
            const text = this.normalizeText([field?.canonical_name, field?.name].filter(Boolean).join(' '));
            const matches = (keys) => keys.some(value => key === value || text === this.normalizeText(value));

            if (matches(['tasinmaz_durumu', 'taşınmaz durumu', 'gunes_alma', 'güneş alma', 'cephe_gunes'])) return true;

            const common = ['kapali_alan_m2', 'toplam_kapali_alan_m2', 'kapali_alan', 'kapalı alan', 'proje_adi', 'proje adı', 'pesinat_orani', 'peşinat oranı'];
            const types = {
                apartment: ['konut_birim_sayisi', 'toplam_daire_sayisi', 'toplam daire sayısı', 'blok_sayisi', 'blok sayısı'],
                villa: ['villa_birim_sayisi', 'toplam_villa_sayisi', 'toplam villa sayısı'],
                office: ['ofis_birim_sayisi', 'toplam_ofis_sayisi', 'toplam ofis büro sayısı', 'blok_sayisi', 'blok sayısı'],
                shop: ['magaza_birim_sayisi', 'toplam_magaza_sayisi', 'toplam mağaza dükkan sayısı', 'blok_sayisi', 'blok sayısı'],
            };
            return matches(common.concat(types[this.currentProjectTypeKey] || []));
        },

        isProjectPdfHiddenFeatureGroup(group) {
            if (!this.isProjectFilterMode || !group) return false;
            return this.projectFeatureGroupMatches(group, [
                'tasinmaz_durumu', 'taşınmaz durumu', 'gunes_alma', 'güneş alma'
            ]);
        },

        projectAlwaysHiddenFieldIds() {
            const ids = new Set();
            [this.projectBedroomField, this.projectSalonField, this.projectRoomCountField, this.projectKitchenField, this.projectCommercialPlanField, this.projectPartitionCountField].forEach(field => {
                if (field) ids.add(Number(field.id));
            });

            // Taşınmaz Durumu varken Yapım/Yenileme yılı aynı kartın içinde gösterilir;
            // proje "Diğer Filtreler" bölümünde ikinci kez listelenmesin.
            if (this.dynamicPropertyStatusField()) {
                [this.dynamicConstructionYearField(), this.dynamicRenovationYearField()].forEach(field => {
                    if (field) ids.add(Number(field.id));
                });
            }
            this.projectRoomMinOnlyItems.forEach(item => { if (item.field) ids.add(Number(item.field.id)); });
            this.projectInstallmentTermItems.forEach(item => { if (item.field) ids.add(Number(item.field.id)); });
            this.projectPriceStatusItems.concat(this.projectPriceOpportunityItems).forEach(item => { if (item.field) ids.add(Number(item.field.id)); });
            this.parkingRelatedFields().forEach(field => { if (field) ids.add(Number(field.id)); });
            const hiddenKeys = this.projectLayoutConfig().hidden || [];
            this.dynamicFields.forEach(field => { if (this.projectFieldMatches(field, hiddenKeys) || this.isGloballyHiddenDynamicField(field) || this.isProjectPdfHiddenField(field)) ids.add(Number(field.id)); });
            return Array.from(ids);
        },

        projectPriceToggleFeatureGroupIds() {
            const ids = new Set();

            this.projectPriceStatusItems
                .concat(this.projectPriceOpportunityItems)
                .forEach(item => {
                    if (item && item.group) {
                        ids.add(Number(item.group.id));
                    }
                });

            return Array.from(ids).filter(id => id > 0);
        },

        projectSectionFieldIds() {
            return this.projectBasicItems
                .concat(this.projectPropertyItems)
                .filter(item => item.type === 'field' && item.field)
                .map(item => Number(item.field.id));
        },

        isProjectOtherFilterRemovedField(field) {
            if (!field) return false;

            const text = this.dynamicFieldHaystack(field);
            const removedKeys = [
                'kapali_alan', 'kapalı alan', 'kapali alan', 'closed_area',
                'toplam_daire_sayisi', 'toplam daire sayısı', 'toplam daire sayisi', 'total_flat_count', 'total_unit_count',
                'blok_sayisi', 'blok sayısı', 'blok sayisi', 'block_count',
                'proje_adi', 'proje adı', 'proje adi', 'project_name',
                'aidat_gideri', 'aidat gideri', 'aylik_aidat_gideri', 'aylık aidat gideri', 'aylik_aidat', 'monthly_dues', 'monthly_fee', 'maintenance_fee',
                'taksit_sayisi', 'taksit sayısı', 'taksit sayisi', 'installment_count',
                'pesinat_orani', 'peşinat oranı', 'pesinat orani', 'pesinat', 'peşinat', 'down_payment'
            ];

            return removedKeys.some(key => text.includes(this.normalizeText(key)))
                || (text.includes('aidat') && (text.includes('gider') || text.includes('monthly') || text.includes('maintenance')))
                || (text.includes('taksit') && text.includes('say'));
        },

        buildProjectRemainingItems() {
            if (!this.isProjectFilterMode) return [];

            const excludedFieldIds = new Set(this.projectAlwaysHiddenFieldIds().concat(this.projectSectionFieldIds()));
            const projectSocialSourceGroupIds = this.projectSocialFeatureGroups
                .flatMap(group => Array.isArray(group.sourceGroupIds) ? group.sourceGroupIds : [group.id])
                .map(id => Number(id))
                .filter(id => Number.isFinite(id) && id > 0);

            const excludedFeatureGroupIds = new Set(
                projectSocialSourceGroupIds
                    .concat(this.projectBasicItems.filter(item => item.type === 'feature_group').map(item => Number(item.group?.id || 0)))
                    .concat(this.projectPropertyItems.filter(item => item.type === 'feature_group').map(item => Number(item.group?.id || 0)))
                    .filter(id => Number.isFinite(id) && id > 0)
                    .concat(this.projectPriceToggleFeatureGroupIds())
                    .concat(this.parkingFeatureGroupIds)
            );

            const excludedFeatureItemIds = new Set(
                this.projectSocialFeatureGroups
                    .flatMap(group => Array.isArray(group.sourceItemIds) ? group.sourceItemIds : [])
                    .map(id => Number(id))
                    .filter(id => Number.isFinite(id) && id > 0)
            );

            const fields = this.dynamicFields
                .filter(field => !excludedFieldIds.has(Number(field.id)))
                .map(field => ({
                    type: 'field',
                    key: `field-${field.id}`,
                    label: field.name,
                    field,
                }));

            const groups = this.dynamicFeatures
                .filter(group => !excludedFeatureGroupIds.has(Number(group.id)))
                .filter(group => !this.isProjectPdfHiddenFeatureGroup(group))
                .map(group => {
                    const visibleItems = Array.isArray(group.items)
                        ? group.items.filter(item => !excludedFeatureItemIds.has(Number(item.id)))
                        : [];

                    return {
                        type: 'feature_group',
                        key: `feature-${group.id}`,
                        label: group.name,
                        group: { ...group, items: visibleItems },
                    };
                })
                .filter(item => Array.isArray(item.group.items) && item.group.items.length > 0);

            return fields.concat(groups);
        },

        findProjectToggleItems(definitions = []) {
            const items = [];
            const used = new Set();

            definitions.forEach(definition => {
                let found = null;

                const directField = this.dynamicFields.find(field => this.projectFieldOwnMatches(field, definition.keys));

                if (directField) {
                    found = {
                        type: 'field_toggle',
                        key: `${definition.key}-field-${directField.id}`,
                        definitionKey: definition.key,
                        label: definition.label,
                        field: directField,
                    };
                }

                if (!found) {
                    for (const field of this.dynamicFields) {
                        if (!Array.isArray(field.options)) continue;

                        const option = field.options.find(opt => this.projectMatches(opt, definition.keys));
                        if (option) {
                            found = {
                                type: 'field_option',
                                key: `${definition.key}-field-${field.id}-option-${option.id}`,
                                definitionKey: definition.key,
                                label: definition.label,
                                field,
                                option,
                            };
                            break;
                        }
                    }
                }

                if (!found) {
                    for (const group of this.dynamicFeatures) {
                        const option = (group.items || []).find(item => this.projectFeatureItemMatches(group, item, definition.keys));
                        if (option) {
                            found = {
                                type: 'feature',
                                key: `${definition.key}-feature-${option.id}`,
                                definitionKey: definition.key,
                                label: definition.label,
                                group,
                                item: option,
                            };
                            break;
                        }
                    }
                }

                if (found && !used.has(found.key)) {
                    used.add(found.key);
                    items.push(found);
                }
            });

            return items;
        },

        projectToggleFieldValue(field) {
            if (this.isBooleanField(field)) {
                return this.booleanFieldValues(field).yesVal;
            }

            const options = Array.isArray(field?.options) ? field.options : [];
            if (options.length > 0) {
                const positives = ['evet', 'var', 'uygun', 'dahil', 'yes', 'true', 'mevcut', 'yapilabilir', 'yapılabilir'];
                const positive = options.find(option => {
                    const name = this.normalizeText([option.canonical_name, option.schema_value, option.name, option.value].filter(Boolean).join(' '));
                    return positives.some(word => name.includes(this.normalizeText(word)));
                });

                return String((positive || options[0]).id);
            }

            return '1';
        },

        isProjectToggleSelected(item) {
            if (!item) return false;

            if (item.type === 'feature') {
                return this.form.feature_value_ids.includes(Number(item.item.id));
            }

            if (item.type === 'field_option') {
                const value = this.form.fields[String(item.field.id)];
                if (Array.isArray(value)) {
                    return value.map(String).includes(String(item.option.id));
                }
                return String(value || '') === String(item.option.id);
            }

            if (item.type === 'field_toggle') {
                const value = this.form.fields[String(item.field.id)];
                return String(value || '') === String(this.projectToggleFieldValue(item.field));
            }

            return false;
        },

        toggleProjectToggleItem(item) {
            if (!item) return;

            if (item.type === 'feature') {
                const id = Number(item.item.id);
                this.form.feature_value_ids = this.form.feature_value_ids.includes(id)
                    ? this.form.feature_value_ids.filter(value => Number(value) !== id)
                    : this.form.feature_value_ids.concat(id);
                return;
            }

            if (item.type === 'field_option') {
                if (this.isMultiField(item.field)) {
                    this.toggleFieldArrayValue(item.field, item.option.id);
                    return;
                }

                const fieldId = String(item.field.id);
                this.form.fields[fieldId] = this.isProjectToggleSelected(item) ? '' : String(item.option.id);
                return;
            }

            if (item.type === 'field_toggle') {
                const fieldId = String(item.field.id);
                this.form.fields[fieldId] = this.isProjectToggleSelected(item) ? '' : this.projectToggleFieldValue(item.field);
            }
        },

        projectInstallmentTermMin(field) {
            const rawMin = field?.meta?.min ?? field?.meta?.min_value ?? field?.min ?? 1;
            const parsed = parseInt(String(rawMin || '1').replace(/\D+/g, ''), 10);
            return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
        },

        projectInstallmentTermMax(field) {
            const min = this.projectInstallmentTermMin(field);
            return Math.max(180, min);
        },

        projectInstallmentTermValue(field) {
            if (!field) return '';
            const value = String(this.getNumericRangeVal(field, 'min') || '').replace(/\D+/g, '');
            if (!value) return '';

            const min = this.projectInstallmentTermMin(field);
            const max = this.projectInstallmentTermMax(field);
            const numeric = parseInt(value, 10);

            if (!Number.isFinite(numeric)) return '';
            return String(Math.max(min, Math.min(max, numeric)));
        },

        projectInstallmentTermSliderValue(field) {
            return this.projectInstallmentTermValue(field) || String(this.projectInstallmentTermMin(field));
        },

        projectInstallmentTermDisplay(field) {
            return this.projectInstallmentTermValue(field) || '-';
        },

        projectInstallmentTermProgress(field) {
            const min = this.projectInstallmentTermMin(field);
            const max = this.projectInstallmentTermMax(field);
            const value = parseInt(this.projectInstallmentTermSliderValue(field), 10);

            if (!Number.isFinite(value) || max <= min) return 0;
            return Math.max(0, Math.min(100, ((value - min) * 100) / (max - min)));
        },

        onProjectInstallmentTermInput(field, event) {
            if (!field) return;

            const min = this.projectInstallmentTermMin(field);
            const max = this.projectInstallmentTermMax(field);
            const raw = event?.target?.value ?? '';
            const parsed = parseInt(String(raw || '').replace(/\D+/g, ''), 10);

            if (!Number.isFinite(parsed)) {
                this.clearProjectInstallmentTermField(field);
                return;
            }

            const next = Math.max(min, Math.min(max, parsed));
            this.setNumericRangeVal(field, 'min', String(next));
            this.setNumericRangeVal(field, 'max', '');
        },

        clearProjectInstallmentTermField(field) {
            if (!field) return;
            this.form.fields[String(field.id)] = { min: '', max: '' };
        },

        installmentFieldUnit(field, fallbackLabel = '') {
            const text = this.normalizeText([
                fallbackLabel,
                field?.name,
                field?.label,
                field?.unit,
                field?.schema_key,
                field?.meta?.schema_key,
            ].filter(Boolean).join(' '));

            if (text.includes('pesinat') || text.includes('down_payment')) return '%';
            if (text.includes('vade') || text.includes('taksit')) return 'Ay';

            return field?.unit || '';
        },

        isProjectMinOnlyNumericField(field) {
            if (!this.isProjectFilterMode) return false;
            const key = this.fieldSchemaKey(field);
            const name = this.normalizeText([field?.canonical_name, field?.name].filter(Boolean).join(' '));
            const minOnlyKeys = ['banyo_sayisi', 'balkon_sayisi', 'teras_sayisi', 'depo_sayisi', 'asansor_sayisi', 'asansör sayısı', 'asansor', 'park_yeri', 'otopark', 'arac_sayisi', 'araç sayısı', 'kat_sayisi', 'bolum_sayisi', 'bölüm sayısı', 'vade_suresi', 'vade süresi', 'taksit_vadesi', 'pesinat_orani', 'peşinat oranı', 'pesinat', 'peşinat', 'down_payment'];
            return minOnlyKeys.some(item => key.includes(this.normalizeText(item)) || name.includes(this.normalizeText(item)));
        },
        stepProjectMinOnlyNumeric(field, direction = 1) {
            this.stepProjectRangeNumeric(field, 'min', direction);
        },

        stepProjectRangeNumeric(field, side = 'min', direction = 1) {
            if (!field) return;
            const currentRaw = this.getNumericRangeVal(field, side);
            const current = parseInt(String(currentRaw || '0').replace(/\D/g, ''), 10);
            const next = Math.max(0, (Number.isFinite(current) ? current : 0) + (direction > 0 ? 1 : -1));
            this.setNumericRangeVal(field, side, next > 0 ? String(next) : '');
            this.syncProjectRoomPresetFromCounts(side);
        },

        projectRoomCounterField(kind) {
            return kind === 'bedrooms' ? this.projectBedroomField : this.projectSalonField;
        },

        normalizeProjectUnitRoomKind(kind) {
            return kind === 'living_rooms' ? 'living_rooms' : 'bedrooms';
        },

        ensureProjectUnitRoomState(kind) {
            const normalizedKind = this.normalizeProjectUnitRoomKind(kind);

            if (!this.form.project_unit_rooms || typeof this.form.project_unit_rooms !== 'object') {
                this.form.project_unit_rooms = {};
            }

            if (!this.form.project_unit_rooms[normalizedKind] || typeof this.form.project_unit_rooms[normalizedKind] !== 'object') {
                this.form.project_unit_rooms[normalizedKind] = { min: '', max: '' };
            }

            return normalizedKind;
        },

        projectRoomCounterValue(kind, side = 'min') {
            const field = this.projectRoomCounterField(kind);
            if (field) {
                return this.getNumericRangeVal(field, side);
            }

            const normalizedKind = this.normalizeProjectUnitRoomKind(kind);
            return this.form.project_unit_rooms?.[normalizedKind]?.[side] || '';
        },

        setProjectRoomCounterValue(kind, side = 'min', rawValue = '', options = {}) {
            const field = this.projectRoomCounterField(kind);

            if (field) {
                this.setNumericRangeVal(field, side, rawValue);
                if (options.sync !== false) {
                    this.syncProjectRoomPresetFromCounts(side);
                }
                return;
            }

            const normalizedKind = this.ensureProjectUnitRoomState(kind);
            const cleanValue = String(rawValue || '').replace(/\D/g, '');
            const current = { ...(this.form.project_unit_rooms[normalizedKind] || { min: '', max: '' }) };
            current[side] = cleanValue;

            if (current.min && current.max) {
                const minNum = parseInt(current.min || '0', 10);
                const maxNum = parseInt(current.max || '0', 10);
                if (Number.isFinite(minNum) && Number.isFinite(maxNum) && maxNum > 0 && maxNum < minNum) {
                    current.max = current.min;
                }
            }

            this.form.project_unit_rooms = {
                ...(this.form.project_unit_rooms || {}),
                [normalizedKind]: current,
            };

            if (options.sync !== false) {
                this.syncProjectRoomPresetFromCounts(side);
            }
        },

        onProjectRoomCounterInput(kind, side = 'min', event) {
            this.setProjectRoomCounterValue(kind, side, event?.target?.value ?? '');
        },

        stepProjectRoomCounter(kind, side = 'min', direction = 1) {
            const currentRaw = this.projectRoomCounterValue(kind, side);
            const current = parseInt(String(currentRaw || '0').replace(/\D/g, ''), 10);
            const next = Math.max(0, (Number.isFinite(current) ? current : 0) + (direction > 0 ? 1 : -1));
            this.setProjectRoomCounterValue(kind, side, next > 0 ? String(next) : '');
        },

        projectRoomPresetValueFromCounts(side = 'min') {
            const bedroom = parseInt(String(this.projectRoomCounterValue('bedrooms', side) || '').replace(/\D/g, ''), 10);
            const salon = parseInt(String(this.projectRoomCounterValue('living_rooms', side) || '').replace(/\D/g, ''), 10);

            if (!Number.isFinite(bedroom) || !Number.isFinite(salon)) {
                return '';
            }

            const option = (this.projectRoomOptions || []).find(item => Number(item.bedrooms) === bedroom && Number(item.salons) === salon)
                || (this.projectRoomOptions || []).find(item => this.normalizeRoomPresetLabel(item.name) === `${bedroom}+${salon}`);

            return option ? String(option.id) : '';
        },

        isProjectPdfMultipleChoiceField(field) {
            if (!this.isProjectFilterMode || !field) return false;
            const key = this.fieldSchemaKey(field);
            if (key === 'yapim_durumu') return true;
            return this.currentProjectTypeKey === 'villa' && ['havuz_durumu', 'havuz_tipi', 'havuz_secimi', 'yapi_tipi'].includes(key);
        },

        projectConstructionStatusField() {
            return this.isProjectFilterMode ? this.projectFindField(['yapim_durumu']) : null;
        },

        isProjectCompletedSelected() {
            const field = this.projectConstructionStatusField();
            if (!field) return false;
            const selected = this.form.fields[String(field.id)];
            const values = Array.isArray(selected) ? selected : [selected];
            return values.some(id => (field.options || []).some(option =>
                String(option.id) === String(id) && this.normalizeText(option.canonical_name || option.name).includes('tamamland')
            ));
        },

        isProjectDeliveryYearField(field) {
            if (!this.isProjectFilterMode || !field) return false;
            const key = this.fieldSchemaKey(field);
            const text = this.normalizeText([field?.canonical_name, field?.name, field?.label, field?.canonical_placeholder, field?.placeholder, field?.schema_key, field?.meta?.schema_key, field?.meta?.input, field?.meta?.section].filter(Boolean).join(' '));

            return key.includes('teslim_tarihi')
                || key.includes('teslim_yili')
                || text.includes('teslim_tarihi')
                || text.includes('teslim_yili')
                || text.includes('teslim_tarihi')
                || text.includes('teslim');
        },

        projectDeliveryYearValue(field, side = 'min') {
            return this.getNumericRangeVal(field, side);
        },

        setProjectDeliveryYear(field, side = 'min', year = '') {
            if (!field || this.isProjectCompletedSelected()) return;
            this.setNumericRangeVal(field, side, year ? String(year) : '');
            this.openDropdown = null;
        },

        filteredProjectDeliveryMaxYears(field) {
            const minYear = parseInt(String(this.projectDeliveryYearValue(field, 'min') || '').replace(/\D/g, ''), 10);
            if (!Number.isFinite(minYear) || minYear <= 0) {
                return this.projectDeliveryYearOptions;
            }

            return this.projectDeliveryYearOptions.filter(year => Number(year) >= minYear);
        },

        turkishRoomPresetOptions() {
            const labels = [
                '1+0', '1+1', '2+1', '3+1', '4+1', '5+1', '6+1', '7+1',
                '2+2', '3+2', '4+2', '5+2', '6+2'
            ];

            return labels.map(label => {
                const parsed = this.parseRoomLabel(label);

                return {
                    id: label,
                    name: label,
                    bedrooms: parsed?.bedrooms ?? null,
                    salons: parsed?.salons ?? null,
                    synthetic: true,
                };
            });
        },

        parseRoomLabel(label) {
            const match = String(label || '').match(/(\d+)\s*\+\s*(\d+)/);
            if (!match) return null;

            const bedrooms = parseInt(match[1], 10);
            const salons = parseInt(match[2], 10);

            if (!Number.isFinite(bedrooms) || !Number.isFinite(salons)) return null;

            return { bedrooms, salons };
        },

        normalizeRoomPresetLabel(label) {
            const parsed = this.parseRoomLabel(label);
            return parsed ? `${parsed.bedrooms}+${parsed.salons}` : this.normalizeText(label);
        },

        mergeTurkishRoomPresetOptions(options = []) {
            const normalized = [];
            const seen = new Set();

            (options || []).forEach(option => {
                const name = option?.name || option?.value || String(option?.id || '');
                const parsed = this.parseRoomLabel(name);
                const normalizedLabel = this.normalizeRoomPresetLabel(name);

                if (!name || seen.has(normalizedLabel)) return;

                seen.add(normalizedLabel);
                normalized.push({
                    ...option,
                    id: String(option.id ?? name),
                    name,
                    bedrooms: parsed?.bedrooms ?? null,
                    salons: parsed?.salons ?? null,
                    synthetic: !!option.synthetic,
                });
            });

            this.turkishRoomPresetOptions().forEach(option => {
                const normalizedLabel = this.normalizeRoomPresetLabel(option.name);
                if (seen.has(normalizedLabel)) return;

                seen.add(normalizedLabel);
                normalized.push(option);
            });

            return normalized;
        },

        roomOptionRank(option) {
            const parsed = this.parseRoomLabel(option?.name || option?.value || option?.id || '');
            if (!parsed) return NaN;
            return (Number(parsed.bedrooms) * 100) + Number(parsed.salons || 0);
        },

        roomPresetRank(options = [], value = '') {
            if (!value) return NaN;
            const option = (options || []).find(item => String(item.id) === String(value)) || { name: value, id: value };
            return this.roomOptionRank(option);
        },

        filteredRoomMaxOptions(options = [], minValue = '') {
            const minRank = this.roomPresetRank(options, minValue);
            if (!Number.isFinite(minRank)) return options || [];

            return (options || []).filter(option => {
                const rank = this.roomOptionRank(option);
                return !Number.isFinite(rank) || rank >= minRank;
            });
        },

        isRoomMaxOptionDisabled(options = [], option = null, minValue = '') {
            const minRank = this.roomPresetRank(options, minValue);
            const optionRank = this.roomOptionRank(option);

            return Number.isFinite(minRank) && Number.isFinite(optionRank) && optionRank < minRank;
        },

        roomPresetConstraintMessage(options = [], minValue = '', maxValue = '') {
            const minRank = this.roomPresetRank(options, minValue);
            const maxRank = this.roomPresetRank(options, maxValue);

            if (!Number.isFinite(minRank) || !Number.isFinite(maxRank) || maxRank >= minRank) {
                return '';
            }

            const minOption = (options || []).find(item => String(item.id) === String(minValue));
            const minLabel = minOption?.name || String(minValue || '');
            return `En çok oda, seçilen en az oda (${minLabel}) değerinden küçük olamaz.`;
        },

        projectRoomCounterConstraintMessage(kind) {
            const minValue = parseInt(String(this.projectRoomCounterValue(kind, 'min') || '').replace(/\D/g, ''), 10);
            const maxValue = parseInt(String(this.projectRoomCounterValue(kind, 'max') || '').replace(/\D/g, ''), 10);

            if (!Number.isFinite(minValue) || !Number.isFinite(maxValue) || minValue <= 0 || maxValue <= 0 || maxValue >= minValue) {
                return '';
            }

            const label = kind === 'living_rooms' ? 'salon' : 'yatak odası';
            return `En çok ${label}, en az ${label} değerinden küçük olamaz.`;
        },

        residentialRoomCounterConstraintMessage(field, label = 'oda') {
            if (!field) return '';
            const minValue = parseInt(String(this.getNumericRangeVal(field, 'min') || '').replace(/\D/g, ''), 10);
            const maxValue = parseInt(String(this.getNumericRangeVal(field, 'max') || '').replace(/\D/g, ''), 10);

            if (!Number.isFinite(minValue) || !Number.isFinite(maxValue) || minValue <= 0 || maxValue <= 0 || maxValue >= minValue) {
                return '';
            }

            return `En çok ${label}, en az ${label} değerinden küçük olamaz.`;
        },

        enforceRoomPresetRange(options = [], minValue = '', maxValue = '', setter = null) {
            const minRank = this.roomPresetRank(options, minValue);
            const maxRank = this.roomPresetRank(options, maxValue);

            if (!Number.isFinite(minRank) || !Number.isFinite(maxRank) || maxRank >= minRank) {
                return;
            }

            const minOption = (options || []).find(item => String(item.id) === String(minValue));
            if (typeof setter === 'function') {
                setter(minValue, minOption?.name || String(minValue || ''));
            }
        },

        enforceProjectRoomPresetRange() {
            this.enforceRoomPresetRange(
                this.projectRoomOptions,
                this.projectRoomPresetValue('min'),
                this.projectRoomPresetValue('max'),
                (value, label) => this.setProjectRoomPreset('max', value, label, { skipEnforce: true })
            );
        },

        enforceResidentialRoomPresetRange() {
            this.enforceRoomPresetRange(
                this.residentialRoomOptions,
                this.residentialRoomPresetValue('min'),
                this.residentialRoomPresetValue('max'),
                (value, label) => this.setResidentialRoomPreset('max', value, label, { skipEnforce: true })
            );
        },

        enforceAllRoomPresetRanges() {
            this.enforceProjectRoomPresetRange();
            this.enforceResidentialRoomPresetRange();
        },

        roomPresetValueFromCounts(options, bedroomField, salonField, side) {
            if (!bedroomField || !salonField) return '';

            const bedroom = parseInt(String(this.getNumericRangeVal(bedroomField, side) || '').replace(/\D/g, ''), 10);
            const salon = parseInt(String(this.getNumericRangeVal(salonField, side) || '').replace(/\D/g, ''), 10);

            if (!Number.isFinite(bedroom) || !Number.isFinite(salon)) return '';

            const option = (options || []).find(item => Number(item.bedrooms) === bedroom && Number(item.salons) === salon)
                || (options || []).find(item => this.normalizeRoomPresetLabel(item.name) === `${bedroom}+${salon}`);

            return option ? String(option.id) : '';
        },

        applyRoomPresetToFields(side, label, bedroomField, salonField) {
            const parsed = this.parseRoomLabel(label);
            if (!parsed) return;

            if (bedroomField && Number.isFinite(parsed.bedrooms)) {
                this.setNumericRangeVal(bedroomField, side, String(parsed.bedrooms));
            }

            if (salonField && Number.isFinite(parsed.salons)) {
                this.setNumericRangeVal(salonField, side, String(parsed.salons));
            }
        },

        clearRoomPresetFields(side, bedroomField, salonField) {
            if (bedroomField) {
                this.setNumericRangeVal(bedroomField, side, '');
            }

            if (salonField) {
                this.setNumericRangeVal(salonField, side, '');
            }
        },

        projectRoomPresetValue(side) {
            const field = this.projectRoomCountField;

            if (field) {
                const current = this.form.fields[String(field.id)];
                if (current && typeof current === 'object' && !Array.isArray(current) && current[side]) {
                    return current[side] || '';
                }
            }

            return this.projectRoomPresetValueFromCounts(side);
        },

        projectRoomPresetLabel(side) {
            const value = this.projectRoomPresetValue(side);
            if (!value) return '';

            const option = this.projectRoomOptions.find(item => String(item.id) === String(value));
            return option?.name || String(value);
        },

        setProjectRoomPreset(side, value, label = '', options = {}) {
            const option = this.projectRoomOptions.find(item => String(item.id) === String(value));
            const optionLabel = label || option?.name || String(value || '');
            const field = this.projectRoomCountField;

            if (field) {
                const fieldId = String(field.id);
                let current = this.form.fields[fieldId];

                if (!current || typeof current !== 'object' || Array.isArray(current)) {
                    current = { min: '', max: '' };
                }

                current[side] = value && !option?.synthetic ? String(value) : '';
                this.form.fields[fieldId] = { ...current };

                if (current.min || current.max) {
                    this.fieldFilterModes[fieldId] = 'range';
                }
            }

            const parsed = this.parseRoomLabel(optionLabel);
            if (value && parsed) {
                this.setProjectRoomCounterValue('bedrooms', side, String(parsed.bedrooms), { sync: false });
                this.setProjectRoomCounterValue('living_rooms', side, String(parsed.salons), { sync: false });
            } else {
                this.setProjectRoomCounterValue('bedrooms', side, '', { sync: false });
                this.setProjectRoomCounterValue('living_rooms', side, '', { sync: false });
            }

            if (!options.skipEnforce) {
                this.enforceProjectRoomPresetRange();
            }

            this.openDropdown = null;
        },

        syncProjectRoomPresetFromCounts(side) {
            const field = this.projectRoomCountField;
            const value = this.projectRoomPresetValueFromCounts(side);

            if (!field) return;

            const fieldId = String(field.id);
            let current = this.form.fields[fieldId];
            if (!current || typeof current !== 'object' || Array.isArray(current)) {
                current = { min: '', max: '' };
            }

            const option = this.projectRoomOptions.find(item => String(item.id) === String(value));
            current[side] = value && !option?.synthetic ? String(value) : '';
            this.form.fields[fieldId] = { ...current };

            if (current.min || current.max) {
                this.fieldFilterModes[fieldId] = 'range';
            }

            this.enforceProjectRoomPresetRange();
        },


        residentialLayoutConfigs() {
            const commonRoomKeys = [
                'yatak_odasi_sayisi', 'yatak odasi', 'yatak odası',
                'salon_sayisi', 'salon sayisi', 'salon sayısı',
                'oda_sayisi', 'oda sayisi', 'oda sayısı', 'oda_salon', 'room_count',
                'mutfak_tipi', 'mutfak_tipi_proje', 'mutfak turu', 'mutfak türü',
                'giyinme_odasi_sayisi', 'giyinme odasi', 'giyinme odası',
                'ebeveyn_banyosu_sayisi', 'ebeveyn banyosu',
                'banyo_sayisi', 'ortak_banyo_sayisi', 'ortak banyo', 'ortak banyo sayisi', 'ortak banyo sayısı',
                'wc_sayisi', 'wc sayisi', 'wc sayısı',
                'balkon_adet', 'balkon_sayisi', 'balkon sayisi', 'balkon sayısı',
                'teras_adet', 'teras_sayisi', 'teras sayisi', 'teras sayısı',
                'depo_adet', 'depo_sayisi', 'depo sayisi', 'depo sayısı',
            ];

            const priceKeys = this.residentialPriceToggleDefinitions('status')
                .concat(this.residentialPriceToggleDefinitions('sale_opportunity'))
                .concat(this.residentialPriceToggleDefinitions('rental_opportunity'))
                .flatMap(item => item.keys || []);

            const revisionTransaction = this.isPdfRevisionTransaction();
            const apartmentTurkishRevision = revisionTransaction && this.isPdfRevisionTurkishLocale();

            return {
                apartment: {
                    label: 'Daire / Residence',
                    hidden: commonRoomKeys.concat(priceKeys),
                    basic: [
                        { label: 'Brüt m²', keys: ['m2_brut', 'brut_m2', 'brüt m2', 'brut metrekare'] },
                        { label: 'Net m²', keys: ['m2_net', 'net_m2', 'net m2', 'net metrekare'] },
                        { label: 'Bulunduğu Kat', keys: ['bulundugu_kat', 'bulunduğu kat', 'bulundugu kat'] },
                        { label: 'Kat Sayısı', keys: ['kat_sayisi', 'kat sayisi', 'kat sayısı'] },
                        { label: 'Eşya Durumu', keys: ['esya_durumu', 'eşya durumu', 'esya durumu'], asCheckbox: true },
                    ],
                    status: [
                        { label: 'Taşınmaz Durumu', keys: ['tasinmaz_durumu', 'taşınmaz durumu', 'tasınmaz durumu', 'tasinmaz durumu'], asCheckbox: true },
                        { label: 'Yapım Yılı', keys: ['yapim_yili', 'yapım yılı', 'yapim yili'] },
                        { label: 'Yenileme Yılı', keys: ['renovasyon_yili', 'renovasyon yılı', 'yenileme_yili', 'yenileme yılı', 'yenilenme_yili', 'yenilenme yılı'] },
                        { label: 'Site İçerisinde', keys: ['site_icerisinde', 'site içerisinde', 'site icerisinde', 'site icinde'], yesNoToggle: true },
                        { label: 'Bahçe Durumu', keys: ['bahce_tipi', 'bahce_durumu', 'bahçe durumu', 'bahçe', 'bahce'] },
                        { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true },
                        ...(apartmentTurkishRevision ? [{ label: 'Güneş Alma', keys: ['gunes_alma', 'güneş alma', 'gunes alma', 'cephe_gunes'], preferFeature: true }] : []),
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'], preferFeature: true },
                    ],
                    detail: [
                        { label: 'Asansör', keys: ['asansor_adet', 'asansor_sayisi', 'asansör sayısı', 'asansor'], minOnly: true },
                        { label: 'Park Yeri', keys: ['park_yeri', 'otopark', 'acik_otopark_arac', 'kapali_otopark_arac', 'kapali_garaj_arac', 'elektrikli_sarj_adet', 'park yeri'] },
                        ...(!apartmentTurkishRevision ? [{ label: 'Güneş Alma', keys: ['gunes_alma', 'güneş alma', 'gunes alma', 'cephe_gunes'], preferFeature: true }] : []),
                        { label: 'Isıtma / Soğutma', keys: ['isitma_sogutma', 'isitma ve sogutma', 'ısıtma ve soğutma', 'isitma', 'ısıtma', 'soğutma', 'sogutma', 'klima'], preferFeature: true },
                        { label: 'Mülk Şekli', keys: ['mulk_sekli_daire', 'mulk_sekli', 'mülk şekli', 'mulk sekli'], asCheckbox: true },
                    ],
                    parking: [],
                    legal: [
                        { label: 'Tapu Durumu', keys: ['tapu_durumu_bina', 'tapu_durumu', 'tapu durumu'], asCheckbox: true },
                        { label: 'İskan Durumu', keys: ['iskan_durumu', 'iskan durumu'], asCheckbox: true },
                        { label: 'Deprem Yönetmeliği', keys: ['deprem_yonetmeligine_uygun', 'deprem yönetmeliğine uygun', 'deprem yonetmeligine uygun', 'deprem yonetmeligi'], yesNoToggle: true },
                    ],
                },
                villa: {
                    label: 'Villa / Müstakil Ev / Tiny House / Çiftlik Evi',
                    hidden: commonRoomKeys.concat(priceKeys).concat(['bulundugu_kat', 'bulunduğu kat', 'bulundugu kat']),
                    basic: [
                        { label: 'Arsa m²', keys: ['arsa_m2', 'arazi_m2', 'arsa metrekare', 'arsa m2'] },
                        { label: revisionTransaction ? 'Brüt m²' : 'Villa Alanı Brüt m²', keys: ['villa_alani_brut', 'villa_brut_m2', 'm2_brut', 'brut_m2', 'brüt m2'] },
                        { label: revisionTransaction ? 'Net m²' : 'Villa Alanı Net m²', keys: ['villa_alani_net', 'villa_net_m2', 'm2_net', 'net_m2', 'net m2'] },
                        { label: 'Kat Sayısı', keys: ['kat_sayisi', 'kat sayisi', 'kat sayısı'] },
                        ...(revisionTransaction ? [{ label: 'Eşya Durumu', keys: ['esya_durumu', 'eşya durumu', 'esya durumu'], asCheckbox: true }] : []),
                    ],
                    status: [
                        { label: 'Taşınmaz Durumu', keys: ['tasinmaz_durumu', 'taşınmaz durumu', 'tasınmaz durumu', 'tasinmaz durumu'], asCheckbox: true },
                        { label: 'Yapım Yılı', keys: ['yapim_yili', 'yapım yılı', 'yapim yili'] },
                        { label: 'Yenileme Yılı', keys: ['renovasyon_yili', 'renovasyon yılı', 'yenileme_yili', 'yenileme yılı', 'yenilenme_yili', 'yenilenme yılı'] },
                        { label: 'Site İçerisinde', keys: ['site_icerisinde', 'site içerisinde', 'site icerisinde', 'site icinde'], yesNoToggle: true },
                        ...(revisionTransaction ? [{ label: 'Havuz Seçimi', keys: ['havuz_tipi', 'havuz_secimi', 'havuz durumu', 'havuz'], asCheckbox: true }] : []),
                        { label: 'Bahçe Durumu', keys: ['bahce_tipi', 'bahce_durumu', 'bahçe durumu', 'bahçe', 'bahce'] },
                        { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true },
                        ...(revisionTransaction ? [{ label: 'Güneş Alma', keys: ['gunes_alma', 'güneş alma', 'gunes alma', 'cephe_gunes'], preferFeature: true }] : []),
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'], preferFeature: true },
                    ],
                    detail: [
                        { label: 'Asansör', keys: ['asansor_adet', 'asansor_sayisi', 'asansör sayısı', 'asansor'], minOnly: true },
                        { label: 'Park Yeri', keys: ['park_yeri', 'otopark', 'acik_otopark_arac', 'kapali_otopark_arac', 'kapali_garaj_arac', 'elektrikli_sarj_adet', 'park yeri'] },
                        ...(!revisionTransaction ? [{ label: 'Havuz Seçimi', keys: ['havuz_tipi', 'havuz_secimi', 'havuz durumu', 'havuz'], asCheckbox: true }] : []),
                        ...(!revisionTransaction ? [{ label: 'Güneş Alma', keys: ['gunes_alma', 'güneş alma', 'gunes alma', 'cephe_gunes'], preferFeature: true }] : []),
                        { label: 'Isıtma / Soğutma', keys: ['isitma_sogutma', 'isitma ve sogutma', 'ısıtma ve soğutma', 'isitma', 'ısıtma', 'soğutma', 'sogutma', 'klima'], preferFeature: true },
                        { label: 'Villa Tipi', keys: ['villa_tipi', 'mulk_sekli_villa', 'villa tipi'], asCheckbox: true },
                        { label: 'Yapı Tipi', keys: ['yapi_tipi', 'yapı tipi', 'yapi tipi'], asCheckbox: true },
                    ],
                    parking: [],
                    legal: [
                        { label: 'Tapu Durumu', keys: ['tapu_durumu_bina', 'tapu_durumu', 'tapu durumu'], asCheckbox: true },
                        { label: 'İskan Durumu', keys: ['iskan_durumu', 'iskan durumu'], asCheckbox: true },
                        { label: 'Deprem Yönetmeliği', keys: ['deprem_yonetmeligine_uygun', 'deprem yönetmeliğine uygun', 'deprem yonetmeligine uygun', 'deprem yonetmeligi'], yesNoToggle: true },
                    ],
                },
            };
        },
        residentialLayoutConfig() {
            const configs = this.residentialLayoutConfigs();
            return configs[this.currentResidentialTypeKey] || configs.apartment;
        },

        residentialSocialDefinitions() {
            return [
                {
                    key: 'security',
                    label: 'Güvenlik',
                    groupNames: ['Güvenlik'],
                    keys: ['guvenlik', 'güvenlik'],
                    labels: [
                        'Yangın Alarmı',
                        'Yangın Merdiveni',
                        'Güvenlik',
                        'Güvenlik Görevlisi',
                        '7/24 Kamera Sistemi',
                        'Site Giriş Kontrolü',
                        'Duman Dedektörü',
                        'Yangın Dedektörü',
                        'Görüntülü Diafon',
                        'Su Baskını Sensörü',
                        'Acil Çağrı Sistemi',
                        'Alarm Sistemi',
                        'Kartlı Geçiş / Elektronik Erişim',
                    ],
                },
                {
                    key: 'pool_beach',
                    label: 'Havuz & Plajlar',
                    groupNames: ['Havuz & Plajlar', 'Havuz ve Plajlar'],
                    keys: ['havuz', 'plaj', 'marina', 'iskele'],
                    labels: [
                        'Açık Havuz',
                        'Kapalı Havuz',
                        'Açık Yüzme Havuzu',
                        'Kapalı Yüzme Havuzu',
                        'Isıtmalı Havuz',
                        'Termal Havuz',
                        'Tuzlu Su Havuzu',
                        'Çocuk Havuzu',
                        'Aqua Parklı Havuz',
                        'Aquaparklı Yüzme Havuzu',
                        'Özel Plaj',
                        'Halk Plajı',
                        'İskele',
                        'Marina',
                        'Tekne Bağlama Alanı',
                        'Beach Club',
                        'Sahil / Plaj',
                        'Şezlong / Güneşlenme Alanı',
                    ],
                },
                {
                    key: 'sport_activity',
                    label: 'Spor & Aktivite',
                    groupNames: ['Spor & Aktivite', 'Spor ve Aktivite', 'Spor Aktivite'],
                    keys: ['spor', 'aktivite', 'fitness', 'tenis', 'basketbol', 'futbol', 'yoga', 'pilates'],
                    labels: [
                        'Fitness Salonu',
                        'Spor Salonu',
                        'Yürüyüş Yolu',
                        'Yürüyüş / Koşu Parkuru',
                        'Açık Spor Alanı',
                        'Basketbol Sahası',
                        'Tenis Kortu',
                        'Futbol Sahası',
                        'Yoga / Pilates Salonu',
                        'Squash Kortu',
                        'Voleybol Sahası',
                        'Bisiklet Parkuru',
                        'Masa Tenisi',
                        'Bilardo',
                        'Oyun Salonu',
                        'Bowling',
                        'Animasyon Alanı',
                        'Kids Club',
                        'Kids Clup',
                        'Tırmanma Duvarı',
                    ],
                },
                {
                    key: 'social_areas',
                    label: 'Sosyal Alanlar',
                    groupNames: ['Sosyal Alanlar', 'Sosyal Alan'],
                    keys: ['sosyal alan', 'restoran', 'kafe', 'kreş', 'sinema', 'toplantı', 'etkinlik', 'lounge'],
                    labels: [
                        'Çocuk Oyun Alanı',
                        'Barbekü Alanı',
                        'Restoran / Kafe',
                        'Restoran/Kafe',
                        'Restoran',
                        'Kafe / Bar / Lounge',
                        'Kafeterya',
                        'Kreş',
                        'Sinema Salonu',
                        'Toplantı Odası',
                        'Toplantı / Konferans Salonu',
                        'Etkinlik Salonu',
                        'Amfi Tiyatro',
                        'Business Center',
                        'Dinlenme Alanı',
                        'Bekleme Alanı',
                        'Yemekhane',
                        'Lounge Alanı',
                        'Ortak Çalışma Alanı',
                    ],
                },
                {
                    key: 'wellness_spa',
                    label: 'Welness & Spa',
                    groupNames: ['Wellness & Spa', 'Welness & Spa', 'Wellness Spa', 'Welness Spa'],
                    keys: ['wellness', 'welness', 'spa', 'hamam', 'sauna', 'buhar', 'masaj', 'jakuzi'],
                    labels: [
                        'Türk Hamamı',
                        'Sauna',
                        'Buhar Odası',
                        'Masaj Odası',
                        'Tuz Odası',
                        'Cilt Bakım Merkezi',
                        'Cilt Bakım Odası',
                        'Güzellik Merkezi',
                        'Termal Spa',
                        'Spa / Hamam / Sauna',
                        'Jakuzi',
                        'Rahatlama Odası',
                    ],
                },
                {
                    key: 'technical_infra',
                    label: 'Teknik Altyapı',
                    groupNames: ['Teknik Altyapı', 'Teknik Altyapi', 'Teknik Altyapı Özellikleri'],
                    keys: ['teknik altyapi', 'teknik altyapı', 'altyapi', 'altyapı', 'jenerator', 'jeneratör', 'akilli ev', 'akıllı ev', 'fiber', 'ups', 'hidrofor'],
                    labels: [
                        'Jeneratör',
                        'Akıllı Ev Sistemi',
                        'Akıllı Ev Sistemleri',
                        'Güneş Enerjisi Sistemi',
                        'UPS Sistemi',
                        'Fiber İnternet Altyapısı',
                        'Uydu TV Sistemi',
                        'Kablo TV',
                        'Kablolu Ağ Altyapısı',
                        'Acil Durum Aydınlatması',
                        'Su Deposu / Hidrofor',
                    ],
                },
                {
                    key: 'other_features',
                    label: 'Diğer Özellikler',
                    groupNames: ['Diğer Özellikler', 'Diger Ozellikler'],
                    keys: ['diger ozellik', 'diğer özellik', 'kapici', 'kapıcı', 'bahcivan', 'bahçıvan'],
                    labels: [
                        'Kapıcı',
                        'Bahçıvan',
                    ],
                    collectUnmatchedSocial: true,
                },
            ];
        },

        residentialPriceToggleDefinitions(type) {
            const groups = {
                status: [
                    { key: 'income_tenant', label: 'Gelir Getiren Kiracılı', keys: ['gelir_getiren_kiracili', 'gelir getiren kiracili', 'gelir getiren kiracılı', 'kiracili', 'kiracılı'] },
                    { key: 'empty_property', label: 'Boş Gayrimenkul', keys: ['bos_gayrimenkul', 'boş gayrimenkul', 'bos gayrimenkul', 'bos', 'boş'] },
                    { key: 'owner_uses', label: 'Mülk Sahibi Kullanıyor', keys: ['mulk_sahibi_kullaniyor', 'mulk sahibi kullaniyor', 'mülk sahibi kullanıyor', 'sahibi kullaniyor'] },
                ],
                sale_opportunity: [
                    { key: 'credit_suitable', label: 'Krediye Uygun', keys: ['krediye_uygun', 'krediye uygun', 'kredi'] },
                    { key: 'barter_suitable', label: 'Takasa Uygun', keys: ['takasa_uygun', 'takas_var_mi', 'takasa uygun', 'takas'] },
                    { key: 'residence_permit', label: 'İkamet İzni', keys: ['ikamet_izni', 'ikamet izni', 'ikamete uygun', 'ikamet'] },
                    { key: 'citizenship', label: 'Türk Vatandaşlığı', keys: ['turk_vatandasligi', 'türk vatandaşlığı', 'turk vatandasligi', 'vatandaslik', 'vatandaşlık'] },
                    { key: 'offer_available', label: 'Fiyat Teklifi Yapılabilir', keys: ['fiyat_teklifi_yapilabilir', 'fiyat_teklifi_var', 'fiyat teklifi', 'teklif yapilabilir', 'teklif yapılabilir', 'teklif'] },
                ],
                rental_opportunity: [
                    { key: 'offer_available', label: 'Fiyat Teklifi Yapılabilir', keys: ['fiyat_teklifi_yapilabilir', 'fiyat_teklifi_var', 'fiyat teklifi', 'teklif yapilabilir', 'teklif yapılabilir', 'teklif'] },
                ],
            };

            return (groups[type] || []).map(item => ({ ...item }));
        },

        residentialDescriptor(value) {
            return this.filterStructuralDescriptor(value, true);
        },

        residentialMatches(value, keys = []) {
            const haystack = this.normalizeText(this.residentialDescriptor(value));
            return keys.some(key => {
                const needle = this.normalizeText(key);
                return needle && haystack.includes(needle);
            });
        },

        residentialFieldMatches(field, keys = []) {
            return this.residentialFieldOwnMatches(field, keys);
        },

        residentialFieldOwnMatches(field, keys = []) {
            return this.residentialMatches({
                schema_key: field?.schema_key,
                key: field?.key,
                name: field?.name,
                canonical_name: field?.canonical_name,
                placeholder: field?.placeholder,
                canonical_placeholder: field?.canonical_placeholder,
                unit: field?.unit,
                meta: field?.meta,
            }, keys);
        },

        residentialFeatureGroupMatches(group, keys = []) {
            return this.residentialMatches({
                schema_key: group?.schema_key,
                key: group?.key,
                name: group?.name,
                canonical_name: group?.canonical_name,
                label: group?.label,
                meta: group?.meta,
            }, keys);
        },

        residentialFeatureItemMatches(group, item, keys = []) {
            return this.filterStructuralMatches([group, item], keys);
        },

        residentialFindField(keys = []) {
            const exact = this.dynamicFields.find(field => this.fieldMatchesExactSchema(field, keys));
            if (exact) return exact;

            return this.dynamicFields.find(field => this.residentialFieldOwnMatches(field, keys)) || null;
        },

        residentialFindFeatureGroup(keys = []) {
            return this.dynamicFeatures.find(group => this.residentialFeatureGroupMatches(group, keys)) || null;
        },

        residentialResolveDefinitions(definitions = [], options = {}) {
            const items = [];
            const usedFieldIds = new Set();
            const usedFeatureIds = new Set();

            definitions.forEach((definition, index) => {
                let field = this.dynamicFields.find(candidate => {
                    const id = Number(candidate.id);
                    return !usedFieldIds.has(id)
                        && !this.isGloballyHiddenDynamicField(candidate)
                        && this.fieldMatchesExactSchema(candidate, definition.keys || []);
                });

                if (!field) {
                    field = this.dynamicFields.find(candidate => {
                        const id = Number(candidate.id);
                        return !usedFieldIds.has(id)
                            && !this.isGloballyHiddenDynamicField(candidate)
                            && this.residentialFieldOwnMatches(candidate, definition.keys || []);
                    });
                }

                if (field) {
                    usedFieldIds.add(Number(field.id));
                    items.push({
                        type: 'field',
                        key: `${definition.label}-${field.id}`,
                        label: definition.label || field.name,
                        field,
                        definitionIndex: index,
                    });
                    return;
                }

                if (options.fieldsOnly) {
                    return;
                }

                const group = this.dynamicFeatures.find(candidate => {
                    const id = Number(candidate.id);
                    return !usedFeatureIds.has(id) && this.residentialFeatureGroupMatches(candidate, definition.keys || []);
                });

                if (group) {
                    usedFeatureIds.add(Number(group.id));
                    items.push({
                        type: 'feature_group',
                        key: `${definition.label}-${group.id}`,
                        label: definition.label || group.name,
                        group,
                        definitionIndex: index,
                    });
                }
            });

            return items;
        },

        buildResidentialSectionItems(section) {
            if (!this.isResidentialFilterMode) return [];

            const config = this.residentialLayoutConfig();
            const definitions = Array.isArray(config[section]) ? config[section] : [];
            const excludedIds = new Set(this.residentialAlwaysHiddenFieldIds());
            const used = new Set();

            return definitions.map((definition, index) => {
                if (this.isParkingDefinition(definition)) {
                    return this.buildParkingFilterItem(`${section}-${index}`);
                }

                const preferFeature = definition.preferFeature === true;
                const findFeatureGroup = () => this.dynamicFeatures.find(candidate => this.residentialFeatureGroupMatches(candidate, definition.keys || []));

                if (preferFeature) {
                    const group = findFeatureGroup();
                    const isPinnedVisualGroup = this.isViewOrFacadeDefinition(definition);
                    if (group && (isPinnedVisualGroup || !this.residentialSocialUsesFeatureGroup(group))) {
                        return {
                            type: 'feature_group',
                            key: `${section}-feature-${group.id}`,
                            label: definition.label || group.name,
                            group,
                            definitionIndex: index,
                        };
                    }
                }

                let field = this.dynamicFields.find(candidate => {
                    const id = Number(candidate.id);
                    return !excludedIds.has(id)
                        && !used.has(id)
                        && this.fieldMatchesExactSchema(candidate, definition.keys || []);
                });

                if (!field) {
                    field = this.dynamicFields.find(candidate => {
                        const id = Number(candidate.id);
                        return !excludedIds.has(id)
                            && !used.has(id)
                            && this.residentialFieldOwnMatches(candidate, definition.keys || []);
                    });
                }

                if (field) {
                    used.add(Number(field.id));
                    return {
                        type: 'field',
                        key: `${section}-${field.id}`,
                        label: definition.label || field.name,
                        field,
                        definitionIndex: index,
                        renderAsCheckboxes: definition.asCheckbox === true,
                        renderAsYesNoToggle: definition.yesNoToggle === true,
                        minOnly: definition.minOnly === true,
                    };
                }

                if (section === 'basic' || section === 'property') {
                    const group = findFeatureGroup();
                    if (group && !this.residentialSocialUsesFeatureGroup(group)) {
                        return {
                            type: 'feature_group',
                            key: `${section}-feature-${group.id}`,
                            label: definition.label || group.name,
                            group,
                            definitionIndex: index,
                        };
                    }
                }

                return null;
            }).filter(Boolean);
        },

        residentialAlwaysHiddenFieldIds() {
            const ids = new Set();

            [
                this.residentialBedroomField,
                this.residentialSalonField,
                this.residentialRoomCountField,
                this.residentialKitchenField,
            ].forEach(field => {
                if (field) ids.add(Number(field.id));
            });

            this.residentialRoomMinOnlyItems.forEach(item => {
                if (item.field) ids.add(Number(item.field.id));
            });

            this.residentialPriceStatusItems.concat(this.residentialPriceOpportunityItems).forEach(item => {
                if (item.field) ids.add(Number(item.field.id));
            });

            this.parkingRelatedFields().forEach(field => {
                if (field) ids.add(Number(field.id));
            });

            const hiddenKeys = this.residentialLayoutConfig().hidden || [];
            this.dynamicFields.forEach(field => {
                if (this.residentialFieldOwnMatches(field, hiddenKeys) || this.isGloballyHiddenDynamicField(field)) {
                    ids.add(Number(field.id));
                }
            });

            return Array.from(ids);
        },

        residentialPriceToggleFeatureGroupIds() {
            const ids = new Set();

            this.residentialPriceStatusItems
                .concat(this.residentialPriceOpportunityItems)
                .forEach(item => {
                    if (item && item.group) {
                        ids.add(Number(item.group.id));
                    }
                });

            return Array.from(ids).filter(id => id > 0);
        },

        residentialSectionFieldIds() {
            return this.residentialBasicItems
                .concat(this.residentialStatusItems)
                .concat(this.residentialDetailItems)
                .concat(this.residentialParkingItems)
                .concat(this.residentialLegalItems)
                .filter(item => item.type === 'field' && item.field)
                .map(item => Number(item.field.id));
        },

        buildResidentialRemainingItems() {
            if (!this.isResidentialFilterMode) return [];

            const excludedFieldIds = new Set(this.residentialAlwaysHiddenFieldIds().concat(this.residentialSectionFieldIds()));
            const residentialSectionFeatureGroups = this.residentialBasicItems
                .concat(this.residentialStatusItems)
                .concat(this.residentialDetailItems)
                .concat(this.residentialParkingItems)
                .concat(this.residentialLegalItems)
                .filter(item => item.type === 'feature_group')
                .map(item => item.group);

            const excludedFeatureGroupIds = new Set(
                residentialSectionFeatureGroups
                    .filter(Boolean)
                    .map(group => Number(group.id))
                    .concat(this.residentialPriceToggleFeatureGroupIds())
                    .concat(this.parkingFeatureGroupIds)
            );
            const excludedFeatureItemIds = new Set(this.residentialSocialFeatureItemIds());

            const fields = this.dynamicFields
                .filter(field => !excludedFieldIds.has(Number(field.id)))
                .filter(field => !this.isPdfRevisionPaymentField(field))
                .map(field => ({
                    type: 'field',
                    key: `field-${field.id}`,
                    label: field.name,
                    field,
                }));

            const groups = this.dynamicFeatures
                .filter(group => !excludedFeatureGroupIds.has(Number(group.id)))
                .filter(group => !this.isPdfRevisionPaymentFeatureGroup(group))
                .map(group => {
                    const visibleItems = Array.isArray(group.items)
                        ? group.items.filter(item => !excludedFeatureItemIds.has(Number(item.id)))
                        : [];

                    return {
                        type: 'feature_group',
                        key: `feature-${group.id}`,
                        label: group.name,
                        group: { ...group, items: visibleItems },
                    };
                })
                .filter(item => Array.isArray(item.group.items) && item.group.items.length > 0);

            return fields.concat(groups);
        },

        findResidentialToggleItems(definitions = []) {
            const items = [];
            const used = new Set();

            definitions.forEach(definition => {
                let found = null;

                const directField = this.dynamicFields.find(field => this.residentialFieldOwnMatches(field, definition.keys));

                if (directField) {
                    found = {
                        type: 'field_toggle',
                        key: `${definition.key}-field-${directField.id}`,
                        definitionKey: definition.key,
                        label: definition.label,
                        field: directField,
                    };
                }

                if (!found) {
                    for (const field of this.dynamicFields) {
                        if (!Array.isArray(field.options)) continue;

                        const option = field.options.find(opt => this.residentialMatches(opt, definition.keys));
                        if (option) {
                            found = {
                                type: 'field_option',
                                key: `${definition.key}-field-${field.id}-option-${option.id}`,
                                definitionKey: definition.key,
                                label: definition.label,
                                field,
                                option,
                            };
                            break;
                        }
                    }
                }

                if (!found) {
                    for (const group of this.dynamicFeatures) {
                        const option = (group.items || []).find(item => this.residentialFeatureItemMatches(group, item, definition.keys));
                        if (option) {
                            found = {
                                type: 'feature',
                                key: `${definition.key}-feature-${option.id}`,
                                definitionKey: definition.key,
                                label: definition.label,
                                group,
                                item: option,
                            };
                            break;
                        }
                    }
                }

                if (found && !used.has(found.key)) {
                    used.add(found.key);
                    items.push(found);
                }
            });

            return items;
        },

        residentialToggleFieldValue(field) {
            if (this.isBooleanField(field)) {
                return this.booleanFieldValues(field).yesVal;
            }

            const options = Array.isArray(field?.options) ? field.options : [];
            if (options.length > 0) {
                const positives = ['evet', 'var', 'uygun', 'dahil', 'yes', 'true', 'mevcut', 'yapilabilir', 'yapılabilir'];
                const positive = options.find(option => {
                    const name = this.normalizeText([option.canonical_name, option.schema_value, option.name, option.value].filter(Boolean).join(' '));
                    return positives.some(word => name.includes(this.normalizeText(word)));
                });

                return String((positive || options[0]).id);
            }

            return '1';
        },

        isResidentialToggleSelected(item) {
            if (!item) return false;

            if (item.type === 'feature') {
                return this.form.feature_value_ids.includes(Number(item.item.id));
            }

            if (item.type === 'field_option') {
                const value = this.form.fields[String(item.field.id)];
                if (Array.isArray(value)) {
                    return value.map(String).includes(String(item.option.id));
                }
                return String(value || '') === String(item.option.id);
            }

            if (item.type === 'field_toggle') {
                const value = this.form.fields[String(item.field.id)];
                return String(value || '') === String(this.residentialToggleFieldValue(item.field));
            }

            return false;
        },

        toggleResidentialToggleItem(item) {
            if (!item) return;

            if (item.type === 'feature') {
                const id = Number(item.item.id);
                this.form.feature_value_ids = this.form.feature_value_ids.includes(id)
                    ? this.form.feature_value_ids.filter(value => Number(value) !== id)
                    : this.form.feature_value_ids.concat(id);
                return;
            }

            if (item.type === 'field_option') {
                if (this.isMultiField(item.field)) {
                    this.toggleFieldArrayValue(item.field, item.option.id);
                    return;
                }

                const fieldId = String(item.field.id);
                this.form.fields[fieldId] = this.isResidentialToggleSelected(item) ? '' : String(item.option.id);
                return;
            }

            if (item.type === 'field_toggle') {
                const fieldId = String(item.field.id);
                this.form.fields[fieldId] = this.isResidentialToggleSelected(item) ? '' : this.residentialToggleFieldValue(item.field);
            }
        },

        isResidentialCheckboxOptionField(field) {
            if (!field || !Array.isArray(field.options) || field.options.length === 0) return false;

            const key = this.fieldSchemaKey(field);
            const checkboxKeys = [
                'esya_durumu', 'esya_durumu_proje',
                'tasinmaz_durumu',
                'mulk_sekli_daire', 'mulk_sekli_villa', 'mulk_sekli',
                'havuz_tipi',
                'yapi_tipi',
                'tapu_durumu_bina', 'tapu_durumu',
                'iskan_durumu',
            ];

            return checkboxKeys.some(item => key.includes(this.normalizeText(item)));
        },

        isResidentialYesNoOptionField(field) {
            if (!field || !Array.isArray(field.options) || field.options.length === 0) return false;

            const key = this.fieldSchemaKey(field);
            const yesNoKeys = [
                'site_icerisinde',
                'site_avm_icerisinde',
                'deprem_yonetmeligine_uygun',
            ];

            if (!yesNoKeys.some(item => key.includes(this.normalizeText(item)))) {
                return false;
            }

            const optionTexts = field.options.map(option => this.normalizeText([option.canonical_name, option.name, option.value].filter(Boolean).join(' ')));
            return optionTexts.some(text => text.includes('evet') || text.includes('var'))
                && optionTexts.some(text => text.includes('hayir') || text.includes('yok'));
        },

        isResidentialMinOnlyNumericField(field) {
            if (!this.isResidentialFilterMode) return false;

            const key = this.fieldSchemaKey(field);
            const name = this.normalizeText([field?.canonical_name, field?.name].filter(Boolean).join(' '));
            const minOnlyKeys = [
                'giyinme_odasi_sayisi', 'ebeveyn_banyosu_sayisi', 'banyo_sayisi', 'ortak_banyo_sayisi', 'wc_sayisi',
                'balkon_adet', 'balkon_sayisi', 'teras_adet', 'teras_sayisi', 'depo_adet', 'depo_sayisi',
                'asansor_adet', 'asansor_sayisi', 'asansör sayısı', 'asansor',
                'park_yeri', 'otopark', 'arac_sayisi', 'araç sayısı',
                'kat_sayisi', 'bulundugu_kat', 'bulunduğu kat', 'bulundugu kat',
            ];

            return minOnlyKeys.some(item => key.includes(this.normalizeText(item)) || name.includes(this.normalizeText(item)));
        },

        stepResidentialMinOnlyNumeric(field, direction = 1) {
            this.stepResidentialRangeNumeric(field, 'min', direction);
        },

        stepResidentialRangeNumeric(field, side = 'min', direction = 1) {
            if (!field) return;
            const currentRaw = this.getNumericRangeVal(field, side);
            const current = parseInt(String(currentRaw || '0').replace(/\D/g, ''), 10);
            const next = Math.max(0, (Number.isFinite(current) ? current : 0) + (direction > 0 ? 1 : -1));
            this.setNumericRangeVal(field, side, next > 0 ? String(next) : '');
            this.syncResidentialRoomPresetFromCounts(side);
        },

        residentialRoomPresetValue(side) {
            const field = this.residentialRoomCountField;

            if (field) {
                const current = this.form.fields[String(field.id)];
                if (current && typeof current === 'object' && !Array.isArray(current) && current[side]) {
                    return current[side] || '';
                }
            }

            return this.roomPresetValueFromCounts(this.residentialRoomOptions, this.residentialBedroomField, this.residentialSalonField, side);
        },

        residentialRoomPresetLabel(side) {
            const value = this.residentialRoomPresetValue(side);
            if (!value) return '';

            const option = this.residentialRoomOptions.find(item => String(item.id) === String(value));
            return option?.name || String(value);
        },

        setResidentialRoomPreset(side, value, label = '', options = {}) {
            const option = this.residentialRoomOptions.find(item => String(item.id) === String(value));
            const optionLabel = label || option?.name || String(value || '');
            const field = this.residentialRoomCountField;

            if (field) {
                const fieldId = String(field.id);
                let current = this.form.fields[fieldId];

                if (!current || typeof current !== 'object' || Array.isArray(current)) {
                    current = { min: '', max: '' };
                }

                current[side] = value && !option?.synthetic ? String(value) : '';
                this.form.fields[fieldId] = { ...current };

                if (current.min || current.max) {
                    this.fieldFilterModes[fieldId] = 'range';
                }
            }

            if (value && optionLabel) {
                this.applyRoomPresetToFields(side, optionLabel, this.residentialBedroomField, this.residentialSalonField);
            } else {
                this.clearRoomPresetFields(side, this.residentialBedroomField, this.residentialSalonField);
            }

            if (!options.skipEnforce) {
                this.enforceResidentialRoomPresetRange();
            }

            this.openDropdown = null;
        },

        syncResidentialRoomPresetFromCounts(side) {
            const field = this.residentialRoomCountField;
            if (!this.residentialBedroomField || !this.residentialSalonField) return;

            const value = this.roomPresetValueFromCounts(this.residentialRoomOptions, this.residentialBedroomField, this.residentialSalonField, side);

            if (!field) return;

            const fieldId = String(field.id);
            let current = this.form.fields[fieldId];
            if (!current || typeof current !== 'object' || Array.isArray(current)) {
                current = { min: '', max: '' };
            }

            const option = this.residentialRoomOptions.find(item => String(item.id) === String(value));
            current[side] = value && !option?.synthetic ? String(value) : '';
            this.form.fields[fieldId] = { ...current };

            if (current.min || current.max) {
                this.fieldFilterModes[fieldId] = 'range';
            }

            this.enforceResidentialRoomPresetRange();
        },

        isLandCompactCounter(item) {
            if (this.currentLandTypeKey !== 'agricultural' || item?.type !== 'field') return false;
            const key = this.fieldSchemaKey(item.field);
            return ['depo_alani_adet', 'depo_adet', 'depo_sayisi', 'ev_konteyner_sayisi', 'ev_konteyner_adet'].includes(key);
        },

        landLayoutConfigs() {
            const commonHidden = [
                // Bu alanlar Arsa/Arazi filtrelerinde hiçbir alt türde gösterilmez.
                'tasinmaz_durumu', 'taşınmaz durumu',
                'min_teklif_fiyati', 'minimum_teklif_fiyati', 'minimum teklif fiyati', 'minimum teklif fiyatı',
                'bahce_alani_m2', 'bahçe alanı m²', 'bahçe alanı m2',
                'ada', 'ada_no', 'ada parsel', 'ada_parsel', 'ada/parsel',
                'parsel', 'parsel_no', 'parsel no',
                'pafta', 'pafta_no', 'pafta no',
                'gabari', 'kaks', 'taks',
                'bahce_m2', 'bahçe m2', 'bahce metrekare', 'bahçe metrekare', 'bahce_metre', 'bahçe metre'
            ];
            const zoningHidden = commonHidden;
            const residentialVillaZonedHidden = [
                ...commonHidden,
                'insaat_alani_m2', 'inşaat alanı',
                // Konut/Villa imarlı arsalarda detaylı filtreyi ilan girişindeki ham
                // fiyat/koşul alanlarıyla kalabalıklaştırma. Fiyat Teklifi Yapılabilir ve
                // Kat Karşılığı Satılıktır seçimleri yukarıdaki Fırsatlar alanında korunur.
                'fiyati_gizle', 'fiyatı gizle',
                'min_teklif_fiyati', 'minimum_teklif_fiyati', 'minimum teklif fiyati', 'minimum teklif fiyatı',
                'emlak_komisyonu_tutari', 'emlak komisyonu tutarı', 'emlak komisyonu tutari',
                'kapora_tutari', 'kapora tutarı', 'kapora tutari', 'kapora_depozito_tutari', 'kapora depozito tutarı',
                'kat_karsiligi_oran', 'kat karşılığı oranı', 'kat karsiligi orani',
            ];
            const standardZoningOrder = [
                { label: 'Arsa/Arazi m²', keys: ['arsa_m2', 'arazi_m2', 'arsa_arazi_m2', 'arsa arazi m2', 'arsa/arazi m2', 'arsa arazi m²', 'arsa/arazi m²', 'arsa arazi m'] },
                { label: 'Azami Kat Sayısı', keys: ['azami_kat_sayisi', 'maksimum_kat_sayisi', 'max_kat', 'azami kat sayisi'] },
                { label: 'İmar Durumu', keys: ['imar_durumu', 'imar durumu'], asCheckbox: true },
                { label: 'Eğim Durumu', keys: ['egim_durumu', 'egim', 'eğim durumu'], asCheckbox: true },
                { label: 'Yol Erişimi', keys: ['yol_erisimi', 'yol erişimi', 'yol erisimi', 'yol_durumu', 'yol durumu', 'yol_bilgisi', 'yol bilgisi', 'yol_tipi', 'yol tipi', 'ulasim', 'ulaşım', 'ulasim_durumu', 'ulaşım durumu', 'arac_yolu', 'araç yolu', 'imar_yolu', 'imar yolu', 'kadastro_yolu', 'kadastro yolu', 'kadastral_yol', 'kadastral yol', 'asfalt_yol', 'asfalt yol', 'stabilize_yol', 'stabilize yol'], asCheckbox: true },
                { label: 'Hafriyat Durumu', keys: ['hafriyat_durumu', 'hafriyat'], asCheckbox: true },
                { label: 'Diğer Özellikler', keys: ['diger_ozellikler', 'diger ozellikler', 'diğer özellikler'], preferFeature: true },
                { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true },
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'] },
                { label: 'Tapu Durumu', keys: ['tapu_durumu', 'tapu durumu'] },
            ];

            const industrialOrder = [
                { label: 'Arsa/Arazi m²', keys: ['arsa_m2', 'arazi_m2', 'arsa_arazi_m2', 'arsa arazi m2', 'arsa/arazi m2', 'arsa arazi m²', 'arsa/arazi m²', 'arsa arazi m'] },
                { label: 'İmar Durumu', keys: ['imar_durumu', 'imar durumu'], asCheckbox: true },
                { label: 'Eğim Durumu', keys: ['egim_durumu', 'egim', 'eğim durumu'], asCheckbox: true },
                { label: 'Yol Erişimi', keys: ['yol_erisimi', 'yol erişimi', 'yol erisimi', 'yol_durumu', 'yol durumu', 'yol_bilgisi', 'yol bilgisi', 'yol_tipi', 'yol tipi', 'ulasim', 'ulaşım', 'ulasim_durumu', 'ulaşım durumu', 'arac_yolu', 'araç yolu', 'imar_yolu', 'imar yolu', 'kadastro_yolu', 'kadastro yolu', 'kadastral_yol', 'kadastral yol', 'asfalt_yol', 'asfalt yol', 'stabilize_yol', 'stabilize yol'], asCheckbox: true },
                { label: 'Hafriyat Durumu', keys: ['hafriyat_durumu', 'hafriyat'], asCheckbox: true },
                { label: 'Su Kaynağı', keys: ['su_kaynagi', 'su kaynağı', 'su kaynagi'], asCheckbox: true },
                { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true },
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'] },
                { label: 'Tapu Durumu', keys: ['tapu_durumu', 'tapu durumu'] },
            ];

            return {
                agricultural: {
                    label: 'Tarım Arazisi / Bağ / Bahçe / Hobi Bahçesi',
                    detailsTitle: 'Tarım Arazisi Bilgileri',
                    hidden: commonHidden,
                    order: [
                        { label: 'Arsa/Arazi m²', keys: ['arsa_m2', 'arazi_m2', 'arsa_arazi_m2', 'arsa arazi m2', 'arsa/arazi m2', 'arsa arazi m²', 'arsa/arazi m²', 'arsa arazi m'] },
                        { label: 'Depo Adedi', keys: ['depo_alani_adet', 'depo_alani_sayisi', 'depo_adet', 'depo_sayisi', 'depo adedi', 'depo en az', 'depo'] },
                        { label: 'Ev Konteyner Adeti', keys: ['ev_konteyner_adet', 'konteyner_adet', 'ev konteyner', 'konteyner'] },
                        { label: 'Eğim Durumu', keys: ['egim_durumu', 'egim', 'eğim durumu'], asCheckbox: true },
                        { label: 'Yol Erişimi', keys: ['yol_erisimi', 'yol erişimi', 'yol erisimi', 'yol_durumu', 'yol durumu', 'yol_bilgisi', 'yol bilgisi', 'yol_tipi', 'yol tipi', 'ulasim', 'ulaşım', 'ulasim_durumu', 'ulaşım durumu', 'arac_yolu', 'araç yolu', 'imar_yolu', 'imar yolu', 'kadastro_yolu', 'kadastro yolu', 'kadastral_yol', 'kadastral yol', 'asfalt_yol', 'asfalt yol', 'stabilize_yol', 'stabilize yol'], asCheckbox: true },
                        { label: 'Hafriyat Durumu', keys: ['hafriyat_durumu', 'hafriyat'], asCheckbox: true },
                        { label: 'Su Kaynağı', keys: ['su_kaynagi', 'su kaynağı', 'su kaynagi'], asCheckbox: true },
                        { label: 'Hasat Durumu', keys: ['hasat_durumu', 'hasat'], asCheckbox: true },
                        { label: 'Sulama Sistemi', keys: ['sulama_sistemi', 'sulama'], asCheckbox: true },
                        { label: 'Diğer Özellikler', keys: ['diger_ozellikler', 'diger ozellikler', 'diğer özellikler'], preferFeature: true },
                        { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true },
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'] },
                        { label: 'Tapu Durumu', keys: ['tapu_durumu', 'tapu durumu'] },
                        { label: 'Diğer Bilgiler - Ağaç Türleri', keys: ['agac_turleri', 'agac_turu', 'ağaç türleri', 'agac', 'ağaç', 'diger_bilgiler_agac', 'diger bilgiler agac', 'diger_bilgiler', 'diğer bilgiler'] },
                    ],
                },
                rural_village: {
                    label: 'Kırsal Köy Arsası',
                    detailsTitle: 'Kırsal Köy Arsası Bilgileri',
                    hidden: zoningHidden,
                    order: [
                        { label: 'Arsa/Arazi m²', keys: ['arsa_m2', 'arazi_m2', 'arsa_arazi_m2', 'arsa arazi m2', 'arsa/arazi m2', 'arsa arazi m²', 'arsa/arazi m²', 'arsa arazi m'] },
                        { label: 'İmar Durumu', keys: ['imar_durumu', 'imar durumu'], asCheckbox: true },
                        { label: 'Eğim Durumu', keys: ['egim_durumu', 'egim', 'eğim durumu'], asCheckbox: true },
                        { label: 'Yol Erişimi', keys: ['yol_erisimi', 'yol erişimi', 'yol erisimi', 'yol_durumu', 'yol durumu', 'yol_bilgisi', 'yol bilgisi', 'yol_tipi', 'yol tipi', 'ulasim', 'ulaşım', 'ulasim_durumu', 'ulaşım durumu', 'arac_yolu', 'araç yolu', 'imar_yolu', 'imar yolu', 'kadastro_yolu', 'kadastro yolu', 'kadastral_yol', 'kadastral yol', 'asfalt_yol', 'asfalt yol', 'stabilize_yol', 'stabilize yol'], asCheckbox: true },
                        { label: 'Hafriyat Durumu', keys: ['hafriyat_durumu', 'hafriyat'], asCheckbox: true },
                        { label: 'Su Kaynağı', keys: ['su_kaynagi', 'su kaynağı', 'su kaynagi'], asCheckbox: true },
                        { label: 'Diğer Özellikler', keys: ['diger_ozellikler', 'diger ozellikler', 'diğer özellikler'], preferFeature: true },
                        { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true },
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'] },
                        { label: 'Tapu Durumu', keys: ['tapu_durumu', 'tapu durumu'] },
                        { label: 'Mevcut Yapılar', keys: ['mevcut_yapilar', 'mevcut yapılar', 'mevcut yapilar'] },
                    ],
                },
                residential_zoned: {
                    label: 'Konut İmarlı Arsa',
                    detailsTitle: 'Konut İmarlı Arsa Bilgileri',
                    hidden: residentialVillaZonedHidden,
                    order: standardZoningOrder,
                },
                villa_zoned: {
                    label: 'Villa İmarlı Arsa',
                    detailsTitle: 'Villa İmarlı Arsa Bilgileri',
                    hidden: residentialVillaZonedHidden,
                    order: standardZoningOrder,
                },
                energy_storage: {
                    label: 'Enerji Depolama Arazisi',
                    detailsTitle: 'Enerji Depolama Arazisi Bilgileri',
                    hidden: [...zoningHidden, 'insaat_alani_m2', 'inşaat alanı'],
                    order: industrialOrder,
                },
                industrial: {
                    label: 'Sanayi Arsası',
                    detailsTitle: 'Sanayi Arsası Bilgileri',
                    hidden: zoningHidden,
                    order: industrialOrder,
                },
                generic_land: {
                    label: 'Arsa / Arazi',
                    detailsTitle: 'Arsa Bilgileri',
                    hidden: commonHidden,
                    order: [
                        { label: 'Arsa/Arazi m²', keys: ['arsa_m2', 'arazi_m2', 'arsa_arazi_m2', 'arsa arazi m2', 'arsa/arazi m2', 'arsa arazi m²', 'arsa/arazi m²', 'arsa arazi m'] },
                        { label: 'İmar Durumu', keys: ['imar_durumu', 'imar durumu'] },
                        { label: 'Eğim Durumu', keys: ['egim_durumu', 'egim', 'eğim durumu'] },
                        { label: 'Yol Erişimi', keys: ['yol_erisimi', 'yol erişimi', 'yol erisimi', 'yol_durumu', 'yol durumu', 'yol_bilgisi', 'yol bilgisi', 'yol_tipi', 'yol tipi', 'ulasim', 'ulaşım', 'ulasim_durumu', 'ulaşım durumu', 'arac_yolu', 'araç yolu', 'imar_yolu', 'imar yolu', 'kadastro_yolu', 'kadastro yolu', 'kadastral_yol', 'kadastral yol', 'asfalt_yol', 'asfalt yol', 'stabilize_yol', 'stabilize yol'] },
                        { label: 'Hafriyat Durumu', keys: ['hafriyat_durumu', 'hafriyat'] },
                        { label: 'Su Kaynağı', keys: ['su_kaynagi', 'su kaynağı', 'su kaynagi'] },
                        { label: 'Manzara', keys: ['manzara', 'manzara_tipi'], preferFeature: true },
                        { label: 'Cephe', keys: ['cephe', 'cephe_durumu'] },
                        { label: 'Tapu Durumu', keys: ['tapu_durumu', 'tapu durumu'] },
                        { label: 'Diğer Özellikler', keys: ['diger_ozellikler', 'diger ozellikler', 'diğer özellikler'], preferFeature: true },
                    ],
                },
            };
        },

        landLayoutConfig() {
            const configs = this.landLayoutConfigs();
            return configs[this.currentLandTypeKey] || configs.generic_land;
        },

        landPriceToggleDefinitions(type) {
            const groups = {
                status: [
                    { key: 'income_tenant', label: 'Gelir Getiren Kiracılı', keys: ['gelir_getiren_kiracili', 'gelir getiren kiracili', 'gelir getiren kiracılı', 'kiracili'] },
                    { key: 'owner_uses', label: 'Mülk Sahibi Kullanıyor', keys: ['mulk_sahibi_kullaniyor', 'mulk sahibi kullaniyor', 'mülk sahibi kullanıyor', 'sahibi kullaniyor'] },
                ],
                opportunity: [
                    { key: 'credit_suitable', label: 'Krediye Uygun', keys: ['krediye_uygun', 'krediye uygun', 'kredi'] },
                    { key: 'barter_suitable', label: 'Takasa Uygun', keys: ['takasa_uygun', 'takas_var_mi', 'takasa uygun', 'takas'] },
                    { key: 'offer_available', label: 'Fiyat Teklifi Yapılabilir', keys: ['fiyat_teklifi_yapilabilir', 'fiyat_teklifi_var', 'fiyat teklifi', 'teklif yapilabilir', 'teklif'] },
                ],
                zoned_ready_opportunity: [
                    { key: 'villa_project_ready', label: 'Projesi Hazır', keys: ['projesi_hazir', 'projesi hazır', 'projesi hazir'] },
                    { key: 'villa_license_ready', label: 'Ruhsatı Hazır', keys: ['ruhsati_hazir', 'ruhsatı hazır', 'ruhsati hazir'] },
                ],
                land_sale_opportunity: [
                    { key: 'floor_share_sale', label: 'Kat Karşılığı Satılıktır', keys: ['kat_karsiligi_satiliktir', 'kat karsiligi', 'kat karşılığı'] },
                    { key: 'citizenship_suitable', label: 'Türk Vatandaşlığına Uygun', keys: ['turk_vatandasligi_ile_ikamete_uygun', 'turk_vatandasligina_uygun', 'turk vatandasligi', 'türk vatandaşlığı', 'vatandaslik', 'vatandaşlık'] },
                    { key: 'residence_permit_suitable', label: 'İkamete Uygun', keys: ['ikamete_uygun', 'ikamet_izni', 'oturum_izni', 'ikamete uygun', 'ikamet izni', 'oturum izni', 'ikamet'] },
                ],
            };

            return (groups[type] || []).map(item => ({ ...item }));
        },

        landDescriptor(value) {
            return this.filterStructuralDescriptor(value, true);
        },

        landMatches(value, keys = []) {
            const haystack = this.normalizeText(this.landDescriptor(value));
            return keys.some(key => {
                const needle = this.normalizeText(key);
                return needle && haystack.includes(needle);
            });
        },

        landFieldMatches(field, keys = []) {
            return this.landMatches(field, keys);
        },

        landFieldOwnMatches(field, keys = []) {
            return this.landMatches({
                schema_key: field?.schema_key,
                key: field?.key,
                name: field?.name,
                canonical_name: field?.canonical_name,
                placeholder: field?.placeholder,
                canonical_placeholder: field?.canonical_placeholder,
                unit: field?.unit,
                meta: field?.meta,
            }, keys);
        },

        landFeatureGroupMatches(group, keys = []) {
            return this.landMatches({
                schema_key: group?.schema_key,
                key: group?.key,
                name: group?.name,
                canonical_name: group?.canonical_name,
                label: group?.label,
                meta: group?.meta,
            }, keys);
        },

        landFeatureItemMatches(group, item, keys = []) {
            return this.filterStructuralMatches([group, item], keys);
        },

        isRemovedLandCategory(category) {
            const text = this.normalizeText([category?.schema_key, category?.meta?.schema_key, category?.canonical_name, category?.name, category?.slug, category?.path_label].filter(Boolean).join(' '));
            return text.includes('ciftlik_arazisi') || (text.includes('ciftlik') && text.includes('arazi'));
        },

        isLandHiddenField(field) {
            if (!this.isLandFilterMode) return false;

            // Arsa/Arazi tarafında Yapım/Yenileme yılı, Taşınmaz Durumu kartının içinde
            // inline gösterilir. Aynı field'ların kalan alanlarda ikinci kez çıkmasını engelle.
            if (
                this.dynamicPropertyStatusField()
                && (this.isDynamicConstructionYearField(field) || this.isDynamicRenovationYearField(field))
            ) {
                return true;
            }

            const hiddenKeys = this.landLayoutConfig().hidden || [];
            // Gizlenecek alan kararında option/feature item isimlerine bakmıyoruz.
            // Örn. bir alanın seçeneklerinde "Bahçe" geçmesi, alanın bahçe m² gibi gizlenmesine sebep olmamalı.
            return this.isGloballyHiddenDynamicField(field) || this.landFieldOwnMatches(field, hiddenKeys);
        },

        isLandHiddenFeatureGroup(group) {
            if (!this.isLandFilterMode || !group) return false;

            const hiddenKeys = this.landLayoutConfig().hidden || [];
            if (!hiddenKeys.length) return false;

            const groupOnlyText = this.normalizeText([group?.canonical_name, group?.name, group?.label, group?.schema_key, group?.key].filter(Boolean).join(' '));
            return hiddenKeys.some(key => {
                const normalizedKey = this.normalizeText(key);
                return normalizedKey && groupOnlyText.includes(normalizedKey);
            });
        },

        landFeatureGroupOrItemMatches(group, keys = []) {
            if (!group) return false;

            if (this.landFeatureGroupMatches(group, keys)) {
                return true;
            }

            return (group.items || []).some(item => this.landFeatureItemMatches(group, item, keys));
        },

        isLandMinOnlyNumericField(field) {
            if (!this.isLandFilterMode) return false;

            const key = this.fieldSchemaKey(field);
            const name = this.normalizeText([field?.canonical_name, field?.name].filter(Boolean).join(' '));
            const minOnlyKeys = [
                'depo_alani_adet',
                'depo_alani_sayisi',
                'depo_adedi',
                'depo_adet',
                'depo_sayisi',
                'konteyner_adet',
                'ev_konteyner_adet',
                'ev_konteyner_sayisi',
                'azami_kat_sayisi',
                'maksimum_kat_sayisi',
                'max_kat_sayisi',
            ];

            return minOnlyKeys.some(item => key.includes(item) || name.includes(item));
        },

        stepLandMinOnlyNumeric(field, direction = 1) {
            const currentRaw = this.getNumericRangeVal(field, 'min');
            const current = parseInt(String(currentRaw || '0').replace(/\D/g, ''), 10);
            const next = Math.max(0, (Number.isFinite(current) ? current : 0) + (direction > 0 ? 1 : -1));
            this.setNumericRangeVal(field, 'min', next > 0 ? String(next) : '');
        },

        landToggleFieldValue(field) {
            if (this.isBooleanField(field)) {
                return this.booleanFieldValues(field).yesVal;
            }

            const options = Array.isArray(field?.options) ? field.options : [];
            if (options.length > 0) {
                const positives = ['evet', 'var', 'uygun', 'dahil', 'yes', 'true', 'mevcut', 'yapilabilir', 'satiliktir'];
                const positive = options.find(option => {
                    const name = this.normalizeText([option.canonical_name, option.schema_value, option.name, option.value].filter(Boolean).join(' '));
                    return positives.some(word => name.includes(this.normalizeText(word)));
                });

                return String((positive || options[0]).id);
            }

            return '1';
        },

        findLandToggleItems(definitions = []) {
            const items = [];
            const used = new Set();

            definitions.forEach(definition => {
                let found = null;

                const directField = this.dynamicFields.find(field =>
                    !this.isLandHiddenField(field) && this.landFieldOwnMatches(field, definition.keys)
                );

                if (directField) {
                    found = {
                        type: 'field_toggle',
                        key: `${definition.key}-field-${directField.id}`,
                        definitionKey: definition.key,
                        label: definition.label,
                        field: directField,
                    };
                }

                if (!found) {
                    for (const field of this.dynamicFields) {
                        if (this.isLandHiddenField(field) || !Array.isArray(field.options)) continue;

                        const option = field.options.find(opt => this.landMatches(opt, definition.keys));
                        if (option) {
                            found = {
                                type: 'field_option',
                                key: `${definition.key}-field-${field.id}-option-${option.id}`,
                                definitionKey: definition.key,
                                label: definition.label,
                                field,
                                option,
                            };
                            break;
                        }
                    }
                }

                if (!found) {
                    for (const group of this.dynamicFeatures) {
                        const option = (group.items || []).find(item => this.landFeatureItemMatches(group, item, definition.keys));
                        if (option) {
                            found = {
                                type: 'feature',
                                key: `${definition.key}-feature-${option.id}`,
                                definitionKey: definition.key,
                                label: definition.label,
                                group,
                                item: option,
                            };
                            break;
                        }
                    }
                }

                if (found && !used.has(found.key)) {
                    used.add(found.key);
                    items.push(found);
                }
            });

            return items;
        },

        landPriceToggleFieldIds() {
            return this.landPriceStatusItems
                .concat(this.landPriceOpportunityItems)
                .filter(item => item.field)
                .map(item => Number(item.field.id));
        },

        landPriceToggleFeatureGroupIds() {
            return this.landPriceStatusItems
                .concat(this.landPriceOpportunityItems)
                .filter(item => item.group)
                .map(item => Number(item.group.id));
        },

        isLandToggleSelected(item) {
            if (!item) return false;

            if (item.type === 'feature') {
                return this.form.feature_value_ids.includes(Number(item.item.id));
            }

            if (item.type === 'field_option') {
                const value = this.form.fields[String(item.field.id)];
                if (Array.isArray(value)) {
                    return value.map(String).includes(String(item.option.id));
                }
                return String(value || '') === String(item.option.id);
            }

            if (item.type === 'field_toggle') {
                const value = this.form.fields[String(item.field.id)];
                return String(value || '') === String(this.landToggleFieldValue(item.field));
            }

            return false;
        },

        toggleLandToggleItem(item) {
            if (!item) return;

            if (item.type === 'feature') {
                const id = Number(item.item.id);
                this.form.feature_value_ids = this.form.feature_value_ids.includes(id)
                    ? this.form.feature_value_ids.filter(value => Number(value) !== id)
                    : this.form.feature_value_ids.concat(id);
                return;
            }

            if (item.type === 'field_option') {
                if (this.isMultiField(item.field)) {
                    this.toggleFieldArrayValue(item.field, item.option.id);
                    return;
                }

                const fieldId = String(item.field.id);
                this.form.fields[fieldId] = this.isLandToggleSelected(item) ? '' : String(item.option.id);
                return;
            }

            if (item.type === 'field_toggle') {
                const fieldId = String(item.field.id);
                this.form.fields[fieldId] = this.isLandToggleSelected(item) ? '' : this.landToggleFieldValue(item.field);
            }
        },

        buildLandOrderedItems() {
            if (!this.isLandFilterMode) return [];

            const config = this.landLayoutConfig();
            const usedFieldIds = new Set(this.landPriceToggleFieldIds());
            const usedFeatureGroupIds = new Set(this.landPriceToggleFeatureGroupIds());
            const items = [];

            (config.order || []).forEach(rule => {
                let matchedField = null;
                let matchedGroup = null;

                if (!rule.preferFeature) {
                    matchedField = this.dynamicFields.find(field =>
                        !usedFieldIds.has(Number(field.id))
                        && !this.isLandHiddenField(field)
                        && this.landFieldOwnMatches(field, rule.keys)
                    );
                }

                if (!matchedField) {
                    matchedGroup = this.dynamicFeatures.find(group =>
                        !usedFeatureGroupIds.has(Number(group.id))
                        && !this.isLandHiddenFeatureGroup(group)
                        && this.landFeatureGroupOrItemMatches(group, rule.keys)
                    );
                }

                if (!matchedField && !matchedGroup && rule.preferFeature) {
                    matchedField = this.dynamicFields.find(field =>
                        !usedFieldIds.has(Number(field.id))
                        && !this.isLandHiddenField(field)
                        && this.landFieldOwnMatches(field, rule.keys)
                    );
                }

                if (matchedField) {
                    usedFieldIds.add(Number(matchedField.id));
                    items.push({
                        type: 'field',
                        key: `field-${matchedField.id}`,
                        label: rule.label || matchedField.name,
                        field: matchedField,
                        renderAsCheckboxes: rule.asCheckbox === true,
                    });
                    return;
                }

                if (matchedGroup) {
                    usedFeatureGroupIds.add(Number(matchedGroup.id));
                    items.push({
                        type: 'feature_group',
                        key: `feature-${matchedGroup.id}`,
                        label: rule.label || matchedGroup.name,
                        group: matchedGroup,
                    });
                }
            });

            return items;
        },

        buildLandRemainingItems() {
            if (!this.isLandFilterMode) return [];

            const usedFieldIds = new Set([
                ...this.landPriceToggleFieldIds(),
                ...this.landOrderedItems.filter(item => item.type === 'field').map(item => Number(item.field.id)),
            ]);
            const usedFeatureGroupIds = new Set([
                ...this.landPriceToggleFeatureGroupIds(),
                ...this.landOrderedItems.filter(item => item.type === 'feature_group').map(item => Number(item.group.id)),
            ]);

            const fields = this.dynamicFields
                .filter(field => !usedFieldIds.has(Number(field.id)) && !this.isLandHiddenField(field))
                .map(field => ({
                    type: 'field',
                    key: `field-${field.id}`,
                    label: field.name,
                    field,
                }));

            const groups = this.dynamicFeatures
                .filter(group => !usedFeatureGroupIds.has(Number(group.id)) && !this.isLandHiddenFeatureGroup(group))
                .map(group => ({
                    type: 'feature_group',
                    key: `feature-${group.id}`,
                    label: group.name,
                    group,
                }));

            return fields.concat(groups);
        },

        fieldSchemaKey(field) {
            return this.normalizeText(field?.schema_key || field?.key || field?.meta?.schema_key || field?.canonical_name || field?.name || '');
        },

        findFieldByKeys(keys = []) {
            const normalizedKeys = keys.map(key => this.normalizeText(key));
            return this.dynamicFields.find(field => normalizedKeys.includes(this.fieldSchemaKey(field)))
                || this.dynamicFields.find(field => {
                    const name = this.normalizeText([field.canonical_name, field.name].filter(Boolean).join(' '));
                    return normalizedKeys.some(key => key && name.includes(key));
                })
                || null;
        },

        dynamicFieldHaystack(field) {
            const meta = field?.meta || {};

            return this.normalizeText([
                field?.schema_key,
                field?.key,
                field?.name,
                field?.label,
                field?.placeholder,
                meta.schema_key,
                meta.key,
                meta.name,
                meta.label,
                meta.placeholder,
                meta.input,
                meta.section,
            ].filter(Boolean).join(' '));
        },

        isGloballyHiddenDynamicField(field) {
            if (!field) return false;

            // Proje Yapım Durumu, konuttaki Taşınmaz Durumu fallback'i değildir.
            if (this.isProjectFilterMode && this.fieldSchemaKey(field) === 'yapim_durumu') {
                return false;
            }

            if (this.isPdfRevisionPaymentField(field)) {
                return true;
            }

            // Taşınmaz Durumu ana seçim alanı korunur; yalnızca onunla çakışan ikincil inşaat/yapım süreci alanları gizlenir.
            if (this.isDynamicPropertyStatusField(field)) {
                return false;
            }

            const text = this.dynamicFieldHaystack(field);

            // Proje kategorilerinde `Taşınmaz Durumu` ile `Yapım Durumu` iki ayrı filtredir.
            // Exact Taşınmaz Durumu mevcutsa proje dokümanındaki Yapım Durumu alanını gizleme.
            if (
                this.isProjectFilterMode
                && this.dynamicFields.some(candidate => this.isExactDynamicPropertyStatusField(candidate))
                && ['yapim_durumu', 'yapim_asamasinda', 'construction_status'].some(key => text.includes(this.normalizeText(key)))
            ) {
                return false;
            }
            const hiddenKeys = [
                'fiyat_gizle',
                'fiyat_gizlensin',
                'fiyat_gizleme',
                'hide_price',
                'price_hidden',
                'price_hide',
                'emlak_komisyonu_tutari',
                'emlak_komisyon_tutari',
                'komisyon_tutari',
                'brokerage_fee',
                'real_estate_commission',
                'kaparo_depozito_tutari',
                'kaparo_tutari',
                'depozito_tutari',
                'deposit_amount',
                'security_deposit',
                'down_payment',
                'aylik_aidat_gideri',
                'aylik_aidat',
                'aidat_gideri',
                'site_aidati',
                'monthly_dues',
                'monthly_fee',
                'maintenance_fee',
                'yapim_durumu',
                'yapim_sureci',
                'yapim_asamasinda',
                'insaat_sureci',
                'insaat_surecinde',
                'construction_status',
                'construction_progress',
                'construction_process',
            ];

            return hiddenKeys.some(key => text.includes(this.normalizeText(key)))
                || (text.includes('fiyat') && text.includes('gizle'))
                || (text.includes('emlak') && text.includes('komisyon') && text.includes('tutar'))
                || (text.includes('kaparo') && text.includes('depozito') && text.includes('tutar'))
                || (text.includes('depozito') && text.includes('tutar'))
                || (text.includes('aylik') && text.includes('aidat') && (text.includes('gider') || text.includes('tutar')))
                || (text.includes('yapim') && (text.includes('durum') || text.includes('surec') || text.includes('asama')))
                || (text.includes('insaat') && text.includes('surec'));
        },

        dynamicFieldOptionHaystack(field) {
            if (!field || !Array.isArray(field.options)) return '';

            return this.normalizeText(field.options.map(option => [
                option?.name,
                option?.label,
                option?.value,
                option?.slug,
                option?.key,
            ].filter(Boolean).join(' ')).join(' '));
        },

        dynamicPropertyStatusOptionLooksLikeStatus(field) {
            const optionText = this.dynamicFieldOptionHaystack(field);
            if (!optionText) return false;

            const requiredOptionTokens = [
                'yeni',
                'iyi_durumda',
                'yenilenmis',
                'tadilat_gerekli',
                'insaat_surecinde',
                'yapim_asamasinda',
            ];

            const matchedCount = requiredOptionTokens.filter(token => optionText.includes(this.normalizeText(token))).length;

            return matchedCount >= 2 || (
                (optionText.includes('yenilenmis') || optionText.includes('renove'))
                && (optionText.includes('yeni') || optionText.includes('iyi_durumda') || optionText.includes('tadilat_gerekli') || optionText.includes('insaat'))
            );
        },

        isExactDynamicPropertyStatusField(field) {
            if (!field || !Array.isArray(field.options) || field.options.length === 0) return false;

            const key = this.fieldSchemaKey(field);
            const text = this.dynamicFieldHaystack(field);
            const exactKeys = [
                'tasinmaz_durumu', 'taşınmaz durumu', 'property_status', 'property condition',
            ];

            return exactKeys.some(item => {
                const normalized = this.normalizeText(item);
                return key === normalized || text.includes(normalized);
            });
        },

        isDynamicPropertyStatusField(field) {
            if (!field || !Array.isArray(field.options) || field.options.length === 0) return false;

            if (this.isProjectFilterMode && this.fieldSchemaKey(field) === 'yapim_durumu') {
                return false;
            }

            if (this.isExactDynamicPropertyStatusField(field)) {
                return true;
            }

            // Arsa/Arazi ve Proje metadata'sına gerçek `tasinmaz_durumu` eklendiğinde
            // `yapim_durumu` gibi ayrı proje alanlarını ikinci bir Taşınmaz Durumu gibi
            // yorumlamıyoruz. Exact alan yoksa eski kategoriler için legacy fallback korunur.
            const exactFieldExists = Array.isArray(this.dynamicFields)
                && this.dynamicFields.some(candidate => this.isExactDynamicPropertyStatusField(candidate));

            if (exactFieldExists) {
                return false;
            }

            const key = this.fieldSchemaKey(field);
            const text = this.dynamicFieldHaystack(field);
            const explicitStatusKeys = [
                'yapi_durumu', 'yapı durumu', 'bina_durumu', 'konut_durumu', 'isyeri_durumu', 'is_yeri_durumu',
                'yapim_durumu', 'yapım durumu', 'yapim_sureci', 'yapim_asamasi', 'yapım aşaması',
                'insaat_sureci', 'inşaat süreci', 'construction_status', 'construction_progress', 'construction_process', 'building_status'
            ];

            const explicitMatch = explicitStatusKeys.some(item => {
                const normalized = this.normalizeText(item);
                return key.includes(normalized) || text.includes(normalized);
            });

            if (explicitMatch) return true;

            // Bazı eski kategorilerde field adı genel gelebiliyor. İlan ekle tarafındaki
            // seçenek seti varsa exact Taşınmaz Durumu alanı bulunmadığı sürece fallback yap.
            return this.dynamicPropertyStatusOptionLooksLikeStatus(field);
        },

        isDynamicConstructionAgeField(field) {
            if (!field) return false;
            const text = this.dynamicFieldHaystack(field);
            const ageKeys = [
                'bina_yasi',
                'bina_yas',
                'bina yaşı',
                'bina yasi',
                'building_age',
                'building age',
            ];

            return ageKeys.some(key => text.includes(this.normalizeText(key)));
        },

        isDynamicConstructionYearField(field) {
            if (!field) return false;
            const text = this.dynamicFieldHaystack(field);
            const keys = [
                'yapim_yili',
                'yapim_yil',
                'yapim_tarihi',
                'bina_yapim_yili',
                'yapi_yili',
                'yapi_yapim_yili',
                'insaat_yili',
                'insaat_tarihi',
                'construction_year',
                'building_year',
                'built_year',
                'year_built',
            ];

            return this.isDynamicConstructionAgeField(field)
                || keys.some(key => text.includes(this.normalizeText(key)))
                || ((text.includes('yapim') || text.includes('insaat') || text.includes('construction') || text.includes('built')) && (text.includes('yil') || text.includes('year') || text.includes('tarih')));
        },

        isDynamicRenovationYearField(field) {
            if (!field) return false;
            const text = this.dynamicFieldHaystack(field);
            const keys = [
                'renovasyon_yili',
                'renovasyon_yil',
                'renovasyon_tarihi',
                'yenileme_yili',
                'yenileme_yil',
                'yenileme_tarihi',
                'yenilenme_yili',
                'yenilenme_yil',
                'yenilenme_tarihi',
                'tadilat_yili',
                'tadilat_yil',
                'tadilat_tarihi',
                'renovation_year',
                'renovated_year',
                'renovation_date',
            ];

            return keys.some(key => text.includes(this.normalizeText(key)))
                || ((text.includes('renovasyon') || text.includes('yenileme') || text.includes('yenilenme') || text.includes('tadilat') || text.includes('renovation') || text.includes('renovated')) && (text.includes('yil') || text.includes('year') || text.includes('tarih') || text.includes('date')));
        },

        dynamicPropertyStatusField() {
            return this.dynamicFields.find(field => this.isExactDynamicPropertyStatusField(field))
                || this.dynamicFields.find(field => this.isDynamicPropertyStatusField(field))
                || null;
        },

        dynamicConstructionYearField() {
            const candidates = this.dynamicFields.filter(field => this.isDynamicConstructionYearField(field));
            if (!candidates.length) return null;

            const exactKeys = [
                'yapim_yili', 'yapim_yil', 'bina_yapim_yili', 'yapi_yili', 'yapi_yapim_yili',
                'insaat_yili', 'construction_year', 'building_year', 'built_year', 'year_built'
            ].map(key => this.normalizeText(key));

            const exact = candidates.find(field => {
                if (this.isDynamicConstructionAgeField(field)) return false;
                const schema = this.normalizeText(this.fieldSchemaKey(field));
                const canonical = this.normalizeText(field?.canonical_name || field?.name || '');
                return exactKeys.includes(schema) || exactKeys.includes(canonical);
            });

            const nonAge = candidates.find(field => !this.isDynamicConstructionAgeField(field));
            return exact || nonAge || candidates[0] || null;
        },

        dynamicRenovationYearField() {
            return this.dynamicFields.find(field => this.isDynamicRenovationYearField(field)) || null;
        },

        dynamicPropertyStatusValues(field = null) {
            const statusField = field || this.dynamicPropertyStatusField();
            if (!statusField) return [];

            const value = this.form.fields[String(statusField.id)];
            if (Array.isArray(value)) return value.map(String).filter(Boolean);
            return value !== null && value !== undefined && String(value).trim() !== '' ? [String(value)] : [];
        },

        dynamicPropertyStatusLabels(field = null) {
            const statusField = field || this.dynamicPropertyStatusField();
            if (!statusField) return [];

            const values = this.dynamicPropertyStatusValues(statusField);
            return values.map(value => {
                const option = (statusField.options || []).find(item => String(item.id) === String(value));
                return this.normalizeText([option?.canonical_name, option?.name, option?.value, value].filter(Boolean).join(' '));
            }).filter(Boolean);
        },

        dynamicPropertyStatusMode() {
            const labels = this.dynamicPropertyStatusLabels();

            if (!labels.length) return '';

            const hasAny = (needles = []) => labels.some(label => needles.some(needle => label.includes(this.normalizeText(needle))));

            if (hasAny([
                'insaat_surecinde', 'inşaat sürecinde', 'insaat_sureci', 'inşaat süreci',
                'yapim_asamasinda', 'yapım aşamasında', 'yapim_surecinde', 'yapım sürecinde',
                'devam_ediyor', 'devam etmekte', 'devam_eden', 'tamamlanmamis', 'tamamlanmamış',
                'insaat_halinde', 'inşaat halinde', 'yapim_devam_ediyor', 'yapım devam ediyor',
                'construction_progress', 'under_construction', 'under construction'
            ])) {
                return 'construction_progress';
            }

            if (hasAny([
                'yenilenmis', 'yenilenmiş', 'yenilenmis_tasinmaz', 'yenilenmiş taşınmaz',
                'renove', 'renovasyonlu', 'renovasyon_yapilmis', 'renovasyon yapılmış',
                'tadilatli', 'tadilatlı', 'renovated', 'renovated_property'
            ])) {
                return 'renovated';
            }

            // Yeni / iyi durumda / tadilat gerekli gibi diğer tüm seçeneklerde sadece yapım yılı görünür.
            return 'standard';
        },

        shouldShowDynamicConstructionYearField() {
            const statusField = this.dynamicPropertyStatusField();
            if (!statusField) return true;

            // Yeni / İkinci El / İyi Durumda / Tadilat Gerekli => En Az Yapım Yılı.
            // Yenilenmiş => Yapım Yılı KALIR; yanına En Az Yenileme Yılı da gelir.
            // İnşaat Sürecinde => Yapım Yılı tamamen gizli.
            const mode = this.dynamicPropertyStatusMode();
            return mode === 'standard' || mode === 'renovated';
        },

        shouldShowDynamicRenovationYearField() {
            const statusField = this.dynamicPropertyStatusField();
            if (!statusField) return false;

            return this.dynamicPropertyStatusMode() === 'renovated';
        },

        shouldShowPropertyStatusInlineYears(statusField = null) {
            if (!this.isDynamicPropertyStatusField(statusField || this.dynamicPropertyStatusField())) {
                return false;
            }

            const constructionField = this.dynamicConstructionYearField();
            const renovationField = this.dynamicRenovationYearField();

            return !!(
                (constructionField && this.shouldShowDynamicConstructionYearField()) ||
                (renovationField && this.shouldShowDynamicRenovationYearField())
            );
        },

        shouldRenderDynamicField(field) {
            if (this.isGloballyHiddenDynamicField(field)) {
                return false;
            }

            if (this.isDynamicConstructionAgeField(field)) {
                const preferredConstructionField = this.dynamicConstructionYearField();
                if (preferredConstructionField && Number(preferredConstructionField.id) !== Number(field.id)) {
                    return false;
                }
            }

            if (this.isDynamicConstructionYearField(field)) {
                // Taşınmaz Durumu varsa Yapım Yılı aynı accordion içinde gösterilir; ayrı blok olarak tekrarlanmaz.
                return !this.dynamicPropertyStatusField() && this.shouldShowDynamicConstructionYearField();
            }

            if (this.isDynamicRenovationYearField(field)) {
                // Taşınmaz Durumu varsa Yenileme Yılı aynı accordion içinde gösterilir; ayrı blok olarak tekrarlanmaz.
                return !this.dynamicPropertyStatusField() && this.shouldShowDynamicRenovationYearField();
            }

            return true;
        },

        isDynamicPropertyStatusOptionSelected(field, optionId) {
            return this.dynamicPropertyStatusValues(field).includes(String(optionId));
        },

        selectDynamicPropertyStatusOption(field, optionId) {
            if (!field) return;

            const fieldId = String(field.id);
            const alreadySelected = this.isDynamicPropertyStatusOptionSelected(field, optionId);
            this.form.fields[fieldId] = alreadySelected ? '' : String(optionId);

            if (this.form.fields[fieldId]) {
                this.fieldFilterModes[fieldId] = 'option';
            } else {
                delete this.fieldFilterModes[fieldId];
            }

            this.syncDynamicConditionalYearFields();
        },

        dynamicYearOptions() {
            const currentYear = new Date().getFullYear();
            const years = [];

            for (let year = currentYear; year >= 1900; year -= 1) {
                years.push(year);
            }

            return years;
        },

        dynamicYearCurrentYear() {
            return new Date().getFullYear();
        },

        dynamicYearRangeValue(field, side = 'min') {
            if (!field) return '';

            const fieldId = String(field.id);
            const raw = this.form.fields[fieldId];
            const key = side === 'max' ? 'max' : 'min';

            if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
                const direct = raw[key];
                if (direct !== null && direct !== undefined && String(direct).trim() !== '') {
                    return this.normalizeDynamicYearValue(direct, field);
                }

                // Önceki tek-yıl URL/state yapısını aralığa taşırken iki tarafı da
                // aynı yıl kabul et; böylece eski linkler davranış değiştirmez.
                if (raw.value !== null && raw.value !== undefined && String(raw.value).trim() !== '') {
                    return this.normalizeDynamicYearValue(raw.value, field);
                }

                return '';
            }

            // Eski scalar/value state'i de exact range olarak yorumla.
            return this.normalizeDynamicYearValue(raw, field);
        },

        setDynamicYearRangeField(field, side = 'min', year = '') {
            if (!field) return;

            const fieldId = String(field.id);
            const key = side === 'max' ? 'max' : 'min';
            const current = this.form.fields[fieldId];

            let min = '';
            let max = '';

            if (current && typeof current === 'object' && !Array.isArray(current)) {
                min = this.normalizeDynamicYearValue(current.min ?? current.value ?? '', field);
                max = this.normalizeDynamicYearValue(current.max ?? current.value ?? '', field);
            } else if (current !== null && current !== undefined && String(current).trim() !== '') {
                const exact = this.normalizeDynamicYearValue(current, field);
                min = exact;
                max = exact;
            }

            const cleanYear = this.normalizeDynamicYearValue(year, field);

            if (key === 'min') {
                min = cleanYear;
            } else {
                max = cleanYear;
            }

            const isConditionalStatusYear = !!this.dynamicPropertyStatusField() && (
                this.isDynamicConstructionYearField(field)
                || this.isDynamicRenovationYearField(field)
            );
            if (isConditionalStatusYear) {
                max = '';
            }

            // Range her zaman geçerli kalsın. Kullanıcı minimumu maksimumun üstüne
            // taşıdığında maksimumu, maksimumu minimumun altına taşıdığında minimumu
            // aynı değere getiriyoruz.
            const minNum = parseInt(min || '', 10);
            const maxNum = parseInt(max || '', 10);

            if (Number.isFinite(minNum) && Number.isFinite(maxNum) && minNum > maxNum) {
                if (key === 'min') {
                    max = min;
                } else {
                    min = max;
                }
            }

            if (!min && !max) {
                this.form.fields[fieldId] = '';
                delete this.fieldFilterModes[fieldId];
            } else {
                this.form.fields[fieldId] = { min, max };
                this.fieldFilterModes[fieldId] = 'range';
            }

            this.openDropdown = null;
            this.syncDynamicConditionalYearFields();

            // Deep watcher normalde bunu zaten çağırır; yıl filtresi inline/hidden olduğunda da
            // sayaç güncellemesini garanti etmek için burada açıkça tetikliyoruz.
            this.$nextTick(() => this.scheduleLiveCount(120));
        },

        stepDynamicYearRangeField(field, side = 'min', direction = 1) {
            if (!field) return;

            const key = side === 'max' ? 'max' : 'min';
            const currentYear = this.dynamicYearCurrentYear();
            const current = parseInt(String(this.dynamicYearRangeValue(field, key) || '').replace(/\D/g, ''), 10);

            if (!Number.isFinite(current)) {
                // PDF revizyonunda koşullu Yapım/Yenileme yılı güncel yıldan başlar.
                this.setDynamicYearRangeField(field, key, String(currentYear));
                return;
            }

            const next = Math.min(
                currentYear,
                Math.max(1900, current + (direction > 0 ? 1 : -1))
            );

            this.setDynamicYearRangeField(field, key, String(next));
        },

        onDynamicYearRangeInput(field, side = 'min', event) {
            if (!field || !event?.target) return;

            const digits = String(event.target.value || '')
                .replace(/\D/g, '')
                .slice(0, 4);

            event.target.value = digits;

            if (!digits) {
                this.setDynamicYearRangeField(field, side, '');
                return;
            }

            if (digits.length === 4) {
                const year = parseInt(digits, 10);
                const currentYear = this.dynamicYearCurrentYear();

                if (Number.isFinite(year) && year >= 1900 && year <= currentYear) {
                    this.setDynamicYearRangeField(field, side, String(year));
                }
            }
        },

        commitDynamicYearRangeInput(field, side = 'min', event) {
            if (!field || !event?.target) return;

            const digits = String(event.target.value || '')
                .replace(/\D/g, '')
                .slice(0, 4);

            if (!digits) {
                this.setDynamicYearRangeField(field, side, '');
                event.target.value = '';
                return;
            }

            const parsed = parseInt(digits, 10);
            if (!Number.isFinite(parsed)) {
                this.setDynamicYearRangeField(field, side, '');
                event.target.value = '';
                return;
            }

            const year = Math.min(this.dynamicYearCurrentYear(), Math.max(1900, parsed));
            this.setDynamicYearRangeField(field, side, String(year));
            event.target.value = this.dynamicYearRangeValue(field, side);
        },

        stepDynamicYearField(field, direction = 1) {
            if (!field) return;

            const currentYear = this.dynamicYearCurrentYear();
            const current = parseInt(String(this.dynamicYearValue(field) || '').replace(/\D/g, ''), 10);

            if (!Number.isFinite(current)) {
                if (direction > 0) {
                    this.setDynamicYearField(field, String(currentYear));
                }
                return;
            }

            const next = Math.min(
                currentYear,
                Math.max(1900, current + (direction > 0 ? 1 : -1))
            );

            this.setDynamicYearField(field, String(next));
        },

        onDynamicYearInput(field, event) {
            if (!field || !event?.target) return;

            const digits = String(event.target.value || '')
                .replace(/\D/g, '')
                .slice(0, 4);

            event.target.value = digits;

            if (!digits) {
                this.setDynamicYearField(field, '');
                return;
            }

            if (digits.length === 4) {
                const year = parseInt(digits, 10);
                const currentYear = this.dynamicYearCurrentYear();

                if (Number.isFinite(year) && year >= 1900 && year <= currentYear) {
                    this.setDynamicYearField(field, String(year));
                }
            }
        },

        commitDynamicYearInput(field, event) {
            if (!field || !event?.target) return;

            const digits = String(event.target.value || '')
                .replace(/\D/g, '')
                .slice(0, 4);

            if (!digits) {
                this.setDynamicYearField(field, '');
                event.target.value = '';
                return;
            }

            const parsed = parseInt(digits, 10);
            if (!Number.isFinite(parsed)) {
                this.setDynamicYearField(field, '');
                event.target.value = '';
                return;
            }

            const year = Math.min(this.dynamicYearCurrentYear(), Math.max(1900, parsed));
            this.setDynamicYearField(field, String(year));
            event.target.value = String(year);
        },

        normalizeDynamicYearValue(value, field = null) {
            if (value === null || value === undefined) return '';

            let candidate = String(value).trim();

            // Eski query/form verisi yıl alanını option id olarak taşıdıysa option label/value içinden gerçek yılı yakala.
            if (field && Array.isArray(field.options) && candidate && !/^\d{4}$/.test(candidate)) {
                const matchedOption = field.options.find(option => String(option?.id) === candidate || String(option?.value) === candidate);
                const optionText = matchedOption ? String(matchedOption.name || matchedOption.label || matchedOption.value || '') : '';
                const optionYear = optionText.match(/\b(19\d{2}|20\d{2})\b/);
                if (optionYear) {
                    candidate = optionYear[1];
                }
            }

            const yearMatch = candidate.match(/\b(19\d{2}|20\d{2})\b/);
            if (!yearMatch) return '';

            const year = parseInt(yearMatch[1], 10);
            const currentYear = new Date().getFullYear();

            if (!Number.isFinite(year) || year < 1900 || year > currentYear) {
                return '';
            }

            return String(year);
        },

        dynamicYearValue(field) {
            if (!field) return '';
            const value = this.form.fields[String(field.id)];

            if (value && typeof value === 'object' && !Array.isArray(value)) {
                return this.normalizeDynamicYearValue(value.min || value.value || '', field);
            }

            return this.normalizeDynamicYearValue(value, field);
        },

        setDynamicYearField(field, year = '') {
            if (!field) return;

            const fieldId = String(field.id);
            let cleanYear = this.normalizeDynamicYearValue(year, field);

            if (cleanYear && this.isDynamicRenovationYearField(field)) {
                const constructionYear = parseInt(String(this.dynamicYearValue(this.dynamicConstructionYearField()) || '').replace(/\D/g, ''), 10);
                const renovationYear = parseInt(cleanYear, 10);

                if (Number.isFinite(constructionYear) && constructionYear > 0 && Number.isFinite(renovationYear) && renovationYear < constructionYear) {
                    cleanYear = String(constructionYear);
                }
            }

            if (!cleanYear) {
                this.form.fields[fieldId] = '';
                delete this.fieldFilterModes[fieldId];
                this.openDropdown = null;
                this.syncDynamicConditionalYearFields();
                return;
            }

            this.form.fields[fieldId] = { min: cleanYear, max: cleanYear, value: cleanYear };
            this.fieldFilterModes[fieldId] = 'value';
            this.openDropdown = null;
            this.syncDynamicConditionalYearFields();
        },

        clearDynamicFieldValue(field) {
            if (!field) return;
            const fieldId = String(field.id);

            if (this.form.fields[fieldId]) {
                this.form.fields[fieldId] = '';
            }

            delete this.fieldFilterModes[fieldId];
        },

        dynamicRenovationYearOptions() {
            const constructionYear = parseInt(String(this.dynamicYearValue(this.dynamicConstructionYearField()) || '').replace(/\D/g, ''), 10);
            if (!Number.isFinite(constructionYear) || constructionYear <= 0) {
                return this.dynamicYearOptions();
            }

            return this.dynamicYearOptions().filter(year => Number(year) >= constructionYear);
        },

        syncDynamicConditionalYearFields() {
            if (this.isDynamicYearSyncing) return;

            this.isDynamicYearSyncing = true;
            try {
                const constructionField = this.dynamicConstructionYearField();
                const renovationField = this.dynamicRenovationYearField();
                const currentYear = String(this.dynamicYearCurrentYear());
                const mode = this.dynamicPropertyStatusMode();

                const syncMinOnlyYear = (field, shouldBeVisible) => {
                    if (!field) return;

                    const fieldId = String(field.id);
                    if (!shouldBeVisible) {
                        this.clearDynamicFieldValue(field);
                        return;
                    }

                    const min = this.dynamicYearRangeValue(field, 'min') || currentYear;
                    const max = this.dynamicYearRangeValue(field, 'max');
                    const raw = this.form.fields[fieldId];
                    const isRangeObject = raw && typeof raw === 'object' && !Array.isArray(raw);

                    // form deep watcher bu methodu her alan değişiminde çağırıyor.
                    // Aynı range'i yeni bir obje olarak tekrar yazmak Vue'da yeniden watcher
                    // tetikleyip sonsuz güncelleme döngüsüne neden olur. Yalnızca state gerçekten
                    // değiştiğinde yazıyoruz.
                    if (!isRangeObject || String(raw.min || '') !== String(min) || String(max || '') !== '') {
                        this.form.fields[fieldId] = { min, max: '' };
                    }

                    if (this.fieldFilterModes[fieldId] !== 'range') {
                        this.fieldFilterModes[fieldId] = 'range';
                    }
                };

                // Yenilenmiş seçiminde yapım yılı kaldırılmaz; iki yıl filtresi birlikte çalışır.
                syncMinOnlyYear(constructionField, mode === 'standard' || mode === 'renovated');
                syncMinOnlyYear(renovationField, mode === 'renovated');
            } finally {
                this.isDynamicYearSyncing = false;
            }
        },
        quickFieldOptions(config) {
            return Array.isArray(config?.field?.options) ? config.field.options : [];
        },

        quickFieldValue(config) {
            const field = config?.field;
            if (!field) return [];

            const key = String(field.id);
            const value = this.form.fields[key];
            return Array.isArray(value) ? value.map(String) : (value ? [String(value)] : []);
        },

        isQuickFieldSelected(config, optionId) {
            return this.quickFieldValue(config).includes(String(optionId));
        },

        toggleQuickField(config, optionId) {
            const field = config?.field;
            if (!field) return;

            const key = String(field.id);
            const selected = this.quickFieldValue(config);
            const id = String(optionId);

            this.form.fields[key] = selected.includes(id)
                ? selected.filter(value => value !== id)
                : selected.concat(id);
        },

        isFieldArrayValueSelected(field, optionId) {
            const value = this.form.fields[String(field.id)];
            const selected = Array.isArray(value)
                ? value.map(String)
                : (value !== null && value !== undefined && String(value).trim() !== '' ? [String(value)] : []);

            return selected.includes(String(optionId));
        },

        toggleFieldArrayValue(field, optionId) {
            const key = String(field.id);
            const rawValue = this.form.fields[key];
            const value = Array.isArray(rawValue)
                ? rawValue.map(String)
                : (rawValue !== null && rawValue !== undefined && String(rawValue).trim() !== '' ? [String(rawValue)] : []);
            const id = String(optionId);

            this.form.fields[key] = value.includes(id)
                ? value.filter(item => item !== id)
                : value.concat(id);

            if (this.form.fields[key].length) {
                this.fieldFilterModes[key] = 'options';
            } else {
                delete this.fieldFilterModes[key];
            }

            if (this.isProjectCompletedSelected()) {
                this.dynamicFields.filter(candidate => this.isProjectDeliveryYearField(candidate)).forEach(candidate => {
                    this.form.fields[String(candidate.id)] = { min: '', max: '' };
                });
                this.openDropdown = null;
            }
        },

        parkingDefinitions() {
            return [
                {
                    key: 'open',
                    label: 'Açık Otopark',
                    featureLabels: ['açık otopark', 'acik otopark', 'açık araç parkı', 'acik arac parki', 'açık park yeri', 'acik park yeri'],
                    fieldKeys: ['acik_otopark_arac', 'açık otopark araç sayısı', 'acik otopark arac sayisi'],
                    countKind: 'vehicle',
                },
                {
                    key: 'closed',
                    label: 'Kapalı Otopark',
                    featureLabels: ['kapalı otopark', 'kapali otopark', 'kapalı araç parkı', 'kapali arac parki'],
                    fieldKeys: ['kapali_otopark_arac', 'kapalı otopark araç sayısı', 'kapali otopark arac sayisi'],
                    countKind: 'vehicle',
                },
                {
                    key: 'garage',
                    label: 'Kapalı Garaj',
                    featureLabels: ['kapalı garaj', 'kapali garaj', 'garaj'],
                    fieldKeys: ['kapali_garaj_arac', 'kapali_garaj_adet', 'kapalı garaj araç sayısı', 'kapali garaj arac sayisi'],
                    countKind: 'vehicle',
                },
                {
                    key: 'electric',
                    label: 'Elektrikli Araç Şarj Alanı',
                    featureLabels: ['elektrikli araç şarj alanı', 'elektrikli arac sarj alani', 'elektrikli şarj istasyonu', 'elektrikli sarj istasyonu', 'elektrikli şarj', 'elektrikli sarj'],
                    fieldKeys: ['elektrikli_sarj_adet', 'elektrikli_sarj_arac', 'şarj cihazı adedi', 'sarj cihazi adedi', 'elektrikli araç şarj adedi', 'elektrikli arac sarj adedi'],
                    countKind: 'charger',
                },
                {
                    key: 'valet',
                    label: 'Vale Hizmeti',
                    featureLabels: ['vale hizmeti', 'vale'],
                    fieldKeys: [],
                    countKind: 'none',
                },
            ];
        },

        parkingGroupKeys() {
            return ['park yeri', 'parkyeri', 'otopark', 'parking'];
        },

        isParkingDefinition(definition = {}) {
            const haystack = [definition.label, ...(definition.keys || [])].filter(Boolean).join(' ');
            const text = this.normalizeText(haystack);
            if (!text) return false;

            return this.parkingGroupKeys().some(key => text.includes(this.normalizeText(key)))
                || this.parkingDefinitions().some(def => (def.fieldKeys || []).some(fieldKey => text.includes(this.normalizeText(fieldKey))));
        },

        parkingTextMatches(value, aliases = []) {
            const source = value && typeof value === 'object'
                ? this.filterStructuralDescriptor(value, false)
                : value;
            const text = this.normalizeText(source || '');
            if (!text) return false;

            return aliases
                .map(alias => this.normalizeText(alias))
                .filter(Boolean)
                .some(alias => text === alias || text.includes(alias) || alias.includes(text));
        },

        parkingFeatureGroups() {
            const groupKeys = this.parkingGroupKeys();
            const definitions = this.parkingDefinitions();

            return this.dynamicFeatures.filter(group => {
                if (this.parkingTextMatches(group, groupKeys)) {
                    return true;
                }

                const items = Array.isArray(group?.items) ? group.items : [];
                return items.some(item => definitions.some(definition => (
                    this.parkingTextMatches(item, definition.featureLabels || [])
                )));
            });
        },

        parkingFeatureGroup() {
            return this.parkingFeatureGroups()[0] || null;
        },

        parkingFeatureItem(definition) {
            const aliases = Array.isArray(definition?.featureLabels) ? definition.featureLabels : [];

            for (const group of this.parkingFeatureGroups()) {
                const items = Array.isArray(group?.items) ? group.items : [];
                const item = items.find(candidate => this.parkingTextMatches(candidate, aliases));
                if (item) return item;
            }

            return null;
        },

        parkingCountField(definition) {
            const keys = Array.isArray(definition?.fieldKeys) ? definition.fieldKeys : [];
            if (!keys.length) return null;

            return this.dynamicFields.find(field => {
                const own = [field?.schema_key, field?.key, field?.meta?.schema_key, field?.meta?.key]
                    .filter(Boolean)
                    .some(value => keys.some(key => this.normalizeText(value) === this.normalizeText(key)));
                if (own) return true;

                const haystack = [field?.name, field?.label, field?.placeholder, field?.unit]
                    .filter(Boolean)
                    .join(' ');
                return keys.some(key => this.parkingTextMatches(haystack, [key]));
            }) || null;
        },

        parkingCountFields() {
            const fields = this.parkingDefinitions()
                .map(definition => this.parkingCountField(definition))
                .filter(Boolean);

            const used = new Set();
            return fields.filter(field => {
                const id = Number(field.id || 0);
                if (!id || used.has(id)) return false;
                used.add(id);
                return true;
            });
        },

        parkingRelatedFields() {
            const countFields = this.parkingCountFields();
            const hasConsolidatedParking = this.parkingFeatureGroups().length > 0 || countFields.length > 0;

            if (!hasConsolidatedParking) {
                return [];
            }

            const structuralKeys = [
                'park_yeri',
                'park_yeri_tipi',
                'otopark',
                'parking',
                'parking_type',
                ...this.parkingDefinitions().flatMap(definition => definition.fieldKeys || []),
            ];

            const fields = this.dynamicFields.filter(field => {
                if (this.fieldMatchesExactSchema(field, structuralKeys)) {
                    return true;
                }

                const identity = this.filterStructuralDescriptor(field, false);
                return structuralKeys.some(key => {
                    const haystack = this.normalizeText(identity);
                    const needle = this.normalizeText(key);
                    return needle && (haystack === needle || haystack.includes(needle));
                });
            });

            const used = new Set();
            return fields.filter(field => {
                const id = Number(field?.id || 0);
                if (!id || used.has(id)) return false;
                used.add(id);
                return true;
            });
        },

        buildParkingFilterItem(keyPrefix = 'parking') {
            const group = this.parkingFeatureGroup();
            const options = this.parkingDefinitions()
                .map(definition => {
                    const featureItem = this.parkingFeatureItem(definition);
                    const countField = this.parkingCountField(definition);

                    if (!featureItem && !countField) {
                        return null;
                    }

                    return {
                        ...definition,
                        featureGroup: group,
                        featureItem,
                        countField,
                    };
                })
                .filter(Boolean);

            if (!options.length) {
                return null;
            }

            return {
                type: 'parking_group',
                key: `${keyPrefix}-parking`,
                label: 'Park Yeri',
                group,
                options,
            };
        },

        isParkingOptionSelected(parking) {
            if (!parking) return false;

            const featureSelected = parking.featureItem
                ? this.form.feature_value_ids.includes(Number(parking.featureItem.id))
                : false;

            const field = parking.countField;
            const range = field ? this.form.fields[String(field.id)] : null;
            const hasCount = range && typeof range === 'object' && !Array.isArray(range)
                ? !!(String(range.min || '').trim() || String(range.max || '').trim())
                : !!String(range || '').trim();

            return featureSelected || hasCount;
        },

        setParkingFeatureSelected(parking, selected) {
            if (!parking?.featureItem) return;

            const id = Number(parking.featureItem.id);
            const exists = this.form.feature_value_ids.includes(id);

            if (selected && !exists) {
                this.form.feature_value_ids = this.form.feature_value_ids.concat(id);
            }

            if (!selected && exists) {
                this.form.feature_value_ids = this.form.feature_value_ids.filter(value => Number(value) !== id);
            }
        },

        clearParkingCount(parking) {
            const field = parking?.countField;
            if (!field) return;

            const key = String(field.id);
            this.form.fields[key] = { min: '', max: '' };
            delete this.fieldFilterModes[key];
        },

        ensureParkingCount(parking) {
            const field = parking?.countField;
            if (!field) return;

            const key = String(field.id);
            const current = this.form.fields[key];
            const hasValue = current && typeof current === 'object' && !Array.isArray(current)
                ? !!(String(current.min || '').trim() || String(current.max || '').trim())
                : !!String(current || '').trim();

            if (!hasValue) {
                this.setNumericRangeVal(field, 'min', '1');
            }
        },

        toggleParkingOption(parking) {
            const selected = this.isParkingOptionSelected(parking);

            if (selected) {
                this.setParkingFeatureSelected(parking, false);
                this.clearParkingCount(parking);
                return;
            }

            this.setParkingFeatureSelected(parking, true);
            this.ensureParkingCount(parking);
        },

        onParkingCountInput(parking, event) {
            this.setParkingFeatureSelected(parking, true);
            this.onNumericRangeInput(parking.countField, 'min', event);
        },

        stepParkingCount(parking, direction) {
            if (!parking?.countField) return;

            this.setParkingFeatureSelected(parking, true);

            const current = parseInt(String(this.getNumericRangeVal(parking.countField, 'min') || '0').replace(/\D/g, ''), 10);
            const next = Math.max(1, (Number.isFinite(current) ? current : 0) + (direction > 0 ? 1 : -1));
            this.setNumericRangeVal(parking.countField, 'min', String(next));
        },

        parkingCountTitle(parking) {
            return parking?.countKind === 'charger' ? 'En az şarj cihazı adedi' : 'En az araç sayısı';
        },

        parkingCountHelp(parking) {
            return parking?.countKind === 'charger'
                ? 'Bu seçenek aktifken şarj cihazı adedi en az değeriyle filtrelenir.'
                : 'Bu seçenek aktifken araç sayısı en az değeriyle filtrelenir.';
        },

        applyQuickRange(field, value) {
            this.form[field] = this.clean(value);
        },

        /* ── Combobox helpers ── */
        toggleCombo(id) {
            this.openDropdown = this.openDropdown === id ? null : id;
        },
        openCombo(id) {
            this.openDropdown = id;
        },
        selectCombo(field, value) {
            this.form[field] = value;
            this.openDropdown = null;
        },
        selectDynField(field, value) {
            const key = String(field.id);
            this.form.fields[key] = value;

            if (value !== null && value !== undefined && String(value).trim() !== '') {
                this.fieldFilterModes[key] = 'option';
            } else {
                delete this.fieldFilterModes[key];
            }

            this.openDropdown = null;
        },
        dynamicFieldLabel(field) {
            const val = this.form.fields[String(field.id)];
            if (!val) return '';
            const opt = (field.options || []).find(o => String(o.id) === String(val));
            return opt ? opt.name : val;
        },
        _onDocClickCombo(e) {
            if (this.openDropdown && !e.target.closest('.nf-combobox')) {
                this.openDropdown = null;
            }
        },

        selectedFeatureCount(group) {
            if (!group || !Array.isArray(group.items)) return 0;
            return group.items.filter(item => this.form.feature_value_ids.includes(Number(item.id))).length;
        },

        openFeaturePicker(group) {
            this.featurePicker = group;
        },

        closeFeaturePicker() {
            this.featurePicker = null;
        },



        /*
         * Detaylı filtre için yalnızca ülke seçimi yeterli değildir.
         * Backend'deki hasSpecificLocationFilter() sözleşmesiyle aynı şekilde
         * en az şehir, ilçe veya mahalle seçilmiş olmalıdır.
         */
        hasSearchLocation() {
            return !!(this.form.city_id || this.form.district_id || this.form.quarter_id);
        },

        locationGuardText(key) {
            const sources = {
                placeholder: 'Lütfen bölge seçiniz',
                title: 'Bölge gerekli',
                message: 'Detaylı filtreyi açmak için önce şehir, ilçe veya mahalle seçiniz.',
            };

            const fallback = {
                tr: {
                    placeholder: 'Lütfen bölge seçiniz',
                    title: 'Bölge gerekli',
                    message: 'Detaylı filtreyi açmak için önce şehir, ilçe veya mahalle seçiniz.',
                },
                en: {
                    placeholder: 'Please select a location',
                    title: 'Location required',
                    message: 'Please select a city, district, or neighborhood before opening detailed filters.',
                },
                fr: {
                    placeholder: 'Veuillez sélectionner une zone',
                    title: 'Zone requise',
                    message: 'Veuillez sélectionner une ville, un district ou un quartier avant d’ouvrir les filtres détaillés.',
                },
                de: {
                    placeholder: 'Bitte wählen Sie eine Region',
                    title: 'Region erforderlich',
                    message: 'Bitte wählen Sie zuerst eine Stadt, einen Bezirk oder ein Viertel aus, bevor Sie die Detailfilter öffnen.',
                },
                ru: {
                    placeholder: 'Пожалуйста, выберите регион',
                    title: 'Требуется регион',
                    message: 'Перед открытием подробных фильтров выберите город, район или микрорайон.',
                },
                ar: {
                    placeholder: 'يرجى اختيار المنطقة',
                    title: 'المنطقة مطلوبة',
                    message: 'يرجى اختيار مدينة أو منطقة أو حي قبل فتح عوامل التصفية التفصيلية.',
                },
                nl: {
                    placeholder: 'Selecteer een regio',
                    title: 'Regio vereist',
                    message: 'Selecteer eerst een stad, district of buurt voordat u de uitgebreide filters opent.',
                },
                es: {
                    placeholder: 'Seleccione una zona',
                    title: 'Se requiere una zona',
                    message: 'Seleccione primero una ciudad, distrito o barrio antes de abrir los filtros detallados.',
                },
                fa: {
                    placeholder: 'لطفاً منطقه را انتخاب کنید',
                    title: 'انتخاب منطقه الزامی است',
                    message: 'پیش از باز کردن فیلترهای پیشرفته، ابتدا شهر، ناحیه یا محله را انتخاب کنید.',
                },
                zh: {
                    placeholder: '请选择地区',
                    title: '需要选择地区',
                    message: '打开详细筛选前，请先选择城市、区县或街区。',
                },
                pl: {
                    placeholder: 'Wybierz region',
                    title: 'Region jest wymagany',
                    message: 'Przed otwarciem filtrów szczegółowych wybierz miasto, dzielnicę lub okolicę.',
                },
                da: {
                    placeholder: 'Vælg venligst et område',
                    title: 'Område påkrævet',
                    message: 'Vælg først en by, et distrikt eller et lokalområde, før du åbner de detaljerede filtre.',
                },
            };

            const source = sources[key] || '';
            const translated = source ? this.uiText(source) : '';

            // resources/lang içindeki çeviri mevcutsa her zaman onu kullan.
            if (translated && translated !== source) {
                return translated;
            }

            const locale = fallback[this.activeLocale] ? this.activeLocale : 'tr';
            return fallback[locale]?.[key] || source;
        },

        locationGuardInput() {
            const candidates = [
                document.getElementById('hsQ'),
                document.getElementById('headerSearchQ'),
                document.getElementById('otherHeaderSearchQ'),
                document.querySelector('.hm-header-location-search input[type="search"]'),
                document.querySelector('.hm-header-location-search input[type="text"]'),
                document.querySelector('.other-header input[type="search"]'),
                document.querySelector('.other-header input[type="text"]'),
            ].filter(Boolean);

            return candidates.find(input => input.offsetParent !== null) || candidates[0] || null;
        },

        requestLocationInput() {
            const input = this.locationGuardInput();
            const wrap = input?.closest(
                '#heroSearchInputWrap, #headerSearchInputWrap, #otherHeaderSearchInputWrap, .hm-header-location-search, .hero-search-input'
            ) || document.getElementById('heroSearchInputWrap');

            const placeholder = this.locationGuardText('placeholder');
            const title = this.locationGuardText('title');
            const message = this.locationGuardText('message');

            this.close();

            if (wrap) {
                wrap.classList.add('is-location-required');
                setTimeout(() => wrap.classList.remove('is-location-required'), 2600);
            }

            if (input) {
                input.value = '';
                input.placeholder = placeholder;
                input.focus();
            }

            if (window.UI && typeof window.UI.toast === 'function') {
                window.UI.toast('warning', title, message);
            } else if (typeof window.showToast === 'function') {
                window.showToast('warning', title, message);
            }
        },
        exposeFilterBridge() {
            window.NetteSearchFilter = {
                context: this.context,

                open: () => {
                    this.open();
                },

                close: () => {
                    this.close();
                },

                syncFromDom: () => {
                    this.syncFromDom();
                    this.syncDomState();
                    return this.paramsObject();
                },

                buildParams: () => {
                    this.syncFromDom();
                    this.syncDomState();
                    return this.buildParams();
                },

                paramsObject: () => {
                    this.syncFromDom();
                    this.syncDomState();
                    return this.paramsObject();
                },

                setTransactionType: (value) => {
                    const cleanValue = String(value || '').trim();

                    if (cleanValue === '1' || cleanValue === '2') {
                        this.form.transaction_type = cleanValue;
                        this.syncDomState();
                        this.scheduleLiveCount(0);
                    }
                },

                setCategory: (mainCategoryId, subCategoryId = '') => {
                    this.form.main_category_id = this.normalizeId(mainCategoryId);
                    this.form.subcategory_id = this.normalizeId(subCategoryId);

                    if (!this.form.main_category_id && this.form.subcategory_id) {
                        this.form.main_category_id = this.findMainCategoryId(this.form.subcategory_id);
                    }

                    this.syncDomState();
                    this.refreshMetadataForCurrentSelection(true);
                    this.scheduleLiveCount(0);
                },

                resolveTypedLocation: async (query = '') => {
                    const q = this.clean(query || this.locationSearch || this.form.location_label || '');
                    if (q.length < 2) return false;

                    const items = await this.searchLocations(q);
                    const first = Array.isArray(items) ? items[0] : null;
                    if (!first) return false;

                    await this.applyLocationItem(first);
                    this.syncDomState();
                    return true;
                },
            };
        },

        paramsObject(params = null) {
            const source = params || this.buildParams();
            const out = {};

            source.forEach((value, key) => {
                if (out[key] === undefined) {
                    out[key] = value;
                    return;
                }

                if (!Array.isArray(out[key])) {
                    out[key] = [out[key]];
                }

                out[key].push(value);
            });

            return out;
        },

        onExternalSearchStateChanged(event) {
            const detail = event?.detail || {};
            this.syncFromDom({ force: true });

            const stateLocationKeys = ['country_id', 'city_id', 'district_id', 'quarter_id'];
            stateLocationKeys.forEach(key => {
                if (detail[key] !== undefined) {
                    this.form[key] = this.normalizeId(detail[key]);
                }
            });

            if (detail.location_label !== undefined) {
                this.form.location_label = this.clean(detail.location_label);
                this.locationSearch = this.form.location_label;
            }

            if (detail.q !== undefined && !this.form.location_label) {
                this.form.q = this.clean(detail.q);
                this.locationSearch = this.form.q;
            }

            if (detail.transaction_type) {
                const tx = String(detail.transaction_type);

                if (tx === '1' || tx === '2') {
                    this.form.transaction_type = tx;
                }
            }

            if (detail.main_category_id !== undefined) {
                this.form.main_category_id = this.normalizeId(detail.main_category_id);
            }

            if (detail.subcategory_id !== undefined) {
                this.form.subcategory_id = this.normalizeId(detail.subcategory_id);
            }

            if (detail.category_id && !this.form.main_category_id) {
                const mainId = this.findMainCategoryId(detail.category_id);
                this.form.main_category_id = mainId;
                this.form.subcategory_id = mainId && String(mainId) !== String(detail.category_id)
                    ? this.normalizeId(detail.category_id)
                    : '';
            }

            this.sanitizeCategoryForCurrentTransaction(true);
            this.syncDomState();
            this.scheduleLiveCount(0);
        },
        async resolveLocationBeforeOpen() {
            const state = this.applyExternalLocationStateToForm();

            // Ülke (örn. varsayılan country_id=1) tek başına detaylı filtreyi açamaz.
            if (this.hasSearchLocation()) {
                this.syncDomState();
                return true;
            }

            /*
             * Daha önce gerçekten seçilmiş bir konum yalnızca location_label ile
             * taşınmışsa ID'leri bir kez tamamlamayı dene. Serbest yazılmış q değeri
             * burada otomatik olarak ilk sonuçla eşleştirilmez; kullanıcı listeden
             * şehir / ilçe / mahalle seçmelidir.
             */
            const selectedLabel = this.clean(state.location_label || this.form.location_label || '');
            if (selectedLabel.length >= 2) {
                this.locationSearch = selectedLabel;
                await this.ensureLocationIdsFromLabel();
                this.syncDomState();

                if (this.hasSearchLocation()) {
                    return true;
                }
            }

            return false;
        },

        bindOpenTriggers() {
            window.addEventListener('open-filter-popup', this.open);

            const listBtn = document.getElementById('adlist-open-filters') || document.getElementById('agency-open-filters');
            if (listBtn && listBtn.dataset.vueFilterBound !== '1') {
                listBtn.dataset.vueFilterBound = '1';
                listBtn.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.open();
                });
            }
        },

        async open() {
            if (this.isOpeningFilter) return;

            this.isOpeningFilter = true;
            this.syncFromDom({ force: true });

            /*
             * Bölge zorunluluğu ortak popup'ta varsayılan olarak devam eder.
             * Yalnızca "İlanlarım" ekranı (context=my_ads) kendi ilanlarını
             * bölge seçmeden filtreleyebildiği için açılış guard'ından muaftır.
             * Ana sayfa ve ilan listesi mevcut zorunluluğu aynen korur.
             */
            if (!this.isMyAdsContext && this.context !== 'agency') {
                const hasSpecificLocation = await this.resolveLocationBeforeOpen();

                // Şehir / ilçe / mahalle seçilmeden popup açılmasın.
                if (!hasSpecificLocation) {
                    this.isOpeningFilter = false;
                    this.requestLocationInput();
                    return;
                }
            }

            this.updateFilterViewportHeight();
            this.isOpen = true;
            this.lockFilterBody();
            this.bootstrapLocationOptions();

            this.$nextTick(() => {
                this.updateFilterViewportHeight();

                setTimeout(() => {
                    this.updateFilterViewportHeight();
                }, 250);
            });

            // Determine initial wizard step based on current state
            if (this.canProceedToStep4) {
                this.currentStep = 4;
                this.maxReachedStep = 4;
                this.refreshMetadataForCurrentSelection(false);
            } else if (this.canProceedToStep3) {
                this.currentStep = 3;
                this.maxReachedStep = 3;
            } else if (this.canProceedToStep2 && !(this.context === 'agency' && !this.form.transaction_type)) {
                this.currentStep = 2;
                this.maxReachedStep = 2;
            } else {
                this.currentStep = 1;
                this.maxReachedStep = 1;
            }

            this.scheduleLiveCount(0);
            this.isOpeningFilter = false;
        },

        close() {
            this.isOpen = false;
            this.openDropdown = null;
            this.featurePicker = null;
            this.locationResultsOpen = false;
            this.unlockFilterBody();
        },

        normalizeId(value) {
            const parsed = parseInt(String(value ?? '').trim(), 10);
            return Number.isFinite(parsed) && parsed > 0 ? String(parsed) : '';
        },

        clean(value) {
            return String(value ?? '').trim();
        },

        /*
         * Layout/gruplama kararları aktif dildeki görünür metinlerden tamamen
         * ayrılır. Backend her kayıt için TR/schema tabanlı canonical_* alanlarını
         * döndürüyor. Bunlar varsa yalnızca bu sabit kimlikleri kullanırız; eski
         * veri setlerinde canonical bilgi hiç yoksa görünür metin son çare fallback'tir.
         *
         * Böylece aynı field/feature ID'si EN/DE/FR/RU/AR/NL/ES/FA/ZH/PL/DA
         * dillerinde başka bir gruba düşemez.
         */
        filterStructuralOwnParts(value) {
            if (!value || typeof value !== 'object') return [];

            const meta = (value.meta && typeof value.meta === 'object') ? value.meta : {};
            const canonicalParts = [
                value.schema_key,
                value.key,
                value.canonical_name,
                value.schema_value,
                value.canonical_schema_value,
                value.canonical_placeholder,
                value.canonical_section,
                meta.schema_key,
                meta.key,
                meta.schema_value,
                meta.canonical_value,
                meta.canonical_section,
                meta.section,
                meta.input,
                meta.group,
                meta.project_unit_key,
            ].filter(part => part !== undefined && part !== null && String(part).trim() !== '');

            if (canonicalParts.length > 0) {
                return canonicalParts;
            }

            return [
                value.name,
                value.label,
                value.value,
                value.placeholder,
            ].filter(part => part !== undefined && part !== null && String(part).trim() !== '');
        },

        filterStructuralDescriptor(value, includeChildren = true) {
            if (!value) return '';

            if (value.field) {
                return this.filterStructuralDescriptor(value.field, includeChildren);
            }

            const parts = this.filterStructuralOwnParts(value);

            if (includeChildren && Array.isArray(value.options)) {
                value.options.forEach(option => {
                    const descriptor = this.filterStructuralDescriptor(option, false);
                    if (descriptor) parts.push(descriptor);
                });
            }

            if (includeChildren && Array.isArray(value.items)) {
                value.items.forEach(item => {
                    const descriptor = this.filterStructuralDescriptor(item, false);
                    if (descriptor) parts.push(descriptor);
                });
            }

            return parts.filter(Boolean).join(' ');
        },

        filterStructuralIdentity(value) {
            return this.normalizeText(this.filterStructuralDescriptor(value, false));
        },

        filterStructuralPrimaryIdentity(value) {
            if (!value || typeof value !== 'object') return '';
            const meta = (value.meta && typeof value.meta === 'object') ? value.meta : {};

            return this.normalizeText(
                value.canonical_name
                || value.schema_value
                || value.schema_key
                || value.key
                || meta.schema_value
                || meta.schema_key
                || meta.key
                || value.name
                || value.label
                || value.value
                || ''
            );
        },

        filterStructuralMatches(values, keys = []) {
            const rows = Array.isArray(values) ? values : [values];
            const haystack = this.normalizeText(
                rows.map(value => this.filterStructuralDescriptor(value, false)).filter(Boolean).join(' ')
            );

            return (Array.isArray(keys) ? keys : [keys]).some(key => {
                const needle = this.normalizeText(key);
                return needle && haystack.includes(needle);
            });
        },

        /*
         * Filtre layout'u görünen çeviriye göre değil, değişmeyen schema_key/meta
         * sözleşmesine göre kurulmalıdır. İngilizce/Almanca vb. label'lar yalnızca
         * sunum içindir.
         */
        fieldSchemaCandidates(field) {
            if (!field || typeof field !== 'object') return [];

            return [
                field.schema_key,
                field.key,
                field.meta?.schema_key,
                field.meta?.key,
            ]
                .filter(Boolean)
                .map(value => this.normalizeText(value))
                .filter(Boolean);
        },

        featureGroupSchemaCandidates(group) {
            if (!group || typeof group !== 'object') return [];

            return [
                group.schema_key,
                group.key,
                group.meta?.schema_key,
                group.meta?.key,
            ]
                .filter(Boolean)
                .map(value => this.normalizeText(value))
                .filter(Boolean);
        },

        featureGroupMatchesExactSchema(group, keys = []) {
            const schemas = this.featureGroupSchemaCandidates(group);
            if (!schemas.length) return false;

            const needles = (Array.isArray(keys) ? keys : [keys])
                .map(value => this.normalizeText(value))
                .filter(Boolean);

            return needles.some(needle => schemas.includes(needle));
        },

        fieldMatchesExactSchema(field, keys = []) {
            const schemas = this.fieldSchemaCandidates(field);
            if (!schemas.length) return false;

            const needles = (Array.isArray(keys) ? keys : [keys])
                .map(value => this.normalizeText(value))
                .filter(Boolean);

            return needles.some(needle => schemas.includes(needle));
        },

        fieldCanonicalSection(field) {
            return this.normalizeText([
                field?.canonical_section,
                field?.meta?.canonical_section,
                field?.meta?.section,
                field?.section,
            ].filter(Boolean).join(' '));
        },

        fieldBelongsToCanonicalSection(field, aliases = []) {
            const section = this.fieldCanonicalSection(field);
            if (!section) return false;

            return (Array.isArray(aliases) ? aliases : [aliases]).some(alias => {
                const needle = this.normalizeText(alias);
                return needle && section.includes(needle);
            });
        },

        normalizeDynamicField(field) {
            if (!field || typeof field !== 'object') {
                return field;
            }

            const normalized = { ...field };
            normalized.canonical_name = String(normalized.canonical_name || normalized.name || normalized.label || '').trim();
            normalized.canonical_placeholder = String(normalized.canonical_placeholder || normalized.placeholder || '').trim();
            normalized.canonical_section = String(
                normalized.canonical_section
                || normalized.meta?.canonical_section
                || normalized.meta?.section
                || normalized.section
                || ''
            ).trim();
            normalized.name = this.uiText(normalized.name || normalized.canonical_name || '');
            normalized.placeholder = normalized.placeholder
                ? this.uiText(normalized.placeholder)
                : (normalized.canonical_placeholder ? this.uiText(normalized.canonical_placeholder) : normalized.placeholder);

            if (Array.isArray(normalized.options)) {
                normalized.options = normalized.options.map(option => {
                    if (!option || typeof option !== 'object') return option;
                    const canonicalName = String(option.canonical_name || option.name || option.label || option.value || '').trim();
                    return {
                        ...option,
                        canonical_name: canonicalName,
                        name: this.uiText(option.name || canonicalName),
                    };
                });
            }

            if (this.isMoneyField(normalized) && !String(normalized.unit || normalized.meta?.unit || '').trim()) {
                normalized.unit = 'TL';
            }

            return normalized;
        },

        prepareDynamicFields(fields) {
            if (!Array.isArray(fields)) {
                return [];
            }

            const seen = new Set();
            const result = [];

            fields.forEach(field => {
                const normalized = this.normalizeDynamicField(field);
                if (!normalized || typeof normalized !== 'object') {
                    return;
                }

                /*
                 * ID varsa tek gerçek kimlik ID'dir. Önceki sürüm id + schema + name
                 * imzalarının tamamını seen'e yazdığı için iki farklı alan aynı adı
                 * taşıdığında ikincisi yanlışlıkla düşebiliyordu.
                 */
                const id = Number(normalized.id || 0);
                const schema = this.fieldSchemaCandidates(normalized)[0] || '';
                const name = this.normalizeText(normalized.canonical_name || normalized.name || '');
                const key = id > 0
                    ? `id:${id}`
                    : (schema ? `schema:${schema}` : `name:${name}:${this.normalizeText(normalized.type || '')}`);

                if (seen.has(key)) {
                    return;
                }

                seen.add(key);
                result.push(normalized);
            });

            return result;
        },

        prepareDynamicFeatures(features) {
            if (!Array.isArray(features)) {
                return [];
            }

            const seen = new Set();
            const result = [];

            features.forEach(group => {
                if (!group || typeof group !== 'object') {
                    return;
                }

                const id = Number(group.id || 0);
                const nameKey = this.normalizeText([group.canonical_name, group.name, group.label, group.key].filter(Boolean).join(' '));
                const signature = id > 0
                    ? `id:${id}`
                    : (nameKey ? `name:${nameKey}` : `idx:${result.length}`);

                if (seen.has(signature)) {
                    return;
                }

                seen.add(signature);

                const itemSeen = new Set();
                const items = Array.isArray(group.items)
                    ? group.items.filter(item => {
                        if (!item || typeof item !== 'object') return false;
                        const itemId = Number(item.id || 0);
                        const itemName = this.normalizeText(item.canonical_name || item.name || item.label || item.value || '');
                        const itemKey = itemId > 0 ? `id:${itemId}` : `name:${itemName}`;
                        if (itemSeen.has(itemKey)) return false;
                        itemSeen.add(itemKey);
                        return true;
                    }).map(item => {
                        const canonicalName = String(item.canonical_name || item.name || item.label || item.value || '').trim();
                        return {
                            ...item,
                            canonical_name: canonicalName,
                            name: this.uiText(item.name || canonicalName),
                        };
                    })
                    : [];

                const canonicalGroupName = String(group.canonical_name || group.name || group.label || group.key || '').trim();
                result.push({
                    ...group,
                    canonical_name: canonicalGroupName,
                    name: this.uiText(group.name || canonicalGroupName),
                    items,
                });
            });

            return result;
        },

        dynamicFieldUniqueKeys(field) {
            const keys = [];
            const id = Number(field?.id || 0);
            const meta = field?.meta || {};
            const schema = this.normalizeText(field?.schema_key || field?.key || meta.schema_key || meta.key || '');
            const name = this.normalizeText(field?.canonical_name || field?.name || field?.label || meta.name || meta.label || '');
            const type = this.normalizeText(field?.type || meta.type || meta.input || '');
            const unit = this.normalizeText(field?.unit || meta.unit || '');

            if (id > 0) keys.push(`id:${id}`);
            if (schema) keys.push(`schema:${schema}`);
            if (name) keys.push(`name:${name}:${type}:${unit}`);

            return keys.length ? keys : [`unknown:${JSON.stringify(field)}`];
        },

        filterItemSignature(item) {
            if (!item || typeof item !== 'object') {
                return '';
            }

            if (item.type === 'field' && item.field) {
                const keys = this.dynamicFieldUniqueKeys(item.field);
                return `field:${keys.find(key => key.startsWith('schema:')) || keys.find(key => key.startsWith('id:')) || keys[0]}`;
            }

            if (item.type === 'feature_group' && item.group) {
                const id = Number(item.group.id || 0);
                const name = this.normalizeText([item.group.canonical_name, item.group.name, item.label].filter(Boolean).join(' '));
                return id > 0 ? `feature:${id}` : `feature-name:${name}`;
            }

            if (item.type === 'parking_group') {
                return 'parking-group';
            }

            return `${item.type || 'item'}:${item.key || item.label || ''}`;
        },

        uniqueFilterItems(items) {
            if (!Array.isArray(items)) {
                return [];
            }

            const seen = new Set();
            return items.filter(item => {
                if (item && item.type === 'field' && item.field && !this.shouldRenderDynamicField(item.field)) {
                    return false;
                }

                const signature = this.filterItemSignature(item);
                if (!signature) return true;
                if (seen.has(signature)) return false;
                seen.add(signature);
                return true;
            });
        },

        filterItemStructuralText(item) {
            if (!item) return '';
            return this.normalizeText([
                item?.label,
                item?.field?.schema_key,
                item?.field?.key,
                item?.field?.canonical_name,
                item?.field?.name,
                item?.group?.schema_key,
                item?.group?.key,
                item?.group?.canonical_name,
                item?.group?.name,
            ].filter(Boolean).join(' '));
        },

        isViewFilterItem(item) {
            const values = [
                item?.label,
                item?.field?.schema_key,
                item?.field?.key,
                item?.field?.canonical_name,
                item?.field?.name,
                item?.group?.schema_key,
                item?.group?.key,
                item?.group?.canonical_name,
                item?.group?.name,
            ].filter(Boolean).map(value => this.normalizeText(value));
            const keys = ['manzara', 'manzara_tipi', 'manzara tipi', 'view_type', 'view type', 'scenic_view', 'scenic view'];
            return values.some(value => keys.map(key => this.normalizeText(key)).includes(value));
        },

        isFacadeFilterItem(item) {
            const values = [
                item?.label,
                item?.field?.schema_key,
                item?.field?.key,
                item?.field?.canonical_name,
                item?.field?.name,
                item?.group?.schema_key,
                item?.group?.key,
                item?.group?.canonical_name,
                item?.group?.name,
            ].filter(Boolean).map(value => this.normalizeText(value));
            const keys = ['cephe', 'cephe_durumu', 'cephe durumu', 'facade', 'frontage'];
            return values.some(value => keys.map(key => this.normalizeText(key)).includes(value));
        },

        isViewOrFacadeDefinition(definition) {
            const values = [definition?.label]
                .concat(Array.isArray(definition?.keys) ? definition.keys : [])
                .filter(Boolean)
                .map(value => this.normalizeText(value));
            const keys = [
                'manzara', 'manzara_tipi', 'manzara tipi',
                'cephe', 'cephe_durumu', 'cephe durumu',
                'facade', 'frontage'
            ].map(key => this.normalizeText(key));
            return values.some(value => keys.includes(value));
        },

        isViewOrFacadeFeatureGroup(group) {
            const values = [
                group?.schema_key,
                group?.key,
                group?.canonical_name,
                group?.name,
                group?.label,
            ].filter(Boolean).map(value => this.normalizeText(value));
            const keys = [
                'manzara', 'manzara_tipi', 'manzara tipi',
                'cephe', 'cephe_durumu', 'cephe durumu',
                'facade', 'frontage'
            ].map(key => this.normalizeText(key));
            return values.some(value => keys.includes(value));
        },

        isSunlightFilterItem(item) {
            const values = [
                item?.label,
                item?.field?.schema_key,
                item?.field?.key,
                item?.field?.canonical_name,
                item?.field?.name,
                item?.group?.schema_key,
                item?.group?.key,
                item?.group?.canonical_name,
                item?.group?.name,
            ].filter(Boolean).map(value => this.normalizeText(value));

            const keys = ['gunes_alma', 'güneş alma', 'gunes alma', 'sunlight', 'sun exposure']
                .map(key => this.normalizeText(key));

            return values.some(value => keys.includes(value));
        },

        orderViewSunlightFacade(items) {
            const ordered = Array.isArray(items) ? [...items] : [];
            const viewItem = ordered.find(item => this.isViewFilterItem(item));
            const sunlightItem = ordered.find(item => this.isSunlightFilterItem(item));
            const facadeItem = ordered.find(item => this.isFacadeFilterItem(item));

            if (!viewItem || !sunlightItem || !facadeItem) {
                return this.orderViewImmediatelyBeforeFacade(ordered);
            }

            const trio = new Set([viewItem, sunlightItem, facadeItem]);
            const remaining = ordered.filter(item => !trio.has(item));
            const originalPositions = [viewItem, sunlightItem, facadeItem]
                .map(item => ordered.indexOf(item))
                .filter(index => index >= 0);
            const insertAt = Math.min(...originalPositions);

            remaining.splice(insertAt, 0, viewItem, sunlightItem, facadeItem);
            return remaining;
        },

        orderViewImmediatelyBeforeFacade(items) {
            const ordered = Array.isArray(items) ? [...items] : [];
            const viewIndex = ordered.findIndex(item => this.isViewFilterItem(item));
            const facadeIndex = ordered.findIndex(item => this.isFacadeFilterItem(item));

            if (viewIndex < 0 || facadeIndex < 0 || viewIndex === facadeIndex - 1) {
                return ordered;
            }

            const [viewItem] = ordered.splice(viewIndex, 1);
            const nextFacadeIndex = ordered.findIndex(item => this.isFacadeFilterItem(item));
            ordered.splice(Math.max(0, nextFacadeIndex), 0, viewItem);
            return ordered;
        },

        moneyFieldHaystack(field) {
            const meta = field?.meta || {};

            return this.normalizeText([
                field?.name,
                field?.label,
                field?.placeholder,
                field?.unit,
                field?.type,
                meta.schema_key,
                meta.key,
                meta.name,
                meta.label,
                meta.placeholder,
                meta.unit,
                meta.type,
                meta.input,
            ].filter(Boolean).join(' '));
        },

        isMoneyField(field) {
            if (!field) return false;

            const type = this.normalizeText(field.type || field.meta?.type || field.meta?.input || '');
            const unit = this.normalizeText(field.unit || field.meta?.unit || '');
            const text = this.moneyFieldHaystack(field);
            const hasOptions = Array.isArray(field.options) && field.options.length > 0;

            if (['money', 'currency', 'price'].includes(type)) {
                return true;
            }

            if (['tl', 'try', 'turk_lirasi', 'turk_lirasi_tl'].some(token => unit.includes(token)) || String(field.unit || field.meta?.unit || '').includes('₺')) {
                return true;
            }

            // Select / checkbox alanları "Fiyat teklifi yapılabilir" gibi para dışı seçenekler olabilir.
            // Option içeren alanları sadece isimden para alanı saymıyoruz.
            if (hasOptions) {
                return false;
            }

            const moneyTokens = [
                'minimum_teklif_fiyati', 'minimum_teklif_fiyatı', 'minimum_teklif',
                'emlak_komisyonu_tutari', 'emlak_komisyonu_tutarı', 'emlak_komisyonu', 'komisyon_tutari', 'komisyon_tutarı',
                'kapora_depozito_tutari', 'kapora_depozito_tutarı', 'kapora_depozito', 'kapora',
                'depozito_tutari', 'depozito_tutarı', 'depozito',
                'aylik_aidat_gideri', 'aylık_aidat_gideri', 'aylik_aidat', 'aylık_aidat', 'aidat_gideri', 'aidat_tutari', 'aidat_tutarı', 'aidat',
                'fiyat', 'price', 'komisyon', 'bedel', 'ucret', 'ücret', 'kira', 'tutar', 'tutari', 'tutarı', 'gider'
            ];

            return moneyTokens.some(token => text.includes(this.normalizeText(token)));
        },

        normalizeMoneyInput(value) {
            return String(value || '').replace(/\D/g, '');
        },

        normalizeNumericInput(value) {
            const raw = String(value || '').trim();

            if (!raw) {
                return '';
            }

            const cleaned = raw.replace(/[^0-9.,]/g, '');
            const lastComma = cleaned.lastIndexOf(',');
            const lastDot = cleaned.lastIndexOf('.');

            if (lastComma !== -1 && lastDot !== -1) {
                const decimal = lastComma > lastDot ? ',' : '.';
                const thousand = decimal === ',' ? '.' : ',';
                return cleaned.split(thousand).join('').replace(decimal, '.');
            }

            if (lastComma !== -1) {
                const after = cleaned.length - lastComma - 1;
                return (after === 1 || after === 2)
                    ? cleaned.replace(/\./g, '').replace(',', '.')
                    : cleaned.replace(/,/g, '');
            }

            if (lastDot !== -1) {
                const after = cleaned.length - lastDot - 1;
                return (after === 1 || after === 2)
                    ? cleaned.replace(/,/g, '')
                    : cleaned.replace(/\./g, '');
            }

            return cleaned;
        },

        formatNumber(value) {
            const n = parseInt(value, 10);
            if (!Number.isFinite(n)) {
                return String(value || 0);
            }

            return new Intl.NumberFormat('tr-TR').format(n);
        },

        formatPrice(value) {
            const raw = String(value || '').replace(/\D/g, '');
            return raw ? raw.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
        },

        onPriceInput(field, event) {
            const raw = String(event.target.value || '').replace(/\D/g, '');
            this.form[field] = raw;
            event.target.value = this.formatPrice(raw);
        },

        rangeText(min, max, suffix, priceFormat) {
            const minText = priceFormat ? this.formatPrice(min) : this.clean(min);
            const maxText = priceFormat ? this.formatPrice(max) : this.clean(max);

            if (minText && maxText) return `${minText} - ${maxText} ${suffix}`;
            if (minText) return `${minText}+ ${suffix}`;
            if (maxText) return `0 - ${maxText} ${suffix}`;
            return '';
        },

        flattenChildren(children, parents = []) {
            const items = [];

            (children || []).forEach(child => {
                const branch = [...parents, child.name].filter(Boolean);

                items.push({
                    id: child.id,
                    name: child.name,
                    path_label: child.path_label || branch.join(' > '),
                    parent_id: child.parent_id,
                    children: child.children || [],
                });

                if (Array.isArray(child.children) && child.children.length > 0) {
                    items.push(...this.flattenChildren(child.children, branch));
                }
            });

            return items;
        },

        allCategoryOptions() {
            const result = [];

            this.mainCategories.forEach(main => {
                result.push({ ...main, path_label: main.name });

                if (Array.isArray(main.children) && main.children.length > 0) {
                    result.push(...this.flattenChildren(main.children, [main.name]));
                }
            });

            return result;
        },

        findMainCategoryId(categoryId) {
            const needle = this.normalizeId(categoryId);
            if (!needle) return '';

            for (const main of this.mainCategories) {
                if (String(main.id) === needle) {
                    return needle;
                }

                const descendants = this.flattenChildren(main.children || [], [main.name]);
                if (descendants.some(item => String(item.id) === needle)) {
                    return String(main.id);
                }
            }

            return '';
        },

        categoryLabel(categoryId) {
            const id = this.normalizeId(categoryId);
            if (!id) return 'Tümü';

            const item = this.allCategoryOptions().find(cat => String(cat.id) === id);
            return item?.path_label || item?.name || `Kategori #${id}`;
        },

        isBooleanField(field) {
            const type = String(field?.type || '').toLowerCase();
            if (type === 'switch') return true;

            // 2 seçenekli select/radio alanlar da boolean olarak render edilir
            const options = field?.options;
            if (!Array.isArray(options) || options.length !== 2) return false;

            const names = options.map(o => this.normalizeText([o.canonical_name, o.schema_value, o.name, o.value].filter(Boolean).join(' ')));
            const boolPairs = [
                ['evet', 'hayir'], ['var', 'yok'],
                ['acik', 'kapali'], ['dahil', 'haric'],
                ['yes', 'no'], ['true', 'false'],
                ['mevcut', 'mevcut degil'],
            ];

            return boolPairs.some(([a, b]) =>
                (names[0].includes(a) && names[1].includes(b)) ||
                (names[0].includes(b) && names[1].includes(a))
            );
        },

        /**
         * Boolean alan için { yesVal, noVal } döndürür.
         * Switch tipinde '1'/'0', 2-option select'te option id'leri kullanılır.
         */
        booleanFieldValues(field) {
            const type = String(field?.type || '').toLowerCase();
            if (type === 'switch') return { yesVal: '1', noVal: '0' };

            const options = field?.options || [];
            if (options.length !== 2) return { yesVal: '1', noVal: '0' };

            const names = options.map(o => this.normalizeText([o.canonical_name, o.schema_value, o.name, o.value].filter(Boolean).join(' ')));
            const positiveWords = ['evet', 'var', 'acik', 'dahil', 'yes', 'true', 'mevcut'];

            // Hangisi pozitif (evet) taraf?
            if (positiveWords.some(w => names[0].includes(w))) {
                return { yesVal: String(options[0].id), noVal: String(options[1].id) };
            }
            return { yesVal: String(options[1].id), noVal: String(options[0].id) };
        },

        isCurrentFloorField(field) {
            if (!field) return false;

            const key = this.fieldSchemaKey(field);
            const name = this.normalizeText([field?.canonical_name, field?.name].filter(Boolean).join(' '));
            const aliases = ['bulundugu_kat', 'bulunduğu kat', 'bulundugu kat'];

            return aliases.some(alias => {
                const normalized = this.normalizeText(alias);
                return key.includes(normalized) || name.includes(normalized);
            });
        },

        parseCurrentFloorValue(value) {
            if (value === null || value === undefined || String(value).trim() === '') return null;
            const match = String(value).trim().match(/-?\d+/);
            if (!match) return null;
            const parsed = parseInt(match[0], 10);
            return Number.isFinite(parsed) ? parsed : null;
        },

        currentFloorValue(field) {
            if (!field) return '';
            const parsed = this.parseCurrentFloorValue(this.getNumericRangeVal(field, 'min'));
            return parsed === null ? '' : String(parsed);
        },

        currentFloorLabel(value) {
            const parsed = this.parseCurrentFloorValue(value);
            if (parsed === null) return '';
            if (parsed === 0) return '0 (Zemin Kat)';
            if (parsed < 0) return `${parsed} (Bodrum ${Math.abs(parsed)})`;
            return String(parsed);
        },

        currentFloorDisplay(field) {
            return this.currentFloorLabel(this.currentFloorValue(field));
        },

        setCurrentFloorValue(field, rawValue) {
            if (!field) return;

            const raw = rawValue === null || rawValue === undefined ? '' : String(rawValue).trim();
            if (raw === '') {
                this.setNumericRangeVal(field, 'min', '');
                this.setNumericRangeVal(field, 'max', '');
                return;
            }

            const parsed = this.parseCurrentFloorValue(raw);
            if (parsed === null) {
                this.setNumericRangeVal(field, 'min', '');
                this.setNumericRangeVal(field, 'max', '');
                return;
            }

            const fieldMin = Number(field?.meta?.min ?? -10);
            const fieldMax = Number(field?.meta?.max ?? 999);
            const safeValue = String(Math.min(
                Number.isFinite(fieldMax) ? fieldMax : 999,
                Math.max(Number.isFinite(fieldMin) ? fieldMin : -10, parsed)
            ));

            this.setNumericRangeVal(field, 'min', safeValue);

            if (this.isPdfCommercialCurrentFloorMinOnly(field)) {
                // PDF Ticari > Mağaza/Ofis/Kafe: Satılık/Kiralık ortak, yalnızca "En az".
                this.setNumericRangeVal(field, 'max', '');
            } else {
                // Diğer mevcut ekranlarda Bulunduğu Kat tek değer davranışı korunur.
                this.setNumericRangeVal(field, 'max', safeValue);
            }
        },

        onCurrentFloorInput(field, event) {
            const rawValue = event?.target?.value ?? '';
            this.setCurrentFloorValue(field, rawValue);
        },

        stepCurrentFloor(field, direction = 1) {
            if (!field) return;

            const currentRaw = this.currentFloorValue(field);
            if (currentRaw === '') {
                this.setCurrentFloorValue(field, direction > 0 ? '0' : '-1');
                return;
            }

            const current = parseInt(currentRaw, 10);
            const fieldMin = Number(field?.meta?.min ?? -10);
            const fieldMax = Number(field?.meta?.max ?? 999);
            const min = Number.isFinite(fieldMin) ? fieldMin : -10;
            const max = Number.isFinite(fieldMax) ? fieldMax : 999;
            const next = Math.min(max, Math.max(min, (Number.isFinite(current) ? current : 0) + (direction > 0 ? 1 : -1)));
            this.setCurrentFloorValue(field, String(next));
        },

        isNumericField(field) {
            const type = String(field?.type || '').toLowerCase();
            const unit = String(field?.unit || field?.meta?.unit || '').toLowerCase();
            const key = this.fieldSchemaKey(field);

            // TL / fiyat / komisyon / kapora / depozito / aidat gibi para alanları da numeriktir.
            if (this.isMoneyField(field)) return true;

            // Tipi 'number' veya 'text' olan ve birimi m², adet, yıl gibi sayısal olanlar
            if (['number'].includes(type)) return true;
            if (unit && ['m²', 'm2', 'adet', 'yıl', 'kat', 'tl', 'try', '₺'].some(u => unit.includes(u))) return true;

            // Bilinen sayısal schema_key'ler
            const numericKeys = [
                'm2_brut', 'm2_net', 'arsa_m2', 'proje_arsa_m2', 'kapali_alan_m2',
                'kat_sayisi', 'bulundugu_kat', 'yapim_yili', 'renovasyon_yili', 'yenileme_yili', 'yenilenme_yili', 'tadilat_yili', 'bina_yasi',
                'banyo_sayisi', 'yatak_odasi_sayisi', 'salon_sayisi',
                'oda_sayisi', 'wc_sayisi', 'balkon_sayisi',
                'minimum_teklif_fiyati', 'minimum_teklif_fiyatı', 'emlak_komisyonu_tutari',
                'emlak_komisyonu_tutarı', 'kapora_depozito_tutari', 'kapora_depozito_tutarı',
                'depozito_tutari', 'depozito_tutarı', 'aylik_aidat_gideri', 'aylık_aidat_gideri',
                'aidat_gideri', 'aidat_tutari', 'aidat_tutarı'
            ];
            return numericKeys.some(nk => key.includes(nk));
        },

        numericPresets(field) {
            const unit = String(field?.unit || field?.meta?.unit || '').toLowerCase();
            const key = this.fieldSchemaKey(field);

            // TL para alanları
            if (this.isMoneyField(field)) {
                return [1000, 2500, 5000, 10000, 15000, 25000, 50000, 75000, 100000, 150000, 250000, 500000, 750000, 1000000];
            }

            // ARSA.pdf s.2: Satılık/Kiralık Arsa/Arazi metrekare seçimleri 90.000 m²'ye kadar.
            if (this.isLandFilterMode && ['arsa_m2', 'arazi_m2', 'arsa_arazi_m2'].includes(key)) {
                return [100, 200, 500, 1000, 2000, 3000, 5000, 7500, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000];
            }

            // m² alanları
            if (unit.includes('m') || ['m2_brut', 'm2_net', 'arsa_m2', 'proje_arsa_m2', 'kapali_alan_m2'].some(k => key.includes(k))) {
                return [30, 50, 75, 100, 120, 150, 200, 250, 300, 400, 500, 750, 1000, 2000, 5000, 10000];
            }

            // Yapım / yenileme yılı alanları gerçek yıl listesiyle çalışır.
            if (this.isDynamicConstructionYearField(field) || this.isDynamicRenovationYearField(field) || key.includes('bina_yasi')) {
                return this.isDynamicRenovationYearField(field) ? this.dynamicRenovationYearOptions() : this.dynamicYearOptions();
            }

            // Bulunduğu kat: zemin kat 0 olarak başlar.
            if (this.isCurrentFloorField(field)) {
                return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30, 40, 50];
            }

            // Kat sayısı
            if (['kat_sayisi'].some(k => key.includes(k))) {
                return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30, 40, 50];
            }

            // Oda / banyo / salon / wc / balkon sayısı
            if (['yatak_odasi', 'salon_sayisi', 'oda_sayisi', 'banyo_sayisi', 'wc_sayisi', 'balkon_sayisi'].some(k => key.includes(k))) {
                return [1, 2, 3, 4, 5, 6, 7, 8, 10];
            }

            // Genel sayısal fallback
            return [1, 2, 3, 5, 10, 15, 20, 25, 50, 100, 250, 500];
        },

        filteredNumericMaxPresets(field) {
            const minVal = parseFloat(this.normalizeNumericInput(this.getNumericRangeVal(field, 'min')));
            const presets = this.numericPresets(field);
            if (isNaN(minVal) || minVal <= 0) return presets;
            return presets.filter(p => p >= minVal);
        },

        isAnyRoomRelatedField(field) {
            if (!field) return false;

            const text = this.normalizeText([
                field?.name,
                field?.label,
                field?.placeholder,
                field?.meta?.schema_key,
                field?.meta?.input,
                field?.meta?.section,
            ].filter(Boolean).join(' '));

            return [
                'oda_sayisi', 'oda sayisi', 'oda sayısı', 'oda_salon', 'room_count', 'room count',
                'yatak_odasi_sayisi', 'yatak odasi', 'yatak odası', 'bedroom',
                'salon_sayisi', 'salon sayisi', 'salon sayısı', 'living room',
            ].some(key => text.includes(this.normalizeText(key)));
        },

        getNumericRangeVal(field, side) {
            const data = this.form.fields[String(field.id)];
            if (data && typeof data === 'object' && !Array.isArray(data)) {
                const value = data[side] || '';
                return this.isMoneyField(field) ? this.formatPrice(value) : value;
            }
            return '';
        },

        setNumericRangeVal(field, side, rawValue) {
            const cleanValue = this.isMoneyField(field)
                ? this.normalizeMoneyInput(rawValue)
                : (this.isCurrentFloorField(field)
                    ? String(rawValue).replace(/[^0-9-]/g, '').replace(/(?!^)-/g, '')
                    : String(rawValue).replace(/[^0-9.,]/g, ''));
            const fieldId = String(field.id);
            let current = this.form.fields[fieldId];

            // Eğer henüz range object değilse oluştur
            if (!current || typeof current !== 'object' || Array.isArray(current)) {
                current = { min: '', max: '' };
            }

            current[side] = cleanValue;

            // Min > Max ise oda alanlarında max'ı min'e sabitle, diğer numeric alanlarda max'ı temizle.
            // Böylece kullanıcı "en çok" değerini yanlışlıkla daha küçük seçmeye çalıştığında alan boş kalmaz.
            if (current.min && current.max) {
                const minNum = parseFloat(this.normalizeNumericInput(current.min));
                const maxNum = parseFloat(this.normalizeNumericInput(current.max));
                if (!isNaN(minNum) && !isNaN(maxNum) && maxNum < minNum) {
                    current.max = this.isAnyRoomRelatedField(field) ? current.min : '';
                }
            }

            this.form.fields[fieldId] = { ...current };

            if (this.isDynamicConstructionYearField(field) || this.isDynamicRenovationYearField(field)) {
                this.syncDynamicConditionalYearFields();
            }

            if (this.isAnyRoomRelatedField(field)) {
                this.enforceAllRoomPresetRanges();
            }
        },

        onNumericRangeInput(field, side, event) {
            const rawValue = event?.target?.value ?? '';
            this.setNumericRangeVal(field, side, rawValue);

            if (field && this.isMoneyField(field) && event?.target) {
                event.target.value = this.formatPrice(this.normalizeMoneyInput(rawValue));
            }
        },

        numericPresetLabel(field, preset) {
            if (this.isMoneyField(field)) {
                return `${this.formatPrice(preset)} TL`;
            }

            if (this.isCurrentFloorField(field)) {
                return this.currentFloorLabel(preset);
            }

            return `${preset}${field?.unit ? ' ' + field.unit : ''}`;
        },

        isSelectField(field) {
            // Boolean alanlar (switch + 2 seçenekli evet/hayır) ayrı toggle olarak gösterilir
            if (this.isBooleanField(field)) return false;
            // Sayısal alanlar da ayrı combobox olarak gösterilir
            const type = String(field?.type || '').toLowerCase();
            if (this.isNumericField(field)) return false;
            return ['select', 'radio'].includes(type) || (Array.isArray(field?.options) && field.options.length > 0);
        },

        isMultiField(field) {
            if (this.isDynamicPropertyStatusField(field)) return false;

            const type = String(field?.type || '').toLowerCase();
            const metaInput = String(field?.meta?.input || '').toLowerCase();
            const key = this.fieldSchemaKey(field);
            const multiKeys = ['mulk_sekli', 'kullanim_amaci', 'tapu_durumu', 'bahce_tipi', 'mutfak_tipi', 'tasinmaz_durumu', 'esya_durumu', 'iskan_durumu'];

            if (this.isProjectPdfMultipleChoiceField(field)) return true;

            return ['checkbox_group', 'multiselect'].includes(type)
                || ['checkbox_group', 'multiselect'].includes(metaInput)
                || multiKeys.some(item => key.includes(item));
        },

        fieldValueLabel(field, value) {
            const opt = (field.options || []).find(item => String(item.id) === String(value));
            return opt?.name || value;
        },

        featureValueLabel(valueId) {
            for (const group of this.dynamicFeatures) {
                const item = (group.items || []).find(row => Number(row.id) === Number(valueId));
                if (item) {
                    return item.name;
                }
            }

            return this.uiText('Özellik #:id', { id: valueId });
        },

        fillFormFromRequest() {
            const r = this.requestParams || {};
            const urlParams = new URLSearchParams(window.location.search || '');
            const qp = (key) => this.clean(urlParams.get(key) || '');
            const rv = (...keys) => {
                for (const key of keys) {
                    if (r[key] !== undefined && r[key] !== null && String(r[key]).trim() !== '') {
                        return r[key];
                    }

                    const queryValue = qp(key);
                    if (queryValue) {
                        return queryValue;
                    }
                }

                return '';
            };

            const requestCategoryId = this.normalizeId(rv('category_id'));

            this.form = this.emptyForm();
            this.form.transaction_type = this.context === 'agency'
                ? (['1', '2'].includes(String(rv('transaction_type'))) ? String(rv('transaction_type')) : '')
                : (this.clean(rv('transaction_type') || document.getElementById('hsTransactionType')?.value || DEFAULT_TRANSACTION_TYPE) || DEFAULT_TRANSACTION_TYPE);

            this.form.main_category_id = this.normalizeId(
                rv('main_category_id') ||
                this.selectedMainCategoryId ||
                this.findMainCategoryId(requestCategoryId)
            );

            this.form.subcategory_id = this.normalizeId(rv('subcategory_id', 'sub_category_id') || this.selectedSubCategoryId || '');

            if (!this.form.subcategory_id && requestCategoryId && this.form.main_category_id && requestCategoryId !== this.form.main_category_id) {
                this.form.subcategory_id = requestCategoryId;
            }

            this.form.min_price = this.clean(rv('min_price', 'price_min') || '');
            this.form.max_price = this.clean(rv('max_price', 'price_max') || '');


            const ownerTypes = Array.isArray(r.owner_types)
                ? r.owner_types
                : (r.owner_types ? [r.owner_types] : []);

            this.form.owner_types = ownerTypes.map(value => String(value)).filter(Boolean);

            this.form.country_id = this.normalizeId(rv('country_id') || '');
            this.form.city_id = this.normalizeId(rv('city_id') || '');
            this.form.district_id = this.normalizeId(rv('district_id') || '');
            this.form.quarter_id = this.normalizeId(rv('quarter_id', 'neighborhood_id') || '');
            this.form.location_label = this.clean(rv('location_label') || document.getElementById('acLocationLabel')?.value || '');
            this.form.q = this.clean(rv('q', 'keyword') || document.getElementById('qHidden')?.value || document.getElementById('hsQ')?.value || '');
            this.form.has_virtual_tour = r.has_virtual_tour ? 1 : 0;

            const featureIds = Array.isArray(r.feature_value_ids)
                ? r.feature_value_ids
                : (r.feature_value_ids ? [r.feature_value_ids] : []);

            this.form.feature_value_ids = featureIds
                .map(id => parseInt(id, 10))
                .filter(id => Number.isFinite(id));

            const rawFields = r.fields && typeof r.fields === 'object' ? r.fields : {};
            Object.keys(rawFields).forEach(fieldId => {
                const rawField = rawFields[fieldId];

                const fieldKey = String(fieldId);

                if (rawField && typeof rawField === 'object' && rawField.options !== undefined) {
                    this.form.fields[fieldKey] = Array.isArray(rawField.options) ? rawField.options.map(String) : [String(rawField.options)];
                    this.fieldFilterModes[fieldKey] = 'options';
                } else if (rawField && typeof rawField === 'object' && rawField.option !== undefined) {
                    this.form.fields[fieldKey] = rawField.option ?? '';
                    if (this.form.fields[fieldKey] !== '') this.fieldFilterModes[fieldKey] = 'option';
                } else if (rawField && typeof rawField === 'object' && rawField.values !== undefined) {
                    this.form.fields[fieldKey] = Array.isArray(rawField.values) ? rawField.values.map(String) : [String(rawField.values)];
                    this.fieldFilterModes[fieldKey] = 'values';
                } else if (rawField && typeof rawField === 'object' && (rawField.min !== undefined || rawField.max !== undefined)) {
                    // Numeric range object
                    this.form.fields[fieldKey] = {
                        min: rawField.min !== undefined && rawField.min !== null && String(rawField.min).trim() !== '' ? String(rawField.min) : '',
                        max: rawField.max !== undefined && rawField.max !== null && String(rawField.max).trim() !== '' ? String(rawField.max) : '',
                    };
                    this.fieldFilterModes[fieldKey] = 'range';
                } else if (rawField && typeof rawField === 'object' && rawField.value !== undefined) {
                    this.form.fields[fieldKey] = rawField.value ?? '';
                    this.fieldFilterModes[fieldKey] = 'value';
                } else if (Array.isArray(rawField)) {
                    this.form.fields[fieldKey] = rawField.map(String);
                    this.fieldFilterModes[fieldKey] = 'values';
                } else if (rawField !== null && rawField !== undefined) {
                    this.form.fields[fieldKey] = rawField;
                }
            });

            const projectUnitRooms = r.project_unit_plans || r.project_unit_rooms || r.project_units || {};
            const projectUnitValue = (key) => {
                if (projectUnitRooms && typeof projectUnitRooms === 'object') {
                    if (projectUnitRooms[key] !== undefined) {
                        return String(projectUnitRooms[key] || '').replace(/\D/g, '');
                    }

                    const parts = String(key).split('_');
                    const side = parts.pop();
                    const baseKey = parts.join('_');

                    if (projectUnitRooms[baseKey] && typeof projectUnitRooms[baseKey] === 'object' && projectUnitRooms[baseKey][side] !== undefined) {
                        return String(projectUnitRooms[baseKey][side] || '').replace(/\D/g, '');
                    }
                }

                const alias = r[`unit_${key}`] ?? r[`project_unit_${key}`] ?? r[`project_unit_plan_${key}`];
                return alias !== undefined ? String(alias || '').replace(/\D/g, '') : '';
            };

            this.form.project_unit_rooms = {
                bedrooms: {
                    min: projectUnitValue('bedrooms_min'),
                    max: projectUnitValue('bedrooms_max'),
                },
                living_rooms: {
                    min: projectUnitValue('living_rooms_min'),
                    max: projectUnitValue('living_rooms_max'),
                },
            };

            this.locationSearch = this.form.location_label;
            this.sanitizeCategoryForCurrentTransaction(false);
        },

        readFirstDomValue(selectors = []) {
            for (const selector of selectors) {
                const nodes = Array.from(document.querySelectorAll(selector));

                for (const node of nodes) {
                    if (!node) continue;

                    if ((node.type === 'radio' || node.type === 'checkbox') && !node.checked) {
                        continue;
                    }

                    const value = this.clean(
                        node.value !== undefined
                            ? node.value
                            : (
                                node.getAttribute('data-location-label') ||
                                node.getAttribute('content') ||
                                node.getAttribute('data-value') ||
                                node.textContent ||
                                ''
                            )
                    );

                    if (value) {
                        return value;
                    }
                }
            }

            return '';
        },

        currentQueryValue(...keys) {
            const params = new URLSearchParams(window.location.search || '');

            for (const key of keys) {
                const value = this.clean(params.get(key) || '');
                if (value) return value;
            }

            return '';
        },

        externalSearchLocationState() {
            const byName = (name) => [
                `:is(#listFilterForm, #agencyFilterForm) [name="${name}"]`,
                `#headerSearchForm [name="${name}"]`,
                `#otherHeaderSearchForm [name="${name}"]`,
                `.other-header form [name="${name}"]`,
                `.header-search form [name="${name}"]`,
                `header form [name="${name}"]`,
                `[name="${name}"]`,
            ];

            const byIds = (...ids) => ids.map(id => `#${id}`);

            return {
                country_id: this.normalizeId(
                    this.readFirstDomValue(byIds('acCountryId', 'headerCountryId', 'headerAcCountryId', 'otherHeaderCountryId').concat(byName('country_id'))) ||
                    this.currentQueryValue('country_id')
                ),
                city_id: this.normalizeId(
                    this.readFirstDomValue(byIds('acCityId', 'headerCityId', 'headerAcCityId', 'otherHeaderCityId').concat(byName('city_id'))) ||
                    this.currentQueryValue('city_id')
                ),
                district_id: this.normalizeId(
                    this.readFirstDomValue(byIds('acDistrictId', 'headerDistrictId', 'headerAcDistrictId', 'otherHeaderDistrictId').concat(byName('district_id'))) ||
                    this.currentQueryValue('district_id')
                ),
                quarter_id: this.normalizeId(
                    this.readFirstDomValue(byIds('acQuarterId', 'headerQuarterId', 'headerNeighborhoodId', 'headerAcQuarterId', 'otherHeaderQuarterId').concat(byName('quarter_id'), byName('neighborhood_id'))) ||
                    this.currentQueryValue('quarter_id', 'neighborhood_id')
                ),
                location_label: this.clean(
                    this.readFirstDomValue(byIds('acLocationLabel', 'headerLocationLabel', 'otherHeaderLocationLabel').concat(
                        byName('location_label'),
                        ['#hsLocationTag span', '.header-location-tag span', '.other-header-location-tag span', '[data-location-label]']
                    )) ||
                    this.currentQueryValue('location_label')
                ),
                q: this.clean(
                    this.readFirstDomValue(byIds('qHidden', 'hsQ', 'headerSearchQ', 'otherHeaderSearchQ').concat(byName('q'), byName('keyword'))) ||
                    this.currentQueryValue('q', 'keyword')
                ),
            };
        },

        applyExternalLocationStateToForm() {
            const state = this.externalSearchLocationState();

            if (state.country_id) this.form.country_id = state.country_id;
            if (state.city_id) this.form.city_id = state.city_id;
            if (state.district_id) this.form.district_id = state.district_id;
            if (state.quarter_id) this.form.quarter_id = state.quarter_id;

            if (state.location_label) {
                this.form.location_label = state.location_label;
                this.locationSearch = state.location_label;
            } else if (state.q && !this.form.location_label && !this.locationSearch) {
                this.locationSearch = state.q;
            }

            if (state.location_label || state.city_id || state.district_id || state.quarter_id) {
                this.form.q = '';
            } else if (state.q && !this.form.q) {
                this.form.q = state.q;
            }

            return state;
        },

        listFormValue(name) {
            const form = (document.getElementById('listFilterForm') || document.getElementById('agencyFilterForm'));
            if (!form) return '';

            const field = form.elements[name];
            if (!field) return '';

            if ((typeof RadioNodeList !== 'undefined' && field instanceof RadioNodeList) || (typeof field.length === 'number' && !field.tagName)) {
                const checked = Array.from(field).find(item => item.checked);
                return checked ? checked.value : '';
            }

            return field.value || '';
        },

        syncFromListForm(options = {}) {
            const form = (document.getElementById('listFilterForm') || document.getElementById('agencyFilterForm'));
            if (!form) return;

            // Popup açıkken kullanıcı seçim yapıyorsa liste üst barındaki eski radio/input
            // değerleri Vue state'ini geri sarmamalı. DOM sadece ilk açılışta veya
            // dışarıdan özellikle force edilirse kaynak kabul edilir.
            if (this.isOpen && !options.force) {
                return;
            }

            const tx = form.querySelector('input[name="transaction_type"]:checked')?.value ?? this.listFormValue('transaction_type');
            if (tx === '1' || tx === '2' || (this.context === 'agency' && tx === '')) {
                this.form.transaction_type = String(tx);
            }

            const categoryId = this.normalizeId(form.querySelector('input[name="category_id"]:checked')?.value || this.listFormValue('category_id'));
            if (categoryId) {
                const mainId = this.findMainCategoryId(categoryId) || categoryId;
                this.form.main_category_id = mainId;
                this.form.subcategory_id = mainId && String(mainId) !== String(categoryId) ? categoryId : '';
            } else if (form.querySelector('input[name="category_id"]:checked')) {
                this.form.main_category_id = '';
                this.form.subcategory_id = '';
            }

            this.form.min_price = this.clean(this.listFormValue('min_price') || this.listFormValue('price_min') || this.form.min_price || '');
            this.form.max_price = this.clean(this.listFormValue('max_price') || this.listFormValue('price_max') || this.form.max_price || '');


            ['country_id', 'city_id', 'district_id', 'quarter_id'].forEach(key => {
                const value = this.normalizeId(this.listFormValue(key));
                if (value) {
                    this.form[key] = value;
                }
            });

            const listLocationLabel = this.clean(this.listFormValue('location_label'));
            if (listLocationLabel) {
                this.form.location_label = listLocationLabel;
                this.locationSearch = listLocationLabel;
            }
        },

        syncFromDom(options = {}) {
            this.isDomSyncing = true;

            try {
                this.syncFromListForm(options);

                const mainId = this.normalizeId(document.getElementById('mainCategoryIdHidden')?.value || '');
                const subId = this.normalizeId(document.getElementById('subCategoryIdHidden')?.value || '');
                const effectiveId = this.normalizeId(document.getElementById('categoryIdHidden')?.value || '');

                if (mainId) {
                    this.form.main_category_id = mainId;
                    this.form.subcategory_id = subId;
                } else if (effectiveId) {
                    const inferredMain = this.findMainCategoryId(effectiveId);
                    this.form.main_category_id = inferredMain;
                    this.form.subcategory_id = inferredMain && inferredMain !== effectiveId ? effectiveId : '';
                }

                const hsTransactionType = document.getElementById('hsTransactionType')?.value;
                if (hsTransactionType === '1' || hsTransactionType === '2') {
                    this.form.transaction_type = String(hsTransactionType);
                }

                const heroCountryId = this.normalizeId(document.getElementById('acCountryId')?.value || '');
                const heroCityId = this.normalizeId(document.getElementById('acCityId')?.value || '');
                const heroDistrictId = this.normalizeId(document.getElementById('acDistrictId')?.value || '');
                const heroQuarterId = this.normalizeId(document.getElementById('acQuarterId')?.value || '');

                if (heroCountryId) {
                    this.form.country_id = heroCountryId;
                }

                if (heroCityId) {
                    this.form.city_id = heroCityId;
                }

                if (heroDistrictId) {
                    this.form.district_id = heroDistrictId;
                }

                if (heroQuarterId) {
                    this.form.quarter_id = heroQuarterId;
                }

                const hiddenLocationLabel = this.clean(document.getElementById('acLocationLabel')?.value || '');
                const tagLocationLabel = this.clean(document.querySelector('#hsLocationTag span')?.textContent || '');

                if (tagLocationLabel || hiddenLocationLabel) {
                    this.form.location_label = tagLocationLabel || hiddenLocationLabel;
                    this.locationSearch = this.form.location_label;
                }

                this.applyExternalLocationStateToForm();

                const qValue = this.clean(
                    document.getElementById('qHidden')?.value ||
                    document.getElementById('hsQ')?.value ||
                    ''
                );

                if (qValue && !this.locationLabel()) {
                    this.form.q = qValue;
                } else if (this.locationLabel()) {
                    this.form.q = '';
                }
            } finally {
                this.isDomSyncing = false;
            }
        },

        syncHeroLocationView() {
            const label = this.locationLabel();
            const tag = document.getElementById('hsLocationTag');
            const wrap = document.getElementById('heroSearchInputWrap');
            const input = document.getElementById('hsQ');

            if (tag) {
                tag.innerHTML = '';

                if (label) {
                    const span = document.createElement('span');
                    span.textContent = label;
                    tag.appendChild(span);

                    const clearButton = document.createElement('button');
                    clearButton.type = 'button';
                    clearButton.setAttribute('aria-label', 'Bölgeyi temizle');
                    clearButton.innerHTML = '<i class="ph-light ph-x"></i>';
                    clearButton.addEventListener('click', (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        this.clearLocationState(false);
                        this.syncDomState();
                    });
                    tag.appendChild(clearButton);
                    tag.style.display = 'inline-flex';
                } else {
                    tag.style.display = 'none';
                }
            }

            if (wrap) {
                wrap.classList.toggle('has-tag', !!label);
            }

            if (input && !input.hasAttribute('name')) {
                if (label) {
                    input.value = '';
                }

                input.style.paddingLeft = '';
            }

            window.dispatchEvent(new CustomEvent('home-search-location-synced', {
                detail: {
                    country_id: this.form.country_id || '',
                    city_id: this.form.city_id || '',
                    district_id: this.form.district_id || '',
                    quarter_id: this.form.quarter_id || '',
                    location_label: label || '',
                    has_location: this.hasSearchLocation(),
                }
            }));
        },

        syncDomState() {
            const mainHidden = document.getElementById('mainCategoryIdHidden');
            const subHidden = document.getElementById('subCategoryIdHidden');
            const effectiveHidden = document.getElementById('categoryIdHidden');
            const heroLabel = document.getElementById('hsCategoryLabel');
            const listCatLabel = document.getElementById('cat-label');
            const countEl = document.getElementById('all-filter-count') || document.getElementById('agency-all-filter-count');
            const ttHidden = document.getElementById('hsTransactionType');
            const ttLabel = document.getElementById('tt-label');
            const sfTtLabel = document.getElementById('sf-tt-label');
            const locationLabelInput = document.getElementById('acLocationLabel');

            const mainId = this.normalizeId(this.form.main_category_id);
            const subId = this.normalizeId(this.form.subcategory_id);
            const effectiveId = this.effectiveCategoryId;

            if (mainHidden) mainHidden.value = mainId;
            if (subHidden) subHidden.value = subId;
            if (effectiveHidden) {
                effectiveHidden.value = effectiveId;
                effectiveHidden.disabled = !effectiveId;
            }

            if (ttHidden) {
                ttHidden.value = this.form.transaction_type || '';
                ttHidden.disabled = !this.form.transaction_type;
            }

            const mainLabel = this.selectedMainNode?.name || this.uiText('Tümü');
            const effectiveLabel = effectiveId ? this.categoryLabel(effectiveId) : this.uiText('Tümü');

            if (heroLabel) heroLabel.textContent = mainLabel;
            if (listCatLabel) listCatLabel.textContent = effectiveLabel;

            const ttText = this.transactionTypeLabel(this.form.transaction_type);
            if (ttLabel) ttLabel.textContent = ttText;
            if (sfTtLabel) sfTtLabel.textContent = ttText;

            document.querySelectorAll('#all-filter-count, #agency-all-filter-count').forEach((el) => {
                el.textContent = String(this.activeFilterCount);
                el.dataset.count = String(this.activeFilterCount);
                el.setAttribute('aria-label', this.uiText(':count aktif filtre', { count: this.activeFilterCount }));
            });

            if (locationLabelInput) {
                locationLabelInput.value = this.locationLabel();
                locationLabelInput.disabled = !locationLabelInput.value;
            }
            const syncHidden = (id, value) => {
                const el = document.getElementById(id);
                if (!el) return;

                const cleanValue = this.clean(value);
                el.value = cleanValue;
                el.disabled = cleanValue === '';
            };

            syncHidden('acCountryId', this.form.country_id);
            syncHidden('acCityId', this.form.city_id);
            syncHidden('acDistrictId', this.form.district_id);
            syncHidden('acQuarterId', this.form.quarter_id);
            document.querySelectorAll('.hero-search-category-list input[name="hero_main_category"]').forEach(input => {
                input.checked = String(input.value || '') === String(mainId || '');
            });

            this.syncHeroLocationView();

            this.syncListFormState({
                transaction_type: this.form.transaction_type,
                category_id: effectiveId,
                min_price: this.form.min_price,
                max_price: this.form.max_price,

                country_id: this.form.country_id,
                city_id: this.form.city_id,
                district_id: this.form.district_id,
                quarter_id: this.form.quarter_id,
                location_label: this.locationLabel(),
            });
        },

        syncListFormState(values = {}) {
            const form = (document.getElementById('listFilterForm') || document.getElementById('agencyFilterForm'));
            if (!form) return;

            const setInputValue = (name, value) => {
                const cleanValue = this.clean(value);
                const fields = Array.from(form.querySelectorAll(`[name="${name}"]`));
                if (!fields.length) return;

                const hasRadio = fields.some(field => field.type === 'radio');

                if (hasRadio) {
                    let matched = false;
                    fields.forEach(field => {
                        const isMatch = String(field.value || '') === String(cleanValue || '');
                        field.checked = isMatch;
                        if (isMatch) matched = true;
                    });

                    if (!matched && cleanValue === '') {
                        const emptyRadio = fields.find(field => String(field.value || '') === '');
                        if (emptyRadio) emptyRadio.checked = true;
                    }

                    return;
                }

                fields.forEach(field => {
                    field.value = cleanValue;
                });
            };

            Object.entries(values).forEach(([name, value]) => setInputValue(name, value));
        },

        onMainCategoryChange() {
            this.form.subcategory_id = '';
            this.resetDynamicState();
            this.syncDomState();
            this.refreshMetadataForCurrentSelection(true);
        },

        onSubCategoryChange() {
            this.resetDynamicState();
            this.syncDomState();
            this.refreshMetadataForCurrentSelection(true);
        },

        resetDynamicState() {
            this.dynamicFields = [];
            this.dynamicFeatures = [];
            this.metadataCategory = null;
            this.form.fields = {};
            this.fieldFilterModes = {};
            this.form.feature_value_ids = [];
        },

        resolveMetadataCategoryId() {
            if (this.normalizeId(this.form.subcategory_id)) {
                return this.normalizeId(this.form.subcategory_id);
            }

            if (!this.normalizeId(this.form.main_category_id)) {
                return '';
            }

            if (this.subCategoryOptions.length > 0) {
                return '';
            }

            return this.normalizeId(this.form.main_category_id);
        },

        async refreshMetadataForCurrentSelection(clearMissing = false) {
            const categoryId = this.resolveMetadataCategoryId();

            if (!categoryId || !this.metadataBaseUrl) {
                this.loading = false;
                this.dynamicFields = [];
                this.dynamicFeatures = [];
                this.metadataCategory = null;
                return;
            }

            await this.fetchMetadata(categoryId, clearMissing);
        },

        async fetchMetadata(categoryId, clearMissing = false) {
            const normalizedCategoryId = this.normalizeId(categoryId);

            if (!normalizedCategoryId || !this.metadataBaseUrl) {
                return;
            }

            this.loading = true;

            try {
                const localizedPromise = this.fetchJson(
                    `${this.metadataBaseUrl}/${normalizedCategoryId}`,
                    true,
                    this.activeLocale
                );

                /*
                 * KRİTİK: Gruplama görünen çeviri metnine göre yapılmamalı.
                 * Backend'deki field / option / feature ID'leri locale değişse de sabittir.
                 * Bu nedenle aktif locale payload'ını (sunum) TR payload'ı (kanonik kimlik)
                 * ile ID üzerinden birleştiriyoruz. Böylece EN/DE/RU/AR/NL/ES/FR/FA/ZH/PL/DA
                 * dillerinin tamamında Türkçe ile aynı grup yapısı korunur.
                 */
                const canonicalPromise = this.activeLocale === 'tr'
                    ? localizedPromise
                    : this.fetchCanonicalMetadata(normalizedCategoryId).catch(error => {
                        console.warn('Canonical TR filter metadata failed; localized fallback will be used.', error);
                        return null;
                    });

                const [localizedPayload, canonicalPayload] = await Promise.all([
                    localizedPromise,
                    canonicalPromise,
                ]);

                if (this.activeLocale === 'tr' && canonicalPayload) {
                    this.canonicalMetadataCache[String(normalizedCategoryId)] = canonicalPayload;
                }

                const payload = this.mergeCanonicalMetadata(localizedPayload, canonicalPayload);

                this.dynamicFields = this.prepareDynamicFields(payload.fields);
                this.dynamicFeatures = this.prepareDynamicFeatures(payload.features);
                this.metadataCategory = payload && payload.category ? payload.category : null;

                const allowedFieldIds = this.dynamicFields.map(field => String(field.id));

                if (clearMissing) {
                    Object.keys(this.form.fields).forEach(fieldId => {
                        if (!allowedFieldIds.includes(String(fieldId))) {
                            delete this.form.fields[fieldId];
                        }
                    });
                }

                this.dynamicFields.forEach(field => {
                    const key = String(field.id);
                    if (!(key in this.form.fields)) {
                        this.form.fields[key] = '';
                    }
                });

                this.syncDynamicConditionalYearFields();
            } catch (error) {
                console.error('Filter metadata failed:', error);
                this.dynamicFields = [];
                this.dynamicFeatures = [];
                this.metadataCategory = null;
            } finally {
                this.loading = false;
            }
        },

        async fetchCanonicalMetadata(categoryId) {
            const key = String(categoryId || '');
            if (!key) return null;

            if (Object.prototype.hasOwnProperty.call(this.canonicalMetadataCache, key)) {
                return this.canonicalMetadataCache[key];
            }

            // Aktif dil zaten Türkçe ise ikinci HTTP isteğine gerek yok.
            if (this.activeLocale === 'tr') {
                const payload = await this.fetchJson(
                    `${this.metadataBaseUrl}/${key}`,
                    true,
                    'tr'
                );
                this.canonicalMetadataCache[key] = payload;
                return payload;
            }

            const payload = await this.fetchJson(
                `${this.metadataBaseUrl}/${key}`,
                true,
                'tr'
            );

            this.canonicalMetadataCache[key] = payload;
            return payload;
        },

        mergeCanonicalMetadata(localizedPayload, canonicalPayload) {
            const localized = (localizedPayload && typeof localizedPayload === 'object')
                ? localizedPayload
                : {};
            const canonical = (canonicalPayload && typeof canonicalPayload === 'object')
                ? canonicalPayload
                : {};

            const byId = (items) => {
                const map = new Map();
                (Array.isArray(items) ? items : []).forEach(item => {
                    const id = Number(item?.id || 0);
                    if (id > 0) map.set(id, item);
                });
                return map;
            };

            /*
             * Backend görünür `name` alanını aktif dilde döndürdüğü için koleksiyon
             * sırası locale'e göre alfabetik değişebilir. `.find()` kullanan layout
             * eşleştirmelerinde bu, aynı anahtara uyan birden fazla aday varsa farklı
             * kaydın seçilmesine yol açıyordu. Aktif dildeki kayıtları TR payload'ının
             * ID sırasına dizerek hem grup hem seçenek sırasını TR ile birebir sabitliyoruz.
             */
            const orderedLocalized = (localizedItems, canonicalItems) => {
                const localizedList = Array.isArray(localizedItems) ? localizedItems : [];
                const canonicalList = Array.isArray(canonicalItems) ? canonicalItems : [];

                const byStableId = (a, b) => {
                    const aId = Number(a?.id || 0);
                    const bId = Number(b?.id || 0);

                    if (aId > 0 && bId > 0 && aId !== bId) return aId - bId;
                    if (aId > 0 && bId <= 0) return -1;
                    if (aId <= 0 && bId > 0) return 1;
                    return 0;
                };

                if (!canonicalList.length) {
                    return localizedList.slice().sort(byStableId);
                }

                const localizedMap = byId(localizedList);
                const used = new Set();
                const ordered = [];

                canonicalList.forEach(canonicalItem => {
                    const id = Number(canonicalItem?.id || 0);
                    if (id <= 0) return;

                    const localizedItem = localizedMap.get(id);
                    if (!localizedItem) return;

                    ordered.push(localizedItem);
                    used.add(id);
                });

                localizedList
                    .filter(localizedItem => {
                        const id = Number(localizedItem?.id || 0);
                        return !(id > 0 && used.has(id));
                    })
                    .sort(byStableId)
                    .forEach(localizedItem => ordered.push(localizedItem));

                return ordered;
            };

            const canonicalFields = byId(canonical.fields);
            const fields = orderedLocalized(localized.fields, canonical.fields).map(field => {
                const canonicalField = canonicalFields.get(Number(field?.id || 0)) || null;
                if (!canonicalField) return field;

                const canonicalOptions = byId(canonicalField.options);
                const options = orderedLocalized(field?.options, canonicalField.options).map(option => {
                    const canonicalOption = canonicalOptions.get(Number(option?.id || 0)) || null;
                    if (!canonicalOption) return option;

                    return {
                        ...option,
                        canonical_name: String(
                            canonicalOption.canonical_name
                            || canonicalOption.name
                            || canonicalOption.label
                            || canonicalOption.value
                            || ''
                        ).trim(),
                        schema_value: canonicalOption.schema_value ?? option?.schema_value,
                        canonical_schema_value: canonicalOption.canonical_schema_value ?? option?.canonical_schema_value,
                        meta: {
                            ...(canonicalOption.meta || {}),
                            ...(option?.meta || {}),
                        },
                    };
                });

                const canonicalMeta = canonicalField.meta || {};
                const localizedMeta = field?.meta || {};

                return {
                    ...field,
                    schema_key: field?.schema_key || canonicalField.schema_key || canonicalMeta.schema_key || null,
                    key: field?.key || canonicalField.key || canonicalMeta.key || null,
                    canonical_name: String(
                        canonicalField.canonical_name
                        || canonicalField.name
                        || canonicalField.label
                        || ''
                    ).trim(),
                    canonical_placeholder: String(
                        canonicalField.canonical_placeholder
                        || canonicalField.placeholder
                        || ''
                    ).trim(),
                    canonical_section: String(
                        canonicalField.canonical_section
                        || canonicalMeta.canonical_section
                        || canonicalMeta.section
                        || canonicalField.section
                        || ''
                    ).trim(),
                    meta: {
                        ...canonicalMeta,
                        ...localizedMeta,
                        schema_key: localizedMeta.schema_key || canonicalMeta.schema_key || canonicalField.schema_key || field?.schema_key || null,
                        key: localizedMeta.key || canonicalMeta.key || canonicalField.key || field?.key || null,
                        canonical_section: localizedMeta.canonical_section || canonicalMeta.canonical_section || canonicalMeta.section || canonicalField.section || null,
                    },
                    options,
                };
            });

            const canonicalGroups = byId(canonical.features);
            const features = orderedLocalized(localized.features, canonical.features).map(group => {
                const canonicalGroup = canonicalGroups.get(Number(group?.id || 0)) || null;
                if (!canonicalGroup) return group;

                const canonicalItems = byId(canonicalGroup.items);
                const items = orderedLocalized(group?.items, canonicalGroup.items).map(item => {
                    const canonicalItem = canonicalItems.get(Number(item?.id || 0)) || null;
                    if (!canonicalItem) return item;

                    return {
                        ...item,
                        canonical_name: String(
                            canonicalItem.canonical_name
                            || canonicalItem.name
                            || canonicalItem.label
                            || canonicalItem.value
                            || ''
                        ).trim(),
                        schema_key: item?.schema_key || canonicalItem.schema_key || canonicalItem.meta?.schema_key || null,
                        key: item?.key || canonicalItem.key || canonicalItem.meta?.key || null,
                        schema_value: canonicalItem.schema_value ?? item?.schema_value,
                        meta: {
                            ...(canonicalItem.meta || {}),
                            ...(item?.meta || {}),
                        },
                    };
                });

                const canonicalMeta = canonicalGroup.meta || {};
                const localizedMeta = group?.meta || {};

                return {
                    ...group,
                    schema_key: group?.schema_key || canonicalGroup.schema_key || canonicalMeta.schema_key || null,
                    key: group?.key || canonicalGroup.key || canonicalMeta.key || null,
                    canonical_name: String(
                        canonicalGroup.canonical_name
                        || canonicalGroup.name
                        || canonicalGroup.label
                        || canonicalGroup.key
                        || ''
                    ).trim(),
                    canonical_section: String(
                        canonicalGroup.canonical_section
                        || canonicalMeta.canonical_section
                        || canonicalMeta.section
                        || canonicalGroup.section
                        || ''
                    ).trim(),
                    meta: {
                        ...canonicalMeta,
                        ...localizedMeta,
                        schema_key: localizedMeta.schema_key || canonicalMeta.schema_key || canonicalGroup.schema_key || group?.schema_key || null,
                        key: localizedMeta.key || canonicalMeta.key || canonicalGroup.key || group?.key || null,
                        canonical_section: localizedMeta.canonical_section || canonicalMeta.canonical_section || canonicalMeta.section || canonicalGroup.section || null,
                    },
                    items,
                };
            });

            const localizedCategory = localized.category && typeof localized.category === 'object'
                ? localized.category
                : null;
            const canonicalCategory = canonical.category && typeof canonical.category === 'object'
                ? canonical.category
                : null;

            const category = localizedCategory
                ? {
                    ...localizedCategory,
                    schema_key: localizedCategory.schema_key || canonicalCategory?.schema_key || canonicalCategory?.meta?.schema_key || null,
                    canonical_name: String(
                        canonicalCategory?.canonical_name
                        || canonicalCategory?.name
                        || canonicalCategory?.label
                        || localizedCategory?.canonical_name
                        || ''
                    ).trim(),
                    canonical_slug: String(
                        canonicalCategory?.canonical_slug
                        || canonicalCategory?.slug
                        || localizedCategory?.canonical_slug
                        || ''
                    ).trim(),
                    meta: {
                        ...(canonicalCategory?.meta || {}),
                        ...(localizedCategory?.meta || {}),
                    },
                }
                : canonicalCategory;

            return {
                ...localized,
                fields,
                features,
                category,
            };
        },

        async fetchJson(url, forceLocale = false, localeOverride = '') {
            let finalUrl = url;
            const requestLocale = String(localeOverride || this.activeLocale || '')
                .replace('_', '-')
                .split('-')[0]
                .toLowerCase();

            if (forceLocale && requestLocale) {
                try {
                    const parsed = new URL(url, window.location.origin);
                    parsed.searchParams.set('locale', requestLocale);
                    finalUrl = parsed.toString();
                } catch (e) {
                    const separator = String(url).includes('?') ? '&' : '?';
                    finalUrl = `${url}${separator}locale=${encodeURIComponent(requestLocale)}`;
                }
            }

            const res = await fetch(finalUrl, {
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    ...(requestLocale ? {
                        'X-Home-Locale': requestLocale,
                        'X-Locale': requestLocale,
                        'Accept-Language': requestLocale,
                    } : {}),
                },
            });

            if (!res.ok) {
                throw new Error(this.uiText('İstek başarısız oldu.'));
            }

            return await res.json();
        },

        async bootstrapLocationOptions() {
            if (!this.countries.length) {
                await this.loadCountries();
            }

            if (this.form.country_id && !this.cities.length) {
                await this.loadCities(this.form.country_id, false);
            }

            if (this.form.city_id && !this.districts.length) {
                await this.loadDistricts(this.form.city_id, false);
            }

            if (this.form.district_id && !this.neighborhoods.length) {
                await this.loadNeighborhoods(this.form.district_id, false);
            }

            /*
             * Header seçiminden URL'ye sadece city/district/quarter ID'leri düşerse
             * requestParams içinde location_label boş kalabiliyor. Option listeleri yüklendikten
             * sonra label'ı ID'lerden tekrar üretip aktif chip ve üst form state'ini dolduruyoruz.
             */
            if (!this.form.location_label && (this.form.city_id || this.form.district_id || this.form.quarter_id)) {
                const label = this.clean(this.locationLabel());

                if (label) {
                    this.form.location_label = label;
                    this.locationSearch = label;
                    this.syncDomState();
                }
            }
        },

        endpointUrl(base, params = {}) {
            if (!base) return '';

            const url = new URL(base, window.location.origin);
            Object.entries(params).forEach(([key, value]) => {
                if (this.clean(value) !== '') {
                    url.searchParams.set(key, value);
                }
            });

            const tt = this.form.transaction_type || (this.context === 'agency' ? '' : DEFAULT_TRANSACTION_TYPE);
            if (tt) url.searchParams.set('transaction_type', tt);

            const cat = this.effectiveCategoryId;
            if (cat) url.searchParams.set('category_id', cat);

            return url.toString();
        },

        async loadCountries() {
            if (!this.countriesUrl) return;

            try {
                const data = await this.fetchJson(this.endpointUrl(this.countriesUrl));
                this.countries = Array.isArray(data.items) ? data.items : [];
            } catch (error) {
                this.countries = [];
            }
        },

        async loadCities(countryId, clear = true) {
            if (!this.citiesUrl || !countryId) {
                this.cities = [];
                return;
            }

            if (clear) {
                this.form.city_id = '';
                this.form.district_id = '';
                this.form.quarter_id = '';
                this.districts = [];
                this.neighborhoods = [];
            }

            const data = await this.fetchJson(this.endpointUrl(this.citiesUrl, { country_id: countryId }));
            this.cities = Array.isArray(data.items) ? data.items : [];
        },

        async loadDistricts(cityId, clear = true) {
            if (!this.districtsUrl || !cityId) {
                this.districts = [];
                return;
            }

            if (clear) {
                this.form.district_id = '';
                this.form.quarter_id = '';
                this.neighborhoods = [];
            }

            const data = await this.fetchJson(this.endpointUrl(this.districtsUrl, { city_id: cityId }));
            this.districts = Array.isArray(data.items) ? data.items : [];
        },

        async loadNeighborhoods(districtId, clear = true) {
            if (!this.neighborhoodsUrl || !districtId) {
                this.neighborhoods = [];
                return;
            }

            if (clear) {
                this.form.quarter_id = '';
            }

            const data = await this.fetchJson(this.endpointUrl(this.neighborhoodsUrl, { district_id: districtId }));
            this.neighborhoods = Array.isArray(data.items) ? data.items : [];
        },

        async onCountryChange() {
            this.form.location_label = '';
            await this.loadCities(this.form.country_id, true);
            this.form.location_label = this.locationLabel();
        },

        async onCityChange() {
            this.form.location_label = '';
            await this.loadDistricts(this.form.city_id, true);
            this.form.location_label = this.locationLabel();
        },

        async onDistrictChange() {
            this.form.location_label = '';
            await this.loadNeighborhoods(this.form.district_id, true);
            this.form.location_label = this.locationLabel();
        },

        onNeighborhoodChange() {
            this.form.location_label = '';
            this.form.location_label = this.locationLabel();
        },

        selectedName(list, id) {
            const item = (list || []).find(row => String(row.id) === String(id));
            return item?.name || '';
        },

        locationLabel() {
            if (this.form.location_label) {
                return this.form.location_label;
            }

            const cfgLabels = window.AD_LIST_CONFIG?.currentLocationLabels || window.HOME_SEARCH_CONFIG?.currentLocationLabels || {};
            const cityLabel = this.selectedName(this.cities, this.form.city_id) || cfgLabels.city || cfgLabels.city_name || '';
            const districtLabel = this.selectedName(this.districts, this.form.district_id) || cfgLabels.district || cfgLabels.district_name || '';
            const neighborhoodLabel = this.selectedName(this.neighborhoods, this.form.quarter_id) || cfgLabels.neighborhood || cfgLabels.neighborhood_name || cfgLabels.quarter || cfgLabels.quarter_name || '';

            return [
                cityLabel,
                districtLabel,
                neighborhoodLabel,
            ].filter(Boolean).join(', ');
        },

        clearHeroLocationDom() {
            ['acCountryId', 'acCityId', 'acDistrictId', 'acQuarterId'].forEach((id) => {
                const el = document.getElementById(id);
                if (!el) return;
                el.value = '';
                el.disabled = true;
            });

            const locationLabelInput = document.getElementById('acLocationLabel');
            if (locationLabelInput) {
                locationLabelInput.value = '';
                locationLabelInput.disabled = true;
            }

            const qHidden = document.getElementById('qHidden');
            if (qHidden) {
                qHidden.value = '';
            }

            const tagBox = document.getElementById('hsLocationTag');
            if (tagBox) {
                tagBox.style.display = 'none';
                tagBox.innerHTML = '';
            }

            const heroInputWrap = document.getElementById('heroSearchInputWrap');
            if (heroInputWrap) {
                heroInputWrap.classList.remove('has-tag');
            }

            const hsQ = document.getElementById('hsQ');
            if (hsQ) {
                hsQ.style.paddingLeft = '';
            }
        },

        clearLocationState(keepSearchText = false) {
            const typedSearch = this.locationSearch;

            this.form.country_id = '';
            this.form.city_id = '';
            this.form.district_id = '';
            this.form.quarter_id = '';
            this.form.location_label = '';
            this.form.q = '';

            this.cities = [];
            this.districts = [];
            this.neighborhoods = [];
            this.locationResults = [];
            this.locationResultsOpen = false;

            this.locationSearch = keepSearchText ? typedSearch : '';
            this.clearHeroLocationDom();
            this.syncDomState();
        },

        clearLocationSearchOnly() {
            this.clearLocationState(false);
        },

        onLocationSearchFocus() {
            if (this.locationResults.length > 0) {
                this.locationResultsOpen = true;
            }
        },

        onLocationSearchInput() {
            const q = this.locationSearch.trim();

            clearTimeout(this.locationTimer);

            if (this.locationLabel() && q !== this.locationLabel()) {
                this.clearLocationState(true);
                this.locationSearch = q;
            }

            if (q.length < 2) {
                if (q.length === 0) {
                    this.clearLocationState(false);
                }

                this.locationResults = [];
                this.locationResultsOpen = false;
                return;
            }

            this.locationTimer = setTimeout(() => {
                this.searchLocations(q);
            }, 320);
        },

        async searchLocations(q) {
            if (!this.locationSearchUrl) {
                return [];
            }

            this.locationLoading = true;
            this.locationResultsOpen = true;

            try {
                const url = new URL(this.locationSearchUrl, window.location.origin);
                url.searchParams.set('q', q);
                url.searchParams.set('smart', '1');
                url.searchParams.set('limit', '12');

                if (this.form.transaction_type) {
                    url.searchParams.set('transaction_type', this.form.transaction_type);
                }

                if (this.effectiveCategoryId) {
                    url.searchParams.set('category_id', this.effectiveCategoryId);
                }

                const data = await this.fetchJson(url.toString());
                this.locationResults = Array.isArray(data.items) ? data.items : [];
                return this.locationResults;
            } catch (error) {
                this.locationResults = [];
                return [];
            } finally {
                this.locationLoading = false;
            }
        },

        locationItemKey(item) {
            return `${item.type || 'loc'}-${item.id || item.quarter_id || item.neighborhood_id || item.district_id || item.city_id || item.label}`;
        },

        async applyLocationItem(item) {
            if (!item) return;

            this.locationResultsOpen = false;
            this.locationResults = [];

            const countryId = this.normalizeId(item.country_id || '');
            const cityId = this.normalizeId(item.city_id || (item.type === 'city' ? item.id : ''));
            const districtId = this.normalizeId(item.district_id || (item.type === 'district' ? item.id : ''));
            const quarterId = this.normalizeId(item.quarter_id || item.neighborhood_id || (['quarter', 'neighborhood'].includes(item.type) ? item.id : ''));

            if (countryId) {
                this.form.country_id = countryId;
            }

            if (this.form.country_id) {
                await this.loadCities(this.form.country_id, false);
            }

            if (cityId) {
                this.form.city_id = cityId;
                await this.loadDistricts(cityId, false);
            }

            if (districtId) {
                this.form.district_id = districtId;
                await this.loadNeighborhoods(districtId, false);
            }

            if (quarterId) {
                this.form.quarter_id = quarterId;
            }

            this.form.location_label = item.full_label || item.label || this.locationLabel();
            this.locationSearch = this.form.location_label;

            /*
             * Lokasyon seçildiğinde ana sayfadaki düz q alanı keyword olarak URL'e taşınmamalı.
             * Aksi halde /ilan/ara?city_id=16&district_id=...&q=Bursa+Kestel gibi çift filtre oluşabilir.
             */
            this.form.q = '';

            const qHidden = document.getElementById('qHidden');
            const hsQ = document.getElementById('hsQ');

            if (qHidden) {
                qHidden.value = '';
            }

            if (hsQ && !hsQ.hasAttribute('name')) {
                hsQ.value = '';
            }
        },

        removeChip(chip) {
            if (!chip) return;

            if (chip.type === 'transaction_type') {
                this.form.transaction_type = this.context === 'agency' ? '' : DEFAULT_TRANSACTION_TYPE;
                return;
            }

            if (chip.type === 'category') {
                this.form.main_category_id = '';
                this.form.subcategory_id = '';
                this.resetDynamicState();
                return;
            }

            if (chip.type === 'location') {
                this.clearLocationState(false);
                return;
            }

            if (chip.type === 'price') {
                this.form.min_price = '';
                this.form.max_price = '';
                return;
            }



            if (chip.type === 'owner_types') {
                this.form.owner_types = [];
                return;
            }

            if (chip.type === 'project_unit_rooms') {
                this.clearProjectUnitRoomFilters();
                return;
            }

            if (chip.type === 'project_unit_area') {
                this.clearProjectUnitAreaFilters();
                return;
            }

            if (chip.type === 'field') {
                const current = this.form.fields[chip.fieldId];
                if (current && typeof current === 'object' && !Array.isArray(current)) {
                    this.form.fields[chip.fieldId] = { min: '', max: '' };
                } else if (Array.isArray(current)) {
                    this.form.fields[chip.fieldId] = [];
                } else {
                    this.form.fields[chip.fieldId] = '';
                }
                return;
            }

            if (chip.type === 'feature') {
                this.form.feature_value_ids = this.form.feature_value_ids.filter(id => Number(id) !== Number(chip.valueId));
                return;
            }

            if (chip.type === 'has_virtual_tour') {
                this.form.has_virtual_tour = 0;
            }
        },

        async ensureLocationIdsFromLabel() {
            const hasIds = !!(this.form.city_id || this.form.district_id || this.form.quarter_id);
            const q = this.clean(this.form.location_label || this.locationSearch || '');

            if (hasIds || q.length < 2 || !this.locationSearchUrl) {
                return false;
            }

            const items = await this.searchLocations(q);
            const first = Array.isArray(items) ? items[0] : null;

            if (!first) {
                return false;
            }

            await this.applyLocationItem(first);
            this.syncDomState();
            return true;
        },

        async ensureTypedLocationSelected() {
            const q = this.clean(this.locationSearch || this.form.location_label || this.form.q || this.externalSearchLocationState().q);
            const currentLabel = this.locationLabel();
            const hasIds = !!(this.form.city_id || this.form.district_id || this.form.quarter_id);

            if (q.length < 2) {
                return false;
            }

            if (hasIds && currentLabel && q === currentLabel) {
                return false;
            }

            const items = await this.searchLocations(q);
            const first = Array.isArray(items) ? items[0] : null;

            if (!first) {
                return false;
            }

            await this.applyLocationItem(first);
            return true;
        },

        findDynamicFieldById(fieldId) {
            return this.dynamicFields.find(item => String(item.id) === String(fieldId)) || null;
        },

        projectUnitRoomFilterValues() {
            return {
                bedrooms_min: this.projectRoomCounterValue('bedrooms', 'min'),
                bedrooms_max: this.projectRoomCounterValue('bedrooms', 'max'),
                living_rooms_min: this.projectRoomCounterValue('living_rooms', 'min'),
                living_rooms_max: this.projectRoomCounterValue('living_rooms', 'max'),
            };
        },

        projectUnitPlanBackedFieldDefinitions() {
            return [
                { key: 'bedrooms', labels: ['yatak_odasi_sayisi', 'yatak odasi', 'yatak odası', 'bedroom'] },
                { key: 'living_rooms', labels: ['salon_sayisi', 'salon sayisi', 'salon sayısı', 'living room'] },
                { key: 'dressing_rooms', labels: ['giyinme_odasi_sayisi', 'giyinme odasi', 'giyinme odası', 'dressing room'] },
                { key: 'bathrooms', labels: ['banyo_sayisi', 'ortak_banyo_sayisi', 'ortak banyo', 'banyo sayisi', 'banyo sayısı', 'bathroom'] },
                { key: 'master_bathrooms', labels: ['ebeveyn_banyosu_sayisi', 'ebeveyn banyosu', 'master bathroom'] },
                { key: 'wc', labels: ['wc_sayisi', 'wc sayisi', 'wc sayısı', 'tuvalet'] },
                { key: 'balconies', labels: ['balkon_adet', 'balkon_sayisi', 'balkon sayisi', 'balkon sayısı'] },
                { key: 'depots', labels: ['depo_adet', 'depo_sayisi', 'depo sayisi', 'depo sayısı'] },
                { key: 'section_rooms', labels: ['bolum_oda_sayisi', 'bölüm oda sayısı', 'bolum_sayisi', 'bölüm sayısı', 'bolunmus_bolum_sayisi'] },
            ];
        },

        projectRoomCountPresetFieldMatches(field) {
            if (!field) return false;
            const key = this.fieldSchemaKey(field);
            const text = this.normalizeText([
                field?.name,
                field?.label,
                field?.placeholder,
                field?.schema_key,
                field?.meta?.schema_key,
            ].filter(Boolean).join(' '));

            return ['oda_sayisi', 'oda sayisi', 'oda sayısı', 'oda_salon', 'room_count', 'room count']
                .some(label => key.includes(this.normalizeText(label)) || text.includes(this.normalizeText(label)));
        },

        projectUnitPlanBackedFieldKey(field) {
            if (!this.isProjectFilterMode || !field) return '';

            if (this.projectRoomCountPresetFieldMatches(field)) {
                return 'room_count_preset';
            }

            const key = this.fieldSchemaKey(field);
            const text = this.normalizeText([
                field?.name,
                field?.label,
                field?.placeholder,
                field?.schema_key,
                field?.meta?.schema_key,
            ].filter(Boolean).join(' '));

            const definition = this.projectUnitPlanBackedFieldDefinitions().find(item => {
                return item.labels.some(label => {
                    const normalized = this.normalizeText(label);
                    return key.includes(normalized) || text.includes(normalized);
                });
            });

            return definition?.key || '';
        },

        isProjectUnitPlanBackedField(field) {
            return !!this.projectUnitPlanBackedFieldKey(field);
        },

        projectUnitPlanFilterValues() {
            const values = { ...this.projectUnitRoomFilterValues() };

            const unitArea = this.form.project_unit_area || {};
            const areaMin = String(unitArea.min || '').replace(/\D/g, '');
            const areaMax = String(unitArea.max || '').replace(/\D/g, '');
            if (areaMin) values.area_min = areaMin;
            if (areaMax) values.area_max = areaMax;

            (this.dynamicFields || []).forEach(field => {
                const unitKey = this.projectUnitPlanBackedFieldKey(field);
                if (!unitKey || unitKey === 'room_count_preset') return;

                const rawValue = this.form.fields?.[String(field.id)];
                if (!rawValue) return;

                if (rawValue && typeof rawValue === 'object' && !Array.isArray(rawValue)) {
                    const min = String(rawValue.min || '').replace(/\D/g, '');
                    const max = String(rawValue.max || '').replace(/\D/g, '');

                    if (min) values[`${unitKey}_min`] = min;
                    if (max) values[`${unitKey}_max`] = max;
                    return;
                }

                const minOnly = String(rawValue || '').replace(/\D/g, '');
                if (minOnly) values[`${unitKey}_min`] = minOnly;
            });

            return values;
        },


        projectUnitAreaValue(side = 'min') {
            const value = this.form.project_unit_area?.[side];
            return String(value || '').replace(/\D/g, '');
        },

        onProjectUnitAreaInput(side = 'min', event) {
            const nextValue = String(event?.target?.value || '').replace(/\D/g, '');
            const current = this.form.project_unit_area || { min: '', max: '' };

            this.form.project_unit_area = {
                min: String(current.min || '').replace(/\D/g, ''),
                max: String(current.max || '').replace(/\D/g, ''),
                [side]: nextValue,
            };

            const min = parseInt(this.form.project_unit_area.min || '0', 10);
            const max = parseInt(this.form.project_unit_area.max || '0', 10);

            if (side === 'min' && min > 0 && max > 0 && max < min) {
                this.form.project_unit_area.max = '';
            }
        },

        clearProjectUnitAreaFilters() {
            this.form.project_unit_area = { min: '', max: '' };
        },

        projectUnitAreaChipLabel() {
            const area = this.form.project_unit_area || {};
            const min = String(area.min || '').replace(/\D/g, '');
            const max = String(area.max || '').replace(/\D/g, '');

            if (!min && !max) return '';
            return this.rangeText(min, max, 'm²', false);
        },

        appendProjectUnitRoomParams(params) {
            if (!this.isProjectFilterMode) {
                return;
            }

            const values = this.projectUnitPlanFilterValues();

            Object.entries(values).forEach(([key, value]) => {
                const cleanValue = String(value || '').replace(/\D/g, '');
                if (!cleanValue) return;

                params.set(`project_unit_plans[${key}]`, cleanValue);
                params.set(`project_unit_rooms[${key}]`, cleanValue);
                params.set(`project_units[${key}]`, cleanValue);
                params.set(`unit_${key}`, cleanValue);
                params.set(`project_unit_${key}`, cleanValue);
            });

            ['min', 'max'].forEach(side => {
                const label = this.projectRoomPresetLabel(side);
                if (!label) return;

                params.set(`project_unit_rooms[room_label_${side}]`, label);
                params.set(`project_unit_plans[room_label_${side}]`, label);
                params.set(`project_units[room_label_${side}]`, label);
                params.set(`project_unit_room_label_${side}`, label);
            });
        },

        projectUnitRoomChipLabel() {
            if (!this.isProjectFilterMode || !this.projectResidentialUnitRoomMode) {
                return '';
            }

            const values = this.projectUnitRoomFilterValues();
            const parts = [];

            if (values.bedrooms_min || values.bedrooms_max) {
                parts.push(`Yatak odası ${this.rangeText(values.bedrooms_min, values.bedrooms_max, '', false)}`);
            }

            if (values.living_rooms_min || values.living_rooms_max) {
                parts.push(`Salon ${this.rangeText(values.living_rooms_min, values.living_rooms_max, '', false)}`);
            }

            return parts.length ? parts.join(', ') : '';
        },

        clearProjectUnitRoomFilters() {
            this.form.project_unit_rooms = {
                bedrooms: { min: '', max: '' },
                living_rooms: { min: '', max: '' },
            };
            this.clearProjectUnitAreaFilters();

            (this.dynamicFields || []).forEach(field => {
                if (this.isProjectUnitPlanBackedField(field)) {
                    this.form.fields[String(field.id)] = { min: '', max: '' };
                }
            });
        },

        appendDynamicYearFilterParams(params) {
            if (!params) return;

            const constructionField = this.dynamicConstructionYearField();
            if (constructionField) {
                const fieldId = String(constructionField.id);
                const minYear = this.shouldShowDynamicConstructionYearField()
                    ? this.dynamicYearRangeValue(constructionField, 'min')
                    : '';

                params.delete(`fields[${fieldId}][value]`);
                params.delete(`fields[${fieldId}][min]`);
                params.delete(`fields[${fieldId}][max]`);
                if (minYear) params.set(`fields[${fieldId}][min]`, minYear);
            }

            const renovationField = this.dynamicRenovationYearField();
            if (renovationField) {
                const fieldId = String(renovationField.id);
                const minYear = this.shouldShowDynamicRenovationYearField()
                    ? this.dynamicYearRangeValue(renovationField, 'min')
                    : '';

                params.delete(`fields[${fieldId}][value]`);
                params.delete(`fields[${fieldId}][min]`);
                params.delete(`fields[${fieldId}][max]`);
                if (minYear) params.set(`fields[${fieldId}][min]`, minYear);
            }
        },
        appendFieldFilterParams(params, fieldId, rawValue) {
            const key = String(fieldId);
            const field = this.findDynamicFieldById(fieldId);

            // Yapım / Yenileme yılı bazı layout'larda görsel olarak property-status içine
            // taşındığı için global hidden listesine düşebilir. Hidden burada yalnızca render
            // tekrarını engellemeli; request serializer yıl filtresini ASLA atmamalıdır.
            const isDynamicYearField = !!(field && (
                this.isDynamicConstructionYearField(field)
                || this.isDynamicRenovationYearField(field)
            ));

            if (field && this.isGloballyHiddenDynamicField(field) && !isDynamicYearField) {
                return;
            }
            if (field && this.isLandFilterMode && this.isLandHiddenField(field)) {
                return;
            }
            if (field && this.isProjectFilterMode && this.isProjectPdfHiddenField(field)) {
                return;
            }
            if (field && this.isProjectDeliveryYearField(field) && this.isProjectCompletedSelected()) {
                return;
            }

            // Proje ünite bilgilerinde oda/banyo/balkon gibi alanlar ads_detail_field_values yerine
            // ad_project_unit_plans tablosunda tutuluyor. Bu alanları fields[] olarak da gönderirsek
            // backend tarafında gereksiz AND oluşup sonuçları düşürebiliyor.
            if (field && this.isProjectUnitPlanBackedField(field)) {
                return;
            }

            const mode = this.fieldFilterModes[key] || '';

            // Select / checkbox_group alanlarda ilanlar field_value_id ile tutulduğu için
            // backend tarafına option/options anahtarları gönderilir.
            // Text/switch alanlar value, number alanlar min/max olarak kalır.
            if (Array.isArray(rawValue)) {
                const isOptionArray = mode === 'options' || (field && (this.isSelectField(field) || this.isMultiField(field)));
                const paramKey = isOptionArray ? 'options' : 'values';

                rawValue
                    .map(value => String(value).trim())
                    .filter(value => value !== '')
                    .forEach(value => {
                        params.append(`fields[${fieldId}][${paramKey}][]`, value);
                    });

                return;
            }

            if (rawValue && typeof rawValue === 'object') {
                let min = rawValue.min === null || rawValue.min === undefined ? '' : String(rawValue.min).trim();
                let max = rawValue.max === null || rawValue.max === undefined ? '' : String(rawValue.max).trim();

                if (field && this.isMoneyField(field)) {
                    min = this.normalizeMoneyInput(min);
                    max = this.normalizeMoneyInput(max);
                }

                if (field && this.isCurrentFloorField(field) && !this.isPdfCommercialCurrentFloorMinOnly(field)) {
                    if (min !== '' && max === '') {
                        max = min;
                    }

                    if (max !== '' && min === '') {
                        min = max;
                    }
                }

                // Taşınmaz Durumuna bağlı Yapım/Yenileme yılı yalnız minimum olarak gönderilir.
                if (field && this.isDynamicConstructionYearField(field)) {
                    const minYear = this.normalizeDynamicYearValue(rawValue.min ?? rawValue.value ?? '', field);
                    if (minYear) params.set(`fields[${fieldId}][min]`, minYear);
                    return;
                }

                if (field && this.isDynamicRenovationYearField(field)) {
                    const minYear = this.normalizeDynamicYearValue(rawValue.min ?? rawValue.value ?? '', field);
                    if (minYear) params.set(`fields[${fieldId}][min]`, minYear);
                    return;
                }

                if (min !== '') params.set(`fields[${fieldId}][min]`, min);
                if (max !== '') params.set(`fields[${fieldId}][max]`, max);

                return;
            }

            if (rawValue === null || rawValue === undefined || String(rawValue).trim() === '') {
                return;
            }

            const value = String(rawValue).trim();

            if (field && this.isDynamicConstructionYearField(field)) {
                const year = this.normalizeDynamicYearValue(value, field);

                if (year) {
                    params.set(`fields[${fieldId}][min]`, year);
                    return;
                }
            }

            if (field && this.isDynamicRenovationYearField(field)) {
                const year = this.normalizeDynamicYearValue(value, field);

                if (year) {
                    params.set(`fields[${fieldId}][min]`, year);
                    return;
                }
            }

            if (mode === 'option' || (field && (this.isSelectField(field) || this.isMultiField(field)))) {
                params.set(`fields[${fieldId}][option]`, value);
                return;
            }

            params.set(`fields[${fieldId}][value]`, value);
        },

        buildParams() {
            // Burada DOM'dan tekrar sync yapılmaz. Popup açıkken canlı sayaç ve submit
            // çalıştığında eski liste radio/input değerleri yeni kategori seçimini ezmemeli.
            const params = new URLSearchParams();

            const current = new URLSearchParams(window.location.search);
            ['sort', 'bbox', 'poly', 'lat', 'lng', 'radius', 'radius_km', 'radius_label', 'mode', 'ai', 'agency_name'].forEach(key => {
                const value = current.get(key);
                if (value !== null && value !== '') {
                    params.set(key, value);
                }
            });

            if (this.context === 'agency') {
                const staffId = this.normalizeId(this.requestParams.staff_id || current.get('staff_id') || '');
                if (staffId) {
                    params.set('staff_id', staffId);
                    params.set('agency_tab', 'staff');
                }
                // Legacy quick controls remain usable alongside the common popup.
                ['m2_min', 'm2_max', 'room_value_id'].forEach(key => {
                    const value = this.listFormValue(key);
                    if (value) params.set(key, value);
                });
            }

            const mode = document.getElementById('hsSearchMode')?.value || params.get('mode') || '';
            const ai = document.getElementById('hsAi')?.value || params.get('ai') || '';
            const sort = document.getElementById('formSortInput')?.value || params.get('sort') || '';

            if (mode) params.set('mode', mode);
            if (ai === '1') params.set('ai', '1');
            else params.delete('ai');
            if (sort) params.set('sort', sort);

            if (this.form.transaction_type) params.set('transaction_type', this.form.transaction_type);
            if (this.effectiveCategoryId) params.set('category_id', this.effectiveCategoryId);

            const hasLocationState = !!(this.form.country_id || this.form.city_id || this.form.district_id || this.form.quarter_id || this.locationLabel());
            const qValue = this.clean(
                !hasLocationState
                    ? (
                        this.form.q ||
                        document.getElementById('qHidden')?.value ||
                        document.getElementById('hsQ')?.value ||
                        current.get('q') ||
                        ''
                    )
                    : ''
            );

            if (qValue) {
                params.set('q', qValue);
            }

            if (this.form.country_id) params.set('country_id', this.form.country_id);
            if (this.form.city_id) params.set('city_id', this.form.city_id);
            if (this.form.district_id) params.set('district_id', this.form.district_id);
            if (this.form.quarter_id) params.set('quarter_id', this.form.quarter_id);

            const locLabel = this.locationLabel();
            if (locLabel) params.set('location_label', locLabel);

            if (this.form.min_price) {
                params.set('min_price', this.form.min_price);
                params.set('price_min', this.form.min_price);
            }

            if (this.form.max_price) {
                params.set('max_price', this.form.max_price);
                params.set('price_max', this.form.max_price);
            }

            this.form.owner_types.forEach(value => params.append('owner_types[]', String(value)));
            if (Number(this.form.has_virtual_tour) === 1) params.set('has_virtual_tour', '1');

            Object.keys(this.form.fields || {}).forEach(fieldId => {
                this.appendFieldFilterParams(params, fieldId, this.form.fields[fieldId]);
            });

            // Yapım Yılı property-status içine inline taşındığında field render açısından hidden
            // olabilir. Bu son geçiş, min/max değerlerini hem canlı sayaç hem arama URL'sine
            // kesin olarak ekler.
            this.appendDynamicYearFilterParams(params);

            this.appendProjectUnitRoomParams(params);

            this.form.feature_value_ids.forEach(id => {
                params.append('feature_value_ids[]', String(id));
            });

            return params;
        },

        async scheduleLiveCount(delay = 350) {
            if (!this.countUrl) return;

            clearTimeout(this.countTimer);
            this.countTimer = setTimeout(async () => {
                const requestId = ++this.countRequestId;

                if (this.countAbortController) {
                    this.countAbortController.abort();
                }

                this.countAbortController = new AbortController();

                try {
                    const url = new URL(this.countUrl, window.location.origin);
                    const params = this.buildParams();

                    params.delete('page');
                    params.forEach((value, key) => {
                        url.searchParams.append(key, value);
                    });

                    const data = await this.fetchJson(url.toString(), {
                        signal: this.countAbortController.signal,
                        cache: 'no-store',
                    });

                    if (requestId !== this.countRequestId) return;

                    const parsed = parseInt(data.count, 10);
                    this.liveCount = Number.isFinite(parsed) ? parsed : null;
                } catch (error) {
                    if (error?.name === 'AbortError') return;
                    if (requestId === this.countRequestId) {
                        this.liveCount = null;
                    }
                }
            }, delay);
        },

        async submitFilter() {
            await this.ensureTypedLocationSelected();
            this.syncDomState();

            if (this.context === 'home' && !this.hasSearchLocation()) {
                this.requestLocationInput();
                return;
            }

            const params = this.buildParams();
            const url = new URL(this.searchUrl, window.location.origin);

            params.forEach((value, key) => {
                url.searchParams.append(key, value);
            });

            window.location.href = url.toString();
        },

        resetFilter() {
            const listTransaction = document.querySelector(':is(#listFilterForm, #agencyFilterForm) input[name="transaction_type"]:checked')?.value || '';
            const keepTransaction = this.context === 'agency'
                ? ''
                : (this.shouldShowTransaction
                    ? (document.getElementById('hsTransactionType')?.value || listTransaction || this.form.transaction_type || DEFAULT_TRANSACTION_TYPE)
                    : (listTransaction || this.form.transaction_type || DEFAULT_TRANSACTION_TYPE));

            const keepState = {
                transaction_type: this.context === 'agency' ? '' : (keepTransaction || DEFAULT_TRANSACTION_TYPE),
                main_category_id: this.form.main_category_id || '',
                subcategory_id: this.form.subcategory_id || '',
                country_id: this.form.country_id || '',
                city_id: this.form.city_id || '',
                district_id: this.form.district_id || '',
                quarter_id: this.form.quarter_id || '',
                location_label: this.locationLabel() || this.form.location_label || '',
                q: '',
            };

            if (this.context === 'agency') {
                const form = document.getElementById('agencyFilterForm');
                form?.querySelectorAll('[name="m2_min"], [name="m2_max"]').forEach(input => input.value = '');
                form?.querySelectorAll('[name="room_value_id"]').forEach(input => input.checked = input.value === '');
            }

            this.form = this.emptyForm();
            this.fieldFilterModes = {};
            Object.assign(this.form, keepState);
            this.locationSearch = keepState.location_label;
            this.locationResults = [];
            this.locationResultsOpen = false;
            this.featurePicker = null;
            this.resetDynamicState();
            this.syncDomState();
            this.bootstrapLocationOptions();
            this.refreshMetadataForCurrentSelection(false);
            this.liveCount = null;
        },

        /* ── Wizard Navigation Methods ── */

        goToStep(step) {
            if (step < 1 || step > 4) return;
            if (step > this.maxReachedStep + 1) return;
            this.currentStep = step;
            if (step > this.maxReachedStep) this.maxReachedStep = step;
        },

        goBack() {
            if (this.currentStep > 1) {
                this.currentStep = this.currentStep - 1;
            }
        },

        selectTransactionType(value) {
            const prev = this.form.transaction_type;
            this.form.transaction_type = String(value);

            // Aynı değer tekrar seçildiyse sadece adımı ilerlet
            if (prev === String(value)) {
                this.$nextTick(() => this.goToStep(2));
                return;
            }

            this.form.min_price = '';
            this.form.max_price = '';

            // İlan tipi değişince mevcut kategori artık uygun değilse temizle.
            this.sanitizeCategoryForCurrentTransaction(true);

            this.syncDomState();
            this.$nextTick(() => this.goToStep(2));
        },

        selectMainCategory(categoryId) {
            const same = String(this.form.main_category_id) === String(categoryId);
            this.form.main_category_id = String(categoryId);

            // Aynı kategori tekrar seçildiyse state'i sıfırlamadan ilerle
            if (!same) {
                this.form.subcategory_id = '';
                this.resetDynamicState();
                this.syncDomState();
            }

            this.$nextTick(() => {
                const leaves = this.filteredLeafCategories;
                if (leaves.length === 0) {
                    this.refreshMetadataForCurrentSelection(!same);
                    this.maxReachedStep = 4;
                    this.currentStep = 4;
                } else {
                    this.maxReachedStep = Math.max(this.maxReachedStep, 3);
                    this.currentStep = 3;
                }
            });
        },

        selectSubCategory(categoryId) {
            const same = String(this.form.subcategory_id) === String(categoryId);
            this.form.subcategory_id = String(categoryId);

            // Aynı alt kategori tekrar seçildiyse state'i sıfırlamadan ilerle
            if (!same) {
                this.resetDynamicState();
                this.syncDomState();
                this.refreshMetadataForCurrentSelection(true);
            }

            this.$nextTick(() => {
                this.maxReachedStep = 4;
                this.currentStep = 4;
            });
        },

        skipSubCategory() {
            this.form.subcategory_id = '';
            this.syncDomState();
            this.refreshMetadataForCurrentSelection(true);

            this.$nextTick(() => {
                this.maxReachedStep = 4;
                this.currentStep = 4;
            });
        },

        resetWizard() {
            const previousStep = this.currentStep;
            const previousMaxStep = this.maxReachedStep;

            this.resetFilter();

            if (previousStep >= 4 && this.canProceedToStep4) {
                this.currentStep = 4;
            } else if (previousStep >= 3 && this.canProceedToStep3) {
                this.currentStep = 3;
            } else if (previousStep >= 2 && this.canProceedToStep2) {
                this.currentStep = 2;
            } else {
                this.currentStep = 1;
            }

            this.maxReachedStep = Math.max(previousMaxStep, this.currentStep);
            this.collapsedSections = {};
        },

        toggleSection(key) {
            this.collapsedSections = {
                ...this.collapsedSections,
                [key]: !this.collapsedSections[key]
            };
        },

        categoryIcon(cat) {
            const name = this.normalizeText(cat?.name || cat?.slug || '');
            if (name.includes('konut')) return 'ph-light ph-house';
            if (name.includes('ticari')) return 'ph-light ph-storefront';
            if (name.includes('arsa') || name.includes('arazi')) return 'ph-light ph-map-trifold';
            if (name.includes('proje') || name.includes('insaat')) return 'ph-light ph-crane';
            return 'ph-light ph-buildings';
        },
    },
};
</script>

<style>

/* ─────────────────────────────────────────────
   DETAIL FILTER POPUP - MOBILE FULLSCREEN FIX
   iOS Safari / Chrome mobile safe viewport fix
───────────────────────────────────────────── */

html.nf-filter-open,
body.nf-filter-open{
    overflow:hidden !important;
    overscroll-behavior:none !important;
    height:100% !important;
}

body.nf-filter-open{
    touch-action:none;
    position:fixed !important;
    left:0 !important;
    right:0 !important;
    width:100% !important;
    top:var(--nf-filter-body-top, 0px) !important;
}

/* Ana popup: global .search-filter-box kurallarını ezer */
.search-filter-box.nf-filter-modal{
    position:fixed !important;
    inset:0 !important;
    top:0 !important;
    right:0 !important;
    bottom:0 !important;
    left:0 !important;
    width:100vw !important;
    height:100vh !important;
    height:100dvh !important;
    min-height:100vh !important;
    min-height:100dvh !important;
    max-height:none !important;
    padding:0 !important;
    margin:0 !important;
    overflow:hidden !important;
    background:rgba(0,0,0,.55) !important;
    z-index:2147483000 !important;
    overscroll-behavior:none !important;
}

/* Overlay: ortalama yerine mobilde tam ekran taşıyıcı */
.search-filter-box-out.nf-filter-overlay{
    float:none !important;
    width:100% !important;
    height:100% !important;
    min-height:0 !important;
    max-height:none !important;
    padding:calc(12px + env(safe-area-inset-top)) 12px calc(12px + env(safe-area-inset-bottom)) !important;
    margin:0 !important;
    display:flex !important;
    align-items:center !important;
    justify-content:center !important;
    overflow:hidden !important;
    box-sizing:border-box !important;
    overscroll-behavior:contain !important;
}

/* Panel: global .search-filter-box-in height/radius kurallarını ezer */
.search-filter-box-in.nf-filter-panel{
    float:none !important;
    width:100% !important;
    max-width:800px !important;
    height:100% !important;
    max-height:calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom) - 24px) !important;
    min-height:0 !important;
    margin:0 auto !important;
    display:flex !important;
    flex-direction:column !important;
    overflow:hidden !important;
    background:#fff !important;
    border-radius:16px !important;
}

/* Scroll alanı: style.css içindeki .filter-box max/min-height değerlerini ezer */
.filter-box.nf-filter-scroll{
    float:none !important;
    width:100% !important;
    height:auto !important;
    min-height:0 !important;
    max-height:none !important;
    flex:1 1 auto !important;
    padding:20px 24px !important;
    overflow:hidden !important;
    overflow-y:auto !important;
    -webkit-overflow-scrolling:touch !important;
    overscroll-behavior:contain !important;
    scrollbar-width:thin;
}

/* Footer CTA sabit kalsın, scroll alanından yemesin */
.filter-cta.nf-filter-cta{
    float:none !important;
    flex:0 0 auto !important;
    width:100% !important;
    padding:14px 24px calc(14px + env(safe-area-inset-bottom)) !important;
    margin:0 !important;
    background:var(--color-light) !important;
    z-index:20 !important;
}

/* Header / steps sabit alanlar */
.nf-filter-head,
.nf-wizard-progress,
.nf-wizard-steps,
.nf-wizard-summary,
.nf-active-filter-bar{
    flex:0 0 auto !important;
}

/* Mobile tam ekran */
@media (max-width:768px){
    .search-filter-box.nf-filter-modal{
        width:100vw !important;
        height:100vh !important;
        height:100dvh !important;
        min-height:100vh !important;
        min-height:100dvh !important;
    }

    .search-filter-box-out.nf-filter-overlay{
        padding:calc(14px + env(safe-area-inset-top)) 16px calc(14px + env(safe-area-inset-bottom)) !important;
        align-items:flex-end !important;
        justify-content:center !important;
    }

    .search-filter-box-in.nf-filter-panel{
        width:100% !important;
        max-width:none !important;
        height:auto !important;
        max-height:calc(100vh - 28px - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;
        max-height:calc(100dvh - 28px - env(safe-area-inset-top) - env(safe-area-inset-bottom)) !important;
        border-radius:22px 22px 18px 18px !important;
        padding:22px !important;
    }

    .filter-box.nf-filter-scroll{
        padding:20px 22px !important;
    }

    .filter-cta.nf-filter-cta{
        padding:16px 20px calc(16px + env(safe-area-inset-bottom)) !important;
        border-radius:0 0 18px 18px !important;
    }

    .nf-filter-close{
        position:absolute !important;
        top:12px !important;
        right:14px !important;
        z-index:50 !important;
    }
}

/* iOS eski Safari desteği */
@supports (-webkit-touch-callout:none){
    .search-filter-box.nf-filter-modal{
        height:-webkit-fill-available !important;
        min-height:-webkit-fill-available !important;
    }

    @media (max-width:768px){
        .search-filter-box-in.nf-filter-panel{
            max-height:calc(-webkit-fill-available - 28px) !important;
        }
    }
}

/* ── Existing quick-field / picker styles ── */
.nf-quick-range{ margin-top:10px; }
.nf-quick-field-list{ display:grid; gap:14px; }
.nf-quick-field-title{ font-size:13px; font-weight:800; color:var(--color-black); margin-bottom:8px; }
.nf-feature-select-btn{ appearance:none; border:0; cursor:pointer; justify-content:flex-start; }
.nf-picker-backdrop{ position:absolute; inset:0; z-index:5; display:flex; align-items:center; justify-content:center; padding:18px; background:rgba(0,0,0,.35); backdrop-filter:blur(6px); -webkit-backdrop-filter:blur(6px); }
.nf-picker-panel{ width:min(520px, 100%); max-height:min(70vh, 680px); overflow:auto; background:#fff; border-radius:12px; padding:18px; box-shadow:0 18px 60px rgba(0,0,0,.18); border:1px solid rgba(0,0,0,.06); }
.nf-picker-head{ display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:14px; }
.nf-picker-head button{ width:34px; height:34px; border:0; border-radius:50%; background:var(--color-light); display:flex; align-items:center; justify-content:center; cursor:pointer; transition:all .2s ease; }
.nf-picker-head button:hover{ background:var(--color-light-red); color:var(--color-red); }
.nf-picker-list{ margin-bottom:14px; }
.hero-search-input.is-location-required .input{ border-color:var(--color-red) !important; box-shadow:0 0 0 3px rgba(234,0,41,.1) !important; }
@media (max-width: 768px){ .nf-picker-backdrop{ align-items:flex-end; padding:0; } .nf-picker-panel{ border-radius:12px 12px 0 0; max-height:80vh; } }

/* ── Wizard Progress Bar ── */
.nf-wizard-progress{ height:3px; background:var(--color-light); border-radius:8px; margin:0 24px 14px; overflow:hidden; }
.nf-wizard-progress-bar{ height:100%; background:var(--color-red); border-radius:8px; transition:width .4s cubic-bezier(.4,0,.2,1); }

/* ── Step Indicator ── */
.nf-wizard-steps{ display:flex; align-items:center; gap:6px; padding:0 24px 16px; flex-wrap:wrap; }
.nf-wizard-step-btn{ display:flex; align-items:center; gap:6px; padding:6px 12px; border:1px solid var(--color-grey-light); border-radius:8px; background:#fff; font-size:12px; font-weight:500; color:var(--color-grey); cursor:pointer; transition:all .25s ease; font-family:var(--font-primary); }
.nf-wizard-step-btn .nf-step-num{ width:22px; height:22px; border-radius:50%; background:var(--color-light); display:flex; align-items:center; justify-content:center; font-weight:700; font-size:11px; color:var(--color-grey); transition:all .25s ease; }
.nf-wizard-step-btn .nf-step-text{ font-weight:600; }
.nf-wizard-step-btn.active{ border-color:var(--color-red); background:var(--color-light-red); color:var(--color-red); }
.nf-wizard-step-btn.active .nf-step-num{ background:var(--color-red); color:#fff; }
.nf-wizard-step-btn.completed{ border-color:var(--color-green); background:var(--color-light-green); color:var(--color-green); }
.nf-wizard-step-btn.completed .nf-step-num{ background:var(--color-green); color:#fff; }
.nf-wizard-step-btn.disabled{ opacity:.4; cursor:not-allowed; }
.nf-step-arrow{ font-size:10px; color:var(--color-grey-light); }
.nf-step-badge{ display:inline-block; font-size:11px; font-weight:700; color:var(--color-red); background:var(--color-light-red); padding:2px 8px; border-radius:8px; margin-left:6px; }

/* ── Selection Summary Chips ── */
.nf-wizard-summary{ display:flex; flex-wrap:wrap; gap:8px; padding:0 24px 16px; }
.nf-wizard-chip{ display:inline-flex; align-items:center; gap:5px; padding:5px 14px; border-radius:20px; background:var(--color-black); color:#fff; font-size:12px; font-weight:600; font-family:var(--font-primary); }
.nf-wizard-chip i{ font-size:14px; color:var(--color-green); }

/* ── Choice Card Grid ── */
.nf-choice-grid{ display:grid; grid-template-columns:repeat(2, 1fr); gap:16px; padding:4px 0; }
.nf-choice-grid-sm{ grid-template-columns:repeat(auto-fit, minmax(140px, 1fr)); }

.nf-choice-card{ position:relative; cursor:pointer; }
.nf-choice-card input[type="radio"]{ position:absolute; opacity:0; width:0; height:0; pointer-events:none; }
.nf-choice-card .nf-choice-inner{
    display:flex; flex-direction:column; align-items:center; justify-content:center; gap:10px;
    padding:24px 16px; border:1px solid var(--color-grey-light); border-radius:12px;
    background:#fff; font-size:15px; font-weight:600; color:var(--color-black);
    transition:all .3s ease; text-align:center; min-height:96px;
    font-family:var(--font-primary);
}
.nf-choice-card .nf-choice-inner > i:first-child{ font-size:32px; color:var(--color-grey); transition:all .3s ease; }
.nf-choice-card .nf-choice-check{ display:none; font-size:16px; color:var(--color-red); position:absolute; top:10px; right:10px; }
.nf-choice-card:hover .nf-choice-inner{ border-color:var(--color-grey); background:var(--color-light); }
.nf-choice-card.selected .nf-choice-inner{
    border-color:var(--color-red); background:rgba(234,0,41,.04);
    color:var(--color-red); box-shadow:0 8px 20px rgba(234,0,41,.08);
}
.nf-choice-card.selected .nf-choice-inner > i:first-child{ color:var(--color-red); }
.nf-choice-card.selected .nf-choice-check{ display:block; }

/* ── Step Title Bar ── */
.nf-step-title-bar{
    display:flex; align-items:center; gap:10px; font-size:15px; font-weight:500;
    color:var(--color-black); margin-bottom:18px; padding-bottom:12px;
    border-bottom:1px solid rgba(0,0,0,.06); font-family:var(--font-primary);
}
.nf-step-title-bar i{ font-size:22px; color:var(--color-red); }

/* ── Step Note ── */
.nf-step-note{
    display:flex; align-items:center; gap:8px; margin-top:18px; padding:12px 16px;
    background:var(--color-light); border:1px solid rgba(0,0,0,.06); border-radius:8px;
    font-size:13px; font-weight:500; color:var(--color-grey);
}
.nf-step-note i{ font-size:18px; color:var(--color-orange); flex-shrink:0; }

/* ── Step Skip ── */
.nf-step-skip{ margin-top:16px; text-align:center; }
.nf-skip-btn{
    display:inline-flex; align-items:center; gap:8px; padding:10px 20px;
    border:1px dashed var(--color-grey-light); border-radius:8px;
    background:#fff; font-size:13px; font-weight:500; color:var(--color-grey);
    cursor:pointer; transition:all .25s ease; font-family:var(--font-primary);
}
.nf-skip-btn:hover{ border-color:var(--color-red); color:var(--color-red); background:var(--color-light-red); }

/* ── Choice Empty ── */
.nf-choice-empty{
    display:flex; align-items:center; justify-content:center; gap:10px;
    padding:36px 20px; background:var(--color-light); border:1px dashed var(--color-grey-light);
    border-radius:12px; font-size:14px; font-weight:500; color:var(--color-grey);
}
.nf-choice-empty i{ font-size:22px; }

/* ── Wizard Step Content ── */
.nf-wizard-step-content{ animation:nfWizardFadeIn .3s cubic-bezier(.4,0,.2,1); }
@keyframes nfWizardFadeIn{ from{ opacity:0; transform:translateY(10px); } to{ opacity:1; transform:translateY(0); } }

/* ── Group Title ── */
.nf-group-title{ font-size:14px; font-weight:700; color:var(--color-black); padding:18px 0 10px; letter-spacing:-.2px; }

/* ── Filter Loading ── */
.filter-loading{ padding:24px; text-align:center; color:var(--color-grey); font-size:14px; font-weight:500; }
.filter-loading i{ margin-right:6px; }

/* ── Switch Row ── */
.nf-switch-row{ gap:12px; }

@media (max-width: 768px){
    .nf-choice-grid{ grid-template-columns:1fr; gap:12px; }
    .nf-choice-grid-sm{ grid-template-columns:repeat(2, 1fr); }
    .nf-wizard-steps{ gap:4px; padding:0 16px 12px; }
    .nf-wizard-step-btn .nf-step-text{ display:none; }
    .nf-wizard-step-btn{ padding:5px 8px; }
    .nf-wizard-summary{ padding:0 16px 12px; }
    .nf-wizard-progress{ margin:0 16px 10px; }
    .nf-choice-card .nf-choice-inner{ padding:18px 12px; min-height:78px; }
}

/* ── Land filter document layout ── */
.nf-land-filter-layout{ display:grid; gap:12px; }
.nf-land-context-card{
    display:flex; align-items:flex-start; gap:12px; padding:14px 16px;
    border:1px solid rgba(16,185,129,.18); background:rgba(16,185,129,.055);
    border-radius:12px; color:var(--color-black); font-family:var(--font-primary);
}
.nf-land-context-card > i{ font-size:22px; color:#059669; margin-top:1px; flex:0 0 auto; }
.nf-land-context-card strong{ display:block; font-size:14px; font-weight:800; letter-spacing:-.2px; }
.nf-land-context-card small{ display:block; margin-top:3px; font-size:12px; color:var(--color-grey); line-height:1.35; }
.nf-land-price-card{ border-color:rgba(234,0,41,.12); box-shadow:0 8px 24px rgba(234,0,41,.035); }
.nf-land-subtitle{ font-size:12.5px; font-weight:800; color:var(--color-black); margin:0 0 8px; letter-spacing:-.1px; }
.nf-land-price-block{ margin-top:14px; padding-top:13px; border-top:1px solid rgba(0,0,0,.055); }
.nf-land-toggle-btn{ appearance:none; cursor:pointer; text-align:left; background:#fff; }
.nf-stepper-field{ display:grid; grid-template-columns:44px minmax(0,1fr) 44px; gap:8px; align-items:center; }
.nf-stepper-btn{
    width:44px; height:44px; border-radius:12px; border:1px solid var(--color-grey-light);
    background:#fff; color:var(--color-black); display:flex; align-items:center; justify-content:center;
    cursor:pointer; transition:all .18s ease;
}
.nf-stepper-btn:hover{ border-color:var(--color-red); color:var(--color-red); background:rgba(234,0,41,.035); }
.nf-stepper-input-wrap{ position:relative; }
.nf-stepper-input-wrap.has-badge .input{ padding-right:54px; }

@media (max-width: 768px){
    .nf-stepper-field{ grid-template-columns:40px minmax(0,1fr) 40px; }
    .nf-stepper-btn{ width:40px; height:40px; border-radius:10px; }
}
/* ── Residential filter document layout ── */
.nf-res-filter-layout{ display:grid; gap:12px; }
.nf-res-context-card{
    display:flex; align-items:flex-start; gap:12px; padding:14px 16px;
    border:1px solid rgba(59,130,246,.18); background:rgba(59,130,246,.055);
    border-radius:12px; color:var(--color-black); font-family:var(--font-primary);
}
.nf-res-context-card > i{ font-size:22px; color:#2563eb; margin-top:1px; flex:0 0 auto; }
.nf-res-context-card strong{ display:block; font-size:14px; font-weight:800; letter-spacing:-.2px; }
.nf-res-context-card small{ display:block; margin-top:3px; font-size:12px; color:var(--color-grey); line-height:1.35; }
.nf-res-price-card{ border-color:rgba(234,0,41,.12); box-shadow:0 8px 24px rgba(234,0,41,.035); }
.nf-res-subtitle{ font-size:12.5px; font-weight:800; color:var(--color-black); margin:0 0 8px; letter-spacing:-.1px; }
.nf-res-price-block{ margin-top:14px; padding-top:13px; border-top:1px solid rgba(0,0,0,.055); }
.nf-res-toggle-btn{ appearance:none; cursor:pointer; text-align:left; background:#fff; }
.nf-room-builder{ display:grid; gap:16px; }
.nf-room-line{ display:grid; gap:9px; padding:12px; border:1px solid rgba(0,0,0,.055); border-radius:12px; background:#fff; }
.nf-room-line > strong{ font-size:12.5px; font-weight:800; color:var(--color-black); }
.nf-room-counter-frame{ display:grid; gap:12px; padding:14px; border:1px solid rgba(0,0,0,.06); border-radius:14px; background:#fff; }
.nf-room-counter-head{ display:flex; align-items:flex-start; justify-content:space-between; gap:12px; padding-bottom:2px; }
.nf-room-counter-head strong{ font-size:13px; font-weight:850; color:var(--color-black); letter-spacing:-.15px; }
.nf-room-counter-head small{ max-width:340px; font-size:11.5px; font-weight:600; color:var(--color-grey); line-height:1.35; text-align:right; }
.nf-room-type-grid{ display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px; }
.nf-room-type-card{ display:grid; gap:10px; padding:12px; border:1px solid rgba(0,0,0,.055); border-radius:13px; background:#fafafa; }
.nf-room-type-title{ font-size:12.5px; font-weight:850; color:var(--color-black); letter-spacing:-.1px; }
.nf-room-inline-grid{ display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; }
.nf-room-range-grid{ display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px; }
.nf-room-range-card{ display:grid; gap:10px; align-content:start; padding:12px; border:1px solid rgba(0,0,0,.055); border-radius:13px; background:#fafafa; }
.nf-room-range-title{ font-size:12.5px; font-weight:850; color:var(--color-black); letter-spacing:-.1px; }
.nf-room-range-fields{ display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; }
.nf-room-counter{ display:grid; gap:6px; min-width:0; }
.nf-room-counter > span{ font-size:11.5px; font-weight:800; color:var(--color-grey); }
.nf-room-counter.has-warning .nf-stepper-field{ padding:3px; border:1px solid rgba(234,0,41,.22); border-radius:13px; background:rgba(234,0,41,.035); }
.nf-room-warning{ display:block; font-size:10.8px; font-weight:700; color:#9f1239; line-height:1.3; }
.nf-room-range-warning{ grid-column:1/-1; display:flex; align-items:flex-start; gap:7px; padding:9px 10px; border:1px solid rgba(234,0,41,.14); border-radius:10px; background:rgba(234,0,41,.045); color:#9f1239; font-size:11.5px; font-weight:700; line-height:1.35; }
.nf-room-range-warning i{ flex:0 0 auto; margin-top:1px; }
.nf-combobox-item.disabled,
.nf-combobox-item:disabled{ opacity:.45; cursor:not-allowed; background:#f8f8f8; color:var(--color-grey); }
.nf-room-counter .nf-stepper-field{ grid-template-columns:36px minmax(48px,1fr) 36px; gap:6px; }
.nf-room-counter .nf-stepper-btn{ width:36px; height:36px; border-radius:10px; }
.nf-room-counter .input{ min-width:0; height:36px; text-align:center; }
.nf-room-dropdowns{ display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; }
@media (max-width: 992px){
    .nf-room-type-grid,
    .nf-room-range-grid{ grid-template-columns:1fr; }
}
@media (max-width: 560px){
    .nf-room-counter-head{ display:grid; gap:4px; }
    .nf-room-counter-head small{ max-width:none; text-align:left; }
    .nf-room-inline-grid,
    .nf-room-range-fields{ grid-template-columns:1fr; }
    .nf-room-dropdowns{ grid-template-columns:1fr; }
}
.nf-combobox-label{ font-size:12px; font-weight:800; color:var(--color-black); margin-bottom:6px; }
.nf-res-nested-fields{ display:grid; gap:14px; padding-top:2px; }
.nf-res-nested-field{ display:grid; gap:8px; }
.nf-res-min-grid{ display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; }
.nf-res-min-card{ display:grid; gap:6px; padding:10px; border:1px solid rgba(0,0,0,.055); border-radius:12px; background:#fff; }
.nf-res-min-card > span{ font-size:12px; font-weight:800; color:var(--color-black); }
.nf-res-min-card .nf-stepper-field{ grid-template-columns:36px minmax(0,1fr) 36px; gap:6px; }
.nf-res-min-card .nf-stepper-btn{ width:36px; height:36px; border-radius:10px; }
.nf-res-min-card .input{ text-align:center; }

@media (max-width: 768px){
    .nf-room-counter-grid,
    .nf-room-dropdowns,
    .nf-res-min-grid{ grid-template-columns:1fr; }
    .nf-room-counter-grid.nf-room-counter-grid-four{ grid-template-columns:repeat(2,minmax(0,1fr)); }
    .nf-room-counter-head{ display:grid; gap:4px; }
    .nf-room-counter-head small{ text-align:left; }
}

@media (max-width: 420px){
    .nf-room-counter-grid.nf-room-counter-grid-four{ grid-template-columns:1fr; }
}

/* ── Project filter document layout ── */

.nf-commercial-filter-layout{ display:grid; gap:12px; }
.nf-commercial-context-card{
    display:flex; gap:10px; align-items:flex-start; padding:12px 14px; border:1px solid rgba(0,0,0,.06);
    border-radius:14px; background:linear-gradient(180deg,rgba(249,115,22,.08),rgba(255,255,255,.96));
}
.nf-commercial-context-card > i{ font-size:22px; color:#f97316; margin-top:1px; flex:0 0 auto; }
.nf-commercial-context-card strong{ display:block; font-size:14px; font-weight:800; letter-spacing:-.2px; }
.nf-commercial-context-card small{ display:block; margin-top:3px; font-size:12px; color:var(--color-grey); line-height:1.35; }
.nf-commercial-price-card{ border-color:rgba(234,0,41,.12); box-shadow:0 8px 24px rgba(234,0,41,.035); }
.nf-commercial-subtitle{ font-size:12.5px; font-weight:800; color:var(--color-black); margin:0 0 8px; letter-spacing:-.1px; }
.nf-commercial-price-block{ margin-top:14px; padding-top:13px; border-top:1px solid rgba(0,0,0,.055); }
.nf-commercial-toggle-btn{ appearance:none; cursor:pointer; text-align:left; background:#fff; }
.nf-commercial-nested-fields{ display:grid; gap:14px; padding-top:2px; }
.nf-commercial-nested-field{ display:grid; gap:8px; }
.nf-commercial-min-grid{ display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; }
.nf-commercial-min-card{ display:grid; gap:6px; padding:10px; border:1px solid rgba(0,0,0,.055); border-radius:12px; background:#fff; }
.nf-commercial-min-card > span{ font-size:12px; font-weight:800; color:var(--color-black); }
.nf-commercial-min-card .nf-stepper-field{ grid-template-columns:36px minmax(0,1fr) 36px; gap:6px; }
.nf-commercial-min-card .nf-stepper-btn{ width:36px; height:36px; border-radius:10px; }
.nf-commercial-min-card .input{ text-align:center; }
@media (max-width: 640px){
    .nf-commercial-min-grid{ grid-template-columns:1fr; }
}

.nf-project-filter-layout{ display:grid; gap:12px; }
.nf-project-context-card{
    display:flex; align-items:flex-start; gap:12px; padding:14px 16px;
    border:1px solid rgba(124,58,237,.18); background:rgba(124,58,237,.055);
    border-radius:12px; color:var(--color-black); font-family:var(--font-primary);
}
.nf-project-context-card > i{ font-size:22px; color:#7c3aed; margin-top:1px; flex:0 0 auto; }
.nf-project-context-card strong{ display:block; font-size:14px; font-weight:800; letter-spacing:-.2px; }
.nf-project-context-card small{ display:block; margin-top:3px; font-size:12px; color:var(--color-grey); line-height:1.35; }
.nf-project-price-card{ border-color:rgba(234,0,41,.12); box-shadow:0 8px 24px rgba(234,0,41,.035); }
.nf-project-subtitle{ font-size:12.5px; font-weight:800; color:var(--color-black); margin:0 0 8px; letter-spacing:-.1px; }
.nf-project-price-block{ margin-top:14px; padding-top:13px; border-top:1px solid rgba(0,0,0,.055); }
.nf-project-toggle-btn{ appearance:none; cursor:pointer; text-align:left; background:#fff; }
.nf-project-nested-fields{ display:grid; gap:14px; padding-top:2px; }
.nf-project-nested-field{ display:grid; gap:8px; }
.nf-project-min-grid{ display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; }
.nf-project-min-card{ display:grid; gap:6px; padding:10px; border:1px solid rgba(0,0,0,.055); border-radius:12px; background:#fff; }
.nf-project-min-card > span{ font-size:12px; font-weight:800; color:var(--color-black); }
.nf-project-min-card .nf-stepper-field{ grid-template-columns:36px minmax(0,1fr) 36px; gap:6px; }
.nf-project-min-card .nf-stepper-btn{ width:36px; height:36px; border-radius:10px; }
.nf-project-min-card .input{ text-align:center; }
.nf-filter-installment-stack{ display:grid; gap:12px; }
.nf-installment-term-slider{
    width:100%; padding:14px 16px 12px; border:1px solid rgba(15,23,42,.10);
    border-radius:18px; background:#eef1f4; transition:border-color .22s ease, box-shadow .22s ease, background-color .22s ease;
}
.nf-installment-term-slider:focus-within{ border-color:rgba(234,0,41,.30); box-shadow:0 0 0 4px rgba(234,0,41,.08); background:#f3f5f7; }
.nf-installment-term-head{ display:flex; align-items:center; justify-content:space-between; gap:10px; margin-bottom:10px; }
.nf-installment-term-head strong{ font-size:12.5px; font-weight:900; color:#0f172a; line-height:18px; }
.nf-installment-term-head small{ font-size:12px; font-weight:700; color:#64748b; line-height:17px; text-align:right; }
.nf-installment-term-slider-row{ display:grid; grid-template-columns:minmax(0,1fr) 150px; gap:16px; align-items:center; }
.nf-installment-term-range-wrap{ min-width:0; height:46px; padding:0 30px; border-radius:999px; background:#fff; display:flex; align-items:center; }
.nf-installment-term-range{
    width:100%; height:6px; margin:0; border:0; outline:none; border-radius:999px;
    background:linear-gradient(to right,var(--color-red) 0%,var(--color-red) var(--range-progress,0%),#d9dee5 var(--range-progress,0%),#d9dee5 100%);
    appearance:none; -webkit-appearance:none; cursor:pointer;
}
.nf-installment-term-range::-webkit-slider-runnable-track{ height:6px; border-radius:999px; background:transparent; }
.nf-installment-term-range::-webkit-slider-thumb{ width:24px; height:24px; margin-top:-9px; border:0; border-radius:50%; background:var(--color-red); box-shadow:0 8px 18px rgba(234,0,41,.28); appearance:none; -webkit-appearance:none; cursor:grab; }
.nf-installment-term-range:active::-webkit-slider-thumb{ cursor:grabbing; transform:scale(1.05); }
.nf-installment-term-range::-moz-range-track{ height:6px; border-radius:999px; background:#d9dee5; }
.nf-installment-term-range::-moz-range-progress{ height:6px; border-radius:999px; background:var(--color-red); }
.nf-installment-term-range::-moz-range-thumb{ width:24px; height:24px; border:0; border-radius:50%; background:var(--color-red); box-shadow:0 8px 18px rgba(234,0,41,.28); cursor:grab; }
.nf-installment-term-value-pill{ height:46px; padding:0 18px; border-radius:999px; background:#fff; display:flex; align-items:center; justify-content:flex-end; gap:5px; color:#0f172a; white-space:nowrap; }
.nf-installment-term-value-pill strong{ font-size:16px; font-weight:900; letter-spacing:-.2px; line-height:1; }
.nf-installment-term-value-pill span{ font-size:13px; font-weight:700; color:#64748b; line-height:1; }
.nf-installment-term-scale{ width:100%; margin-top:8px; padding:0 170px 0 30px; display:flex; align-items:center; justify-content:space-between; gap:12px; }
.nf-installment-term-scale small{ font-size:11px; font-weight:700; color:#64748b; line-height:15px; }
.nf-installment-term-clear{ border:0; background:transparent; color:var(--color-red); font-size:11px; font-weight:800; cursor:pointer; padding:2px 4px; }

@media (max-width: 768px){
    .nf-project-min-grid{ grid-template-columns:1fr; }
    .nf-installment-term-slider-row{ grid-template-columns:1fr; gap:10px; }
    .nf-installment-term-range-wrap{ padding:0 22px; }
    .nf-installment-term-value-pill{ justify-content:center; }
    .nf-installment-term-scale{ padding:0 22px; }
    .nf-installment-term-head{ align-items:flex-start; flex-direction:column; }
    .nf-installment-term-head small{ text-align:left; }
}



/* ── Conditional parking filter ── */
.nf-parking-grid{ display:grid; grid-template-columns:repeat(auto-fit,minmax(220px,1fr)); gap:12px; width:100%; }
.nf-parking-option{ min-width:0; padding:12px; border:1px solid rgba(15,23,42,.08); border-radius:14px; background:rgba(248,250,252,.78); transition:border-color .18s ease, box-shadow .18s ease, background-color .18s ease; }
.nf-parking-option.active{ border-color:rgba(34,197,94,.34); box-shadow:0 0 0 4px rgba(34,197,94,.06); background:#fff; }
.nf-parking-toggle-btn{ width:100%; justify-content:flex-start; text-align:left; cursor:pointer; background:#fff; }
.nf-parking-count{ margin-top:12px; display:grid; gap:8px; }
.nf-parking-count-title{ font-size:12px; font-weight:800; color:var(--color-black); }
.nf-parking-count .nf-stepper-field{ grid-template-columns:36px minmax(0,1fr) 36px; gap:6px; }
.nf-parking-count .nf-stepper-btn{ width:36px; height:36px; border-radius:10px; }
.nf-parking-count .input{ text-align:center; }
.nf-parking-count-help{ font-size:12px; line-height:17px; color:var(--color-grey); }
@media (max-width:768px){ .nf-parking-grid{ grid-template-columns:1fr; } }


.nf-installment-input-stack {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}

.nf-installment-term-input {
    border: 1px solid rgba(0, 0, 0, .08);
    border-radius: 18px;
    background: #fff;
    padding: 14px;
}

.nf-installment-min-field {
    margin-top: 10px;
}

.nf-installment-input-clear {
    margin-top: 9px;
    width: 100%;
    justify-content: center;
}

@media (max-width: 640px) {
    .nf-installment-input-stack {
        grid-template-columns: 1fr;
    }
}



/* Yapım Yılı: min / max aralığı, her iki taraf da Step 3 tarzı stepper */
.nf-year-filter-control{
    width:100%;
}

.nf-year-range-grid{
    display:grid;
    grid-template-columns:repeat(2, minmax(0,1fr));
    gap:12px;
    width:100%;
}

/* Tek taraflı yıl filtresinde (En Az) ikinci, boş kolon oluşturma.
   Yenilenmiş durumunda Yapım + Yenileme kartları yan yana kalır; her stepper kendi
   kartının genişliğini tamamen kullanır. */
.nf-year-range-grid-min-only{
    grid-template-columns:minmax(0,1fr);
}

.nf-year-range-item{
    min-width:0;
    padding:0;
    border:0;
    border-radius:0;
    background:transparent;
}

.nf-year-range-label{
    margin-bottom:8px;
    font-size:11.5px;
    line-height:1;
    font-weight:850;
    color:#6b7280;
}

@media (max-width:640px){
    .nf-year-range-grid{
        grid-template-columns:1fr;
    }
}

.nf-year-stepper-field{
    display:grid;
    grid-template-columns:48px minmax(0,1fr) 48px;
    align-items:center;
    gap:8px;
    width:100%;
}

.nf-year-stepper-btn{
    width:48px;
    height:46px;
    display:flex;
    align-items:center;
    justify-content:center;
    border:1px solid rgba(15,23,42,.10);
    border-radius:12px;
    background:#f8fafc;
    color:#111827;
    cursor:pointer;
    transition:border-color .18s ease, background-color .18s ease, opacity .18s ease;
}

.nf-year-stepper-btn:hover:not(:disabled){
    border-color:rgba(15,23,42,.18);
    background:#f8fafc;
}

.nf-year-stepper-btn:disabled{
    opacity:.38;
    cursor:not-allowed;
}

.nf-year-stepper-input{
    width:100%;
    min-width:0;
    height:46px;
    text-align:center;
    font-weight:800;
    font-variant-numeric:tabular-nums;
}

/* Taşınmaz Durumu altında ilan ekle akışıyla uyumlu koşullu yıl alanları */
.nf-property-status-block{
    display:flex;
    flex-direction:column;
    gap:14px;
}

.nf-property-year-stack{
    display:grid;
    /* Tek yıl varsa tam genişlik; Yenilenmiş'te Yapım + Yenileme yan yana.
       Dar ekranda otomatik olarak alt alta düşer. */
    grid-template-columns:repeat(auto-fit, minmax(min(200px, 100%), 1fr));
    gap:12px;
    padding:0;
    border:0;
    border-radius:0;
    background:transparent;
}

.nf-property-year-card{
    display:flex;
    flex-direction:column;
    gap:7px;
}

.nf-property-year-label{
    font-size:12px;
    font-weight:900;
    color:#222;
    letter-spacing:-.1px;
}

.nf-property-year-help{
    margin-top:2px;
    font-size:11.5px;
    line-height:1.35;
    color:#777;
    font-weight:650;
}

.nf-construction-year-card{
    width:100%;
}


/* ARSA.pdf s.5 — Tarım Arazisi / Bağ Bahçe / Hobi Bahçesi sayaçları yan yana. */
.nf-land-filter-layout { grid-template-columns:repeat(2,minmax(0,1fr)); }
.nf-land-filter-layout > :not(.nf-land-compact-counter) { grid-column:1 / -1; }
.nf-land-filter-layout > .nf-land-compact-counter { grid-column:auto; min-width:0; }
.nf-land-compact-counter .nf-accordion-header { min-height:42px; padding:10px 12px; }
.nf-land-compact-counter .nf-accordion-body { padding:8px 10px 12px; }
.nf-land-compact-counter .nf-stepper-field { grid-template-columns:34px minmax(0,1fr) 34px; gap:5px; }
.nf-land-compact-counter .nf-stepper-btn { min-width:0; width:34px; }
.nf-land-compact-counter .fbr-title { font-size:13px; }
@media(max-width:700px) {
    .nf-land-filter-layout { grid-template-columns:minmax(0,1fr); }
    .nf-land-filter-layout > .nf-land-compact-counter { grid-column:1 / -1; }
}

</style>
